"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[913],{

/***/ 1226:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Button; }
/* harmony export */ });
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_icons_map__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9816);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5893);






function Button(_ref) {
  var text = _ref.text,
      url = _ref.url,
      _ref$icon = _ref.icon,
      icon = _ref$icon === void 0 ? 'none' : _ref$icon,
      textColor = _ref.textColor,
      _ref$newTab = _ref.newTab,
      newTab = _ref$newTab === void 0 ? false : _ref$newTab,
      _ref$underline = _ref.underline,
      underline = _ref$underline === void 0 ? false : _ref$underline,
      _ref$background = _ref.background,
      background = _ref$background === void 0 ? true : _ref$background,
      _ref$iconColor = _ref.iconColor,
      iconColor = _ref$iconColor === void 0 ? 'black' : _ref$iconColor,
      _ref$customClass = _ref.customClass,
      customClass = _ref$customClass === void 0 ? '' : _ref$customClass,
      animation = _ref.animation;
  var textClasses = '';
  var darkTextClass = '';

  if (background) {
    // Orange background button
    textClasses = 'text-black'; // Black text in light mode

    darkTextClass = 'dark:text-white'; // White text in dark mode
  } else {
    // Transparent background button
    textClasses = "text-".concat(textColor); // Use textColor prop

    darkTextClass = customClass.includes('dark:') ? '' : 'dark:text-white'; // Add dark:text-white if not already present in customClass
  }

  var className = "py-1 px-4 inline-flex items-center whitespace-nowrap btn rounded-full font-vinila-extended text-[14px] md:text-[16px]" + (background ? ' bg-brand-orange' : ' bg-transparent') + " ".concat(textClasses, " ").concat(darkTextClass, " ") + // Add the dynamic text classes and dark mode class
  customClass; // Append customClass at the end

  var target = '_self';

  if (underline == true) {
    className += ' underline';
  }

  if (newTab == true) {
    target = '_blank';
  }

  if (animation) {
    className += ' animate-pulse';
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
    children: url ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_0___default()), {
      href: url,
      passHref: true,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("a", {
        className: className,
        target: target,
        "aria-label": typeof text === 'string' ? text : undefined,
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("span", {
          children: text
        }), icon === 'none' ? "" : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("span", {
          className: "w-4 h-4 ml-2",
          children: (0,_utils_icons_map__WEBPACK_IMPORTED_MODULE_1__/* .getIconComponentByName */ .l)('ArrowRight' + iconColor.charAt(0).toUpperCase() + iconColor.slice(1))
        })]
      })
    }) : null
  });
}

/***/ }),

/***/ 9913:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Layout; }
});

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(29);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(7794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(4012);
// EXTERNAL MODULE: ./utils/icons-map.tsx
var icons_map = __webpack_require__(9816);
// EXTERNAL MODULE: ./components/icons/index.tsx + 29 modules
var icons = __webpack_require__(5742);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next-themes/dist/index.modern.js
var index_modern = __webpack_require__(425);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./components/Footer.tsx













function Footer() {
  var _useState = (0,react.useState)([]),
      postsData = _useState[0],
      setPostsData = _useState[1];

  var _useState2 = (0,react.useState)([]),
      newsData = _useState2[0],
      setNewsData = _useState2[1];

  var _useRouter = (0,router.useRouter)(),
      locale = _useRouter.locale;

  var _useTheme = (0,index_modern/* useTheme */.F)(),
      theme = _useTheme.theme;

  var _useState3 = (0,react.useState)(false),
      mounted = _useState3[0],
      setMounted = _useState3[1];

  (0,react.useEffect)(function () {
    setMounted(true);
  }, []);
  (0,react.useEffect)(function () {
    var fetchData = /*#__PURE__*/function () {
      var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var posts, news;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return fetch("https://ergo-platform-cms-nvbpfiue6q-ez.a.run.app" + '/api/posts?sort=date:desc&pagination[page]=1&pagination[pageSize]=5&populate=*&filters[type][$eq]=blog&locale=' + locale).then(function (response) {
                  return response.json();
                }).then(function (response) {
                  return response.data;
                })["catch"](function (err) {
                  return null;
                });

              case 2:
                posts = _context.sent;
                _context.next = 5;
                return fetch("https://ergo-platform-cms-nvbpfiue6q-ez.a.run.app" + '/api/posts?sort=date:desc&pagination[page]=1&pagination[pageSize]=5&populate=*&filters[type][$eq]=news&locale=' + locale).then(function (response) {
                  return response.json();
                }).then(function (response) {
                  return response.data;
                })["catch"](function (err) {
                  return null;
                });

              case 5:
                news = _context.sent;
                setPostsData(posts);
                setNewsData(news);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function fetchData() {
        return _ref.apply(this, arguments);
      };
    }();

    fetchData();
  }, [locale]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("footer", {
    id: "Footer",
    className: "relative z-10",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "absolute inset-0 -z-10 w-full h-full",
      children: mounted && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "md:hidden relative w-full h-full",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            src: theme === 'dark' ? '/assets/footer.png' : '/assets/footer-light.png',
            alt: "Ergo Footer Background",
            layout: "fill",
            objectFit: "cover",
            objectPosition: "bottom center",
            quality: 90,
            priority: false
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "hidden md:block relative w-full h-full",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            src: theme === 'dark' ? '/assets/footer.png' : '/assets/footer-light.png',
            alt: "Ergo Footer Background",
            layout: "fill",
            objectFit: "cover",
            objectPosition: "bottom center"
          })
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "max-w-[1300px] mx-auto py-12 px-4 relative z-20",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "md:flex justify-between",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "my-6 md:my-auto flex justify-start md:justify-center",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: "/",
            passHref: true,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              "aria-label": "Ergo Platform Home",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(icons/* LogoWithText */.uH, {
                viewBox: "0 0 213 82",
                className: "w-40 md:w-52"
              })
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "grid grid-cols-5 gap-4 md:gap-2 lg:gap-4 justify-items-center",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "box",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              href: "https://sigmaverse.io",
              target: "_blank",
              rel: "noreferrer",
              "aria-label": "Sigmaverse website",
              children: (0,icons_map/* getIconComponentByName */.l)('Sigmaverse')
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "box",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
              href: "/ecosystem/#Wiki",
              passHref: true,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                "aria-label": "Ergo Wiki",
                children: (0,icons_map/* getIconComponentByName */.l)('ErgoWiki')
              })
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "box",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              href: "https://github.com/ergoplatform",
              target: "_blank",
              rel: "noreferrer",
              "aria-label": "Ergo Platform GitHub",
              children: (0,icons_map/* getIconComponentByName */.l)('Github')
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "box",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              href: "https://x.com/Ergo_Platform",
              target: "_blank",
              rel: "noreferrer",
              "aria-label": "Ergo Platform X (formerly Twitter)",
              children: (0,icons_map/* getIconComponentByName */.l)('X')
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "box",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              href: "https://www.youtube.com/c/ErgoPlatform",
              target: "_blank",
              rel: "noreferrer",
              "aria-label": "Ergo Platform YouTube",
              children: (0,icons_map/* getIconComponentByName */.l)('Youtube')
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "box",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              href: "https://t.me/Ergo_Chats",
              target: "_blank",
              rel: "noreferrer",
              "aria-label": "Ergo Platform Telegram",
              children: (0,icons_map/* getIconComponentByName */.l)('Telegram')
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "box",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              href: "https://discord.gg/ergo-platform-668903786361651200",
              target: "_blank",
              rel: "noreferrer",
              "aria-label": "Ergo Platform Discord",
              children: (0,icons_map/* getIconComponentByName */.l)('Discord')
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "box",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              href: "https://reddit.com/r/ergonauts",
              target: "_blank",
              rel: "noreferrer",
              "aria-label": "Ergo Platform Reddit",
              children: (0,icons_map/* getIconComponentByName */.l)('Reddit')
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "box",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              href: "https://www.ergoforum.org/",
              target: "_blank",
              rel: "noreferrer",
              "aria-label": "Ergo Forum",
              children: (0,icons_map/* getIconComponentByName */.l)('Discourse')
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "box",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              href: "https://www.coingecko.com/en/coins/ergo",
              target: "_blank",
              rel: "noreferrer",
              "aria-label": "Ergo on CoinGecko",
              children: (0,icons_map/* getIconComponentByName */.l)('Coingecko')
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "my-6 md:my-auto flex justify-start md:justify-center",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            className: "text-brand-orange dark:text-brand-orange",
            href: "mailto:team@ergoplatform.org",
            children: "team@ergoplatform.org"
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "my-6 grid md:grid-cols-2 lg:grid-cols-6",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "mx-1",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: "/community",
            passHref: true,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
              className: "font-button text-black dark:text-white my-4 cursor-pointer",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                defaultMessage: [{
                  "type": 0,
                  "value": "COMMUNITY"
                }],
                id: "footer.community.title"
              })
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
            className: "hidden md:block",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              className: "mb-4",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                href: "/community/#JoinUs",
                passHref: true,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: "text-black dark:text-gray-300",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                    defaultMessage: [{
                      "type": 0,
                      "value": "Join our channels"
                    }],
                    id: "footer.community.1"
                  })
                })
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              className: "mb-4",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                href: "/community/#Sigmanauts",
                passHref: true,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: "text-black dark:text-gray-300",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                    defaultMessage: [{
                      "type": 0,
                      "value": "Sigmanauts"
                    }],
                    id: "footer.community.2"
                  })
                })
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              className: "mb-4",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                href: "/community/#Contribute",
                passHref: true,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: "text-black dark:text-gray-300",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                    defaultMessage: [{
                      "type": 0,
                      "value": "Contribute to Ergo"
                    }],
                    id: "footer.community.3"
                  })
                })
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              className: "mb-4",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                href: "/community/#HallOfFame",
                passHref: true,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: "text-black dark:text-gray-300",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                    defaultMessage: [{
                      "type": 0,
                      "value": "Hall of Fame"
                    }],
                    id: "footer.community.4"
                  })
                })
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              className: "mb-4",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                href: "/community/#Foundation",
                passHref: true,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: "text-black dark:text-gray-300",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                    defaultMessage: [{
                      "type": 0,
                      "value": "Ergo Foundation"
                    }],
                    id: "footer.community.5"
                  })
                })
              })
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "mx-1",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: "/get-erg",
            passHref: true,
            prefetch: false,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
              className: "font-button text-black dark:text-white my-4 cursor-pointer",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                defaultMessage: [{
                  "type": 0,
                  "value": "GET ERG"
                }],
                id: "footer.getErg.title"
              })
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
            className: "hidden md:block",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              className: "mb-4",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                href: "/get-erg/#Mining",
                prefetch: false,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: "text-black dark:text-gray-300",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                    defaultMessage: [{
                      "type": 0,
                      "value": "Mining"
                    }],
                    id: "footer.getErg.1"
                  })
                })
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              className: "mb-4",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                href: "/get-erg/#MiningCalculator",
                prefetch: false,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: "text-black dark:text-gray-300",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                    defaultMessage: [{
                      "type": 0,
                      "value": "Mining Calculator"
                    }],
                    id: "footer.getErg.2"
                  })
                })
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              className: "mb-4",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                href: "/get-erg/#Wallets",
                prefetch: false,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: "text-black dark:text-gray-300",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                    defaultMessage: [{
                      "type": 0,
                      "value": "Wallets"
                    }],
                    id: "footer.getErg.3"
                  })
                })
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              className: "mb-4",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                href: "/get-erg/#Exchanges",
                prefetch: false,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: "text-black dark:text-gray-300",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                    defaultMessage: [{
                      "type": 0,
                      "value": "Exchanges"
                    }],
                    id: "footer.getErg.4"
                  })
                })
              })
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "mx-1",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: "/discover",
            passHref: true,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
              className: "font-button text-black dark:text-white my-4 cursor-pointer",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                defaultMessage: [{
                  "type": 0,
                  "value": "DISCOVER"
                }],
                id: "footer.discover.title"
              })
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
            className: "hidden md:block",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              className: "mb-4",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                href: "/discover/#DiscoverERG",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: "text-black dark:text-gray-300",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                    defaultMessage: [{
                      "type": 0,
                      "value": "Software Releases"
                    }],
                    id: "footer.discover.1"
                  })
                })
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              className: "mb-4",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                href: "/discover/#GrantsAndBounties",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: "text-black dark:text-gray-300",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                    defaultMessage: [{
                      "type": 0,
                      "value": "Grants & Bounties"
                    }],
                    id: "footer.discover.2"
                  })
                })
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              className: "mb-4",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                href: "/discover/#FAQ",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: "text-black dark:text-gray-300",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                    defaultMessage: [{
                      "type": 0,
                      "value": "FAQ"
                    }],
                    id: "footer.discover.3"
                  })
                })
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              className: "mb-4",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                href: "/discover/#Explore",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: "text-black dark:text-gray-300",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                    defaultMessage: [{
                      "type": 0,
                      "value": "Explore"
                    }],
                    id: "footer.discover.4"
                  })
                })
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              className: "mb-4",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                href: "/discover/#Documents",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: "text-black dark:text-gray-300",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                    defaultMessage: [{
                      "type": 0,
                      "value": "Documents"
                    }],
                    id: "footer.discover.5"
                  })
                })
              })
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "mx-1",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: "/ecosystem",
            passHref: true,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
              className: "font-button text-black dark:text-white my-4 cursor-pointer",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                defaultMessage: [{
                  "type": 0,
                  "value": "ECOSYSTEM"
                }],
                id: "footer.ecosystem.title"
              })
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
            className: "hidden md:block",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              className: "mb-4",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                href: "/ecosystem/#DApps",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: "text-black dark:text-gray-300",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                    defaultMessage: [{
                      "type": 0,
                      "value": "DApps"
                    }],
                    id: "footer.ecosystem.1"
                  })
                })
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              className: "mb-4",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                href: "/ecosystem/#Roadmap",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: "text-black dark:text-gray-300",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                    defaultMessage: [{
                      "type": 0,
                      "value": "Roadmap"
                    }],
                    id: "footer.ecosystem.2"
                  })
                })
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              className: "mb-4",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                href: "/ecosystem/#Wiki",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: "text-black dark:text-gray-300",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                    defaultMessage: [{
                      "type": 0,
                      "value": "Wiki"
                    }],
                    id: "footer.ecosystem.3"
                  })
                })
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              className: "mb-4",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                href: "/ecosystem/#Favorites",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: "text-black dark:text-gray-300",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                    defaultMessage: [{
                      "type": 0,
                      "value": "OUR FAVORITES"
                    }],
                    id: "footer.favorites.title"
                  })
                })
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              className: "mb-4",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                href: "/ecosystem#Videocasts",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: "text-black dark:text-gray-300",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                    defaultMessage: [{
                      "type": 0,
                      "value": "Real Life Ergo"
                    }],
                    id: "footer.realLifeErgo.title"
                  })
                })
              })
            })]
          })]
        }), postsData.length !== 0 ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "mx-1",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: "/blog",
            passHref: true,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
              className: "font-button text-black dark:text-white my-4 cursor-pointer",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                defaultMessage: [{
                  "type": 0,
                  "value": "BLOG"
                }],
                id: "footer.blog.title"
              })
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
            className: "hidden md:block",
            children: postsData.map(function (_ref2) {
              var attributes = _ref2.attributes,
                  id = _ref2.id;
              return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                className: "mb-4",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                  href: attributes.url,
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                    className: "text-black dark:text-gray-300",
                    children: attributes.title
                  })
                })
              }, id);
            })
          })]
        }) : null, newsData.length !== 0 ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "mx-1",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: "/news",
            passHref: true,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
              className: "font-button text-black dark:text-white my-4 cursor-pointer",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                defaultMessage: [{
                  "type": 0,
                  "value": "NEWS"
                }],
                id: "footer.news.title"
              })
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
            className: "hidden md:block",
            children: newsData.map(function (_ref3) {
              var attributes = _ref3.attributes,
                  id = _ref3.id;
              return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                className: "mb-4",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                  href: attributes.url,
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                    className: "text-black dark:text-gray-300",
                    children: attributes.title
                  })
                })
              }, id);
            })
          })]
        }) : null]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "md:flex",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "flex-grow md:flex-grow my-auto",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
            className: "inline-flex",
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
              className: "mr-6 text-black dark:text-white",
              children: ["Ergo Platform \xA9 ", new Date().getFullYear()]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              className: "mr-6",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                href: '/privacy-policy',
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: "text-black dark:text-gray-300",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                    defaultMessage: [{
                      "type": 0,
                      "value": "Privacy Policy"
                    }],
                    id: "footer.privacyPolicy"
                  })
                })
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              className: "mr-6",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                href: '/legal',
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: "text-black dark:text-gray-300",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                    defaultMessage: [{
                      "type": 0,
                      "value": "Legal"
                    }],
                    id: "footer.legal"
                  })
                })
              })
            })]
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "mt-5 md:mt-0 text-black dark:text-white",
        children: "1 Irving Place, #08/11 The Commerze@irving Singapore (369546)"
      })]
    })]
  });
}
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/popover/popover.js + 4 modules
var popover = __webpack_require__(1761);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/transitions/transition.js + 4 modules
var transition = __webpack_require__(1407);
;// CONCATENATED MODULE: ./components/SecondaryMenu.tsx





function SecondaryMenu() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "justify-between bg-gray-100 dark:bg-gray-800 w-full relative md:flex hidden",
      style: {
        boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
        zIndex: 100
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "max-w-[700px] mx-auto flex justify-between w-full px-4 py-2",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          href: "/get-erg#Wallets",
          passHref: true,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            className: "text-xs mr-2 hover:text-orange-500 transition-colors duration-300 text-gray-900 dark:text-white",
            "aria-label": "Wallets",
            children: "WALLETS"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: "text-xs mx-2 text-gray-900 dark:text-white",
          children: "\u2022"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          href: "/get-erg#Exchanges",
          passHref: true,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            className: "text-xs mr-2 hover:text-orange-500 transition-colors duration-300 text-gray-900 dark:text-white",
            "aria-label": "Exchanges",
            children: "EXCHANGES"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: "text-xs mx-2 text-gray-900 dark:text-white",
          children: "\u2022"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          href: "/ecosystem#Roadmap",
          passHref: true,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            className: "text-xs mr-2 hover:text-orange-500 transition-colors duration-300 text-gray-900 dark:text-white",
            "aria-label": "Roadmap",
            children: "ROADMAP"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: "text-xs mx-2 text-gray-900 dark:text-white",
          children: "\u2022"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          href: "/blog",
          passHref: true,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            className: "text-xs mr-2 hover:text-orange-500 transition-colors duration-300 text-gray-900 dark:text-white",
            "aria-label": "Blog",
            children: "BLOG"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: "text-xs mx-2 text-gray-900 dark:text-white",
          children: "\u2022"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          href: "https://docs.ergoplatform.org/",
          target: "_blank",
          className: "text-xs mr-2 hover:text-orange-500 transition-colors duration-300 text-gray-900 dark:text-white",
          rel: "noreferrer",
          "aria-label": "Documentation",
          children: "DOCUMENTATION"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: "text-xs mx-2 text-gray-900 dark:text-white",
          children: "\u2022"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          href: "https://sigmaverse.io/",
          target: "_blank",
          className: "text-xs mr-2 hover:text-orange-500 transition-colors duration-300 text-gray-900 dark:text-white",
          rel: "noreferrer",
          "aria-label": "Sigmaverse",
          children: "SIGMAVERSE"
        })]
      })
    })
  });
}

/* harmony default export */ var components_SecondaryMenu = (SecondaryMenu);
// EXTERNAL MODULE: ./components/Button.tsx
var Button = __webpack_require__(1226);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/listbox/listbox.js + 4 modules
var listbox = __webpack_require__(3507);
;// CONCATENATED MODULE: ./components/LanguageSwitcher.tsx







function LanguageSwitcher(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'default' : _ref$color;
  var data = (0,router.useRouter)();
  var locale = data.locale,
      locales = data.locales,
      asPath = data.asPath;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(listbox/* Listbox */.R, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "relative",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(listbox/* Listbox.Button */.R.Button, {
        className: "relative py-2 pl-3 pr-8 text-left cursor-pointer sm:text-sm",
        "aria-label": "Select language",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: "block truncate font-button-bold underline uppercase",
          children: locale
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: "absolute inset-y-0 right-0 flex items-center pointer-events-none",
          children: color == 'default' ? (0,icons_map/* getIconComponentByName */.l)('LanguageSelector') : (0,icons_map/* getIconComponentByName */.l)('LanguageSelectorWhite')
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(transition/* Transition */.u, {
        as: react.Fragment,
        leave: "transition ease-in duration-100",
        leaveFrom: "opacity-100",
        leaveTo: "opacity-0",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(listbox/* Listbox.Options */.R.Options, {
          className: "absolute overflow-auto max-h-60",
          children: locales === null || locales === void 0 ? void 0 : locales.filter(function (obj) {
            return obj !== 'default';
          }).map(function (loc, key) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(listbox/* Listbox.Option */.R.Option, {
              className: "cursor-default select-none relative",
              value: loc,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                href: asPath,
                locale: loc,
                passHref: true,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: "py-2 pl-3 pr-8",
                  "aria-label": "Switch to ".concat(loc),
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    className: "font-button-bold text-[14px] uppercase",
                    children: loc
                  })
                })
              })
            }, key);
          })
        })
      })]
    })
  });
}
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(6896);
// EXTERNAL MODULE: ./node_modules/react-icons/ri/index.esm.js
var index_esm = __webpack_require__(9352);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(4184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./components/darkModeSwitcher/DarkModeSwitcher.tsx





function DarkModeSwitch() {
  var _useTheme = (0,index_modern/* useTheme */.F)(),
      theme = _useTheme.theme,
      setTheme = _useTheme.setTheme;

  var _useState = (0,react.useState)(false),
      mounted = _useState[0],
      setMounted = _useState[1];

  (0,react.useEffect)(function () {
    return setMounted(true);
  }, []);

  var toggleSwitch = function toggleSwitch() {
    console.log('Toggling theme:', theme);
    setTheme(theme === 'light' ? 'dark' : 'light');
  };

  if (!mounted) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    onClick: toggleSwitch,
    className: classnames_default()("flex-start flex h-[40px] w-[80px] rounded-[50px] bg-zinc-100 shadow-inner hover:cursor-pointer dark:bg-black", {
      'place-content-end': theme === 'light'
    }),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "flex h-[40px] w-[40px] items-center justify-center rounded-full",
      children: theme === 'light' ? /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* RiSunFill */.RNE, {
        className: "h-6 w-6 text-orange-500"
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* RiMoonClearFill */.sfr, {
        className: "h-6 w-6 text-slate-200"
      })
    })
  });
}
;// CONCATENATED MODULE: ./components/Search.tsx




function Search() {
  var searchRef = (0,react.useRef)(null);

  var _useState = (0,react.useState)(''),
      query = _useState[0],
      setQuery = _useState[1];

  var _useState2 = (0,react.useState)(false),
      active = _useState2[0],
      setActive = _useState2[1];

  var _useState3 = (0,react.useState)([]),
      results = _useState3[0],
      setResults = _useState3[1];

  var searchEndpoint = function searchEndpoint(query) {
    return "https://ergo-platform-cms-nvbpfiue6q-ez.a.run.app" + "/api/posts?sort=date:desc&pagination[withCount]=true&pagination[pageSize]=100&[$or][0][title][$containsi]=".concat(query, "&filters[$or][1][subtitle][$containsi]=").concat(query, "&filters[$or][2][content][$containsi]=").concat(query);
  };

  var onChange = (0,react.useCallback)(function (event) {
    var query = event.target.value;
    setQuery(query);

    if (query.length) {
      fetch(searchEndpoint(query)).then(function (res) {
        return res.json();
      }).then(function (res) {
        return res.data;
      }).then(function (res) {
        console.log(res);
        setResults(res);
      });
    } else {
      setResults([]);
    }
  }, []);
  var onClick = (0,react.useCallback)(function (event) {
    if (searchRef.current && !searchRef.current.contains(event.target)) {
      setActive(false);
      window.removeEventListener('click', onClick);
    }
  }, []);
  var onFocus = (0,react.useCallback)(function () {
    setActive(true);
    window.addEventListener('click', onClick);
  }, [onClick]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    ref: searchRef,
    className: "mx-4",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", {
      className: " bg-transparent w-full text-4xl placeholder-opacity-30 placeholder-white text-white focus:outline-none border-b-2 py-6 ",
      onChange: onChange,
      onFocus: onFocus,
      placeholder: "Type to search...",
      type: "text",
      value: query
    }), active && results.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      children: results.map(function (result, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          href: "/blog/".concat(result.attributes.permalink),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "search-card my-3 py-4 px-8 cursor-pointer",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "mb-3",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("b", {
                  className: "items-center px-3 py-0.5 rounded-full text-sm font-medium mr-4 bg-brand-black text-white uppercase z-10",
                  children: result.attributes.type
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: "text-[16px] md:text-[24px] font-bold text-white mb-3",
                children: result.attributes.title
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: "text-[14px] md:text-[16px] text-white",
                children: result.attributes.subtitle
              })]
            })
          }, result.id)
        }, index);
      })
    }), active && results.length == 0 && query.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      className: "font-vinila-extended text-[56px] my-24 text-white",
      children: "Ops! We didn\u2019t find what you looking for :("
    })]
  });
}
;// CONCATENATED MODULE: ./components/Navigation.tsx

















function Navigation(_ref) {
  var _ref$enableLanguages = _ref.enableLanguages,
      enableLanguages = _ref$enableLanguages === void 0 ? true : _ref$enableLanguages;

  var _useTheme = (0,index_modern/* useTheme */.F)(),
      theme = _useTheme.theme,
      setTheme = _useTheme.setTheme;

  var _useRouter = (0,router.useRouter)(),
      pathname = _useRouter.pathname;

  var intl = (0,useIntl/* default */.Z)();
  var ergoCommunity = intl.formatMessage({
    id: "navigation.ergoCommunity",
    defaultMessage: [{
      "type": 0,
      "value": "ERGO COMMUNITY"
    }]
  });
  var getErg = intl.formatMessage({
    id: "navigation.getErg",
    defaultMessage: [{
      "type": 0,
      "value": "GET ERG"
    }]
  });
  var discover = intl.formatMessage({
    id: "navigation.discover",
    defaultMessage: [{
      "type": 0,
      "value": "DISCOVER"
    }]
  });
  var ecosystem = intl.formatMessage({
    id: "navigation.ecosystem",
    defaultMessage: [{
      "type": 0,
      "value": "ECOSYSTEM"
    }]
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components_SecondaryMenu, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(popover/* Popover */.J, {
      className: "max-w-[1300px] mx-auto px-4 relative z-20",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "flex mx-0 mt-2 mb-10 lg:my-5 md:mx-0",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "my-auto flex-grow z-10",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: "/",
            passHref: true,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              className: "flex justify-center align-center",
              "aria-label": "Ergo Platform Home",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(icons/* LogoWithText */.uH, {
                viewBox: "0 0 213 82",
                className: "w-24 lg:w-32"
              })
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "hidden lg:block my-auto flex-grow",
          style: {
            zIndex: 12
          },
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
            text: ergoCommunity,
            url: "/community",
            textColor: "black",
            background: false,
            underline: pathname == '/community',
            customClass: " decoration-brand-orange dark:decoration-brand-orange underline-offset-2"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
            text: getErg,
            url: "/get-erg",
            textColor: "white",
            background: true,
            underline: pathname == '/get-erg',
            customClass: " text-white decoration-white dark:decoration-white underline-offset-2"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
            text: discover,
            url: "/discover",
            textColor: "black",
            background: false,
            underline: pathname == '/discover',
            customClass: " decoration-brand-orange dark:decoration-brand-orange underline-offset-2"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
            text: ecosystem,
            url: "/ecosystem",
            textColor: "black",
            background: false,
            underline: pathname == '/ecosystem',
            customClass: " decoration-brand-orange dark:decoration-brand-orange underline-offset-2"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "inline-flex",
          style: {
            zIndex: 12
          },
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "my-auto hidden xs:block",
            children: enableLanguages ? /*#__PURE__*/(0,jsx_runtime.jsx)(LanguageSwitcher, {}) : null
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "my-auto ml-5 lg:ml-10",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(DarkModeSwitch, {})
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "my-auto ml-5 lg:ml-10 z-40"
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(transition/* Transition */.u, {
        as: react.Fragment,
        enter: "transition-opacity duration-300",
        enterFrom: "opacity-0",
        enterTo: "opacity-100",
        leave: "transition-opacity duration-300",
        leaveFrom: "opacity-100",
        leaveTo: "opacity-0",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(popover/* Popover.Panel */.J.Panel, {
          className: "fixed overflow-auto inset-0 bg-brand-orange dark:bg-brand-black z-50",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "max-w-[1300px] mx-auto p-4",
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "flex mx-0 mt-2 mb-10 lg:my-10 md:mx-5",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "my-auto flex-grow",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                  href: "/",
                  passHref: true,
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                    className: "flex justify-center align-center",
                    "aria-label": "Ergo Platform Home",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(icons/* LogoWithTextWhite */.lp, {
                      viewBox: "0 0 213 82",
                      className: "w-24 lg:w-32"
                    })
                  })
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "inline-flex",
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "my-auto text-white hidden xs:block",
                  children: [enableLanguages ? /*#__PURE__*/(0,jsx_runtime.jsx)(LanguageSwitcher, {
                    color: "white"
                  }) : null, ' ']
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "my-auto ml-5 lg:ml-10",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(DarkModeSwitch, {})
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "my-auto ml-5 lg:ml-10",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(popover/* Popover.Button */.J.Button, {
                    "aria-label": "Close menu",
                    children: (0,icons_map/* getIconComponentByName */.l)('MenuClose')
                  })
                })]
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Search, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "mx-0 md:mx-4 mt-16 grid grid-cols-1 md:grid-cols-4 text-white",
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                  href: "/community",
                  passHref: true,
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                      className: "font-button mt-4 mb-10",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                        defaultMessage: [{
                          "type": 0,
                          "value": "COMMUNITY"
                        }],
                        id: "footer.community.title"
                      })
                    })
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
                  className: "hidden md:block",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                    className: "mb-2",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                      href: "/community/#JoinUs",
                      passHref: true,
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                          defaultMessage: [{
                            "type": 0,
                            "value": "Join our channels"
                          }],
                          id: "footer.community.1"
                        })
                      })
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                    className: "mb-2",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                      href: "/community/#Sigmanauts",
                      passHref: true,
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                          defaultMessage: [{
                            "type": 0,
                            "value": "Sigmanauts"
                          }],
                          id: "footer.community.2"
                        })
                      })
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                    className: "mb-2",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                      href: "/community/#Contribute",
                      passHref: true,
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                          defaultMessage: [{
                            "type": 0,
                            "value": "Contribute to Ergo"
                          }],
                          id: "footer.community.3"
                        })
                      })
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                    className: "mb-2",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                      href: "/community/#HallOfFame",
                      passHref: true,
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                          defaultMessage: [{
                            "type": 0,
                            "value": "Hall of Fame"
                          }],
                          id: "footer.community.4"
                        })
                      })
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                    className: "mb-2",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                      href: "/community/#Foundation",
                      passHref: true,
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                          defaultMessage: [{
                            "type": 0,
                            "value": "Ergo Foundation"
                          }],
                          id: "footer.community.5"
                        })
                      })
                    })
                  })]
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                  href: "/get-erg",
                  passHref: true,
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                      className: "font-button mt-4 mb-10",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                        defaultMessage: [{
                          "type": 0,
                          "value": "GET ERG"
                        }],
                        id: "footer.getErg.title"
                      })
                    })
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
                  className: "hidden md:block",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                    className: "mb-2",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                      href: "/get-erg/#Mining",
                      passHref: true,
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                          defaultMessage: [{
                            "type": 0,
                            "value": "Mining"
                          }],
                          id: "footer.getErg.1"
                        })
                      })
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                    className: "mb-2",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                      href: "/get-erg#MiningCalculator",
                      passHref: true,
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                          defaultMessage: [{
                            "type": 0,
                            "value": "Mining Calculator"
                          }],
                          id: "footer.getErg.2"
                        })
                      })
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                    className: "mb-2",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                      href: "/get-erg/#Wallets",
                      passHref: true,
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                          defaultMessage: [{
                            "type": 0,
                            "value": "Wallets"
                          }],
                          id: "footer.getErg.3"
                        })
                      })
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                    className: "mb-2",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                      href: "/get-erg/#Exchanges",
                      passHref: true,
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                          defaultMessage: [{
                            "type": 0,
                            "value": "Exchanges"
                          }],
                          id: "footer.getErg.4"
                        })
                      })
                    })
                  })]
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                  href: "/discover",
                  passHref: true,
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                      className: "font-button mt-4 mb-10",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                        defaultMessage: [{
                          "type": 0,
                          "value": "DISCOVER"
                        }],
                        id: "footer.discover.title"
                      })
                    })
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
                  className: "hidden md:block",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                    className: "mb-2",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                      href: "/discover/#DiscoverERG",
                      passHref: true,
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                          defaultMessage: [{
                            "type": 0,
                            "value": "Software Releases"
                          }],
                          id: "footer.discover.1"
                        })
                      })
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                    className: "mb-2",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                      href: "/discover/#GrantsAndBounties",
                      passHref: true,
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                          defaultMessage: [{
                            "type": 0,
                            "value": "Grants & Bounties"
                          }],
                          id: "footer.discover.2"
                        })
                      })
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                    className: "mb-2",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                      href: "/discover/#FAQ",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                          defaultMessage: [{
                            "type": 0,
                            "value": "FAQ"
                          }],
                          id: "footer.discover.3"
                        })
                      })
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                    className: "mb-2",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                      href: "/discover/#Explore",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                          defaultMessage: [{
                            "type": 0,
                            "value": "Explore"
                          }],
                          id: "footer.discover.4"
                        })
                      })
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                    className: "mb-2",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                      href: "/discover/#Documents",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                          defaultMessage: [{
                            "type": 0,
                            "value": "Documents"
                          }],
                          id: "footer.discover.5"
                        })
                      })
                    })
                  })]
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                  href: "/ecosystem",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                      className: "font-button mt-4 mb-8 md:mb-10",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                        defaultMessage: [{
                          "type": 0,
                          "value": "ECOSYSTEM"
                        }],
                        id: "footer.ecosystem.title"
                      })
                    })
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
                  className: "hidden md:block",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                    className: "mb-2",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                      href: "/ecosystem/#dApps",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                          defaultMessage: [{
                            "type": 0,
                            "value": "DApps"
                          }],
                          id: "footer.ecosystem.1"
                        })
                      })
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                    className: "mb-2",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                      href: "/ecosystem/#Roadmap",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                          defaultMessage: [{
                            "type": 0,
                            "value": "Roadmap"
                          }],
                          id: "footer.ecosystem.2"
                        })
                      })
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                    className: "mb-2",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                      href: "/ecosystem/#Wiki",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                          defaultMessage: [{
                            "type": 0,
                            "value": "Wiki"
                          }],
                          id: "footer.ecosystem.3"
                        })
                      })
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                    className: "mb-2",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                      href: "/ecosystem/#Favorites",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                          defaultMessage: [{
                            "type": 0,
                            "value": "Ergo Raffle"
                          }],
                          id: "footer.ecosystem.4"
                        })
                      })
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                    className: "mb-2",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                      href: "/ecosystem/#Videocasts",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                          defaultMessage: [{
                            "type": 0,
                            "value": "Videocasts"
                          }],
                          id: "footer.ecosystem.5"
                        })
                      })
                    })
                  })]
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "mt-10 w-80 hidden md:block",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                  className: "font-subtitle-2",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                    defaultMessage: [{
                      "type": 0,
                      "value": "More content?"
                    }],
                    id: "navigation.moreContent"
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                  className: "font-subtitle-2",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                    defaultMessage: [{
                      "type": 0,
                      "value": "We got it!"
                    }],
                    id: "footer.weGotIt"
                  })
                })]
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "mx-0 md:mx-4 text-white md:flex",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "my-6 flex-grow md:flex-grow",
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
                  className: "md:inline-flex",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                      href: "/blog",
                      passHref: true,
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                          className: "font-button mt-4 mb-14 mr-20",
                          children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                            defaultMessage: [{
                              "type": 0,
                              "value": "BLOG"
                            }],
                            id: "footer.blog.title"
                          })
                        })
                      })
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                      href: "/news",
                      passHref: true,
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                          className: "font-button mt-4 mb-14 mr-20",
                          children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                            defaultMessage: [{
                              "type": 0,
                              "value": "NEWS"
                            }],
                            id: "footer.news.title"
                          })
                        })
                      })
                    })
                  })]
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "my-6 dark",
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "grid overflow-hidden grid-cols-3 gap-6 text-red md:grid-cols-9",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "box mx-auto my-auto",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                      href: "https://sigmaverse.io",
                      target: "_blank",
                      rel: "noreferrer",
                      children: (0,icons_map/* getIconComponentByName */.l)('Sigmaverse')
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "box mx-auto my-auto",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                      href: "/ecosystem/#Wiki",
                      passHref: true,
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                        children: (0,icons_map/* getIconComponentByName */.l)('ErgoWiki')
                      })
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "box mx-auto my-auto",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                      href: "https://github.com/ergoplatform",
                      target: "_blank",
                      rel: "noreferrer",
                      children: (0,icons_map/* getIconComponentByName */.l)('Github')
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "box mx-auto my-auto",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                      href: "https://x.com/Ergo_Platform",
                      target: "_blank",
                      rel: "noreferrer",
                      children: (0,icons_map/* getIconComponentByName */.l)('X')
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "box mx-auto my-auto",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                      href: "https://www.youtube.com/c/ErgoPlatform",
                      target: "_blank",
                      rel: "noreferrer",
                      children: (0,icons_map/* getIconComponentByName */.l)('Youtube')
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "box mx-auto my-auto",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                      href: "https://t.me/Ergo_Chats",
                      target: "_blank",
                      rel: "noreferrer",
                      children: (0,icons_map/* getIconComponentByName */.l)('Telegram')
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "box mx-auto my-auto",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                      href: "https://discord.gg/ergo-platform-668903786361651200",
                      target: "_blank",
                      rel: "noreferrer",
                      children: (0,icons_map/* getIconComponentByName */.l)('Discord')
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "box mx-auto my-auto",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                      href: "https://reddit.com/r/ergonauts",
                      target: "_blank",
                      rel: "noreferrer",
                      children: (0,icons_map/* getIconComponentByName */.l)('Reddit')
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "box mx-auto my-auto",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                      href: "https://www.ergoforum.org/",
                      target: "_blank",
                      rel: "noreferrer",
                      children: (0,icons_map/* getIconComponentByName */.l)('Discourse')
                    })
                  })]
                })
              })]
            })]
          })
        })
      })]
    })]
  });
}

/* harmony default export */ var components_Navigation = (Navigation);
;// CONCATENATED MODULE: ./components/Layout.tsx






function Layout(_ref) {
  var children = _ref.children,
      title = _ref.title,
      desc = _ref.desc,
      _ref$footer = _ref.footer,
      footer = _ref$footer === void 0 ? true : _ref$footer;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("main", {
    className: "dark:bg-brand-black overflow-hidden min-h-screen",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        charSet: "utf-8"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: "".concat(title, " | Ergo Platform")
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "description",
        content: typeof desc !== 'undefined' && desc !== null ? String(desc) : 'Ergo is a next-generation smart contract platform focused on secure, accessible, and decentralized financial tools.'
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("header", {
      className: "w-full fixed top-0 left-0 right-0 z-50 h-16 md:h-20 lg:h-24",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_Navigation, {})
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "h-16 md:h-20 lg:h-24",
      "aria-hidden": "true"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "flex-grow",
      children: children
    }), footer && /*#__PURE__*/(0,jsx_runtime.jsx)(Footer, {})]
  });
}

/***/ }),

/***/ 7390:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var SvgArrowRightBlack = function SvgArrowRightBlack(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("svg", _objectSpread(_objectSpread({
    width: 18,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M1 8h16M10 1l7 7-7 7",
      stroke: "#000",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  }));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgArrowRightBlack);

/***/ }),

/***/ 1891:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var SvgArrowRightOrange = function SvgArrowRightOrange(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("svg", _objectSpread(_objectSpread({
    width: 18,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M1 8h16M10 1l7 7-7 7",
      stroke: "#FF5E18",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  }));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgArrowRightOrange);

/***/ }),

/***/ 346:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgCheckDark = function SvgCheckDark(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", _objectSpread(_objectSpread({
    width: 43,
    height: 42,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("ellipse", {
      cx: 21.497,
      cy: 20.765,
      rx: 21.497,
      ry: 20.753,
      fill: "#585858"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "m19.522 26.17-5.638-5.338 1.531-1.467 4.107 4.003 8.282-8.007 1.532 1.468-9.814 9.341Z",
      fill: "#807e7e"
    })]
  }));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgCheckDark);

/***/ }),

/***/ 6156:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgCheckDarkHighlited = function SvgCheckDarkHighlited(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", _objectSpread(_objectSpread({
    width: 54,
    height: 47,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("ellipse", {
      cx: 21.497,
      cy: 25.753,
      rx: 21.497,
      ry: 20.753,
      fill: "#585858"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "m19.522 31.158-5.638-5.338 1.531-1.468 4.107 4.003 8.282-8.006 1.532 1.468-9.814 9.34Z",
      fill: "#807e7e"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "m46.576 10.032.336-.432 1.128-2.352.096-.96h.336l.12.96L49.72 9.6l.312.432 2.52-1.752-.312-.432-1.872-1.824-.888-.384.096-.336.936.216 2.592-.336.528-.168-1.008-3.024-.48.168-2.304 1.248-.648.72-.288-.24.48-.792.456-2.592V0h-3.072v.504l.48 2.592.48.792-.312.24-.648-.72-2.28-1.248-.504-.168L43 5.016l.504.168 2.592.336.96-.216.072.336-.864.384-1.896 1.824-.288.432 2.496 1.752Z",
      fill: "#FF5E18"
    })]
  }));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgCheckDarkHighlited);

/***/ }),

/***/ 4793:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgCheckGreen = function SvgCheckGreen(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", _objectSpread(_objectSpread({
    width: 43,
    height: 42,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("ellipse", {
      cx: 21.497,
      cy: 20.778,
      rx: 21.497,
      ry: 20.753,
      fill: "url(#check-green_svg__a)"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "m19.522 26.183-5.638-5.338 1.531-1.468 4.107 4.003 8.282-8.006 1.532 1.468-9.814 9.34Z",
      fill: "#141414"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("defs", {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("linearGradient", {
        id: "check-green_svg__a",
        x1: 21.497,
        y1: 0.025,
        x2: 21.497,
        y2: 41.531,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          stopColor: "#00C68A"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: 1,
          stopColor: "#98FFD4"
        })]
      })
    })]
  }));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgCheckGreen);

/***/ }),

/***/ 6024:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgCheckOrange = function SvgCheckOrange(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", _objectSpread(_objectSpread({
    width: 51,
    height: 50,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
      filter: "url(#check-orange_svg__a)",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("ellipse", {
        cx: 25.497,
        cy: 20.753,
        rx: 21.497,
        ry: 20.753,
        fill: "url(#check-orange_svg__b)"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "m23.522 26.158-5.638-5.338 1.532-1.468 4.106 4.003 8.282-8.006 1.532 1.468-9.814 9.34Z",
        fill: "#fff"
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("defs", {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("linearGradient", {
        id: "check-orange_svg__b",
        x1: 25.497,
        y1: 0,
        x2: 25.497,
        y2: 41.506,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: 1,
          stopColor: "#FF7C44"
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("filter", {
        id: "check-orange_svg__a",
        x: 0,
        y: 0,
        width: 50.995,
        height: 49.506,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feColorMatrix", {
          "in": "SourceAlpha",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feOffset", {
          dy: 4
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feGaussianBlur", {
          stdDeviation: 2
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feComposite", {
          in2: "hardAlpha",
          operator: "out"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feColorMatrix", {
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feBlend", {
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_335_20996"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feBlend", {
          "in": "SourceGraphic",
          in2: "effect1_dropShadow_335_20996",
          result: "shape"
        })]
      })]
    })]
  }));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgCheckOrange);

/***/ }),

/***/ 8512:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgCheckOrangeHighlighted = function SvgCheckOrangeHighlighted(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", _objectSpread(_objectSpread({
    width: 54,
    height: 47,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("ellipse", {
      cx: 21.497,
      cy: 25.297,
      rx: 21.497,
      ry: 20.753,
      fill: "url(#check-orange-highlighted_svg__a)"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "m19.522 30.701-5.638-5.338 1.531-1.467 4.107 4.003 8.282-8.007 1.532 1.468-9.814 9.341Z",
      fill: "#fff"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "m46.576 10.032.336-.432 1.128-2.352.096-.96h.336l.12.96L49.72 9.6l.312.432 2.52-1.752-.312-.432-1.872-1.824-.888-.384.096-.336.936.216 2.592-.336.528-.168-1.008-3.024-.48.168-2.304 1.248-.648.72-.288-.24.48-.792.456-2.592V0h-3.072v.504l.48 2.592.48.792-.312.24-.648-.72-2.28-1.248-.504-.168L43 5.016l.504.168 2.592.336.96-.216.072.336-.864.384-1.896 1.824-.288.432 2.496 1.752Z",
      fill: "#FF5E18"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("defs", {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("linearGradient", {
        id: "check-orange-highlighted_svg__a",
        x1: 21.497,
        y1: 4.543,
        x2: 21.497,
        y2: 46.05,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: 1,
          stopColor: "#FF7C44"
        })]
      })
    })]
  }));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgCheckOrangeHighlighted);

/***/ }),

/***/ 3353:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgCoingecko = function SvgCoingecko(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", _objectSpread(_objectSpread({
    width: 40,
    height: 40,
    className: "fill-current text-black dark:text-white",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M40.2162 20.8258C40.2414 28.9225 35.4238 36.2372 27.9577 39.3649C20.4916 42.4926 11.8905 40.8279 6.13962 35.1274C0.388721 29.4269 -1.35168 20.8258 1.70033 13.3345C4.75234 5.84323 12.0419 0.949914 20.1133 0.899468C31.1863 0.874244 40.1658 9.77805 40.2162 20.8258Z",
      fill: "black"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M38.7281 20.8255C38.7533 28.3168 34.2888 35.0766 27.3777 37.9773C20.4665 40.8779 12.5212 39.3141 7.19907 34.0677C1.87697 28.796 0.262679 20.8507 3.08768 13.9395C5.91268 7.00314 12.6473 2.48818 20.1134 2.43773C30.354 2.38728 38.6777 10.6101 38.7281 20.8255Z",
      fill: "white"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M20.5674 3.624C21.7529 3.42221 22.9384 3.42221 24.1239 3.624C25.3094 3.80056 26.4696 4.20413 27.529 4.75904C28.5884 5.33918 29.4964 6.1211 30.4044 6.85257C31.3125 7.58404 32.2205 8.34074 33.0781 9.17311C33.9609 9.98025 34.7176 10.9135 35.3482 11.9224C36.004 12.9314 36.5337 14.016 36.9373 15.1258C37.7192 17.3959 37.9714 19.8425 37.5931 22.1631H37.4669C37.0886 19.8425 36.5589 17.6481 35.7265 15.5546C35.3482 14.4952 34.869 13.4611 34.3645 12.4773C33.8096 11.4936 33.2294 10.5099 32.5736 9.6019C31.9178 8.66864 31.0855 7.83628 30.1522 7.15525C29.219 6.47423 28.1344 6.04543 27.1002 5.64186C26.066 5.23829 25.0067 4.80949 23.9221 4.48159C22.8375 4.17891 21.7277 3.92668 20.5674 3.69967V3.624Z",
      fill: "white"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M29.5974 14.2932C28.2606 13.9149 26.8733 13.36 25.4608 12.8051C25.3851 12.4519 25.0572 12.0231 24.4266 11.4682C23.5186 10.6611 21.7782 10.6863 20.29 11.0394C18.6505 10.6611 17.011 10.5098 15.4472 10.8881C2.659 14.4194 9.89807 22.9953 5.20654 31.6468C5.86235 33.0593 13.0762 41.3325 23.4934 39.1129C23.4934 39.1129 19.9369 30.5622 27.9831 26.4508C34.5159 23.1214 39.2075 16.9165 29.5974 14.2932Z",
      fill: "black"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M20.29 11.0391C21.2233 11.1148 24.6032 12.1994 25.4608 12.8047C24.7293 10.7112 22.3079 10.4338 20.29 11.0391Z",
      fill: "black"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M31.1863 19.9183C31.1863 20.5993 30.3539 20.9524 29.8747 20.4732C29.3955 19.994 29.7234 19.1616 30.4044 19.1364C30.8332 19.1616 31.1863 19.4895 31.1863 19.9183ZM21.1727 16.3618C21.1727 17.7995 20.2899 19.1111 18.953 19.666C17.6162 20.221 16.0776 19.9183 15.0434 18.8841C14.0093 17.85 13.7066 16.3114 14.2615 14.9745C14.8164 13.6377 16.128 12.7549 17.5658 12.7549C18.5242 12.7549 19.4323 13.1332 20.0881 13.789C20.7943 14.4953 21.1727 15.4033 21.1727 16.3618Z",
      fill: "white"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M20.1135 16.3864C20.1135 17.3953 19.5082 18.3286 18.5497 18.7069C17.6164 19.0853 16.5318 18.8835 15.8004 18.152C15.0689 17.4206 14.8671 16.3612 15.2454 15.4027C15.6238 14.4694 16.5571 13.8389 17.566 13.8389C18.9785 13.8641 20.1135 14.9991 20.1135 16.3864Z",
      fill: "black"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M34.0873 21.5072C31.1866 23.5503 27.8824 25.0889 23.2161 25.0889C21.0216 25.0889 20.5928 22.7684 19.1299 23.9034C18.3732 24.4835 15.75 25.7951 13.6565 25.7195C11.5629 25.6186 8.18301 24.3826 7.24975 19.9434C6.8714 24.4079 6.69484 27.6869 5.00488 31.4452C8.33435 36.7925 16.2797 40.9039 23.4935 39.1382C22.7116 33.7152 27.4536 28.4184 30.102 25.7195C31.1362 24.6601 33.0783 22.9954 34.0873 21.5072Z",
      fill: "black"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M33.9607 21.6328C33.0527 22.4652 31.9933 23.0705 30.9087 23.6002C29.7989 24.1299 28.6639 24.5335 27.4784 24.8614C26.2929 25.1641 25.0569 25.3911 23.821 25.2902C22.5598 25.1893 21.2987 24.7605 20.4663 23.8272L20.5168 23.7768C21.5257 24.4326 22.7112 24.6596 23.8714 24.71C25.0569 24.7353 26.2424 24.6596 27.4027 24.4326C28.563 24.1804 29.7232 23.8272 30.8331 23.3732C31.9429 22.9192 33.0275 22.3895 33.986 21.6328H33.9607Z",
      fill: "white"
    })]
  }));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgCoingecko);

/***/ }),

/***/ 4985:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var SvgDiscord = function SvgDiscord(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("svg", _objectSpread(_objectSpread({
    width: 50,
    height: 40,
    className: "fill-current text-black dark:text-white",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M40.938 5.469h-.079a37.824 37.824 0 0 0-9.297-2.89c-.078 0-.078-.079-.078-.079l-.078.078c-.468.781-.86 1.64-1.172 2.422-1.718-.234-3.515-.39-5.312-.39-1.797 0-3.516.156-5.235.39-.312-.781-.703-1.64-1.171-2.422h-.157a37.823 37.823 0 0 0-9.297 2.89h-.078c-5.937 8.907-7.578 17.579-6.796 26.173 0 0 0 .078.078.078C5.625 34.297 9.53 36.25 13.75 37.5h.156c.86-1.25 1.64-2.5 2.344-3.828v-.078c0-.078-.078-.078-.078-.157-1.25-.468-2.5-1.015-3.594-1.718-.078 0-.078 0-.078-.078s0-.078.078-.157c.235-.156.469-.312.703-.547h.157c7.5 3.438 15.624 3.438 23.046 0h.157c.234.235.468.391.703.547.078.078.078.078.078.157 0 .078 0 .078-.078.078a21.622 21.622 0 0 1-3.594 1.718c-.078.079-.078.079-.078.157v.078a38.61 38.61 0 0 0 2.344 3.828h.156c4.14-1.25 8.047-3.203 11.484-5.781.078 0 .078-.078.078-.078.938-9.922-1.64-18.516-6.797-26.172ZM17.343 26.406c-2.266 0-4.14-2.11-4.14-4.61 0-2.577 1.874-4.608 4.14-4.608 2.343 0 4.14 2.03 4.14 4.609 0 2.5-1.875 4.61-4.14 4.61Zm15.234 0c-2.266 0-4.062-2.11-4.062-4.61 0-2.577 1.797-4.608 4.062-4.608 2.344 0 4.219 2.03 4.14 4.609 0 2.5-1.796 4.61-4.14 4.61Z"
    })
  }));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgDiscord);

/***/ }),

/***/ 9199:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var SvgDiscourse = function SvgDiscourse(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 50,
    height: 40
  }, props), {}, {
    className: "fill-current text-black dark:text-white",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M.506 24a.504.504 0 0 1-.354-.146.504.504 0 0 1-.146-.354L0 11.799C0 5.293 5.427 0 12.098 0 18.661.001 24 5.382 24 11.996c0 6.614-5.34 11.995-11.902 11.995L.506 24zm11.59-22.999a11.18 11.18 0 0 0-7.81 3.167C2.167 6.219 1 8.929 1 11.799L1.006 23l11.092-.009C18.109 22.99 23 18.058 23 11.996S18.109 1.001 12.098 1.001h-.002zM5.043 19.482a.498.498 0 0 1-.478-.646l1.115-3.655a7.079 7.079 0 0 1 6.319-10.252c3.899 0 7.071 3.172 7.071 7.071a7.079 7.079 0 0 1-9.912 6.477l-3.995.99a.493.493 0 0 1-.12.015zm6.956-13.553a6.078 6.078 0 0 0-5.342 8.965.5.5 0 0 1 .039.384l-.918 3.007 3.309-.82a.501.501 0 0 1 .334.033A6.078 6.078 0 0 0 18.07 12a6.078 6.078 0 0 0-6.071-6.071z"
    })
  }));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgDiscourse);

/***/ }),

/***/ 9082:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgErgoFoundationIcon = function SvgErgoFoundationIcon(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", _objectSpread(_objectSpread({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "m248 124-36.318-87.672L124 0 36.338 36.3 0 124l36.318 87.682L124 248l87.653-36.299L248 124ZM124 232.5l-76.715-31.785L15.5 124l31.785-76.706L124 15.5l76.706 31.765L232.5 124l-31.775 76.715L124 232.5Z",
      fill: "#fff"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M124 100.75v-15.5H62v15.5L85.25 124 62 147.25v15.5h62v-15.5H85.25L108.5 124l-23.25-23.25H124ZM155 147.25h-15.5v15.5H155v-15.5ZM155 85.25h-15.5v15.5H155v-15.5ZM170.5 85.25H155v15.5h15.5v-15.5ZM186 85.25h-15.5v15.5H186v-15.5Z",
      fill: "#fff"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M155 116.25h-15.5v15.5H155v-15.5ZM170.5 116.25H155v15.5h15.5v-15.5Z",
      fill: "#FF4221"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M170.5 116.25h-31v15.5h31v-15.5Z",
      fill: "#FF4221"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M186 85.25h-46.5v15.5H186v-15.5Z",
      fill: "#fff"
    })]
  }));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgErgoFoundationIcon);

/***/ }),

/***/ 7623:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgErgoFoundationIconLight = function SvgErgoFoundationIconLight(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", _objectSpread(_objectSpread({
    width: 248,
    height: 248,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "m248 124-36.318-87.672L124 0 36.338 36.3 0 124l36.318 87.682L124 248l87.653-36.299L248 124ZM124 232.5l-76.715-31.785L15.5 124l31.785-76.706L124 15.5l76.706 31.765L232.5 124l-31.775 76.715L124 232.5Z",
      fill: "#141414"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M124 100.75v-15.5H62v15.5L85.25 124 62 147.25v15.5h62v-15.5H85.25L108.5 124l-23.25-23.25H124ZM155 147.25h-15.5v15.5H155v-15.5ZM155 85.25h-15.5v15.5H155v-15.5ZM170.5 85.25H155v15.5h15.5v-15.5ZM186 85.25h-15.5v15.5H186v-15.5Z",
      fill: "#141414"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M155 116.25h-15.5v15.5H155v-15.5ZM170.5 116.25H155v15.5h15.5v-15.5Z",
      fill: "#FF4221"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M170.5 116.25h-31v15.5h31v-15.5Z",
      fill: "#FF4221"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M186 85.25h-46.5v15.5H186v-15.5Z",
      fill: "#141414"
    })]
  }));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgErgoFoundationIconLight);

/***/ }),

/***/ 6017:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgErgoNode = function SvgErgoNode(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", _objectSpread(_objectSpread({
    width: 125,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M22.008 30.04h9.097v4.227h-15.21v-3.842l5.985-6.626-5.956-6.207v-3.853h15.18v4.226h-8.903l5.521 5.782-5.714 6.292Z",
      fill: "#fff"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "m23.5 4.777 13.596 5.63 5.63 13.596-5.63 13.595L23.5 43.23 9.905 37.598 4.273 24.003l5.632-13.595L23.5 4.777ZM23.5.5c-.242 0-.48.048-.704.14L7.48 6.985a1.839 1.839 0 0 0-.996.996L.14 23.295c-.187.451-.187.958 0 1.409l6.345 15.314a1.835 1.835 0 0 0 .996.996l15.315 6.345a1.828 1.828 0 0 0 1.408 0l15.315-6.345a1.839 1.839 0 0 0 .996-.996l6.345-15.314a1.841 1.841 0 0 0 0-1.409L40.515 7.981a1.842 1.842 0 0 0-.996-.996L24.204.64A1.854 1.854 0 0 0 23.5.5ZM66.12 24.686h-3.938v2.666h4.62V29h-6.671v-9.953h6.658v1.661h-4.607v2.372h3.937v1.607Zm5.912-1.23a5.36 5.36 0 0 0-.71-.055c-.748 0-1.238.253-1.47.76V29h-1.976v-7.396h1.866l.055.881c.396-.679.946-1.018 1.647-1.018.22 0 .424.03.616.089l-.028 1.9Zm.533 1.791c0-1.135.27-2.048.807-2.741.542-.693 1.272-1.04 2.188-1.04.81 0 1.442.279 1.893.835l.082-.697h1.791v7.15c0 .647-.148 1.21-.444 1.688a2.81 2.81 0 0 1-1.238 1.094c-.533.25-1.157.376-1.873.376a4.02 4.02 0 0 1-1.585-.328c-.515-.214-.905-.492-1.17-.834l.876-1.203c.492.551 1.089.827 1.79.827.525 0 .933-.141 1.224-.424.292-.278.438-.674.438-1.19v-.396c-.456.515-1.055.773-1.798.773-.889 0-1.609-.347-2.16-1.04-.547-.697-.82-1.62-.82-2.768v-.082Zm1.976.144c0 .67.135 1.196.403 1.579.27.378.638.567 1.108.567.601 0 1.032-.226 1.292-.677v-3.11c-.265-.451-.69-.677-1.279-.677a1.3 1.3 0 0 0-1.12.581c-.27.388-.404.966-.404 1.737Zm6.002-.158c0-.733.141-1.387.424-1.962a3.108 3.108 0 0 1 1.217-1.332c.533-.315 1.15-.472 1.852-.472.998 0 1.812.305 2.44.916.634.61.987 1.44 1.06 2.488l.014.506c0 1.135-.317 2.046-.95 2.734-.634.684-1.484 1.026-2.55 1.026-1.067 0-1.919-.342-2.557-1.026-.633-.683-.95-1.613-.95-2.789v-.089Zm1.976.144c0 .702.132 1.24.396 1.613.264.37.643.554 1.135.554.478 0 .852-.182 1.12-.547.27-.37.404-.957.404-1.764 0-.688-.134-1.221-.403-1.6-.269-.377-.647-.567-1.135-.567-.483 0-.857.19-1.121.568-.264.373-.396.954-.396 1.743ZM100.477 29h-2.051l-3.992-6.549V29h-2.051v-9.953h2.05l4 6.562v-6.562h2.044V29Zm1.353-3.767c0-.733.141-1.387.424-1.962a3.104 3.104 0 0 1 1.217-1.332c.533-.315 1.15-.472 1.852-.472.998 0 1.812.305 2.441.916.633.61.986 1.44 1.059 2.488l.014.506c0 1.135-.317 2.046-.95 2.734-.634.684-1.484 1.026-2.55 1.026-1.066 0-1.919-.342-2.557-1.026-.633-.683-.95-1.613-.95-2.789v-.089Zm1.976.144c0 .702.132 1.24.396 1.613.264.37.643.554 1.135.554.478 0 .852-.182 1.121-.547.269-.37.403-.957.403-1.764 0-.688-.134-1.221-.403-1.6-.269-.377-.647-.567-1.135-.567-.483 0-.857.19-1.121.568-.264.373-.396.954-.396 1.743Zm5.94-.13c0-1.153.258-2.071.773-2.755.519-.683 1.228-1.025 2.126-1.025.72 0 1.314.269 1.784.806V18.5h1.982V29h-1.784l-.096-.786c-.492.615-1.125.923-1.9.923-.871 0-1.57-.342-2.099-1.026-.524-.688-.786-1.643-.786-2.864Zm1.976.144c0 .692.12 1.223.362 1.592.242.37.592.554 1.053.554.61 0 1.041-.257 1.292-.772v-2.92c-.246-.514-.672-.772-1.279-.772-.952 0-1.428.773-1.428 2.318Zm9.625 3.746c-1.085 0-1.969-.333-2.653-.998-.679-.666-1.018-1.552-1.018-2.66v-.19c0-.744.143-1.407.43-1.99a3.148 3.148 0 0 1 1.217-1.354c.529-.319 1.13-.478 1.805-.478 1.012 0 1.807.319 2.386.957.583.638.875 1.543.875 2.714v.806h-4.71c.064.483.255.87.574 1.162.323.292.731.438 1.224.438.761 0 1.355-.276 1.784-.827l.97 1.087c-.296.419-.697.747-1.203.984a3.979 3.979 0 0 1-1.681.349Zm-.226-6.07c-.392 0-.711.132-.957.396-.241.264-.396.642-.465 1.135h2.748v-.158c-.009-.437-.127-.774-.355-1.011-.228-.242-.552-.363-.971-.363Z",
      fill: "#fff"
    })]
  }));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgErgoNode);

/***/ }),

/***/ 4057:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgErgoWiki = function SvgErgoWiki(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", _objectSpread(_objectSpread({
    width: 40,
    height: 40,
    clipRule: "evenodd",
    fillRule: "evenodd",
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 369.72 377.19",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("defs", {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("style", {
        children: '.ergo-wiki_svg__str0{stroke:#000;strokeWidth:5.8;strokeMiterlimit:22.9256}.ergo-wiki_svg__fil0{fill:none}'
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      className: "ergo-wiki_svg__fil0 ergo-wiki_svg__str0",
      d: "M328.43 266.29c52.85-40.4 41.06-117.23 23.94-155.42-64.57-143.96-270.44-143.96-335.01 0C.23 149.05-11.55 225.88 41.3 266.29m143.35 31.09s83.05 1.91 126.14-9.77c6.25-1.69 11.66-3.68 15.86-5.99 0 0 8.5-14.69 1.78-15.33m4.65 60.38s-6.08-16.54-22.06-38.64m28.39 46.62c-24.73 16.59-55.51 20.28-55.51 20.28-3.86-4.8-1.32-9.49-1.32-9.49s35.67-8.43 53.22-19.69c0 0 5.32 3.18 3.61 8.9z"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      className: "ergo-wiki_svg__fil0 ergo-wiki_svg__str0",
      d: "m286.59 354.54 3.51 19.31 62.12.42c0-8.54-14.21-38.35-14.21-38.35m-63.04-30.97s5.19 31.5 8.88 39.56"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      className: "ergo-wiki_svg__fil0 ergo-wiki_svg__str0",
      d: "M278.78 325.7c2.73 20.02-8.13 37.23-8.13 37.23-15.97 13.36-155.62 13.36-171.59 0 0 0-10.86-17.21-8.13-37.23m-49.64-59.41c18.85 6.32 143.03 4.73 143.57 4.73s124.72 1.59 143.57-4.73"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      className: "ergo-wiki_svg__fil0 ergo-wiki_svg__str0",
      d: "M185.07 297.38s-83.05 1.91-126.14-9.77c-6.25-1.69-11.66-3.68-15.86-5.99 0 0-8.5-14.69-1.78-15.33m-4.65 60.38s6.08-16.54 22.06-38.64m-28.39 46.62c24.73 16.59 55.51 20.28 55.51 20.28 3.86-4.8 1.32-9.49 1.32-9.49s-35.67-8.43-53.22-19.69c0 0-5.32 3.18-3.61 8.9z"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      className: "ergo-wiki_svg__fil0 ergo-wiki_svg__str0",
      d: "M31.7 335.91s-14.21 29.81-13.83 38.35l62.5-.42 3.51-19.31m5.97-61.26c-.05.25-.65 2.86-.67 3.1-1.87 15.51 46.47 14.28 46.47 14.28l10.07 13.02 9.8-12.31 29.34.11 29.34-.11 9.8 12.31 10.07-13.02s48.34 1.23 46.47-14.28c-.03-.24-.62-2.85-.67-3.1"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      className: "ergo-wiki_svg__fil0 ergo-wiki_svg__str0",
      d: "M94.75 304.95s-5.19 31.5-8.88 39.56m31.37-34.56s-8.16.24-7.51 24.55c-.91 34.45 39.96 38.17 60.68 38 9.74-.08 19.17-.08 28.91 0 20.72.17 61.58-3.56 60.68-38 .65-24.3-7.51-24.55-7.51-24.55"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      className: "ergo-wiki_svg__fil0",
      stroke: "#000",
      strokeWidth: 4.35,
      strokeMiterlimit: 22.926,
      d: "M182.4 353.44h14.99v6.96h-25.06v-6.33l9.86-10.92-9.81-10.22v-6.35h25.01v6.96h-14.67l9.1 9.53z"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      className: "dark:fill-white",
      d: "M251.17 104.61h-20.94c-3.61 0-6.54 2.93-6.54 6.54s2.93 6.54 6.54 6.54h4.67l-25.61 71.72-25.62-71.72h4.67c3.61 0 6.54-2.93 6.54-6.54s-2.93-6.54-6.54-6.54H167.4c-3.61 0-6.54 2.93-6.54 6.54s2.93 6.54 6.54 6.54h2.37l8.13 22.77-17.48 48.95-25.62-71.72h4.67c3.61 0 6.54-2.93 6.54-6.54 0-3.62-2.93-6.54-6.54-6.54h-20.94c-3.61 0-6.54 2.93-6.54 6.54s2.93 6.54 6.54 6.54h2.37l30.03 84.09c1.45 4.06 5.17 6.68 9.48 6.68s8.03-2.62 9.48-6.68l14.95-41.86 14.95 41.86c1.45 4.06 5.17 6.68 9.48 6.68s8.03-2.62 9.48-6.68l30.03-84.09h2.37c3.61 0 6.54-2.93 6.54-6.54 0-3.62-2.93-6.54-6.55-6.54z"
    })]
  }));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgErgoWiki);

/***/ }),

/***/ 4193:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var SvgGithub = function SvgGithub(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("svg", _objectSpread(_objectSpread({
    width: 39,
    height: 40,
    className: "fill-current text-black dark:text-white",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M12.89 31.094c0-.157-.156-.313-.39-.313s-.39.157-.39.313.156.312.39.234c.234 0 .39-.078.39-.234Zm-2.421-.39c0 .155.156.39.39.39.157.078.391 0 .47-.157 0-.156-.079-.312-.313-.39-.235-.078-.47 0-.547.156Zm3.515-.079c-.234 0-.39.156-.39.39 0 .157.234.235.469.157.234-.078.39-.156.312-.313 0-.156-.234-.312-.39-.234Zm5.079-30C8.28.625 0 8.906 0 19.688c0 8.671 5.39 16.093 13.203 18.75 1.016.156 1.328-.47 1.328-.938v-4.844s-5.469 1.172-6.64-2.343c0 0-.86-2.266-2.11-2.813 0 0-1.797-1.25.078-1.25 0 0 1.954.156 3.047 2.031 1.719 3.047 4.531 2.188 5.703 1.64.157-1.25.625-2.108 1.25-2.655-4.375-.47-8.828-1.094-8.828-8.594 0-2.188.625-3.203 1.875-4.61-.234-.546-.86-2.578.235-5.312 1.562-.469 5.39 2.11 5.39 2.11 1.563-.47 3.203-.626 4.844-.626 1.719 0 3.36.157 4.922.625 0 0 3.75-2.656 5.39-2.109 1.094 2.734.391 4.766.235 5.313 1.25 1.406 2.031 2.421 2.031 4.609 0 7.5-4.61 8.125-8.984 8.594.703.625 1.328 1.797 1.328 3.672 0 2.578-.078 5.859-.078 6.484 0 .547.39 1.172 1.406.937 7.813-2.578 13.125-10 13.125-18.672C38.75 8.908 29.922.625 19.062.625ZM7.578 27.578c-.156.078-.078.313 0 .469.156.078.313.156.469.078.078-.078.078-.313-.078-.469-.157-.078-.313-.156-.39-.078Zm-.86-.625c-.077.156 0 .235.157.313.156.078.313.078.39-.078 0-.079-.077-.157-.234-.235-.156-.078-.234-.078-.312 0Zm2.5 2.813c-.077.078-.077.312.157.468.156.157.39.235.469.078.078-.078.078-.312-.078-.468-.157-.157-.391-.235-.547-.078Zm-.859-1.172c-.156.078-.156.312 0 .468.157.157.313.235.47.157.077-.078.077-.313 0-.469-.157-.156-.313-.234-.47-.156Z"
    })
  }));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgGithub);

/***/ }),

/***/ 8029:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var SvgHighlight = function SvgHighlight(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("svg", _objectSpread(_objectSpread({
    width: 12,
    height: 11,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "m4.076 10.532.336-.432L5.54 7.748l.096-.96h.336l.12.96L7.22 10.1l.312.432 2.52-1.752-.312-.432-1.872-1.824-.888-.384.096-.336.936.216 2.592-.336.528-.168-1.008-3.024-.48.168L7.34 3.908l-.648.72-.288-.24.48-.792.456-2.592V.5H4.268v.504l.48 2.592.48.792-.312.24-.648-.72-2.28-1.248-.504-.168L.5 5.516l.504.168 2.592.336.96-.216.072.336-.864.384-1.896 1.824-.288.432 2.496 1.752Z",
      fill: "#FF5E18"
    })
  }));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgHighlight);

/***/ }),

/***/ 2720:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgHighlights1 = function SvgHighlights1(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", _objectSpread(_objectSpread({
    width: 562,
    height: 562,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("g", {
      filter: "url(#highlights-1_svg__a)",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("circle", {
        cx: 281.287,
        cy: 280.374,
        r: 184.826,
        transform: "rotate(40.411 281.287 280.374)",
        fill: "url(#highlights-1_svg__b)"
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("g", {
      filter: "url(#highlights-1_svg__c)",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M410.033 129.163a199.241 199.241 0 1 1-46.654-29.65L280.87 280.866l129.163-151.704Z",
        fill: "url(#highlights-1_svg__d)",
        shapeRendering: "crispEdges"
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("defs", {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("linearGradient", {
        id: "highlights-1_svg__b",
        x1: 146.755,
        y1: 135.148,
        x2: 445.478,
        y2: 680.799,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          stopColor: "#EFEFEF"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: 1,
          stopColor: "#292835",
          stopOpacity: 0
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("linearGradient", {
        id: "highlights-1_svg__d",
        x1: 302.54,
        y1: 524.219,
        x2: 120.856,
        y2: 81.25,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: 1,
          stopColor: "#FF5E18",
          stopOpacity: 0
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("filter", {
        id: "highlights-1_svg__a",
        x: 96.457,
        y: 95.545,
        width: 369.659,
        height: 369.659,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feBlend", {
          "in": "SourceGraphic",
          in2: "BackgroundImageFix",
          result: "shape"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feColorMatrix", {
          "in": "SourceAlpha",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feOffset", {
          dy: 2
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feComposite", {
          in2: "hardAlpha",
          operator: "arithmetic",
          k2: -1,
          k3: 1
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feColorMatrix", {
          values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.11 0"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feBlend", {
          in2: "shape",
          result: "effect1_innerShadow_705_20471"
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("filter", {
        id: "highlights-1_svg__c",
        x: 77.627,
        y: 81.625,
        width: 406.485,
        height: 406.485,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feColorMatrix", {
          "in": "SourceAlpha",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feOffset", {
          dy: 4
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feGaussianBlur", {
          stdDeviation: 2
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feComposite", {
          in2: "hardAlpha",
          operator: "out"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feColorMatrix", {
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feBlend", {
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_705_20471"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feBlend", {
          "in": "SourceGraphic",
          in2: "effect1_dropShadow_705_20471",
          result: "shape"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feColorMatrix", {
          "in": "SourceAlpha",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feOffset", {
          dy: 2
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feComposite", {
          in2: "hardAlpha",
          operator: "arithmetic",
          k2: -1,
          k3: 1
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feColorMatrix", {
          values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feBlend", {
          in2: "shape",
          result: "effect2_innerShadow_705_20471"
        })]
      })]
    })]
  }));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgHighlights1);

/***/ }),

/***/ 1191:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgHighlights1 = function SvgHighlights1(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", _objectSpread(_objectSpread({
    width: 562,
    height: 562,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("g", {
      filter: "url(#highlights-1big_svg__a)",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("circle", {
        cx: 281.287,
        cy: 280.374,
        r: 184.826,
        transform: "rotate(40.411 281.287 280.374)",
        fill: "url(#highlights-1big_svg__b)"
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("g", {
      filter: "url(#highlights-1big_svg__c)",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M410.033 129.163a199.241 199.241 0 1 1-46.654-29.65L280.87 280.866l129.163-151.704Z",
        fill: "url(#highlights-1big_svg__d)",
        shapeRendering: "crispEdges"
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("defs", {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("linearGradient", {
        id: "highlights-1big_svg__b",
        x1: 146.755,
        y1: 135.148,
        x2: 445.478,
        y2: 680.799,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          stopColor: "#EFEFEF"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: 1,
          stopColor: "#292835",
          stopOpacity: 0
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("linearGradient", {
        id: "highlights-1big_svg__d",
        x1: 302.54,
        y1: 524.219,
        x2: 120.856,
        y2: 81.25,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: 1,
          stopColor: "#FF5E18",
          stopOpacity: 0
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("filter", {
        id: "highlights-1big_svg__a",
        x: 96.457,
        y: 95.545,
        width: 369.659,
        height: 369.659,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feBlend", {
          "in": "SourceGraphic",
          in2: "BackgroundImageFix",
          result: "shape"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feColorMatrix", {
          "in": "SourceAlpha",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feOffset", {
          dy: 2
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feComposite", {
          in2: "hardAlpha",
          operator: "arithmetic",
          k2: -1,
          k3: 1
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feColorMatrix", {
          values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.11 0"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feBlend", {
          in2: "shape",
          result: "effect1_innerShadow_705_20471"
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("filter", {
        id: "highlights-1big_svg__c",
        x: 77.627,
        y: 81.625,
        width: 406.485,
        height: 406.485,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feColorMatrix", {
          "in": "SourceAlpha",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feOffset", {
          dy: 4
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feGaussianBlur", {
          stdDeviation: 2
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feComposite", {
          in2: "hardAlpha",
          operator: "out"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feColorMatrix", {
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feBlend", {
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_705_20471"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feBlend", {
          "in": "SourceGraphic",
          in2: "effect1_dropShadow_705_20471",
          result: "shape"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feColorMatrix", {
          "in": "SourceAlpha",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feOffset", {
          dy: 2
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feComposite", {
          in2: "hardAlpha",
          operator: "arithmetic",
          k2: -1,
          k3: 1
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feColorMatrix", {
          values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feBlend", {
          in2: "shape",
          result: "effect2_innerShadow_705_20471"
        })]
      })]
    })]
  }));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgHighlights1);

/***/ }),

/***/ 1104:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgHighlights2 = function SvgHighlights2(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", _objectSpread(_objectSpread({
    width: 416,
    height: 402,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M211.291.025C96.373-1.766.268 92.604.001 207.586a208.193 208.193 0 0 0 34.819 115.75 208.085 208.085 0 0 0 93.25 76.875 10.393 10.393 0 0 0 13.954-6.828l33.872-120.414a10.357 10.357 0 0 0-4.07-11.365 64.513 64.513 0 0 1-21.489-24.35 64.545 64.545 0 0 1-6.906-31.739 64.86 64.86 0 0 1 18.747-42.917 64.82 64.82 0 0 1 42.753-19.093 64.62 64.62 0 0 1 25.648 4.011 64.625 64.625 0 0 1 36.801 35.119 64.67 64.67 0 0 1 5.214 25.439 64.54 64.54 0 0 1-7.515 30.289 64.516 64.516 0 0 1-20.846 23.218 10.403 10.403 0 0 0-4.139 11.411l33.86 120.414a10.409 10.409 0 0 0 5.445 6.547 10.4 10.4 0 0 0 8.509.281 208.06 208.06 0 0 0 93.118-76.669 208.164 208.164 0 0 0 34.951-115.467 208.108 208.108 0 0 0-59.745-145.97A207.966 207.966 0 0 0 211.291.025Z",
      fill: "url(#highlights-2_svg__a)"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("defs", {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("linearGradient", {
        id: "highlights-2_svg__a",
        x1: 124.5,
        y1: 0,
        x2: 295.5,
        y2: 434,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: 1,
          stopColor: "#F6F6F6"
        })]
      })
    })]
  }));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgHighlights2);

/***/ }),

/***/ 7655:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgHighlights2 = function SvgHighlights2(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", _objectSpread(_objectSpread({
    width: 416,
    height: 402,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M211.291.025C96.373-1.766.268 92.604.001 207.586a208.193 208.193 0 0 0 34.819 115.75 208.085 208.085 0 0 0 93.25 76.875 10.393 10.393 0 0 0 13.954-6.828l33.872-120.414a10.357 10.357 0 0 0-4.07-11.365 64.513 64.513 0 0 1-21.489-24.35 64.545 64.545 0 0 1-6.906-31.739 64.86 64.86 0 0 1 18.747-42.917 64.82 64.82 0 0 1 42.753-19.093 64.62 64.62 0 0 1 25.648 4.011 64.625 64.625 0 0 1 36.801 35.119 64.67 64.67 0 0 1 5.214 25.439 64.54 64.54 0 0 1-7.515 30.289 64.516 64.516 0 0 1-20.846 23.218 10.403 10.403 0 0 0-4.139 11.411l33.86 120.414a10.409 10.409 0 0 0 5.445 6.547 10.4 10.4 0 0 0 8.509.281 208.06 208.06 0 0 0 93.118-76.669 208.164 208.164 0 0 0 34.951-115.467 208.108 208.108 0 0 0-59.745-145.97A207.966 207.966 0 0 0 211.291.025Z",
      fill: "url(#highlights-2big_svg__a)"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("defs", {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("linearGradient", {
        id: "highlights-2big_svg__a",
        x1: 124.5,
        y1: 0,
        x2: 295.5,
        y2: 434,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: 1,
          stopColor: "#F6F6F6"
        })]
      })
    })]
  }));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgHighlights2);

/***/ }),

/***/ 4881:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgHighlights3 = function SvgHighlights3(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", _objectSpread(_objectSpread({
    width: 528,
    height: 257,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M528 128.499c-145.923 171.335-382.077 171.335-528 0 145.916-171.332 382.077-171.332 528 0Z",
      fill: "url(#highlights-3_svg__a)"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("circle", {
      cx: 264,
      cy: 128,
      r: 107,
      fill: "#F6F6F6"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "m312.955 73.425-44.968-18.628a10.333 10.333 0 0 0-7.958 0l-44.976 18.628a10.316 10.316 0 0 0-5.629 5.624l-18.627 44.97a10.348 10.348 0 0 0 0 7.962l18.627 44.97a10.316 10.316 0 0 0 5.629 5.624l44.968 18.628a10.334 10.334 0 0 0 7.958 0l44.968-18.628a10.38 10.38 0 0 0 3.38-2.249 10.39 10.39 0 0 0 2.249-3.375l18.627-44.97a10.334 10.334 0 0 0 0-7.958l-18.627-44.974a10.327 10.327 0 0 0-5.621-5.624Zm-6.903 101.201-39.547 16.378-16.379-39.548 39.568-16.379 16.358 39.549ZM217.37 85.941l39.547 16.378-16.378 39.549-39.548-16.379 16.379-39.548Zm71.006 38.066a9.089 9.089 0 0 0-.32.891l-35.804 14.829 14.832-35.802c.299-.096.595-.199.891-.319l34.826-14.426-14.425 34.827Zm-24.224-60.002 35.585 14.741-35.901 14.873c-.291.12-.579.255-.859.4l-35.796-14.83 36.659-15.18a.398.398 0 0 1 .324.012l-.012-.016Zm-45.284 109.33a.399.399 0 0 1-.22-.224l-14.741-35.585 35.741 14.804 14.809 35.746-35.589-14.741Zm109.103-45.509a.393.393 0 0 1 0 .316l-15.18 36.66-14.828-35.801c.144-.28.28-.563.4-.859l14.868-35.902 14.74 35.586Z",
      fill: "#807e7e"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("defs", {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("linearGradient", {
        id: "highlights-3_svg__a",
        x1: 111.643,
        y1: 46.567,
        x2: 656.412,
        y2: 337.155,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: 1,
          stopColor: "#F6F6F6"
        })]
      })
    })]
  }));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgHighlights3);

/***/ }),

/***/ 8283:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgHighlights3 = function SvgHighlights3(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", _objectSpread(_objectSpread({
    width: 528,
    height: 257,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M528 128.499c-145.923 171.335-382.077 171.335-528 0 145.916-171.332 382.077-171.332 528 0Z",
      fill: "url(#highlights-3big_svg__a)"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("circle", {
      cx: 264,
      cy: 128,
      r: 107,
      fill: "#F6F6F6"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "m312.955 73.425-44.968-18.628a10.333 10.333 0 0 0-7.958 0l-44.976 18.628a10.316 10.316 0 0 0-5.629 5.624l-18.627 44.97a10.348 10.348 0 0 0 0 7.962l18.627 44.97a10.316 10.316 0 0 0 5.629 5.624l44.968 18.628a10.334 10.334 0 0 0 7.958 0l44.968-18.628a10.38 10.38 0 0 0 3.38-2.249 10.39 10.39 0 0 0 2.249-3.375l18.627-44.97a10.334 10.334 0 0 0 0-7.958l-18.627-44.974a10.327 10.327 0 0 0-5.621-5.624Zm-6.903 101.201-39.547 16.378-16.379-39.548 39.568-16.379 16.358 39.549ZM217.37 85.941l39.547 16.378-16.378 39.549-39.548-16.379 16.379-39.548Zm71.006 38.066a9.089 9.089 0 0 0-.32.891l-35.804 14.829 14.832-35.802c.299-.096.595-.199.891-.319l34.826-14.426-14.425 34.827Zm-24.224-60.002 35.585 14.741-35.901 14.873c-.291.12-.579.255-.859.4l-35.796-14.83 36.659-15.18a.398.398 0 0 1 .324.012l-.012-.016Zm-45.284 109.33a.399.399 0 0 1-.22-.224l-14.741-35.585 35.741 14.804 14.809 35.746-35.589-14.741Zm109.103-45.509a.393.393 0 0 1 0 .316l-15.18 36.66-14.828-35.801c.144-.28.28-.563.4-.859l14.868-35.902 14.74 35.586Z",
      fill: "#807e7e"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("defs", {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("linearGradient", {
        id: "highlights-3big_svg__a",
        x1: 111.643,
        y1: 46.567,
        x2: 656.412,
        y2: 337.155,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: 1,
          stopColor: "#F6F6F6"
        })]
      })
    })]
  }));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgHighlights3);

/***/ }),

/***/ 5713:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var SvgLanguageSelector = function SvgLanguageSelector(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("svg", _objectSpread(_objectSpread({
    width: 17,
    height: 10,
    xmlns: "http://www.w3.org/2000/svg",
    className: "fill-current text-black dark:text-white"
  }, props), {}, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M0 1.415 8.485 9.9l8.485-8.485L15.556 0 8.485 7.072 1.414 0 0 1.415Z"
    })
  }));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgLanguageSelector);

/***/ }),

/***/ 3928:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var SvgLanguageSelectorWhite = function SvgLanguageSelectorWhite(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("svg", _objectSpread(_objectSpread({
    width: 17,
    height: 10,
    xmlns: "http://www.w3.org/2000/svg",
    className: "fill-current text-white"
  }, props), {}, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M0 1.415 8.485 9.9l8.485-8.485L15.556 0 8.485 7.072 1.414 0 0 1.415Z"
    })
  }));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgLanguageSelectorWhite);

/***/ }),

/***/ 3265:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var SvgLedger = function SvgLedger(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("svg", _objectSpread(_objectSpread({
    width: 90,
    height: 34,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M28.084.842H13.125V20.79h20.077V6.032c.008-2.802-2.297-5.19-5.117-5.19Zm-19.553 0h-2.51C3.202.842.792 3.124.792 6.04v2.493h7.74V.843ZM.791 13.203h7.74v7.691H.791v-7.69ZM25.468 33.15h2.51c2.82 0 5.23-2.282 5.23-5.198v-2.485h-7.74v7.683Zm-12.344-7.683h7.741v7.69h-7.74v-7.69Zm-12.335 0v2.493c0 2.802 2.297 5.198 5.232 5.198h2.51v-7.691H.79ZM48.281 20.352h4.355V22H46.23v-9.953h2.051v8.305Zm8.812 1.785c-1.085 0-1.97-.333-2.653-.998-.679-.666-1.018-1.552-1.018-2.66v-.19c0-.744.143-1.407.43-1.99a3.142 3.142 0 0 1 1.217-1.354c.529-.319 1.13-.478 1.805-.478 1.012 0 1.807.319 2.386.957.583.638.875 1.543.875 2.714v.806h-4.71c.064.483.255.87.574 1.162.323.292.731.438 1.223.438.762 0 1.356-.276 1.785-.827l.97 1.087a2.99 2.99 0 0 1-1.203.984 3.98 3.98 0 0 1-1.681.349Zm-.226-6.07c-.392 0-.71.132-.957.396-.241.264-.396.642-.465 1.135h2.748v-.158c-.009-.437-.127-.774-.355-1.011-.228-.242-.552-.363-.97-.363Zm4.088 2.18c0-1.153.257-2.071.772-2.755.52-.683 1.229-1.025 2.126-1.025.72 0 1.315.269 1.785.806V11.5h1.982V22h-1.784l-.096-.786c-.492.615-1.125.923-1.9.923-.87 0-1.57-.342-2.099-1.026-.524-.688-.786-1.643-.786-2.864Zm1.976.144c0 .692.12 1.223.362 1.592.241.37.592.554 1.053.554.61 0 1.04-.257 1.292-.772v-2.92c-.247-.514-.673-.772-1.279-.772-.952 0-1.428.773-1.428 2.318Zm5.933-.144c0-1.135.269-2.048.807-2.741.542-.693 1.271-1.04 2.187-1.04.811 0 1.443.279 1.894.835l.082-.697h1.79v7.15c0 .647-.147 1.21-.444 1.688a2.81 2.81 0 0 1-1.237 1.094c-.533.25-1.157.376-1.873.376a4.02 4.02 0 0 1-1.586-.328c-.515-.214-.904-.492-1.169-.834l.875-1.203c.493.551 1.09.827 1.791.827.524 0 .932-.141 1.224-.424.292-.278.438-.674.438-1.19v-.396c-.456.515-1.056.773-1.798.773-.89 0-1.61-.347-2.16-1.04-.547-.697-.82-1.62-.82-2.768v-.082Zm1.976.144c0 .67.134 1.196.403 1.579.269.378.638.567 1.108.567.601 0 1.032-.226 1.291-.677v-3.11c-.264-.451-.69-.677-1.278-.677a1.3 1.3 0 0 0-1.121.581c-.269.388-.403.966-.403 1.737Zm9.714 3.746c-1.085 0-1.97-.333-2.653-.998-.679-.666-1.018-1.552-1.018-2.66v-.19c0-.744.143-1.407.43-1.99a3.142 3.142 0 0 1 1.217-1.354c.529-.319 1.13-.478 1.805-.478 1.012 0 1.807.319 2.386.957.583.638.875 1.543.875 2.714v.806h-4.71c.063.483.255.87.574 1.162.323.292.731.438 1.224.438.76 0 1.355-.276 1.784-.827l.97 1.087c-.296.419-.697.747-1.203.984a3.98 3.98 0 0 1-1.681.349Zm-.226-6.07c-.392 0-.71.132-.957.396-.242.264-.396.642-.465 1.135h2.748v-.158c-.009-.437-.127-.774-.355-1.011-.228-.242-.552-.363-.971-.363Zm8.552.39a5.361 5.361 0 0 0-.711-.056c-.748 0-1.237.253-1.47.76V22h-1.975v-7.396h1.866l.054.881c.397-.679.946-1.018 1.648-1.018.219 0 .424.03.615.089l-.027 1.9Z",
      fill: "#fff"
    })
  }));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgLedger);

/***/ }),

/***/ 7810:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var SvgLine = function SvgLine(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 345.333,
    height: 337.333,
    viewBox: "0 0 259 253"
  }, props), {}, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M122.2 4c-28.9 7.3-39 13.5-42.7 26.5-3.9 13.2 3.4 28.8 16.3 35.2 5.2 2.5 6.7 2.8 16.2 2.7 8.3 0 13.2-.7 23.5-3.3 30.7-7.6 53.7-11.3 72-11.4 10.1 0 12.7.3 16.8 2.1 4 1.8 4.7 2.5 4.7 5 0 5.7-7.8 10.5-28.2 17.1-17.5 5.7-45.1 12.6-116.8 29.5-90.9 21.4-84.4 19.7-82.4 21.5.5.4 15.5 9.7 33.4 20.6 44.3 27.1 102.5 63 137.9 85.2 16.1 10.1 29.5 18.3 29.6 18.1.2-.2-2.3-12.9-5.6-28.3s-8.4-40.8-11.4-56.4c-3-15.6-5.6-28.5-5.7-28.6-.4-.3-26.9 6.3-27.4 6.8-.3.2 1.6 10.7 4.1 23.2 2.4 12.6 4.3 23 4.2 23.1-.1.1-9.6-5.6-21.2-12.8-11.5-7.2-30.4-18.7-42-25.7-11.6-7-21.1-13.1-21.3-13.5-.1-.5 11.8-3.9 26.5-7.6 14.7-3.7 30.2-7.7 34.3-8.9 4.1-1.2 17.4-4.4 29.5-7.2 26.1-5.9 36.3-8.8 50.5-14.1 22.4-8.4 33.5-15.8 38.7-26.2 2.3-4.6 2.5-5.8 2.1-14.6-.6-12.4-2.8-17.3-9.9-23-11-8.8-20.8-11.4-41.9-11.3-16.7.1-34.7 2.5-57.9 7.8-8.4 1.9-20.1 4.4-25.9 5.5-9.7 1.9-10.7 1.9-12.1.5-1.5-1.5-1.4-1.8.4-3.1 2.9-2.2 15.1-5.8 31.5-9.4 7.9-1.7 14.6-3.3 14.7-3.4.2-.2-3.5-5.8-8.3-12.4C138.4-1 140.1-.5 122.2 4z"
    })
  }));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgLine);

/***/ }),

/***/ 1979:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("svg", _objectSpread(_objectSpread({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M26 0H1.937C.875 0 0 .938 0 2.063V26c0 1.125.875 2 1.938 2H26c1.063 0 2-.875 2-2V2.062C28 .938 27.062 0 26 0ZM8.437 24H4.314V10.687h4.125V24ZM6.376 8.812C5 8.813 3.937 7.75 3.937 6.438A2.44 2.44 0 0 1 6.376 4C7.688 4 8.75 5.125 8.75 6.438a2.374 2.374 0 0 1-2.375 2.375ZM24 24h-4.188v-6.5c0-1.5 0-3.5-2.125-3.5-2.187 0-2.5 1.688-2.5 3.438V24h-4.124V10.687H15V12.5h.063C15.624 11.437 17 10.312 19 10.312c4.188 0 5 2.813 5 6.376V24Z",
      fill: "#FF5E18"
    })
  }));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgLinkedin);

/***/ }),

/***/ 3715:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", _objectSpread(_objectSpread({
    width: 82,
    height: 82,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      className: "fill-black dark:fill-white",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M38.396 51.536h15.871v7.376H27.732V52.21l10.442-11.56-10.392-10.83v-6.722h26.485v7.374H38.733l9.633 10.087-9.97 10.978Z"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      className: "fill-black dark:fill-white",
      d: "m41 7.462 23.719 9.823 9.824 23.72-9.824 23.72-23.72 9.825-23.719-9.826-9.825-23.72 9.825-23.719L41 7.462ZM41 0c-.422 0-.84.083-1.23.244l-26.718 11.07a3.209 3.209 0 0 0-1.738 1.737L.244 39.771a3.212 3.212 0 0 0 0 2.457l11.07 26.719a3.203 3.203 0 0 0 1.738 1.737l26.719 11.07a3.191 3.191 0 0 0 2.457 0l26.72-11.07a3.208 3.208 0 0 0 1.737-1.737l11.07-26.72a3.212 3.212 0 0 0 0-2.457l-11.07-26.719a3.215 3.215 0 0 0-1.738-1.737L42.228.244A3.234 3.234 0 0 0 41 0Z"
    })]
  }));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgLogo);

/***/ }),

/***/ 5204:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgLogoWhite = function SvgLogoWhite(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", _objectSpread(_objectSpread({
    width: 82,
    height: 82,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M38.396 51.536h15.871v7.376H27.732V52.21l10.442-11.56-10.392-10.83v-6.722h26.485v7.374H38.733l9.633 10.087-9.97 10.978Z",
      fill: "#fff"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "m41 7.462 23.719 9.823 9.824 23.72-9.824 23.72-23.72 9.825-23.719-9.826-9.825-23.72 9.825-23.719L41 7.462ZM41 0c-.422 0-.84.083-1.23.244l-26.718 11.07a3.209 3.209 0 0 0-1.738 1.737L.244 39.771a3.212 3.212 0 0 0 0 2.457l11.07 26.719a3.203 3.203 0 0 0 1.738 1.737l26.719 11.07a3.191 3.191 0 0 0 2.457 0l26.72-11.07a3.208 3.208 0 0 0 1.737-1.737l11.07-26.72a3.212 3.212 0 0 0 0-2.457l-11.07-26.719a3.215 3.215 0 0 0-1.738-1.737L42.228.244A3.234 3.234 0 0 0 41 0Z",
      fill: "#fff"
    })]
  }));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgLogoWhite);

/***/ }),

/***/ 6586:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgLogoWithText = function SvgLogoWithText(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", _objectSpread(_objectSpread({
    width: 213,
    height: 82,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      className: "fill-black dark:fill-white",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M97.365 31.142v6.241h15.372v6.512h-15.38v6.795h15.704v6.506H90.213V24.638h22.856v6.504H97.365Zm31.099 14.55h-3.986v11.506h-7.154v-32.56h14.407c6.311 0 10.943 4.107 10.943 10.531 0 2.565-.745 5.026-2.489 6.95a9.442 9.442 0 0 1-4.29 2.677l7.713 12.4h-8.306l-6.838-11.505Zm-3.986-14.55v8.045h6.514c2.457 0 4.392-1.457 4.392-4.021 0-2.565-1.935-4.024-4.392-4.024h-6.514Zm44.39 17.808v-3.536h-9.189v-6.506h16.343v12.759l-.226.25c-3.489 3.86-8.15 5.876-13.35 5.876-9.726 0-17.04-7.039-17.04-16.856 0-9.818 7.32-16.808 17.04-16.808 5.49 0 9.991 2.305 13.141 6.793l.554.78-5.966 3.356-.454-.65a8.944 8.944 0 0 0-7.275-3.736c-5.851 0-9.751 4.535-9.751 10.255 0 5.72 3.887 10.303 9.751 10.303 2.169 0 4.722-.858 6.422-2.29v.01Zm10.117-8.014c0-9.667 6.898-16.807 16.624-16.807 9.726 0 16.622 7.14 16.622 16.808 0 9.667-6.898 16.805-16.622 16.805s-16.624-7.136-16.624-16.805Zm25.956 0c0-5.642-3.417-10.254-9.332-10.254-5.915 0-9.334 4.59-9.334 10.255 0 5.663 3.415 10.258 9.334 10.258s9.332-4.636 9.332-10.258ZM38.396 51.536h15.871v7.376H27.732V52.21l10.442-11.56-10.392-10.83v-6.722h26.485v7.374H38.733l9.633 10.087-9.97 10.978Z"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      className: "fill-black dark:fill-white",
      d: "m41 7.462 23.719 9.823 9.824 23.72-9.824 23.72-23.72 9.825-23.719-9.826-9.825-23.72 9.825-23.719L41 7.462ZM41 0c-.422 0-.84.083-1.23.244l-26.718 11.07a3.209 3.209 0 0 0-1.738 1.737L.244 39.771a3.212 3.212 0 0 0 0 2.457l11.07 26.719a3.203 3.203 0 0 0 1.738 1.737l26.719 11.07a3.191 3.191 0 0 0 2.457 0l26.72-11.07a3.208 3.208 0 0 0 1.737-1.737l11.07-26.72a3.212 3.212 0 0 0 0-2.457l-11.07-26.719a3.215 3.215 0 0 0-1.738-1.737L42.228.244A3.234 3.234 0 0 0 41 0Z"
    })]
  }));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgLogoWithText);

/***/ }),

/***/ 7983:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgMenuClose = function SvgMenuClose(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", _objectSpread(_objectSpread({
    width: 50,
    height: 51,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fill: "#fff",
      d: "M.344 47.207 46.864.687l2.792 2.79-46.52 46.521z"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fill: "#fff",
      d: "m3.135 1 46.52 46.52-2.79 2.791L.345 3.791z"
    })]
  }));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgMenuClose);

/***/ }),

/***/ 5128:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var SvgMenuOpen = function SvgMenuOpen(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("svg", _objectSpread(_objectSpread({
    width: 50,
    height: 25,
    xmlns: "http://www.w3.org/2000/svg",
    className: "fill-current text-black dark:text-white"
  }, props), {}, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M0 0h50v3H0zM0 11h50v3H0zM0 22h50v3H0z"
    })
  }));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgMenuOpen);

/***/ }),

/***/ 4802:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgPower = function SvgPower(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", _objectSpread(_objectSpread({
    width: 43,
    height: 42,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("ellipse", {
      cx: 21.497,
      cy: 20.79,
      rx: 21.497,
      ry: 20.753,
      fill: "url(#power_svg__a)"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M28.919 18.647c-.123-.22-.365-.346-.663-.346h-6.641a.251.251 0 0 1-.246-.25V10.66c0-.627-.4-.659-.48-.659-.297 0-.466.285-.522.378L13.13 22.6c-.153.259-.17.534-.048.754.124.22.365.346.663.346h6.641c.133 0 .246.114.246.25v7.392c0 .627.4.66.48.66.298 0 .466-.285.522-.38l7.238-12.22c.154-.259.17-.534.048-.754Z",
      fill: "#141414"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("defs", {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("linearGradient", {
        id: "power_svg__a",
        x1: 21.497,
        y1: 0.037,
        x2: 21.497,
        y2: 41.544,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          stopColor: "#fff"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: 1,
          stopColor: "#807e7e"
        })]
      })
    })]
  }));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgPower);

/***/ }),

/***/ 3157:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var SvgReddit = function SvgReddit(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("svg", _objectSpread(_objectSpread({
    width: 40,
    height: 40,
    xmlns: "http://www.w3.org/2000/svg",
    className: "fill-current text-black dark:text-white"
  }, props), {}, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M15.703 23.906c1.094 0 1.953-.86 1.953-1.953 0-1.015-.86-1.953-1.953-1.953-1.094 0-1.953.938-1.953 1.953 0 1.094.86 1.953 1.953 1.953ZM39.375 20C39.375 9.297 30.703.625 20 .625S.625 9.297.625 20 9.297 39.375 20 39.375 39.375 30.703 39.375 20Zm-10.39-3.203c2.734 0 3.593 3.672 1.171 4.922.078.39.157.781.157 1.25 0 4.062-4.61 7.422-10.313 7.422S9.687 27.03 9.687 22.969c0-.469 0-.86.079-1.25-2.422-1.25-1.563-4.922 1.171-4.922.704 0 1.407.312 1.876.781 1.718-1.172 4.062-1.953 6.64-2.031l1.563-6.797c0-.234.234-.39.468-.313l4.844 1.016c.313-.625.938-1.015 1.719-1.015 1.094 0 1.953.859 1.953 1.953 0 1.015-.86 1.875-1.953 1.875-1.094 0-1.953-.86-1.953-1.875l-4.297-1.016-1.406 6.172c2.656.078 5 .86 6.718 2.031.547-.469 1.172-.781 1.875-.781Zm-5.391 9.062c-1.407 1.485-5.938 1.407-7.266 0-.156-.156-.469-.156-.703 0-.156.235-.156.547 0 .703 1.797 1.797 6.875 1.797 8.672 0 .156-.156.156-.468 0-.703a.586.586 0 0 0-.703 0ZM24.219 20c-1.094 0-1.953.938-1.953 1.953 0 1.094.937 1.953 1.953 1.953 1.093 0 1.953-.86 1.953-1.953 0-1.015-.86-1.953-1.953-1.953Z"
    })
  }));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgReddit);

/***/ }),

/***/ 6804:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgRoadmapCompleted = function SvgRoadmapCompleted(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", _objectSpread(_objectSpread({
    width: 25,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("ellipse", {
      cx: 12.429,
      cy: 12.5,
      rx: 12.429,
      ry: 12,
      fill: "url(#roadmap-completed_svg__a)"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "m11.286 15.625-3.26-3.086.886-.85 2.374 2.316 4.789-4.63.885.849-5.674 5.401Z",
      fill: "#141414"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("defs", {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("linearGradient", {
        id: "roadmap-completed_svg__a",
        x1: 12.429,
        y1: 0.5,
        x2: 12.429,
        y2: 24.5,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          stopColor: "#00C68A"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: 1,
          stopColor: "#98FFD4"
        })]
      })
    })]
  }));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgRoadmapCompleted);

/***/ }),

/***/ 8657:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgRoadmapInProgress = function SvgRoadmapInProgress(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", _objectSpread(_objectSpread({
    width: 29,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("ellipse", {
      cx: 14.5,
      cy: 14,
      rx: 14.5,
      ry: 14,
      fill: "url(#roadmap-in-progress_svg__a)"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.134 19.777a.723.723 0 0 0 .715-.715v-1.104a6.746 6.746 0 0 0 5.315 2.596 6.744 6.744 0 0 0 6.683-5.906l.047-.342h-1.43l-.031.264c-.389 2.596-2.642 4.554-5.269 4.554-1.865 0-3.605-1.01-4.569-2.595h1.787a.723.723 0 0 0 .715-.716.723.723 0 0 0-.714-.715H8.119c-.342 0-.7.218-.7.715v3.25c0 .388.327.714.715.714Zm.73-6.466.032-.264c.388-2.596 2.642-4.555 5.268-4.555 1.865 0 3.606 1.01 4.57 2.596h-1.772a.723.723 0 0 0-.715.715c0 .389.326.715.715.715h3.233c.295-.015.714-.202.714-.715V8.555a.723.723 0 0 0-.714-.715.723.723 0 0 0-.715.715v1.103a6.747 6.747 0 0 0-5.316-2.596 6.744 6.744 0 0 0-6.682 5.907l-.047.342h1.43Z",
      fill: "#141414"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("defs", {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("linearGradient", {
        id: "roadmap-in-progress_svg__a",
        x1: 14.5,
        y1: 0,
        x2: 14.5,
        y2: 28,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: 1,
          stopColor: "#FF7C44"
        })]
      })
    })]
  }));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgRoadmapInProgress);

/***/ }),

/***/ 3027:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgRoadmapPlanned = function SvgRoadmapPlanned(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", _objectSpread(_objectSpread({
    width: 29,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("ellipse", {
      cx: 14.5,
      cy: 14,
      rx: 14.5,
      ry: 14,
      fill: "url(#roadmap-planned_svg__a)"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M19.506 12.554c-.083-.148-.246-.234-.447-.234h-4.48a.17.17 0 0 1-.166-.168V7.166c0-.424-.27-.445-.323-.445-.201 0-.315.192-.352.255L8.855 15.22c-.103.175-.115.36-.032.509.084.148.246.234.447.234h4.48a.17.17 0 0 1 .166.168v4.986c0 .424.27.445.323.445.201 0 .315-.192.352-.255l4.883-8.244c.103-.175.115-.36.032-.509Z",
      fill: "#141414"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("defs", {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("linearGradient", {
        id: "roadmap-planned_svg__a",
        x1: 14.5,
        y1: 0,
        x2: 14.5,
        y2: 28,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          stopColor: "#fff"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: 1,
          stopColor: "#807e7e"
        })]
      })
    })]
  }));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgRoadmapPlanned);

/***/ }),

/***/ 9738:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgSigmanauts = function SvgSigmanauts(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", _objectSpread(_objectSpread({
    width: 248,
    height: 300,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M107.152 267.965 73.84 286.524c35.611-4.929 64.83-11.723 99.771-20.208l38.859 23.404c6.495-1.237 32.992-17.754 28.446-27.91 6.99-7.753 7.464-13.269 3.917-17.414h-99.162l8.877 1.65c6.804 1.258 5.546 2.413-.619 3.413l-26.147 3.361c-7.98.928-8.248 6.526 2.66 7.815 4.98.474 2.97 3.835-4 4.753l-19.29 2.577Z",
      fill: "url(#sigmanauts_svg__a)",
      stroke: "#000",
      strokeWidth: 1.031,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M218.437 27.43c12.964-8.712 22.119-17.79 20.448-20.275-1.67-2.486-13.534 2.56-26.498 11.272-12.964 8.711-22.119 17.788-20.448 20.274 1.67 2.486 13.534-2.56 26.498-11.272Z",
      stroke: "#585858",
      strokeWidth: 1.691,
      strokeMiterlimit: 10
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M52.512 206.829v24.27l13.238 13.32h81.749M52.512 118.471v46.498-46.498Z",
      stroke: "#FF5E18",
      strokeWidth: 1.031,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M9.929 46.3h12.238l8.928 6.495v156.498l-8.928 6.485H9.929L1 209.293V52.795L9.929 46.3Z",
      stroke: "#FF5E18",
      strokeWidth: 1.031,
      strokeMiterlimit: 10
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.436 46.3h7.733l8.929 6.495v156.498l-8.929 6.485h-7.733l-8.928-6.485V52.795l8.928-6.495Z",
      fill: "url(#sigmanauts_svg__b)",
      stroke: "#FF5E18",
      strokeWidth: 1.031,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M84.251 217.942c-6.753 3.382-17.919 4.67-19.32-5.382-.589-4.124-3.754-14.434-11.754-6.434-6.774 6.826-17.332 4.259-20.074-5.711-3.64-13.331-9.403-14.806-18.033-12.878 10.393-11.588 54.54-25.559 68.563-48.653",
      stroke: "#807e7e",
      strokeWidth: 1.031,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M106.647 71.207c17.692 5.97 38.148 3.867 53.386-.474 11.145 3.093 22.816 6.805 32.724 17.61 3.093 3.36 4.795 12.826 5.351 17.661.196 1.794.361 3.619.557 5.464 1.547 15.466 1.547 13.826-9.279 30.766l3.608.33 7.867 7.619v13.816l-10.248 15.114-10.661 8.032c3.856 8.815 5.258 18.651 7.382 28.023l3.784 10.671 6.526 20.404a113.228 113.228 0 0 0 7.867 20.743l2.629 5.465a42.758 42.758 0 0 1 3.774 9.877c.763 5.155 1.938 12.176-4.423 14.527-5.619 2.062-12.847 3.474-18.363.309-5.289-2.99-5.846-4.474-7.475-14.217-.948-.568-1.897-1.093-2.856-1.65-4.897-2.444-4.783-3.341-5.485-9.104-.195-1.598-.278-2.907.506-3.67-.815-3.465 1.031-5.423.309-9.042a59.649 59.649 0 0 0-3.722-11.393c-2.237-5.403-4.619-10.723-7.001-16.063l-4.227-9.547a196.267 196.267 0 0 1-24.424-38.89l-.671-1.031c-4.619 11.001-9.578 21.888-19.589 34.405l-2.825 9.939-2.299 24.074c-.423 4.258-.361 2.856.979 6.557 1.093 3.093 1.093 5.928 1.258 9.434.877 1.454.815 1.144.815 2.825v4c-2.351 3.722-9.372 4.732-12.733 5.073-7.537.752-9.94 2.124-16.435 4.866-9.609 4.124-20.414 4.732-26.538-.165v-4.619c0-1.99-.144-1.515 1.258-2.938 2.382-6.186 7.506-7.145 14.692-9.774a117.936 117.936 0 0 1 10.67-11.867l2.238-28.497c-3.02-7.898-.752-15.094 3.98-19.177l.897-11.537-1.371-.279c-3.815-.783-5.66-.814-5.155-5.876l1.958-14.868c.372-2.804 1.434-3.196 4.011-3.196h2.99l3.33-15.898c-2.062-.557-1.31-8.248.114-8.99.752-6.351 1.03-9.486 3.093-15.558l-1.68-.784-2.568.701c-3.815 1.959-10.475 2.681-16.888 1.732-21.414-3.196-14.61-28.332-2.66-39.642-3.02-10.97.196-20.94-10.248-28.384-2.062-1.825-.835-6.135 1.773-4.258l26.167 18.702c2.97-3.03 7.702-6.443 13.331-7.35Z",
      fill: "url(#sigmanauts_svg__c)"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M99.447 130.43c-1.99 5.794-2.351 8.929-3.021 14.754 1.65-3.196 4.062-6.836 7.031-9.022-.536-.391-1.031-.783-1.598-1.144a2.282 2.282 0 0 1-1.124-1.78 2.282 2.282 0 0 1 .815-1.942l.309-.196a28.966 28.966 0 0 1-4.124-1.454l1.712.784Z",
      fill: "#fff"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M181.56 119.448c-8.145-1.196-10.661 8.176-17.043 16.692l-5.155-5.155 4.207-6.629 4.124-4.506-10.826-18.744 2.062-18.063 8.351-3.939c-4.423 9.166 4.485 27.889 14.28 40.344Z",
      fill: "#FF5E18"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M171.571 75.559c-4.99 1.68-14.434 4.361-20.435 5.733l-8.062 5.515 1.618-.051.65-1.32h6.547l1.031 1.34 2.598.052.814 5.207-1.464 11.97-11.341-.598-2.33-.103-.897-3.093v-.145l2.062-12.795c-5.155 3.609-9.124 8.434-12.96 13.156l6.186 5.32a41.23 41.23 0 0 1 13.888 1.155 31.044 31.044 0 0 1 8.393 3.691 40.062 40.062 0 0 1 9.908 9.186 53.761 53.761 0 0 1-4.898-10.949 53.756 53.756 0 0 1-1.928-8.403c-1.031-7.104-.226-13.857 3.093-18.249.444-1.515 3.609-5.371 13.517-5.402 1.093.154-4.134-1.3-5.99-1.217Z",
      fill: "#fff"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M97.457 218.808c6.104 0 5.433-4.505 6.248-10.135.919-7.444 2.454-14.8 4.588-21.991 2.382-7.733 5.238-15.208 8.011-23.043.474-2.062.918-4.176 1.402-6.269M116.716 214.127c-4.392-4.392-8.733-7.475-4.619-16.764a203.956 203.956 0 0 1 11.228-21.723M132.184 157.864c4.124 14.95 8.794 21.889 16.238 35.127 1.516 2.835 3 5.66 4.506 8.485 2.237 4.227 4.289 8.248 6.248 12.372 3.247 6.722 3.247 9.218 8.866 9.279M161.18 194.476c3.866 6.186 5.969 11.784 8.712 18.898M175.77 189.661c2.907 8.846 3.691 16.857 9.598 16.269M181.371 230.87c.897 2.155 1.794 4.341 2.722 6.495M89.314 227.457c-.113 1.846-.36 4.454-.36 6.3M100.996 234.963c1.34-6.279 1.289-11.176 11.341-10.424M162.16 229.158c6.3 0 7.372 5.743 9.444 11.341M104.051 174.041a90.084 90.084 0 0 0 4.619-17.414",
      stroke: "#000",
      strokeWidth: 1.031,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M106.991 164.688c-4.537-.556-4.929-1.031-7.589 7.279M114.152 169.73l4.124 1.093M136.4 170.185c-2.062.257-3.495.505-5.505.732M146.623 171.721c-.835-1.207-1.681-2.382-2.516-3.557-.278-1.124-.567-2.238-.845-3.393M169.387 141.008c7.815-8.505 9.794-14.434 18.506-10.104",
      stroke: "#000",
      strokeWidth: 1.031,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M180.641 141.904c10.464-16.372 12.31-14.98 10.495-34.095M162.773 108.87c1.516-.443 3.001-.866 4.506-1.32a3.178 3.178 0 0 1 3.949 1.763c.227.423.474.877.701 1.32 1.711 3.093 4.763 3.722 6.299.144 1.32-3 2.609-6.021 3.918-9.021",
      stroke: "#000",
      strokeWidth: 1.031,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M178.578 97.725c-2.443 6.361-3.093 4.794 1.031 9.939M176.412 94.365a33.835 33.835 0 0 0-7.506.257c-1.763.248-2.433.64-2.35 2.547.195 3.413-.31 2.547-3.918 3.093l-1.794.248M163.898 82.22c4.98.165 9.207 1.258 12.816 4.732M174.816 77.064a18.366 18.366 0 0 1 3.248 2.578M149.374 106.943c-.392 3.217-.783 6.382-1.206 9.599M157.768 110.582a34.947 34.947 0 0 0-1.598 10.826c1.031.113 2.918 0 3.835.371a81.66 81.66 0 0 0 .258 8.248M137.136 83.815a32.701 32.701 0 0 0-3.64 10.888M110.707 147.728c.083-2.268-.392-9.279 5.99-9.279h3.887M71.352 97.395c-2.062 5.403-3.021 9.517-1.32 11.228.815.639 1.031.835 1.846 1.475 3.093 2.464 5.299 2.268 7.959-.753a10.774 10.774 0 0 1 8.454-3.753",
      stroke: "#000",
      strokeWidth: 1.031,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M70.82 100.642c4.557.897 3.743.805 7.217-2.64M65.637 108.984c-.278 5.341 3.093 9.96 8.65 13.857 2.609 1.846 3.31 1.031 4.063-1.515.36-1.196.7-2.382 1.03-3.578 1.681.722 3.362 1.423 5.011 2.155M93.627 110.665c-7.753 1.846-10.31 10.97-8.062 16.094M64.43 117.047c3.98 8.537 8.062 6.825 9.97 14.104",
      stroke: "#000",
      strokeWidth: 1.031,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M85.574 128.161a1.402 1.402 0 1 0 0-2.804 1.402 1.402 0 0 0 0 2.804ZM191.14 109.21a1.403 1.403 0 1 0 0-2.806 1.403 1.403 0 0 0 0 2.806Z",
      fill: "#000",
      stroke: "#000",
      strokeWidth: 0.227,
      strokeMiterlimit: 10
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M103.203 212.93c1.705.128 3.378.525 4.959 1.175",
      stroke: "#000",
      strokeWidth: 1.031,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M108.164 215.508a1.402 1.402 0 1 0 0-2.803 1.402 1.402 0 0 0 0 2.803Z",
      fill: "#FF5E18",
      stroke: "#000",
      strokeWidth: 0.227,
      strokeMiterlimit: 10
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M118.297 172.227a1.402 1.402 0 1 0 0-2.805 1.402 1.402 0 0 0 0 2.805ZM130.898 172.309a1.402 1.402 0 1 0 0-2.803 1.402 1.402 0 0 0 0 2.803Z",
      fill: "#000",
      stroke: "#000",
      strokeWidth: 0.227,
      strokeMiterlimit: 10
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "m91.84 206.828 1.515-11.29",
      stroke: "#000",
      strokeWidth: 1.031,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m142.985 123.43-15.207 18.476c-1.031 1.319-1.681 2.886-.114 4.227l2.825 2.825 1.743 1.742.866.887c.066-1.164.383-2.3.928-3.33 1.649-2.372 5.371-.588 5.258 3.309 1.794-1.454 3.701.113 4.567 2.382a6.812 6.812 0 0 1 .413 3.186c1.35-2.238 3.67-1.341 4.763.845.36.74.56 1.548.588 2.371.015.292.015.585 0 .877 0 .391-.134.804-.217 1.227l-.422 2.237a3.184 3.184 0 0 0 .732 2.402l-1.031 1.701 10.547-14.753 9.413-5.764 4.98-3.093-4.227-4.227-9.713-9.712-8.763-8.764-1.031-.536c-2.67-1.536-4.97-.835-6.898 1.485Z",
      fill: "#000"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M65.407 64.052c10.444 7.444 7.217 17.414 10.248 28.384a25.09 25.09 0 0 0 2.351 5.568 23.213 23.213 0 0 0 3.928 4.99 10.416 10.416 0 0 1 6.382 2.598 62.606 62.606 0 0 1 5.31 5.073c.875.887 1.812 1.71 2.804 2.464l4.764 2.907c4.051.454 6.938.65 9.794 1.124l2.062-2.969c-.618-1.732-.278-4.124 1.763-6.413l6.723-7.558c-.681-.474-1.351-1.03-2.063-1.515a722.087 722.087 0 0 1-7.639-5.96s-.062 0-.062-.051l-6.392-4.99c-3.753-2.938-7.754-6.021-12.043-9.155L67.232 59.794c-2.66-1.876-3.887 2.434-1.825 4.258Z",
      fill: "url(#sigmanauts_svg__d)"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M166.773 239.634c.65 1.485 1.351 3.093 2.062 4.733.65 1.505 1.32 3.093 1.959 4.67 5.155 3.093 6.671 12.681 8.094 20.435.34 1.711.649 3.34.979 4.794.65 1.227 1.207 2.577 1.825 4.031.804 1.897 1.681 3.805 2.598 5.537 3.331 6.248 5.856 8.042 13.404 7.619 4.227-.248 8.753-1.454 11.083-3.949a6.25 6.25 0 0 0 1.175-1.907c.835-2.155.639-4.836.423-8.032-.392-.917-.784-1.866-1.175-2.711-.196-.475-.423-.928-.619-1.403a.864.864 0 0 1-.113-.247l-2.516-5.155-.505-1.031a113.238 113.238 0 0 1-7.867-20.744l-.588-1.846-4.505-14.083c-.196 2.66-3.897 5.206-8.454 7.083a42.933 42.933 0 0 1-12.486 3.093c-2.248.093-4.011-.155-4.774-.887Z",
      fill: "url(#sigmanauts_svg__e)"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m85.07 232.603-.927 11.763-.784 9.939a118.045 118.045 0 0 0-10.671 11.867c-7.217 2.629-12.31 3.588-14.692 9.774 2.63 3.093 7.279 3.526 11.898 3.3 5.825-.31 8.96-1.124 12.372-2.63 3.949-1.763 6.444-2.855 8.65-3.608 6.413-12.042 8.547-26.043 18.93-26.683l.196-1.959.979-10.083a67.183 67.183 0 0 1-9.99.681 56.653 56.653 0 0 1-12.043-1.207 28.708 28.708 0 0 1-3.918-1.154Z",
      fill: "url(#sigmanauts_svg__f)"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M109.815 246.325c-10.382.639-12.517 14.641-18.93 26.683-2.206.752-4.701 1.845-8.65 3.608-3.382 1.506-6.516 2.32-12.372 2.629-4.619.227-9.28-.247-11.898-3.299-1.402 1.423-1.258.949-1.258 2.939v4.619c4.124 3.33 10.465 4.124 17.105 2.989a41.821 41.821 0 0 0 9.434-2.824c6.495-2.743 8.897-4.125 16.434-4.867 3.361-.34 10.382-1.351 12.733-5.072v-4.001c0-1.484.062-1.433-.557-2.412a3.319 3.319 0 0 1-.258-.413c-.165-3.505-.165-6.361-1.257-9.434-1.341-3.701-1.403-2.299-.98-6.557l.454-4.588Z",
      fill: "url(#sigmanauts_svg__g)"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M200.015 253.831c1.54 4.49 3.372 8.874 5.485 13.125l2.629 5.464a42.79 42.79 0 0 1 3.773 9.877c.347 1.904.554 3.83.619 5.764m-11.135 10.475c-4.207.783-8.63.701-12.269-1.402-5.289-2.99-5.846-4.475-7.475-14.218-.949-.567-1.897-1.093-2.856-1.65-4.897-2.443-4.784-3.34-5.485-9.104-.196-1.598-.278-2.907.505-3.67-.814-3.464 1.031-5.423.31-9.042a59.79 59.79 0 0 0-3.722-11.393c-2.238-5.402-4.619-10.722-7.001-16.063l-4.227-9.547a196.29 196.29 0 0 1-24.415-38.859l-.67-1.031m-34.374 96.307c-7.536.753-9.939 2.124-16.434 4.866-9.61 4.125-20.414 4.733-26.538-.165v-4.618c0-1.99-.145-1.516 1.258-2.939 2.381-6.186 7.505-7.145 14.691-9.774a117.923 117.923 0 0 1 10.671-11.867l2.238-28.497c-3.021-7.898-.753-15.094 3.98-19.177l.896-11.537-1.37-.278c-3.816-.784-5.661-.815-5.156-5.877l1.959-14.867c.371-2.805 1.433-3.196 4.01-3.196h2.99l3.33-15.899c-2.061-.556-1.309-8.248.114-8.99.753-6.351 1.031-9.485 3.093-15.558l-1.68-.784-2.567.702a19.82 19.82 0 0 1-5.238 1.649m-17.775-1.763c-7-3.443-8.712-10.609-7.31-18.146m3.392-45.694a21.003 21.003 0 0 0-2.835-2.403c-2.062-1.824-.835-6.134 1.773-4.258l26.168 18.703c2.938-2.97 7.67-6.382 13.3-7.31 17.692 5.97 38.147 3.866 53.385-.474 11.146 3.093 22.817 6.805 32.725 17.61m-7.166 118.783c.588 2.721 1.124 5.433 1.732 8.093M70.303 98.993a36.087 36.087 0 0 1 5.34-6.495 60.93 60.93 0 0 1-1.618-10.073l-3.722 16.569Zm119.092 43.221 3.609.33 7.866 7.619v13.836l-10.248 15.115-10.661 8.031a66.183 66.183 0 0 1 2.403 6.557l7.031-51.488Z",
      stroke: "#fff",
      strokeWidth: 1.031,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M185.951 82.136a50.85 50.85 0 0 1 6.805 6.187 12.353 12.353 0 0 1 2.134 3.69l.248 5.32-4.372 5.465-8.619-1.031-5.681-6.382-.392-7.64 5.155-6.103 4.722.495Z",
      fill: "#fff",
      stroke: "#000",
      strokeWidth: 1.031,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m132.232 150.699.866.887c.066-1.164.383-2.3.928-3.33 1.649-2.372 5.371-.588 5.258 3.309 1.794-1.453 3.701.114 4.567 2.382a6.812 6.812 0 0 1 .413 3.186c1.35-2.238 3.67-1.341 4.763.845a6.06 6.06 0 0 1 .557 3.248c-.217 2.01-1.454 4.052.113 5.877l-1.031 1.701 10.548-14.754 8.124-4.98-25.641-24.074-13.919 16.909c-1.031 1.319-1.681 2.887-.114 4.227l2.825 2.825 1.743 1.742Z",
      fill: "#000"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M74.445 105.283c11.568-6.743 15.466 2.969 22.033 7.846-7.588 3.691-8.34 13.712-1.227 17.218",
      stroke: "#fff",
      strokeWidth: 1.031,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M89.574 206.632a15.682 15.682 0 0 0-5.32 11.341 19.796 19.796 0 0 0 1.34 7.867 7.209 7.209 0 0 0 2.97 1.484c.244.08.496.135.752.165a5.09 5.09 0 0 0 5.042-1.319c1.711-1.681 2.69-4.454 3.093-7.331.418-2.663.39-5.377-.083-8.032-.36-1.68-1.175-2.526-3.577-3.392a13.86 13.86 0 0 0-1.96-.556l-2.257-.227Z",
      fill: "#fff"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M167.671 119.82c-10.104-16.806-12.093-45.303 10.475-42.56",
      stroke: "#fff",
      strokeWidth: 1.031,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "m178.621 88.353.392 5.702 4.423 4.877 6.671 1.093 3.557-4.032V89.53",
      stroke: "#000",
      strokeWidth: 1.031,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m85.542 176.505-1.629 12.434c-.474 5.063 1.371 5.094 5.155 5.877l1.371.278v.052c1.031.093 2.01.289 2.877.392l.65.093 3.247.412c2.485.423 4.124-.196 4.897-2.907a58.447 58.447 0 0 0 1.031-4.197c-.226-.062-.474-.144-.721-.196-2.526-.68-.794-6.248 1.144-5.691.227.062.474.145.701.196.279-1.567.557-3.217.897-5.031a3.187 3.187 0 0 0-.68-2.836 21.84 21.84 0 0 0-5.155-3.412c-1.403-.639-3.609-.784-6.527-1.093h-2.886c-2.578 0-3.64.392-4.011 3.196l-.361 2.433Z",
      fill: "#fff"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "m190.109 100.024.671 2.774",
      stroke: "#fff",
      strokeWidth: 1.031,
      strokeMiterlimit: 10
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "m183.433 98.93-1.288 2.826M176.469 95.375l2.546-1.31",
      stroke: "#000",
      strokeWidth: 1.031,
      strokeMiterlimit: 10
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M133.136 17.357c19.146 0 34.652 14.64 34.652 32.725a31.468 31.468 0 0 1-7.753 20.62c-15.28 4.34-35.694 6.444-53.386.474a31.737 31.737 0 0 1-8.145-21.105c0-18.042 15.506-32.714 34.632-32.714Z",
      fill: "url(#sigmanauts_svg__h)",
      stroke: "#000",
      strokeWidth: 1.031,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M191.55 227.179c32.034-23.466 40.21-59.18 31.271-96.616a83.194 83.194 0 0 0-4.196-12.733c-10.383-24.414-27.91-46.499-55.005-52.18-.34.609-.959 1.588-1.68 2.66 5.371 3.33-32.312 12.228-38.746 11.95-8.764-.361-13.3-4.67-20.105-8.145l3.784-.846a44.692 44.692 0 0 1-3.784-4.897c-6.804 1.155-9.155 6.135-7.588 9.805 3.897 9.094 28.528 8.98 41.014 7.691 1.175-.113 2.237-.247 3.165-.36a182.77 182.77 0 0 0 28.528-7.001c4.124-1.402 5.258-1.536 9.042.31a50.863 50.863 0 0 1 13.805 9.742 30.089 30.089 0 0 1 4.475 5.826 112.871 112.871 0 0 1 10.021 18.444c16.713 38.272 10.022 65.336-12.176 88.606 13.042-8.764 13.775 15.279-1.825 27.744Z",
      fill: "url(#sigmanauts_svg__i)",
      stroke: "#000",
      strokeWidth: 1.031,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M75.66 92.436a23.259 23.259 0 0 0 6.279 10.558",
      stroke: "#fff",
      strokeWidth: 1.031,
      strokeMiterlimit: 10
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m110.09 118.417 5.877 10.918 2.526 2.547c2.319 2.32 2.711 3.186 2.268 5.712-.784 4.309-2.268 3.887.979 7.134l1.031 1.031a3.978 3.978 0 0 0 4.929.392c-1.568-1.34-.949-2.907.113-4.227l15.207-18.476c1.928-2.32 4.228-3.021 6.857-1.433l1.031.536c.639-1.32 1.206-2.32-.454-4.031l-22.589-19.208c-2.124-1.505-5.032-.443-6.321.928l-6.722 7.557c-2.062 2.269-2.381 4.681-1.763 6.413l-2.969 4.207Zm15.145 6.33 1.227 1.031a2.306 2.306 0 0 1 .196 3.217l-1.763 1.99a2.33 2.33 0 0 1-3.217.196l-1.206-1.093a2.26 2.26 0 0 1-.767-1.557 2.25 2.25 0 0 1 .571-1.639l1.763-1.98a2.225 2.225 0 0 1 3.196-.165Z",
      fill: "#FF5E18",
      stroke: "#000",
      strokeWidth: 1.031,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m145.5 173.205-.082 11.022 8.176 9.609-.67-12.712 13.547-19.425 20.208-12.795 14.166 1.258-7.753-7.722h-3.495l-10.413-.619-19.961 12.228-13.723 19.156Z",
      fill: "#807e7e",
      stroke: "#fff",
      strokeWidth: 1.031,
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "m150.906 122.532 22.703 22.703M127.684 146.132l5.423 5.454",
      stroke: "#fff",
      strokeWidth: 1.031,
      strokeMiterlimit: 10
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M135.488 105.788c14.579-1.031 24.044 3.815 32.189 14.032M129.27 100.468c3.835-4.722 7.835-9.547 12.959-13.156M96.426 145.182c1.65-3.196 4.062-6.835 7.031-9.021",
      stroke: "#000",
      strokeWidth: 1.031,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m140.215 100.108.928 3.196 13.681.701 1.485-11.99-.815-5.207-2.598-.052-1.01-1.35-6.547.03-.639 1.32-2.382.082-2.103 13.27Z",
      fill: "#fff",
      stroke: "#000",
      strokeWidth: 1.031,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "m140.242 100.252 12.847.474.948-8.537",
      stroke: "#000",
      strokeWidth: 1.031,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "m144.702 86.756-1.155 8.98 8.011.31.752-6.383M143.07 86.807l8.063-5.516",
      stroke: "#000",
      strokeWidth: 1.031,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M96.203 154.978a237.461 237.461 0 0 0 38.045 2.907",
      stroke: "#fff",
      strokeWidth: 1.031,
      strokeMiterlimit: 10
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M124.535 140.286 140 121.47c2.516-3.093 6.073-5.042 9.96-3.33",
      stroke: "#000",
      strokeWidth: 1.031,
      strokeMiterlimit: 10
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M104.35 129.388c-.928.618-1.845 1.258-2.773 1.907a2.28 2.28 0 0 0-.815 1.942 2.276 2.276 0 0 0 1.124 1.78c1.567 1.031 3.268 2.464 4.897 3.444a8.331 8.331 0 0 0 1.207-3.64c.587-.866 1.144-1.763 1.732-2.629l-5.372-2.804Z",
      fill: "#000",
      stroke: "#fff",
      strokeWidth: 1.031,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m130.635 120.933 4.763-5.454-14.084-12.238-4.732 5.093 14.053 12.599Z",
      fill: "#fff"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "m141.703 124.996 25.641 24.074",
      stroke: "#fff",
      strokeWidth: 1.031,
      strokeMiterlimit: 10
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "m113.062 114.19 1.207 1.31",
      stroke: "#000",
      strokeWidth: 1.031,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M112.949 50.587c-1.567 2.382-3.165 4.732-4.732 7.114.144 2.32.278 4.67.392 7.021 11.98 1.516 24.744 1.351 28.383.506v-7.506c-6.516.227-13.011.618-19.847-.165 1.681-2.35 3.815-5.238 5.496-7.589-2.186-2.711-4.289-5.155-6.475-7.866a152.435 152.435 0 0 1 21.28-1.114l.33-7.361c-9.568.051-20.064.474-29.755 2.68l-.619 7.558c1.939 2.217 3.619 4.454 5.547 6.722Z",
      fill: "#fff",
      stroke: "#FF5E18",
      strokeWidth: 1.031,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M119.981 84.435v-4.619c-8.145-.505-11.702 2.598-14.61 7.836l6.495 5.093c6.259-2.124 7.63-5.485 8.115-8.31Z",
      fill: "#FF5E18",
      stroke: "#000",
      strokeWidth: 1.031,
      strokeMiterlimit: 10
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M125.271 79.9a6.754 6.754 0 0 0-5.042-.372c-.979 1.093-1.093 3.093-.423 4.908 1.176 1.227 4.423.783 5.382.051a10.463 10.463 0 0 1 .083-4.588Z",
      fill: "#FF5E18",
      stroke: "#000",
      strokeWidth: 1.031,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M125.179 84.487a7.505 7.505 0 0 1 .083-4.588c4.052 2.351 5.846 3.887 4.866 10.135-1.845 11.702-20.465 8.671-4.949-5.547Z",
      fill: "#FF5E18",
      stroke: "#000",
      strokeWidth: 1.031,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M124.97 82.189c2.32 3.7 1.258 7.278-.587 9.939M119.416 82.755a13.55 13.55 0 0 0-7.217 3.66",
      stroke: "#000",
      strokeWidth: 1.031,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M134.084 182.496a10.218 10.218 0 0 0-4.928-4.309",
      stroke: "#fff",
      strokeWidth: 1.031,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M92.879 170.876c6.444.701 9.279.454 8.124 6.97-.288 1.567-1.66 7.67-2.546 11.619m-.732 3.093a9.392 9.392 0 0 1-.67 1.763c-1.29 2.186-3.64 1.031-6.578.835",
      stroke: "#000",
      strokeWidth: 1.031,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M99.399 171.968a21.84 21.84 0 0 1 5.155 3.412 3.181 3.181 0 0 1 .68 2.836 141.148 141.148 0 0 1-3.093 14.918c-.783 2.712-2.413 3.331-4.897 2.908l-3.248-.412",
      stroke: "#000",
      strokeWidth: 1.031,
      strokeMiterlimit: 10
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M103.625 183.052c9.681 2.753 17.805 5.041 26.084 9.351l-2.371 4.815a182.908 182.908 0 0 0-24.858-8.475c-2.526-.681-.794-6.248 1.145-5.691Z",
      fill: "#fff",
      stroke: "#000",
      strokeWidth: 1.031,
      strokeMiterlimit: 10
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M87.14 180.144c.392.866.753 1.732 1.114 2.577 1.031 2.464.474 2.124 3.093 2.382 2.619.257 2.062.165 3.97-1.825 1.907-1.99 3.814-3.949 5.711-5.908",
      stroke: "#25211A",
      strokeWidth: 1.031,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M85.598 225.859a7.21 7.21 0 0 0 2.969 1.485c2.63.67 4.31.299 5.794-1.155 3.475-3.381 3.867-11.341 3.021-15.362-.36-1.68-1.175-2.526-3.578-3.392a11.354 11.354 0 0 0-3.98-.752",
      stroke: "#000",
      strokeWidth: 1.031,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M170.475 228.861c-.783-1.938-1.598-3.835-2.412-5.743-1.959-4.65-2.712-6.773 2.217-9.743 3.093-1.845 7.392-2.938 9.825-1.227 1.928 1.341 4.227 9.743 4.897 12.177.784 2.66.506 4.536-3.639 6.547-.815.391-1.619.783-2.464 1.175-3.918 1.907-6.774.67-8.424-3.186Z",
      fill: "#807e7e",
      stroke: "#000",
      strokeWidth: 1.031,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M57.95 275.946c2.628 3.093 7.278 3.526 11.897 3.299 5.825-.309 8.96-1.123 12.372-2.629 7.145-3.216 9.527-4.175 14.115-4.928 4.753-.814 8.145-.753 11.836-2.711M72.688 266.173c2.33.113 4.732 1.237 7.278 3.33M83.36 254.305c1.092-.309 3.608.31 5.154 1.372",
      stroke: "#fff",
      strokeWidth: 1.031,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M109.812 246.325c-10.382.639-12.516 14.641-18.93 26.683M85.07 232.603c5.403 2.134 16.012 3.144 25.92 1.68M166.773 239.634c3.279 3.165 25.281-2.825 25.776-9.352M173.809 268.245c4.732 2.186 6.021 5.712 7.897 10.052.804 1.898 1.681 3.805 2.598 5.537 3.33 6.248 5.856 8.042 13.403 7.619 5.156-.278 10.806-2.062 12.259-5.856.835-2.155.639-4.866.423-8.083",
      stroke: "#fff",
      strokeWidth: 1.031,
      strokeMiterlimit: 10
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M181.671 282.915a13.028 13.028 0 0 0-2.062-4.176M208.637 273.421c-4.619-4.124-13.104-3.269-20.496 1.123M170.789 249.036c6.3 3.784 7.217 17.167 9.094 25.229M132.239 150.699c-.814-.814-.928-2.381.33-3.897l10.527-12.764M139.125 149.627l9.011-10.496M143.859 153.936l9.011-10.321M149.031 157.968l8.455-9.651M153.602 193.836l13.496 1.145 12.846-7.867",
      stroke: "#fff",
      strokeWidth: 1.031,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M208.241 183.64c1.993 0 3.609-1.528 3.609-3.413 0-1.885-1.616-3.413-3.609-3.413-1.993 0-3.608 1.528-3.608 3.413 0 1.885 1.615 3.413 3.608 3.413Z",
      fill: "#FF5E18",
      stroke: "#FF5E18",
      strokeWidth: 1.031,
      strokeMiterlimit: 10
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M164.798 235.139c-12.156 2.216-23.549 1.99-23.404-15.465 0-5.888-.846-11.991-5.856-12.826-3.269-.557-5.991.752-8.424 2.691-6.248 4.897-8.145 7.887-12.259 7.021",
      stroke: "#807e7e",
      strokeWidth: 1.031,
      strokeMiterlimit: 10
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M54.324 205.063c9.547-8.825 14.672-14.001 21.476-22.373",
      stroke: "#807e7e",
      strokeWidth: 1.031,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M109.812 75.951a97.351 97.351 0 0 0 27.766 2.01",
      stroke: "#000",
      strokeWidth: 1.031,
      strokeMiterlimit: 10
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m141.782 35.688-8.145.227.392-4.258h7.949l-.196 4.031ZM130.478 63.66c-5.533.25-11.075.174-16.599-.226.103 1.237.247 2.433.361 3.67 5.455.615 10.949.812 16.434.588-.082-1.35-.144-2.67-.196-4.032Z",
      fill: "#25211A"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M101.638 93.723 81.399 78.155a1.3 1.3 0 1 1 1.485-2.124l32.085 24.384M89.93 93.19l-8.599-6.63a1.29 1.29 0 1 1 1.485-2.061l28.312 21.506m-9.97-4.185-8.063-6.186 8.063 6.186ZM86.554 99.004l-5.805-4.486a1.286 1.286 0 0 1-.479-1.91 1.286 1.286 0 0 1 1.498-.454c.175.066.335.169.466.303l25.208 19.042m-6.98-1.763-10.722-8.248 10.722 8.248Z",
      stroke: "#fff",
      strokeWidth: 1.031,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m168.633 148.286-9.403 5.763 7.248 7.651 9.548-6.052-7.393-7.362ZM186.992 142.265l-7.804-.444 7.495 7.083 7.65.671-7.341-7.31ZM145.418 184.227l.031-4.557 7.836 8.227.309 5.939-8.176-9.609Z",
      fill: "#000",
      stroke: "#fff",
      strokeWidth: 1.031,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "m96.426 113.128 4.763 2.907",
      stroke: "#fff",
      strokeWidth: 1.031,
      strokeMiterlimit: 10
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M114.797 51.898c-4.065.259-8.142.259-12.207 0 .062.896.113 1.762.196 2.66 4.02.372 8.061.458 12.094.257-.021-.959-.052-1.938-.083-2.917ZM115.388 37.091l-5.021.505.227-6.413 4.897-.474-.103 6.382ZM135.741 53.608h-5.011l.165-2.887 4.898-.134-.052 3.02Z",
      fill: "#fff"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "m187.613 87.704-1.938.103c-3.021.196-1.093 3.279 1.031 3.165h1.031c1.546-.082 3.474 2.908 1.433 3.217l-2.691.423",
      stroke: "#FF5E18",
      strokeWidth: 2.062,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M149.784 87.375h-1.505c-1.712 0-1.908 2.206-.258 2.206h.34c1.794 0 1.815 2.609-.392 2.526h-1.453M94.554 173.517l-1.814-.145a1.327 1.327 0 0 0-1.084.209 1.316 1.316 0 0 0-.174 1.997 1.32 1.32 0 0 0 1.031.392h.392c2.124.165 2.206 3.279-.423 2.97l-1.732-.165",
      stroke: "#FF5E18",
      strokeWidth: 1.547,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M110.709 147.73c-4.65-.454-9.279-1.031-14.434-1.743-1.423.784-2.206 8.434-.114 8.991a203.52 203.52 0 0 0 12.465 1.649c3.021.31 6.011.567 9.042.732 4.784.31 9.568.444 14.496.506h2.063a6.794 6.794 0 0 1-1.207-3.547 15.625 15.625 0 0 1 0-2.753l-.866-.887-1.742-1.742a290.83 290.83 0 0 1-19.703-1.206Z",
      fill: "#807e7e"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "m157.827 190.362-.784-8.423 12.259-16.713 18.506-11.506 8.506.721",
      stroke: "#25211A",
      strokeWidth: 1.031,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m167.096 194.981-13.496-1.144-.67-12.713 13.547-19.424 20.208-12.795 14.166 1.258v13.805l-10.238 15.115-10.671 8.032-12.846 7.866Z",
      fill: "url(#sigmanauts_svg__j)",
      stroke: "#000",
      strokeWidth: 1.031,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M162.663 190.197c-1.392-.062-2.763-.113-4.124-.196-.279-2.804-.526-5.598-.805-8.423l12.29-16.692L188.5 153.38c2.856.258 5.681.505 8.506.732v8.093c-.557.918-1.145 1.846-1.712 2.763-5.516 8.908-1.227 16.806 4.568 8.548 2.855-4.032 6.918-2.062 7.279 1.031-4.898-1.031-5.372 3.474-9.403 9.279-5.073 7.217-15.569 4.309-25.281 1.433-2.062.721-2.33 1.814-2.062 5.011-1.371.164-4.309-.732-4.784-2.3l-2.948 2.227Z",
      fill: "url(#sigmanauts_svg__k)",
      stroke: "#FF5E18",
      strokeWidth: 1.031,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M93.352 78.497c11.145 8.197 14.929 11.929 22.733 17.775",
      stroke: "#fff",
      strokeWidth: 1.031,
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M101.051 146.636c7.083.897 13.578 1.536 20.496 1.928",
      stroke: "#000",
      strokeWidth: 1.031,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M101.195 116.035c5.928.65 9.351.784 13.795 2.062 3.474.918 4.815 1.567 5.856 2.681a38.383 38.383 0 0 1 3.557 5.351c1.196 2.773-.588 5.093-2.774 3.722a38.026 38.026 0 0 1-2.938-2.516 3.704 3.704 0 0 1-2.83 4.54 3.705 3.705 0 0 1-1.964-.117c.588 3.464-3.887 5.928-6.186 2.825a9.284 9.284 0 0 0-3.732-2.887 36.805 36.805 0 0 1-6.186-2.01c-2.846-3.124-2.114-11.434 3.402-13.651Z",
      fill: "#fff",
      stroke: "#000",
      strokeWidth: 1.031,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M113.897 131.719a13.661 13.661 0 0 0-2.124-2.918M118.692 127.295a9.686 9.686 0 0 0-1.68-2.526",
      stroke: "#000",
      strokeWidth: 1.031,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M137.472 159.319c-2.97.113-4.124-2.413-4.403-4.98-.165-1.516.062-4.794.959-6.083 1.65-2.372 5.372-.588 5.258 3.309 2.609-2.062 5.403 2.124 4.98 5.568 1.877-3.165 5.743-.114 5.32 4.124-.216 2.01-1.454 4.052.114 5.877l-1.031 1.701c-1.599.062-4.537.113-5.516-4.227-3.001.587-5.351-2.578-5.681-5.289Z",
      fill: "#fff",
      stroke: "#000",
      strokeWidth: 1.031,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M139.291 151.564c-1.536 1.506-1.814 5.094-1.814 7.754",
      stroke: "#000",
      strokeWidth: 1.031,
      strokeMiterlimit: 10
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M144.272 157.133a11.57 11.57 0 0 0-1.113 7.423",
      stroke: "#000",
      strokeWidth: 1.031,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m145.504 173.206 6.805-9.465 7.165 8.001-6.547 9.382-7.423-7.918Z",
      fill: "#000",
      stroke: "#fff",
      strokeWidth: 1.031,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M193.378 199.435c13.073-8.764 13.774 15.28-1.825 27.745 25.229-18.476 35.693-44.571 34.611-73.13a119.974 119.974 0 0 0-3.341-23.487m-13.238-30.147c-8.506-13.609-19.878-25.053-34.601-31.24",
      stroke: "#fff",
      strokeWidth: 1.031,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M101.886 64.248a31.389 31.389 0 0 1-3.382-14.166c0-18.084 15.465-32.724 34.632-32.724a36.007 36.007 0 0 1 16.826 4.124",
      stroke: "#807e7e",
      strokeWidth: 1.031,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M173.136 175.442c1.993 0 3.608-1.528 3.608-3.413 0-1.885-1.615-3.413-3.608-3.413s-3.609 1.528-3.609 3.413c0 1.885 1.616 3.413 3.609 3.413ZM182.911 181.484c.786 0 1.423-.6 1.423-1.34 0-.74-.637-1.34-1.423-1.34s-1.423.6-1.423 1.34c0 .74.637 1.34 1.423 1.34ZM178.434 193.692c2.921 0 5.289-2.258 5.289-5.042s-2.368-5.042-5.289-5.042-5.289 2.258-5.289 5.042 2.368 5.042 5.289 5.042Z",
      fill: "#FF5E18",
      stroke: "#FF5E18",
      strokeWidth: 1.031,
      strokeMiterlimit: 10
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M159.676 131.296a30.222 30.222 0 0 1 8-11.475 30.264 30.264 0 0 1 16.301.196",
      stroke: "#fff",
      strokeWidth: 1.031,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M211.041.583a24.96 24.96 0 0 1 29.734 18.981 24.978 24.978 0 0 1-19.012 29.766 24.962 24.962 0 0 1-26.385-37.817A24.925 24.925 0 0 1 211.041.582Z",
      fill: "url(#sigmanauts_svg__l)"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M199.33 33.07a4.702 4.702 0 1 0 0-9.402 4.702 4.702 0 0 0 0 9.403Z",
      fill: "#141414"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M238.847 7.161c1.67 2.495-7.475 11.599-20.445 20.3-12.97 8.703-24.827 14.023-26.476 11.229",
      stroke: "#585858",
      strokeWidth: 1.031,
      strokeMiterlimit: 10
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M199.135 116.263c.392 7.897.278 8.485-3.217 15.671",
      stroke: "#fff",
      strokeWidth: 1.031,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("defs", {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("linearGradient", {
        id: "sigmanauts_svg__a",
        x1: 136.063,
        y1: 301.571,
        x2: 221.637,
        y2: 234.04,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: 1,
          stopColor: "#141414"
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("linearGradient", {
        id: "sigmanauts_svg__b",
        x1: 18.303,
        y1: 46.3,
        x2: 22.652,
        y2: 175.274,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: 1,
          stopColor: "#141414"
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("linearGradient", {
        id: "sigmanauts_svg__c",
        x1: 87.09,
        y1: 241.773,
        x2: 237.617,
        y2: 76.295,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: 1,
          stopColor: "#141414"
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("linearGradient", {
        id: "sigmanauts_svg__d",
        x1: 63.027,
        y1: 113.22,
        x2: 45.593,
        y2: 109.925,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: 1,
          stopColor: "#EDDCB9"
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("linearGradient", {
        id: "sigmanauts_svg__e",
        x1: 175.239,
        y1: 277.343,
        x2: 210.293,
        y2: 274.765,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: 1,
          stopColor: "#141414"
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("linearGradient", {
        id: "sigmanauts_svg__f",
        x1: 73.687,
        y1: 276.312,
        x2: 107.195,
        y2: 242.288,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: 1,
          stopColor: "#141414"
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("linearGradient", {
        id: "sigmanauts_svg__g",
        x1: -767622,
        y1: -572554,
        x2: -723842,
        y2: -554047,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          stopColor: "#D97316"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: 1,
          stopColor: "#25211A"
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("linearGradient", {
        id: "sigmanauts_svg__h",
        x1: 162.87,
        y1: 26.291,
        x2: 101.524,
        y2: 61.861,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: 1,
          stopColor: "#141414"
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("linearGradient", {
        id: "sigmanauts_svg__i",
        x1: 160.623,
        y1: 65.65,
        x2: 160.623,
        y2: 227.179,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: 1,
          stopColor: "#141414"
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("linearGradient", {
        id: "sigmanauts_svg__j",
        x1: 135.38,
        y1: 206.431,
        x2: 159.197,
        y2: 199.085,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          stopColor: "#fff"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: 1
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("linearGradient", {
        id: "sigmanauts_svg__k",
        x1: 166.478,
        y1: 163.932,
        x2: 191.222,
        y2: 187.645,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: 1,
          stopColor: "#141414"
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("radialGradient", {
        id: "sigmanauts_svg__l",
        cx: 0,
        cy: 0,
        r: 1,
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "rotate(148.173 103.168 42.792) scale(17.5953)",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: 0.66,
          stopColor: "#FF7C44"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: 1,
          stopColor: "#D97316",
          stopOpacity: 0
        })]
      })]
    })]
  }));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgSigmanauts);

/***/ }),

/***/ 7567:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgSigmaverse = function SvgSigmaverse(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 40,
    height: 40,
    className: "fill-current text-black dark:text-white",
    style: {
      shapeRendering: 'geometricPrecision',
      textRendering: 'geometricPrecision',
      imageRendering: 'optimizeQuality',
      fillRule: 'evenodd',
      clipRule: 'evenodd'
    },
    viewBox: "0 0 9477.2 9144"
  }, props), {}, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M4160.6 1329.72c-233.9 80.09-152.11 298.91 83.42 233.49 259.14-71.97 736.7-186.42 768.16-194.22 1139.55-282.73 3894.46-959.29 4407.27 561.33 69.74 206.77 79.59 418.04 11.47 626.61-259.87 795.66-1544.35 1216.69-2273.33 1420.76l-1.81.51-2870.81 697.82-649.3-926.55 3246.51-788.97c426.66-119.79 904.12-270.47 1281.89-504.3 462.92-286.55 107.6-457.31-234.34-500.43-865.11-109.09-1860.37 145.11-2698.69 353.1-511.3 126.86-1244.46 274.54-1738.81 39.69-507.31-241-760.51-979.22-447.38-1461.68 280.68-432.47 923.09-601.66 1397.57-709.2L5119.75 0l644.89 920.28c-543.26 157.99-1063.29 260.41-1604.04 409.44z"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M4284.97 4676.02 2722.7 5055.77l3186.8 1938.48-344.2-1714.14L6590.08 5031l825.9 4113L.01 4633.02l3635.66-883.55z"
    })]
  }));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgSigmaverse);

/***/ }),

/***/ 1745:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgSync = function SvgSync(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", _objectSpread(_objectSpread({
    width: 43,
    height: 43,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("ellipse", {
      cx: 21.497,
      cy: 21.284,
      rx: 21.497,
      ry: 20.753,
      fill: "url(#sync_svg__a)"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.06 29.848c.576 0 1.06-.484 1.06-1.06v-1.636A10.003 10.003 0 0 0 21 31c5.023 0 9.286-3.756 9.908-8.756l.069-.507h-2.12l-.046.392c-.576 3.848-3.917 6.751-7.811 6.751-2.765 0-5.346-1.497-6.774-3.848h2.65c.576 0 1.06-.483 1.06-1.06 0-.576-.484-1.06-1.06-1.06h-4.84c-.506 0-1.036.323-1.036 1.06v4.816c0 .576.484 1.06 1.06 1.06Zm1.083-9.585.046-.392c.576-3.848 3.917-6.751 7.811-6.751 2.765 0 5.346 1.498 6.774 3.848h-2.627c-.576 0-1.06.484-1.06 1.06 0 .576.484 1.06 1.06 1.06h4.793c.438-.023 1.06-.3 1.06-1.06v-4.816c0-.576-.484-1.06-1.06-1.06-.576 0-1.06.484-1.06 1.06v1.636A10.003 10.003 0 0 0 21 11c-5.023 0-9.286 3.756-9.908 8.756l-.069.507h2.12Z",
      fill: "#141414"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("defs", {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("linearGradient", {
        id: "sync_svg__a",
        x1: 21.497,
        y1: 0.531,
        x2: 21.497,
        y2: 42.037,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: 1,
          stopColor: "#FF7C44"
        })]
      })
    })]
  }));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgSync);

/***/ }),

/***/ 5866:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var SvgTelegram = function SvgTelegram(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("svg", _objectSpread(_objectSpread({
    width: 39,
    height: 40,
    className: "fill-current text-black dark:text-white",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M19.375.625C8.672.625 0 9.297 0 20s8.672 19.375 19.375 19.375S38.75 30.703 38.75 20 30.078.625 19.375.625Zm9.453 13.281-3.125 15c-.234 1.094-.86 1.328-1.797.86l-4.843-3.594-2.344 2.265c-.235.235-.469.47-.938.47l.313-4.923 8.984-8.125c.39-.312-.078-.546-.625-.234L13.36 22.656l-4.765-1.484c-1.016-.313-1.016-1.094.234-1.563L27.5 12.422c.86-.313 1.64.234 1.328 1.484Z"
    })
  }));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgTelegram);

/***/ }),

/***/ 8357:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgThemeDarkBig = function SvgThemeDarkBig(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", _objectSpread(_objectSpread({
    width: 81,
    height: 38,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
      filter: "url(#theme-dark-big_svg__a)",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M0 19C0 8.507 8.507 0 19 0h43c10.493 0 19 8.507 19 19s-8.507 19-19 19H19C8.507 38 0 29.493 0 19Z",
        fill: "#141414"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("g", {
        filter: "url(#theme-dark-big_svg__b)",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M64.356 22.735C66.969 15.305 61.273 7.67 53.7 8.011 60.94 14.555 56.65 26.826 47 27.235c5.696 5.112 14.81 2.863 17.356-4.5Z",
          fill: "url(#theme-dark-big_svg__c)"
        })
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("defs", {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("filter", {
        id: "theme-dark-big_svg__a",
        x: 0,
        y: 0,
        width: 81,
        height: 42,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feBlend", {
          "in": "SourceGraphic",
          in2: "BackgroundImageFix",
          result: "shape"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feColorMatrix", {
          "in": "SourceAlpha",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feOffset", {
          dy: 4
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feGaussianBlur", {
          stdDeviation: 4.5
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feComposite", {
          in2: "hardAlpha",
          operator: "arithmetic",
          k2: -1,
          k3: 1
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feColorMatrix", {
          values: "0 0 0 0 0.708333 0 0 0 0 0.708333 0 0 0 0 0.708333 0 0 0 0.25 0"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feBlend", {
          in2: "shape",
          result: "effect1_innerShadow_602_15054"
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("filter", {
        id: "theme-dark-big_svg__b",
        x: 43,
        y: 8,
        width: 26,
        height: 30,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feColorMatrix", {
          "in": "SourceAlpha",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feOffset", {
          dy: 4
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feGaussianBlur", {
          stdDeviation: 2
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feComposite", {
          in2: "hardAlpha",
          operator: "out"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feColorMatrix", {
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feBlend", {
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_602_15054"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feBlend", {
          "in": "SourceGraphic",
          in2: "effect1_dropShadow_602_15054",
          result: "shape"
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("linearGradient", {
        id: "theme-dark-big_svg__c",
        x1: 63.169,
        y1: 8,
        x2: 45.953,
        y2: 9.181,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          stopColor: "#FF7C44"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: 1,
          stopColor: "#FF5E18"
        })]
      })]
    })]
  }));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgThemeDarkBig);

/***/ }),

/***/ 5883:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgThemeDarkSmall = function SvgThemeDarkSmall(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", _objectSpread(_objectSpread({
    width: 50,
    height: 38,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
      filter: "url(#theme-dark-small_svg__a)",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M0 19C0 8.507 8.507 0 19 0h12c10.493 0 19 8.507 19 19s-8.507 19-19 19H19C8.507 38 0 29.493 0 19Z",
        fill: "#141414"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("g", {
        filter: "url(#theme-dark-small_svg__b)",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M41.356 22.735C43.969 15.305 38.273 7.67 30.7 8.011 37.94 14.555 33.65 26.826 24 27.235c5.696 5.112 14.81 2.863 17.356-4.5Z",
          fill: "url(#theme-dark-small_svg__c)"
        })
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("defs", {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("filter", {
        id: "theme-dark-small_svg__a",
        x: 0,
        y: 0,
        width: 50,
        height: 42,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feBlend", {
          "in": "SourceGraphic",
          in2: "BackgroundImageFix",
          result: "shape"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feColorMatrix", {
          "in": "SourceAlpha",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feOffset", {
          dy: 4
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feGaussianBlur", {
          stdDeviation: 4.5
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feComposite", {
          in2: "hardAlpha",
          operator: "arithmetic",
          k2: -1,
          k3: 1
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feColorMatrix", {
          values: "0 0 0 0 0.708333 0 0 0 0 0.708333 0 0 0 0 0.708333 0 0 0 0.25 0"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feBlend", {
          in2: "shape",
          result: "effect1_innerShadow_604_16290"
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("filter", {
        id: "theme-dark-small_svg__b",
        x: 20,
        y: 8,
        width: 26,
        height: 30,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feColorMatrix", {
          "in": "SourceAlpha",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feOffset", {
          dy: 4
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feGaussianBlur", {
          stdDeviation: 2
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feComposite", {
          in2: "hardAlpha",
          operator: "out"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feColorMatrix", {
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feBlend", {
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_604_16290"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feBlend", {
          "in": "SourceGraphic",
          in2: "effect1_dropShadow_604_16290",
          result: "shape"
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("linearGradient", {
        id: "theme-dark-small_svg__c",
        x1: 40.169,
        y1: 8,
        x2: 22.953,
        y2: 9.181,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          stopColor: "#FF7C44"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: 1,
          stopColor: "#FF5E18"
        })]
      })]
    })]
  }));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgThemeDarkSmall);

/***/ }),

/***/ 478:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgThemeLightBig = function SvgThemeLightBig(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", _objectSpread(_objectSpread({
    width: 81,
    height: 38,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
      filter: "url(#theme-light-big_svg__a)",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M0 19C0 8.507 8.507 0 19 0h43c10.493 0 19 8.507 19 19s-8.507 19-19 19H19C8.507 38 0 29.493 0 19Z",
        fill: "#F6F6F6"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("circle", {
        cx: 27,
        cy: 19,
        r: 11,
        fill: "url(#theme-light-big_svg__b)"
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("defs", {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("linearGradient", {
        id: "theme-light-big_svg__b",
        x1: 35.763,
        y1: 8,
        x2: 14.769,
        y2: 9.76,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          stopColor: "#FF7C44"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: 1,
          stopColor: "#FF5E18"
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("filter", {
        id: "theme-light-big_svg__a",
        x: 0,
        y: 0,
        width: 81,
        height: 42,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feBlend", {
          "in": "SourceGraphic",
          in2: "BackgroundImageFix",
          result: "shape"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feColorMatrix", {
          "in": "SourceAlpha",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feOffset", {
          dy: 4
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feGaussianBlur", {
          stdDeviation: 4.5
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feComposite", {
          in2: "hardAlpha",
          operator: "arithmetic",
          k2: -1,
          k3: 1
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feColorMatrix", {
          values: "0 0 0 0 0.595833 0 0 0 0 0.595833 0 0 0 0 0.595833 0 0 0 0.3 0"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feBlend", {
          in2: "shape",
          result: "effect1_innerShadow_602_15056"
        })]
      })]
    })]
  }));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgThemeLightBig);

/***/ }),

/***/ 2650:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgThemeLightSmall = function SvgThemeLightSmall(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", _objectSpread(_objectSpread({
    width: 50,
    height: 34,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
      filter: "url(#theme-light-small_svg__a)",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M0 17C0 7.611 7.611 0 17 0h16c9.389 0 17 7.611 17 17s-7.611 17-17 17H17C7.611 34 0 26.389 0 17Z",
        fill: "#F6F6F6"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("circle", {
        cx: 17,
        cy: 17,
        r: 9,
        fill: "url(#theme-light-small_svg__b)"
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("defs", {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("linearGradient", {
        id: "theme-light-small_svg__b",
        x1: 24.169,
        y1: 8,
        x2: 6.993,
        y2: 9.44,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          stopColor: "#FF7C44"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: 1,
          stopColor: "#FF5E18"
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("filter", {
        id: "theme-light-small_svg__a",
        x: 0,
        y: 0,
        width: 50,
        height: 38,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feBlend", {
          "in": "SourceGraphic",
          in2: "BackgroundImageFix",
          result: "shape"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feColorMatrix", {
          "in": "SourceAlpha",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feOffset", {
          dy: 4
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feGaussianBlur", {
          stdDeviation: 4.5
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feComposite", {
          in2: "hardAlpha",
          operator: "arithmetic",
          k2: -1,
          k3: 1
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feColorMatrix", {
          values: "0 0 0 0 0.595833 0 0 0 0 0.595833 0 0 0 0 0.595833 0 0 0 0.3 0"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("feBlend", {
          in2: "shape",
          result: "effect1_innerShadow_604_16292"
        })]
      })]
    })]
  }));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgThemeLightSmall);

/***/ }),

/***/ 2838:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgUniqueErgo1 = function SvgUniqueErgo1(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", _objectSpread(_objectSpread({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 290 150",
    width: "100%",
    height: "100%"
  }, props), {}, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M211.629 0a75.117 75.117 0 0 1 53.108 21.914 74.777 74.777 0 0 1 22.001 53.064 74.516 74.516 0 0 1-22.001 53.04A74.904 74.904 0 0 1 211.629 150a74.86 74.86 0 0 1-53.085-21.982 74.496 74.496 0 0 1-22-53.04 74.755 74.755 0 0 1 22-53.064A75.096 75.096 0 0 1 211.629 0Zm51.485 23.581A72.583 72.583 0 0 0 239.5 7.795a72.64 72.64 0 0 0-27.871-5.52 72.64 72.64 0 0 0-27.858 5.524 72.59 72.59 0 0 0-23.604 15.782 72.524 72.524 0 0 0-15.8 23.595 72.47 72.47 0 0 0-5.524 27.846 72.524 72.524 0 0 0 21.324 51.487 72.62 72.62 0 0 0 51.462 21.306 72.596 72.596 0 0 0 51.485-21.306 72.543 72.543 0 0 0 21.325-51.486 72.508 72.508 0 0 0-21.325-51.441Z",
      fill: "url(#unique-ergo-1_svg__a)"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M174.228 46.955a1.783 1.783 0 0 1-2.377.369 1.714 1.714 0 0 1-.324-2.374 50.66 50.66 0 0 1 18.42-15.127 49.85 49.85 0 0 1 23.056-4.94 50.034 50.034 0 0 1 19.077 4.271 49.99 49.99 0 0 1 15.979 11.254 50.064 50.064 0 0 1 13.779 35.718 50.093 50.093 0 0 1-15.561 35.026 50.034 50.034 0 0 1-35.903 13.651 49.065 49.065 0 0 1-22.777-6.16 49.815 49.815 0 0 1-17.637-15.966 1.712 1.712 0 0 1 .443-2.355 1.717 1.717 0 0 1 2.355.487 46.728 46.728 0 0 0 16.289 14.896 46.092 46.092 0 0 0 21.298 5.763 46.6 46.6 0 0 0 33.357-12.837 46.559 46.559 0 0 0 14.511-32.686 46.528 46.528 0 0 0-12.848-33.329 46.622 46.622 0 0 0-32.669-14.497 46.104 46.104 0 0 0-21.561 4.685 46.082 46.082 0 0 0-16.907 14.151Z",
      fill: "url(#unique-ergo-1_svg__b)"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M103.655 148.896c40.859 0 73.981-33.095 73.981-73.92 0-40.823-33.122-73.918-73.981-73.918-40.859 0-73.981 33.095-73.981 73.919s33.122 73.919 73.981 73.919Z",
      stroke: "#fff",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M33.164 1.487A38.683 38.683 0 0 1 61.821 8.8a38.62 38.62 0 0 1 15.096 25.412 38.594 38.594 0 0 1-7.31 28.647 38.65 38.65 0 0 1-25.443 15.092 38.728 38.728 0 0 1-28.66-7.319A38.665 38.665 0 0 1 .39 45.226a38.647 38.647 0 0 1 7.333-28.643A38.71 38.71 0 0 1 33.164 1.487Z",
      fill: "url(#unique-ergo-1_svg__c)"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M275.986 125.044c7.519 0 13.615-6.091 13.615-13.604 0-7.513-6.096-13.603-13.615-13.603-7.52 0-13.615 6.09-13.615 13.603s6.095 13.604 13.615 13.604ZM207.237 33.4a6.58 6.58 0 0 0 6.582-6.577 6.58 6.58 0 0 0-6.582-6.577 6.579 6.579 0 0 0-6.582 6.577 6.579 6.579 0 0 0 6.582 6.576Z",
      fill: "#fff"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M157.055 81.554a6.58 6.58 0 0 0 6.583-6.576 6.58 6.58 0 0 0-6.583-6.577 6.58 6.58 0 0 0-6.582 6.577 6.58 6.58 0 0 0 6.582 6.576Z",
      fill: "#FF5E18"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("defs", {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("linearGradient", {
        id: "unique-ergo-1_svg__a",
        x1: 196.12,
        y1: 38.22,
        x2: 241.139,
        y2: 144.103,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          stopColor: "#FF5E18",
          stopOpacity: 0
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: 0.4,
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: 1,
          stopColor: "#FF5E18"
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("linearGradient", {
        id: "unique-ergo-1_svg__b",
        x1: 215.663,
        y1: 104.659,
        x2: 246.7,
        y2: 34.453,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          stopColor: "#FF5E18",
          stopOpacity: 0
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: 0.54,
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: 1,
          stopColor: "#FF5E18"
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("radialGradient", {
        id: "unique-ergo-1_svg__c",
        cx: 0,
        cy: 0,
        r: 1,
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "matrix(0 38.6222 -38.656 0 38.656 39.718)",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: 0.609,
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: 0.969,
          stopColor: "#FF5E18",
          stopOpacity: 0
        })]
      })]
    })]
  }));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgUniqueErgo1);

/***/ }),

/***/ 9510:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgUniqueErgo2 = function SvgUniqueErgo2(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", _objectSpread(_objectSpread({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 148 151",
    width: "100%",
    height: "100%"
  }, props), {}, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M73.838 150c40.228 0 72.838-32.583 72.838-72.777 0-40.193-32.61-72.777-72.838-72.777C33.611 4.446 1 37.03 1 77.223 1 117.417 33.61 150 73.838 150Z",
      stroke: "#fff",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M73.84 120.082c23.691 0 42.896-19.189 42.896-42.86 0-23.67-19.205-42.86-42.895-42.86-23.69 0-42.896 19.19-42.896 42.86 0 23.671 19.205 42.86 42.896 42.86Z",
      stroke: "#fff",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M68.121 38.242a39.52 39.52 0 0 1 29.276 7.466 39.435 39.435 0 0 1 15.421 25.955 39.407 39.407 0 0 1-7.475 29.243 39.508 39.508 0 0 1-41.363 14.583 39.48 39.48 0 0 1-13.894-6.641A39.431 39.431 0 0 1 39.796 97.4a39.384 39.384 0 0 1-5.117-14.511 39.44 39.44 0 0 1 7.478-29.231 39.524 39.524 0 0 1 25.964-15.416Z",
      fill: "url(#unique-ergo-2_svg__a)"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M73.84 124.474c2.457 0 4.45-1.99 4.45-4.445a4.448 4.448 0 0 0-4.45-4.446 4.448 4.448 0 0 0-4.45 4.446 4.447 4.447 0 0 0 4.45 4.445Z",
      fill: "#FF5E18"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M92.694 28.178a1.329 1.329 0 0 1-.789-1.792 1.325 1.325 0 0 1 1.258-.902c.185 0 .367.039.536.113a55.298 55.298 0 0 1 25.78 20.31 55.173 55.173 0 0 1 9.616 31.369 55.084 55.084 0 0 1-9.687 31.19 55.236 55.236 0 0 1-25.78 20.327 1.344 1.344 0 0 1-1.795-.788 1.384 1.384 0 0 1 .332-1.504c.132-.125.288-.224.458-.289a52.497 52.497 0 0 0 24.488-19.324 51.946 51.946 0 0 0 9.275-29.612 52.05 52.05 0 0 0-9.203-29.702 52.773 52.773 0 0 0-24.489-19.396ZM55.02 126.212a1.384 1.384 0 0 1 .768.732 1.38 1.38 0 0 1 .022 1.061 1.366 1.366 0 0 1-1.794.788 55.23 55.23 0 0 1-25.78-20.327 54.963 54.963 0 0 1-9.617-31.19 55.052 55.052 0 0 1 9.706-31.244 55.302 55.302 0 0 1 25.78-20.31 1.346 1.346 0 0 1 1.794.79 1.325 1.325 0 0 1-.789 1.792A52.774 52.774 0 0 0 30.55 47.52a51.953 51.953 0 0 0-9.204 29.756 51.737 51.737 0 0 0 9.204 29.666 52.505 52.505 0 0 0 24.488 19.27h-.018Z",
      fill: "url(#unique-ergo-2_svg__b)"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M95.8 15.523a7.764 7.764 0 0 0 7.768-7.761A7.764 7.764 0 0 0 95.8 0c-4.29 0-7.768 3.475-7.768 7.762 0 4.286 3.478 7.761 7.768 7.761ZM20.056 137.094c5.985 0 10.836-4.848 10.836-10.827 0-5.98-4.851-10.827-10.836-10.827-5.984 0-10.836 4.847-10.836 10.827 0 5.979 4.852 10.827 10.836 10.827Z",
      fill: "#FF5E18"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("defs", {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("radialGradient", {
        id: "unique-ergo-2_svg__a",
        cx: 0,
        cy: 0,
        r: 1,
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "matrix(0 39.4357 -39.469 0 73.75 77.277)",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: 0.557,
          stopColor: "#FF5E18",
          stopOpacity: 0.589
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: 1,
          stopColor: "#FF5E18",
          stopOpacity: 0
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("linearGradient", {
        id: "unique-ergo-2_svg__b",
        x1: 58.501,
        y1: 80.862,
        x2: 57.605,
        y2: 25.293,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: 0.34,
          stopColor: "#FF5E18",
          stopOpacity: 0.46
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: 1,
          stopColor: "#FF5E18",
          stopOpacity: 0
        })]
      })]
    })]
  }));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgUniqueErgo2);

/***/ }),

/***/ 7548:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgUniqueErgo3 = function SvgUniqueErgo3(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", _objectSpread(_objectSpread({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 151 150",
    width: "100%",
    height: "100%"
  }, props), {}, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m90.883 89.643 59.321 59.255-1.151 1.102-59.305-59.255 1.135-1.102Z",
      fill: "url(#unique-ergo-3_svg__a)"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M74.413 74.305c28.653-28.63 59.881-43.918 69.714-34.14 9.834 9.776-5.516 41.026-34.185 69.655-28.67 28.629-59.881 43.966-69.715 34.141-9.833-9.826 5.5-40.963 34.186-69.656Z",
      stroke: "#fff",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M115.318 56.858a41.69 41.69 0 0 1 16.251 27.418 41.667 41.667 0 0 1-7.873 30.879 41.676 41.676 0 0 1-27.437 16.264 41.697 41.697 0 0 1-30.909-7.892 41.624 41.624 0 0 1-8.379-58.297 41.657 41.657 0 0 1 12.1-10.86 41.692 41.692 0 0 1 31.578-4.53 41.685 41.685 0 0 1 14.669 7.018Z",
      fill: "url(#unique-ergo-3_svg__b)"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M103.198 76.621a.764.764 0 0 1 0 1.103.766.766 0 0 1-1.135 0 122.774 122.774 0 0 1-24.448-35.355C70.244 26.68 66.422 11.168 65.958.83a.846.846 0 0 1 .8-.83.832.832 0 0 1 .847.75c.432 10.257 4.142 25.562 11.465 41.01a120.714 120.714 0 0 0 24.128 34.86ZM76.256 100.89a.847.847 0 0 1 0 1.15.848.848 0 0 1-1.151 0 116.492 116.492 0 0 0-34.138-23.82C25.889 71.222 11.034 67.835.753 67.34a.783.783 0 0 1-.751-.83.767.767 0 0 1 .847-.751c10.441.48 25.583 3.914 40.821 11.055a117.707 117.707 0 0 1 34.586 24.06v.016Zm6.747-6.07a.814.814 0 0 1 0 1.134.816.816 0 0 1-1.15 0 226.818 226.818 0 0 0-31.884-26.648c-13.144-9.17-25.184-15.513-32.987-18.42a.768.768 0 0 1-.447-1.007.784.784 0 0 1 1.023-.496c7.995 2.956 20.067 9.394 33.338 18.596a232.666 232.666 0 0 1 32.107 26.824v.016Zm6.748-6.04a.782.782 0 0 1 0 1.103.848.848 0 0 1-1.151 0C74.8 76.094 60.73 61.908 49.697 50.836 42.95 44.062 37.45 38.503 33.164 34.237a.782.782 0 0 1 0-1.102.816.816 0 0 1 1.151 0c3.342 3.339 9.306 9.298 16.485 16.567C61.433 60.39 75.01 74.049 89.75 88.763v.016Zm6.731-6.087a.75.75 0 0 1 0 1.103.798.798 0 0 1-1.135 0 227.707 227.707 0 0 1-26.91-32.288c-9.386-13.58-15.99-26.04-18.948-34.013a.75.75 0 0 1 .48-1.022.768.768 0 0 1 1.007.447c2.91 7.876 9.45 20.226 18.74 33.71a231.91 231.91 0 0 0 26.767 32.048v.015Z",
      fill: "url(#unique-ergo-3_svg__c)"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M85.464 85.329c8.779-8.82 18.117-13.756 20.787-11.056 2.67 2.7-2.255 11.982-11.08 20.769-8.827 8.787-18.117 13.755-20.787 11.055-2.67-2.7 2.254-11.902 11.08-20.768ZM129.515 34.476a6.814 6.814 0 0 1 0 9.745 6.896 6.896 0 0 1-9.738 0 6.866 6.866 0 0 1 0-9.745 6.894 6.894 0 0 1 9.738 0ZM59.495 142.906a3.988 3.988 0 0 1 0 5.687 4 4 0 0 1-5.645 0 3.976 3.976 0 0 1 0-5.687 4.03 4.03 0 0 1 5.645 0Z",
      fill: "#FF5E18"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M93.841 66.428a1.215 1.215 0 0 1-1.678-.224 1.198 1.198 0 0 1 .223-1.597 86.722 86.722 0 0 1 22.849-13.548c6.7-2.428 12.073-2.38 15.031.623 2.958 3.004 3.006 8.324.623 15.018a89.991 89.991 0 0 1-13.495 22.83 1.278 1.278 0 0 1-1.727.223 1.196 1.196 0 0 1-.176-1.677 87.85 87.85 0 0 0 13.144-22.16c2.078-5.83 2.206-10.32 0-12.556-2.207-2.237-6.748-2.125-12.568 0a85.21 85.21 0 0 0-22.226 13.068Zm-5.692 48.903a1.263 1.263 0 0 1 1.727.224 1.18 1.18 0 0 1-.224 1.597 87.147 87.147 0 0 1-22.88 13.484c-6.717 2.428-12.041 2.38-15.047-.607-3.006-2.988-2.99-8.34-.576-15.034a88.566 88.566 0 0 1 13.495-22.813 1.2 1.2 0 0 1 1.68-.224 1.198 1.198 0 0 1 .223 1.597 84.826 84.826 0 0 0-13.143 22.207c-2.079 5.768-2.207 10.257 0 12.51 2.206 2.252 6.747 2.108 12.52 0 6.395-2.125 14.118-6.647 22.225-12.941Z",
      fill: "url(#unique-ergo-3_svg__d)"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M80.972 80.823c16.885-16.87 34.794-26.344 39.974-21.184 5.181 5.16-4.365 23.037-21.25 39.94-16.885 16.903-34.745 26.345-39.974 21.184-5.228-5.16 4.35-23.053 21.25-39.94Z",
      stroke: "url(#unique-ergo-3_svg__e)",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("defs", {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("linearGradient", {
        id: "unique-ergo-3_svg__a",
        x1: 129.946,
        y1: 140.526,
        x2: 100.527,
        y2: 110.476,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          stopColor: "#fff",
          stopOpacity: 0
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: 0.505,
          stopColor: "#DBDBDB"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: 1,
          stopColor: "#FF5E18"
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("linearGradient", {
        id: "unique-ergo-3_svg__c",
        x1: 29.212,
        y1: 33.486,
        x2: 81.136,
        y2: 83.854,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          stopColor: "#fff",
          stopOpacity: 0
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: 0.515,
          stopColor: "#824E38"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: 1,
          stopColor: "#FF5E18"
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("linearGradient", {
        id: "unique-ergo-3_svg__d",
        x1: 83.577,
        y1: 75.822,
        x2: 117.929,
        y2: 106.205,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          stopColor: "#fff",
          stopOpacity: 0
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: 0.526,
          stopColor: "#FF5E18"
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("linearGradient", {
        id: "unique-ergo-3_svg__e",
        x1: 102.136,
        y1: 103.416,
        x2: 81.196,
        y2: 84.186,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          stopColor: "#fff"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: 1,
          stopColor: "#fff",
          stopOpacity: 0
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("radialGradient", {
        id: "unique-ergo-3_svg__b",
        cx: 0,
        cy: 0,
        r: 1,
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "rotate(48.745 -54.38 144.783) scale(38.2633 38.253)",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: 0.578,
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: 0.97,
          stopColor: "#FF5E18",
          stopOpacity: 0
        })]
      })]
    })]
  }));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgUniqueErgo3);

/***/ }),

/***/ 2435:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgUniqueErgo4 = function SvgUniqueErgo4(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", _objectSpread(_objectSpread({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 140 151",
    width: "100%",
    height: "100%"
  }, props), {}, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M63.343 26a44.072 44.072 0 0 1 32.623 8.35 44 44 0 0 1 16.27 46.085 43.948 43.948 0 0 1-7.414 15.49 44 44 0 0 1-28.994 17.178 44.07 44.07 0 0 1-32.655-8.33 44 44 0 0 1-17.2-28.959 44.013 44.013 0 0 1 8.366-32.635 44.084 44.084 0 0 1 29.004-17.178Z",
      fill: "url(#unique-ergo-4_svg__a)"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M69.643 1a68.706 68.706 0 0 0-48.54 20.11A68.59 68.59 0 0 0 1 69.618a68.525 68.525 0 0 0 10.303 36.094 68.6 68.6 0 0 0 27.777 25.266c7.35 3.68 14.58 1.773 17.554-4.287 3.598-7.208 3.497-16.88-4.325-20.611a40.383 40.383 0 0 1-16.814-14.895 40.336 40.336 0 0 1-6.247-21.567 40.314 40.314 0 0 1 11.826-28.544 40.382 40.382 0 0 1 28.569-11.816 40.375 40.375 0 0 1 28.545 11.824 40.301 40.301 0 0 1 11.799 28.536 40.336 40.336 0 0 1-6.247 21.567 40.386 40.386 0 0 1-16.814 14.895c-7.823 3.714-7.873 13.403-4.342 20.611 3.04 6.06 10.255 7.967 17.621 4.287a68.64 68.64 0 0 0 27.734-25.282 68.567 68.567 0 0 0 10.279-36.078 68.514 68.514 0 0 0-20.06-48.504 68.607 68.607 0 0 0-22.255-14.88A68.659 68.659 0 0 0 69.643 1v0Z",
      stroke: "#fff",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M88.515 20.311a1.285 1.285 0 0 1-.76-1.688 1.351 1.351 0 0 1 1.69-.742 55.744 55.744 0 0 1 25.764 20.256 54.803 54.803 0 0 1 9.765 31.482 54.675 54.675 0 0 1-9.681 31.245 55.576 55.576 0 0 1-25.764 20.257 1.373 1.373 0 0 1-1.69-.743 1.316 1.316 0 0 1 .76-1.688 52.912 52.912 0 0 0 24.549-19.328 52.558 52.558 0 0 0 9.241-29.743 52.634 52.634 0 0 0-9.241-29.895A53.346 53.346 0 0 0 88.515 20.31Zm-37.793 98.463a1.297 1.297 0 0 1 .833 1.187c.004.171-.027.342-.09.501a1.288 1.288 0 0 1-.687.729 1.267 1.267 0 0 1-1.002.014 55.748 55.748 0 0 1-25.815-20.256 54.949 54.949 0 0 1-9.63-31.33 55.048 55.048 0 0 1 9.698-31.28 55.576 55.576 0 0 1 25.815-20.256 1.285 1.285 0 0 1 1.69.743 1.247 1.247 0 0 1-.744 1.688A52.872 52.872 0 0 0 26.19 39.926 52.163 52.163 0 0 0 16.85 69.62a52.08 52.08 0 0 0 9.275 29.793 52.363 52.363 0 0 0 24.598 19.362Z",
      fill: "url(#unique-ergo-4_svg__b)"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M69.644 76.877a7.312 7.312 0 0 0 7.315-7.309 7.312 7.312 0 0 0-7.315-7.31 7.312 7.312 0 0 0-7.315 7.31 7.312 7.312 0 0 0 7.315 7.31Z",
      fill: "#fff"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M68.32 69.62a1.333 1.333 0 0 1 1.319-1.3 1.285 1.285 0 0 1 1.267 1.3v80.08a1.284 1.284 0 0 1-1.25 1.3 1.335 1.335 0 0 1-1.318-1.3l-.017-80.08Z",
      fill: "url(#unique-ergo-4_svg__c)"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("defs", {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("linearGradient", {
        id: "unique-ergo-4_svg__b",
        x1: 46.8,
        y1: 31.638,
        x2: 107.556,
        y2: 110.181,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: 0.51,
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: 1,
          stopColor: "#121212"
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("linearGradient", {
        id: "unique-ergo-4_svg__c",
        x1: 62.85,
        y1: 142.205,
        x2: 62.007,
        y2: 72.995,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          stopColor: "#121212",
          stopOpacity: 0
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: 0.681,
          stopColor: "#fff"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: 1,
          stopColor: "#fff"
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("radialGradient", {
        id: "unique-ergo-4_svg__a",
        cx: 0,
        cy: 0,
        r: 1,
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "matrix(0 43.9948 -44.0349 0 69.565 69.555)",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: 0.443,
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: 0.964,
          stopColor: "#FF5E18",
          stopOpacity: 0
        })]
      })]
    })]
  }));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgUniqueErgo4);

/***/ }),

/***/ 417:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgUsingErgBuyIt = function SvgUsingErgBuyIt(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", _objectSpread(_objectSpread({
    width: "auto",
    height: "auto",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 224 414"
  }, props), {}, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
      clipPath: "url(#clip0_1_1463)",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M43.9703 411.806L63.5851 414.029L81.985 375.752C90.1332 358.821 93.5702 345.894 81.1554 333.975C77.2662 330.445 72.9213 327.453 68.2369 325.08C63.674 322.619 56.1481 320.247 52.2369 323.034L48.5628 329.735L38.5776 346.428C45.6887 338.897 50.6073 330.625 59.8221 334.39C76.9777 347.228 75.348 356.39 63.5851 378.212L43.9703 411.806Z",
        fill: "url(#paint0_linear_1_1463)"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M46.6668 406.588L51.8224 407.151L69.6001 376.078C82.3409 353.93 80.3853 346.428 61.1853 335.28C59.1895 333.858 56.7846 333.126 54.3356 333.196C51.8865 333.266 49.527 334.133 47.615 335.666C44.0847 338.657 40.9039 342.039 38.1335 345.746L35.9409 348.711C38.7471 345.995 41.8137 343.562 45.0965 341.447C53.5705 335.784 57.3335 339.401 64.0298 343.819C74.7557 350.906 73.6891 358.644 65.1854 374.625L46.6668 406.588Z",
        fill: "url(#paint1_linear_1_1463)"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M98.2222 62.3237H190.637V200.166C183.724 202.486 177.133 205.674 171.022 209.654C161.215 216.117 162.133 230.112 176.267 226.346C178.222 225.783 180.178 225.279 182.193 224.716C163.141 233.284 171.881 251.4 186.667 245.47C188.059 244.966 189.363 244.729 190.667 244.225V252.409L184.889 254.128L177.926 257.479L174.815 262.134L98.3407 261.392V225.516L101.541 214.309L104.296 198.772L104.711 190.767L102.904 178.403L98.3407 171.198L98.2222 62.3237Z",
        fill: "url(#paint2_linear_1_1463)"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M85.6592 198.238L88.4444 185.4L88.5925 179.737C91.1999 180.982 93.0073 183.354 92.6814 188.632C91.6506 196.468 89.7831 204.172 87.111 211.61C83.5258 220.861 80.4147 226.435 78.0444 232.543C68.8888 255.107 69.5407 293.384 91.1999 312.36L79.9406 312.598C71.0517 312.835 72.3258 314.08 67.7629 321.997L22.2517 402.051H1.65918L21.9258 371.956L39.5555 345.064L46.0147 334.361L51.0814 325.466L54.5184 318.854L57.6295 310.759L59.7628 300.678L60.7999 290.627L61.7777 275.506L62.9332 258.012L63.4962 252.853L65.2147 244.581L68.1777 237.228L73.0073 228.007L78.1332 218.341L81.3332 211.551L83.7925 205.087L85.6592 198.238Z",
        fill: "url(#paint3_linear_1_1463)"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M114.341 281.791C109.748 316.867 157.719 302.724 165.896 285.142C169.985 276.395 114.578 279.923 114.341 281.791Z",
        fill: "url(#paint4_linear_1_1463)"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M190.489 272.541V281.702C190.481 283.587 189.729 285.393 188.398 286.726C187.066 288.058 185.261 288.811 183.378 288.818H105.185C103.306 288.795 101.511 288.038 100.183 286.709C98.8539 285.379 98.0973 283.583 98.0742 281.702V227.088M98.0742 171.642V125.685C98.1047 123.808 98.8637 122.015 100.191 120.687C101.518 119.359 103.309 118.6 105.185 118.569H183.378C185.259 118.585 187.059 119.34 188.389 120.671C189.719 122.002 190.474 123.803 190.489 125.685V200.166M190.489 243.84V252.735",
        stroke: "white",
        strokeWidth: "3",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M144.326 20.2212C143.822 20.2127 143.321 20.2929 142.845 20.4584L112.119 33.2078C111.668 33.3936 111.262 33.6716 110.925 34.0239C110.588 34.3762 110.329 34.7951 110.163 35.2536L97.4224 66.0004C97.2035 66.4639 97.0898 66.9702 97.0898 67.4829C97.0898 67.9956 97.2035 68.5019 97.4224 68.9654L110.163 99.7122C110.331 100.159 110.592 100.565 110.93 100.902C111.267 101.24 111.672 101.501 112.119 101.669L142.845 114.419C143.307 114.639 143.814 114.751 144.326 114.745C144.81 114.751 145.288 114.639 145.719 114.419L176.445 101.669C176.903 101.503 177.321 101.244 177.673 100.907C178.026 100.57 178.303 100.163 178.489 99.7122L191.23 68.9654C191.576 68.0074 191.576 66.9584 191.23 66.0004L178.489 35.2536C178.306 34.7911 178.03 34.371 177.678 34.0191C177.327 33.6673 176.907 33.3912 176.445 33.2078L145.719 20.4584C145.275 20.2884 144.801 20.2078 144.326 20.2212ZM144.326 28.7899L171.615 40.0865L182.904 67.394L171.615 94.7014L144.326 106.057L117.037 94.7014L105.659 67.394L117.037 40.0865L144.326 28.7899Z",
        fill: "#121212"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M182.904 67.3941L171.615 40.057L144.326 28.79L117.037 40.057L105.659 67.3941L117.037 94.7015L144.326 106.057L171.615 94.7015L182.904 67.3941Z",
        fill: "#121212"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M141.304 73.1759H159.615V81.6854H129.037V74.0061L141.037 60.6637L129.126 48.1515V40.4722H159.615V48.9817H141.719L152.83 60.6044L141.304 73.1759Z",
        fill: "white"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M144.326 13.8467C143.817 13.8696 143.316 13.98 142.844 14.1728L112.118 26.9222C111.672 27.0902 111.267 27.3517 110.929 27.6892C110.592 28.0267 110.331 28.4324 110.163 28.8791L97.4222 59.7149C97.217 60.1455 97.1104 60.6165 97.1104 61.0936C97.1104 61.5707 97.217 62.0417 97.4222 62.4723L110.074 93.4267C110.237 93.8764 110.496 94.2848 110.834 94.623C111.172 94.9612 111.58 95.2208 112.03 95.3836L142.756 108.163C143.231 108.341 143.73 108.451 144.237 108.489C144.716 108.458 145.187 108.347 145.63 108.163L176.355 95.3836C176.816 95.223 177.238 94.9651 177.59 94.6275C177.943 94.2899 178.219 93.8804 178.4 93.4267L191.141 62.5909C191.467 61.7008 191.467 60.7236 191.141 59.8335L178.4 28.9977C178.214 28.547 177.936 28.1401 177.584 27.8031C177.232 27.4661 176.814 27.2065 176.355 27.0408L145.63 14.2914C145.227 14.0622 144.785 13.9114 144.326 13.8467ZM144.326 22.5044L171.615 33.7713L182.904 61.1085L171.615 88.4159L144.326 99.6828L117.037 88.4159L105.659 61.1085L117.037 33.7713L144.326 22.5044Z",
        fill: "white"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M1.48145 402.229C17.837 377.145 39.3185 347.851 52.8889 321.937C61.4518 305.511 59.9999 297.18 62.9333 257.923C63.9999 244.433 66.7852 238.71 74.3704 225.309C82.0694 212.488 86.7882 198.099 88.1777 183.206C89.4221 170.605 92.2666 168.381 95.9407 170.279C106.815 175.764 104.83 194.651 102.815 207.578C101.007 217.955 95.0518 231.683 98.0741 240.608",
        stroke: "white",
        strokeWidth: "3",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M95.6147 401.992L110.074 370.593C116.859 355.768 120.8 348.177 126.341 340.587C139.911 322.175 162.874 307.053 175.941 288.67",
        stroke: "white",
        strokeWidth: "3",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M176.119 226.435C178.074 225.872 180.03 225.368 182.045 224.805C162.993 233.373 171.734 251.489 186.519 245.56C195.378 242.03 204.717 239.852 214.222 239.096C223.615 233.373 220.771 221.84 211.615 217.837C214.578 210.395 214.578 198.772 202.222 198.298C192.978 197.942 179.082 204.406 170.993 209.802C161.067 216.206 161.985 230.201 176.119 226.435Z",
        stroke: "white",
        strokeWidth: "3",
        strokeLinejoin: "round"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M208.296 249.325C201.452 250.807 191.141 252.29 184.593 254.158C167.674 258.576 172.741 276.899 188.978 272.956C196.12 271.511 203.142 269.529 209.985 267.026C223.348 261.689 220.385 246.805 208.296 249.325Z",
        stroke: "white",
        strokeWidth: "3",
        strokeMiterlimit: "10"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M211.496 217.778C201.345 218.749 191.375 221.114 181.867 224.805",
        stroke: "white",
        strokeWidth: "3",
        strokeMiterlimit: "10"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M190.489 174.341C194.974 168.379 200.316 163.113 206.341 158.715C216.059 151.362 230.459 158.715 217.126 172.473C208.92 180.92 201.204 189.829 194.015 199.158",
        stroke: "white",
        strokeWidth: "3",
        strokeMiterlimit: "10"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M214.104 239.007L198.489 251.193",
        stroke: "white",
        strokeWidth: "3",
        strokeMiterlimit: "10"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M98.0742 278.678V261.511L173.571 262.164L174.785 267.975L180.119 272.689L184.533 273.43L190.489 272.541V281.703L188.771 286.269L183.378 288.819H170.4H107.052L101.985 287.989L98.815 284.638L98.0742 278.678Z",
        fill: "white"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M173.808 16.0109C178.226 16.0109 181.808 12.4267 181.808 8.00544C181.808 3.58416 178.226 0 173.808 0C169.389 0 165.808 3.58416 165.808 8.00544C165.808 12.4267 169.389 16.0109 173.808 16.0109Z",
        fill: "white"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M75.3479 81.9521H85.748C86.7072 82.0354 87.5955 82.4921 88.2217 83.224C88.8478 83.956 89.1619 84.9046 89.0961 85.8659V97.9037C89.1619 98.865 88.8478 99.8137 88.2217 100.546C87.5955 101.278 86.7072 101.734 85.748 101.817H75.3479C74.3887 101.734 73.5004 101.278 72.8743 100.546C72.2481 99.8137 71.9341 98.865 71.9998 97.9037V85.8659C71.9341 84.9046 72.2481 83.956 72.8743 83.224C73.5004 82.4921 74.3887 82.0354 75.3479 81.9521Z",
        fill: "#FF5E18",
        stroke: "#FF5E18",
        strokeMiterlimit: "10"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M165.067 108.696H175.467C177.304 108.696 178.815 111.068 178.815 114.004V130.103C178.815 133.068 177.304 135.411 175.467 135.411H165.067C163.23 135.411 161.719 133.039 161.719 130.103V114.004C161.719 111.217 163.23 108.696 165.067 108.696Z",
        fill: "white",
        stroke: "#FF5E18",
        strokeWidth: "3",
        strokeMiterlimit: "10"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M137.037 140.065V203.605L125.126 186.527",
        stroke: "white",
        strokeWidth: "3",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M151.911 203.605V140.065L163.852 157.173",
        stroke: "white",
        strokeWidth: "3",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M85.7481 252.023C85.2444 261.274 82.3703 271.325 76.6517 275.565C67.9999 281.97 61.6295 263.142 68.1776 246.864C75.4369 228.896 87.0518 226.999 85.7481 252.023Z",
        fill: "#FF5E18"
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("defs", {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("linearGradient", {
        id: "paint0_linear_1_1463",
        x1: "63.9448",
        y1: "321.777",
        x2: "63.9448",
        y2: "414.029",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: "1",
          stopColor: "#FF5E18",
          stopOpacity: "0"
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("linearGradient", {
        id: "paint1_linear_1_1463",
        x1: "59.2594",
        y1: "352.833",
        x2: "56.8109",
        y2: "407.151",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          stopColor: "white"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: "1",
          stopColor: "#121212",
          stopOpacity: "0"
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("linearGradient", {
        id: "paint2_linear_1_1463",
        x1: "75.5554",
        y1: "249.058",
        x2: "36.9885",
        y2: "114.165",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          stopColor: "#FF5E18",
          stopOpacity: "0"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: "1",
          stopColor: "#FF5E18"
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("linearGradient", {
        id: "paint3_linear_1_1463",
        x1: "59.259",
        y1: "210.513",
        x2: "69.6434",
        y2: "314.286",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          stopColor: "white"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: "1",
          stopColor: "#121212",
          stopOpacity: "0"
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("linearGradient", {
        id: "paint4_linear_1_1463",
        x1: "158.519",
        y1: "290.568",
        x2: "117.033",
        y2: "302.413",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: "1",
          stopColor: "#121212"
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("clipPath", {
        id: "clip0_1_1463",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("rect", {
          width: "224",
          height: "414",
          fill: "white"
        })
      })]
    })]
  }));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgUsingErgBuyIt);

/***/ }),

/***/ 9140:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgUsingErgBuyItLight = function SvgUsingErgBuyItLight(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", _objectSpread(_objectSpread({
    width: "auto",
    height: "auto",
    fill: "none",
    viewBox: "0 0 224 414",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
      clipPath: "url(#using-erg-buy-it-light_svg__a)",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "m43.97 411.806 19.615 2.223 18.4-38.277c8.148-16.931 11.585-29.858-.83-41.777a58.673 58.673 0 0 0-12.918-8.895c-4.563-2.461-12.089-4.833-16-2.046l-3.674 6.701-9.985 16.693c7.11-7.531 12.03-15.803 21.244-12.038 17.156 12.838 15.526 22 3.763 43.822L43.97 411.806Z",
        fill: "url(#using-erg-buy-it-light_svg__b)"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "m46.667 406.588 5.155.563L69.6 376.078c12.74-22.148 10.785-29.65-8.415-40.798a11.25 11.25 0 0 0-13.57.386 61.336 61.336 0 0 0-9.482 10.08l-2.192 2.965a59.506 59.506 0 0 1 9.155-7.264c8.474-5.663 12.237-2.046 18.934 2.372 10.726 7.087 9.659 14.825 1.155 30.806l-18.518 31.963Z",
        fill: "url(#using-erg-buy-it-light_svg__c)"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M98.222 62.324h92.415v137.842a86.188 86.188 0 0 0-19.615 9.488c-9.807 6.464-8.889 20.458 5.245 16.693 1.955-.563 3.911-1.068 5.926-1.631-19.052 8.569-10.312 26.685 4.474 20.755 1.392-.504 2.696-.741 4-1.245v8.183l-5.778 1.72-6.963 3.35-3.111 4.655-76.474-.741v-35.876l3.2-11.208 2.755-15.536.415-8.006-1.807-12.364-4.563-7.205-.119-108.874Z",
        fill: "url(#using-erg-buy-it-light_svg__d)"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "m85.66 198.239 2.785-12.839.148-5.663c2.607 1.246 4.414 3.618 4.088 8.895a110.644 110.644 0 0 1-5.57 22.979c-3.585 9.251-6.696 14.825-9.067 20.933-9.155 22.563-8.503 60.841 13.156 79.817l-11.26.237c-8.888.237-7.614 1.483-12.177 9.399l-45.511 80.054H1.659l20.267-30.094 17.63-26.892 6.459-10.704 5.066-8.895 3.438-6.612 3.11-8.094 2.134-10.081 1.037-10.051.978-15.122 1.155-17.493.563-5.159 1.719-8.273 2.963-7.353 4.83-9.221 5.125-9.666 3.2-6.789 2.46-6.464 1.866-6.849Z",
        fill: "url(#using-erg-buy-it-light_svg__e)"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M114.341 281.792c-4.593 35.076 43.378 20.933 51.555 3.35 4.089-8.746-51.318-5.218-51.555-3.35Z",
        fill: "url(#using-erg-buy-it-light_svg__f)"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M190.489 272.541v9.161a7.151 7.151 0 0 1-2.092 5.024 7.135 7.135 0 0 1-5.019 2.092h-78.193a7.2 7.2 0 0 1-7.11-7.116v-54.614m0-55.446v-45.957a7.228 7.228 0 0 1 7.11-7.116h78.193a7.17 7.17 0 0 1 7.111 7.116v74.481m0 43.674v8.895",
        stroke: "#141414",
        strokeWidth: 3,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M144.326 20.221a4.297 4.297 0 0 0-1.482.237l-30.725 12.75a3.503 3.503 0 0 0-1.956 2.046L97.423 66a3.472 3.472 0 0 0 0 2.965l12.74 30.747a3.35 3.35 0 0 0 1.956 1.957l30.725 12.75c.463.22.97.332 1.482.326.484.006.962-.106 1.393-.326l30.725-12.75a3.493 3.493 0 0 0 2.045-1.957l12.741-30.747a4.364 4.364 0 0 0 0-2.965l-12.741-30.746a3.639 3.639 0 0 0-2.045-2.046l-30.725-12.75a3.616 3.616 0 0 0-1.393-.237Zm0 8.569 27.289 11.297 11.289 27.307-11.289 27.307-27.289 11.356-27.289-11.356-11.378-27.307 11.378-27.308 27.289-11.296Z",
        fill: "#141414"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "m182.904 67.394-11.289-27.337-27.289-11.267-27.289 11.267-11.378 27.337 11.378 27.307 27.289 11.356 27.289-11.356 11.289-27.307Z",
        fill: "#141414"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M141.304 73.175h18.311v8.51h-30.578v-7.68l12-13.342-11.911-12.512v-7.68h30.489v8.51h-17.897l11.112 11.623-11.526 12.571Z",
        fill: "#fff"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M144.326 13.847a4.447 4.447 0 0 0-1.482.326l-30.726 12.75a3.358 3.358 0 0 0-1.955 1.956l-12.74 30.836a3.205 3.205 0 0 0 0 2.757l12.651 30.955a3.266 3.266 0 0 0 1.956 1.957l30.726 12.779c.475.178.974.288 1.481.326a4.37 4.37 0 0 0 1.393-.326l30.725-12.78a3.402 3.402 0 0 0 2.045-1.956l12.741-30.836a4.01 4.01 0 0 0 0-2.758L178.4 28.998a3.505 3.505 0 0 0-2.045-1.957L145.63 14.29a3.674 3.674 0 0 0-1.304-.444Zm0 8.657 27.289 11.267 11.289 27.337-11.289 27.308-27.289 11.267-27.289-11.267-11.378-27.307 11.378-27.338 27.289-11.267Z",
        fill: "#fff"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M1.481 402.229c16.356-25.084 37.837-54.378 51.408-80.292 8.563-16.426 7.11-24.757 10.044-64.014 1.067-13.49 3.852-19.213 11.437-32.614a99.79 99.79 0 0 0 13.808-42.103c1.244-12.601 4.089-14.825 7.763-12.927 10.874 5.485 8.889 24.372 6.874 37.299-1.808 10.377-7.763 24.105-4.74 33.03M95.615 401.991l14.459-31.399c6.785-14.825 10.726-22.415 16.267-30.005 13.57-18.413 36.533-33.534 49.6-51.917",
        stroke: "#141414",
        strokeWidth: 3,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M176.119 226.436c1.955-.563 3.911-1.067 5.925-1.631-19.051 8.569-10.311 26.685 4.474 20.755a95.287 95.287 0 0 1 27.704-6.464c9.393-5.722 6.548-17.256-2.607-21.259 2.963-7.442 2.963-19.064-9.393-19.539-9.244-.356-23.141 6.108-31.229 11.504-9.926 6.405-9.008 20.399 5.126 16.634Z",
        stroke: "#141414",
        strokeWidth: 3,
        strokeLinejoin: "round"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M208.296 249.325c-6.844 1.482-17.155 2.965-23.703 4.833-16.919 4.418-11.852 22.741 4.385 18.798a144.661 144.661 0 0 0 21.007-5.93c13.363-5.337 10.4-20.221-1.689-17.701ZM211.496 217.777a111.149 111.149 0 0 0-29.629 7.027M190.489 174.341a75.65 75.65 0 0 1 15.852-15.625c9.718-7.353 24.118 0 10.785 13.757a308.98 308.98 0 0 0-23.111 26.685M214.104 239.007l-15.615 12.186",
        stroke: "#141414",
        strokeWidth: 3,
        strokeMiterlimit: 10
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M98.074 278.678v-17.167l75.496.652 1.215 5.811 5.334 4.715 4.414.741 5.956-.89v9.162l-1.719 4.566-5.392 2.55h-76.326l-5.067-.83-3.17-3.35-.74-5.96Z",
        fill: "#141414"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M173.807 16.01c4.419 0 8-3.583 8-8.005a8.002 8.002 0 0 0-8-8.005c-4.418 0-8 3.584-8 8.005 0 4.422 3.582 8.006 8 8.006Z",
        fill: "#141414"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M75.348 81.952h10.4a3.674 3.674 0 0 1 3.348 3.914v12.038a3.671 3.671 0 0 1-3.348 3.913h-10.4A3.671 3.671 0 0 1 72 97.904V85.866a3.678 3.678 0 0 1 3.348-3.914Z",
        fill: "#FF5E18",
        stroke: "#FF5E18",
        strokeMiterlimit: 10
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M165.067 108.696h10.4c1.837 0 3.348 2.372 3.348 5.308v16.099c0 2.965-1.511 5.308-3.348 5.308h-10.4c-1.837 0-3.348-2.372-3.348-5.308v-16.099c0-2.787 1.511-5.308 3.348-5.308Z",
        fill: "#FF5E18",
        stroke: "#fff",
        strokeWidth: 3,
        strokeMiterlimit: 10
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M137.037 140.065v63.54l-11.911-17.078M151.911 203.605v-63.54l11.941 17.108",
        stroke: "#141414",
        strokeWidth: 3,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M85.748 252.023c-.504 9.25-3.378 19.302-9.096 23.542-8.652 6.404-15.022-12.424-8.474-28.701 7.259-17.968 18.874-19.866 17.57 5.159Z",
        fill: "#FF5E18"
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("defs", {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("linearGradient", {
        id: "using-erg-buy-it-light_svg__b",
        x1: 63.945,
        y1: 321.777,
        x2: 63.945,
        y2: 414.029,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: 1,
          stopColor: "#FF5E18",
          stopOpacity: 0
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("linearGradient", {
        id: "using-erg-buy-it-light_svg__c",
        x1: 59.259,
        y1: 352.833,
        x2: 56.811,
        y2: 407.151,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          stopColor: "#141414"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: 1,
          stopColor: "#141414",
          stopOpacity: 0
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("linearGradient", {
        id: "using-erg-buy-it-light_svg__d",
        x1: 75.555,
        y1: 249.059,
        x2: 36.989,
        y2: 114.166,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          stopColor: "#FF5E18",
          stopOpacity: 0
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: 1,
          stopColor: "#FF5E18"
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("linearGradient", {
        id: "using-erg-buy-it-light_svg__e",
        x1: 59.259,
        y1: 210.513,
        x2: 69.644,
        y2: 314.286,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          stopColor: "#141414"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: 1,
          stopColor: "#141414",
          stopOpacity: 0
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("linearGradient", {
        id: "using-erg-buy-it-light_svg__f",
        x1: 158.518,
        y1: 290.569,
        x2: 117.033,
        y2: 302.414,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: 1,
          stopColor: "#fff",
          stopOpacity: 0
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("clipPath", {
        id: "using-erg-buy-it-light_svg__a",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
          fill: "#fff",
          d: "M0 0h224v414H0z"
        })
      })]
    })]
  }));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgUsingErgBuyItLight);

/***/ }),

/***/ 2236:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgUsingErgMineIt = function SvgUsingErgMineIt(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", _objectSpread(_objectSpread({
    width: "auto",
    height: "auto",
    fill: "none",
    viewBox: "0 0 258 397",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
      clipPath: "url(#clip0_1_1488)",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M1.48193 393.151L20.8379 393.654C37.3482 353.478 51.8133 317.801 65.0631 278.69C69.7168 264.953 72.918 255.005 75.9415 247.07C81.8698 231.971 86.731 224.954 100.129 215.391C115.928 204.288 133.891 196.294 149.038 184.629C154.966 180.04 151.557 173.438 146.311 178.175C142.014 182.123 137.245 185.524 132.112 188.3C122.36 193.926 112.401 198.011 99.9808 204.377C79.8542 214.651 70.7838 225.102 63.4327 251.748C48.4045 306.195 29.5821 342.197 1.48193 393.151Z",
        fill: "url(#paint0_linear_1_1488)"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M40.9648 394.217L64.2038 394.779L76.7125 354.366C82.2555 336.394 83.3226 322.923 66.1602 311.821C59.9401 308.078 53.2923 305.096 46.3596 302.938C44.0772 308.86 44.0772 308.475 41.5577 314.219C64.441 325.795 64.5891 335.358 56.0227 358.629L40.9648 394.217Z",
        fill: "url(#paint1_linear_1_1488)"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M42.5062 394.217L48.642 394.394L62.6031 355.668C71.4956 331.095 67.6125 325.38 41.6762 313.952C40.2238 317.475 40.6981 316.321 39.1567 319.874C62.2771 326.89 64.5892 334.677 57.2084 354.662L42.5062 394.217Z",
        fill: "url(#paint2_linear_1_1488)"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M1.48193 393.151C29.5821 342.197 48.4045 306.195 63.4327 251.807C70.7838 225.161 79.8542 214.65 99.9808 204.436C112.401 198.071 122.36 193.985 132.112 188.36C139.286 184.43 145.749 179.326 151.231 173.26C153.276 171.128 155.084 169.5 156.626 169.411C160.538 169.174 163.74 174.888 162.021 181.994C160.403 187.218 157.439 191.925 153.425 195.643C145.421 203.637 134.869 207.308 126.391 214.502C118.536 221.105 124.346 226.079 134.721 221.016C147.378 215.095 156.389 211.157 163.888 207.959C197.324 193.985 207.728 179.714 228.566 164.348C234.109 160.262 244.187 159.226 245.491 168.019C255.036 166.006 260.312 172.194 253.079 179.3L245.728 186.405C251.301 186.583 253.82 192.327 248.277 198.396L233.872 210.239C241.163 210.565 243.535 213.644 242.764 218.144C242.171 221.579 235.976 225.901 233.279 227.944L184.785 264.361C174.262 270.282 163.71 276.203 153.158 282.125C108.28 307.35 110 313.005 98.7952 362.715L91.3551 395.52",
        stroke: "white",
        strokeWidth: "3",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M246.055 167.96C236.332 170.921 222.667 184.955 213.834 192.12C202.948 200.771 191.174 208.244 178.709 214.414",
        stroke: "white",
        strokeWidth: "3",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M245.728 186.494C238.051 187.323 233.457 191.379 227.943 195.968C221.244 201.505 209.062 210.979 202.511 215.568C195.812 220.378 188.665 224.532 181.169 227.973",
        stroke: "white",
        strokeWidth: "3",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M236.243 210.269C231.295 210.896 226.623 212.896 222.756 216.042C202.007 232.533 202.333 233.125 177.227 245.945",
        stroke: "white",
        strokeWidth: "3",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M123.753 217.345C114.268 230.846 119.752 249.527 100.781 261.133",
        stroke: "white",
        strokeWidth: "3",
        strokeMiterlimit: "10",
        strokeLinecap: "round"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M74.2223 251.896C70.3689 265.278 70.6357 272.621 77.4829 290.03C72.0289 286.447 68.7386 279.727 61.9507 278.601L65.0631 261.459L74.2223 251.896Z",
        fill: "white"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M121.234 302.761C120.315 293.612 123.517 290.918 131.283 285.796L145.096 276.914C153.425 271.526 160.154 268.654 168.157 276.677C172.573 281.148 169.965 283.842 166.111 286.152C154.759 293.08 143.554 300.008 132.261 307.202C128.437 310.044 122.123 312.087 121.234 302.761Z",
        fill: "white",
        stroke: "white",
        strokeMiterlimit: "10"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M121.412 304.063L124.909 309.304H116.076L121.412 304.063Z",
        fill: "white",
        stroke: "white",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M85.1898 143.86C93.3867 113.541 108.619 85.5773 129.652 62.234L127.933 54.9507L149.66 33.2192L159.472 36.6536C162.143 34.8861 164.904 33.2557 167.741 31.7685C155.322 24.3371 150.401 20.3993 136.44 32.4198C108.547 56.4902 81.0103 98.2361 76.1788 140.367C75.2895 149.101 83.2038 151.055 85.1898 143.86Z",
        fill: "white"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M105.05 79.613L105.702 73.3363L111.186 70.2275L219.022 138.087L216.472 145.755L210.426 151.143L105.05 79.613Z",
        fill: "white"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M162.851 116.503L168.779 107.621C169.522 106.522 170.663 105.753 171.963 105.476C173.262 105.2 174.618 105.439 175.745 106.141L217.006 133.824C228.536 141.344 217.183 158.664 205.653 151.144L164.155 123.55C163.599 123.179 163.124 122.7 162.756 122.142C162.389 121.584 162.137 120.958 162.015 120.301C161.894 119.645 161.905 118.97 162.048 118.318C162.192 117.666 162.465 117.049 162.851 116.503Z",
        fill: "#FF5E18",
        stroke: "#FF5E18",
        strokeMiterlimit: "10"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M103.419 13.2047C107.07 13.2047 110.029 10.2487 110.029 6.60236C110.029 2.95598 107.07 0 103.419 0C99.7685 0 96.8091 2.95598 96.8091 6.60236C96.8091 10.2487 99.7685 13.2047 103.419 13.2047Z",
        fill: "white"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M127.755 40.5913C103.094 65.3131 80.5956 102.766 76.2679 140.367C75.2898 149.249 83.2041 151.055 85.1604 143.86",
        stroke: "#FF5E18",
        strokeWidth: "3",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M155.915 105.815L129.741 89.1763",
        stroke: "#121212",
        strokeWidth: "3",
        strokeMiterlimit: "10",
        strokeLinecap: "round"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M66.3675 36.5054H75.1117C76.7123 36.5054 78.0758 38.6667 78.0758 41.3313V56.1348C78.0758 58.7994 76.8012 60.9608 75.1117 60.9608H66.3675C64.7965 60.9608 63.4033 58.7994 63.4033 56.1348V41.3313C63.5219 38.6667 64.6779 36.5054 66.3675 36.5054Z",
        fill: "#FF5E18",
        stroke: "white",
        strokeWidth: "3",
        strokeMiterlimit: "10"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M199.043 49.6509H214.664C216.179 49.8439 217.561 50.6137 218.522 51.7996C219.483 52.9855 219.948 54.496 219.822 56.0164V75.557C219.948 77.0773 219.483 78.5879 218.522 79.7738C217.561 80.9597 216.179 81.7294 214.664 81.9225H199.043C197.533 81.7224 196.158 80.9498 195.204 79.7647C194.249 78.5795 193.787 77.0728 193.915 75.557V56.0164C193.787 54.5005 194.249 52.9939 195.204 51.8087C196.158 50.6236 197.533 49.8509 199.043 49.6509V49.6509Z",
        fill: "#FF5E18",
        stroke: "#FF5E18",
        strokeMiterlimit: "10"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M202.155 56.2534H211.403C212.287 56.3789 213.088 56.8397 213.64 57.54C214.192 58.2403 214.453 59.1262 214.368 60.0135V71.5306C214.453 72.4179 214.192 73.3038 213.64 74.0041C213.088 74.7045 212.287 75.1653 211.403 75.2907H202.155C201.272 75.1653 200.471 74.7045 199.919 74.0041C199.367 73.3038 199.106 72.4179 199.191 71.5306V60.0135C199.106 59.1262 199.367 58.2403 199.919 57.54C200.471 56.8397 201.272 56.3789 202.155 56.2534Z",
        fill: "white",
        stroke: "#FF5E18",
        strokeMiterlimit: "10"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M211.729 67.7705H220.948C221.835 67.8889 222.64 68.3479 223.194 69.05C223.747 69.752 224.005 70.6419 223.912 71.5306V83.0477C224.005 83.9365 223.747 84.8263 223.194 85.5284C222.64 86.2304 221.835 86.6894 220.948 86.8078H211.729C210.843 86.6894 210.037 86.2304 209.484 85.5284C208.93 84.8263 208.672 83.9365 208.765 83.0477V71.5306C208.672 70.6419 208.93 69.752 209.484 69.05C210.037 68.3479 210.843 67.8889 211.729 67.7705Z",
        fill: "white",
        stroke: "#FF5E18",
        strokeWidth: "3",
        strokeMiterlimit: "10"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M117.292 128.109H124.406C125.68 128.109 126.718 130.626 126.718 133.735V150.818C126.718 153.927 125.68 156.443 124.406 156.443H117.292C116.047 156.443 115.009 153.927 115.009 150.818V133.735C115.069 130.626 116.047 128.109 117.292 128.109Z",
        fill: "#FF5E18",
        stroke: "#FF5E18",
        strokeMiterlimit: "10"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M117.292 128.109H124.406C125.68 128.109 126.718 130.626 126.718 133.735V150.818C126.718 153.927 125.68 156.443 124.406 156.443H117.292C116.047 156.443 115.009 153.927 115.009 150.818V133.735C115.069 130.626 116.047 128.109 117.292 128.109Z",
        fill: "#FF5E18",
        stroke: "#FF5E18",
        strokeMiterlimit: "10"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M183.244 3.58252H193.618C194.584 3.66554 195.477 4.12575 196.104 4.86314C196.731 5.60053 197.042 6.55547 196.968 7.52025V19.363C197.042 20.3278 196.731 21.2827 196.104 22.0201C195.477 22.7575 194.584 23.2178 193.618 23.3008H183.244C182.282 23.2104 181.393 22.748 180.767 22.0124C180.142 21.2768 179.828 20.3261 179.894 19.363V7.52025C179.828 6.55722 180.142 5.6065 180.767 4.87087C181.393 4.13524 182.282 3.67293 183.244 3.58252V3.58252Z",
        fill: "#FF5E18",
        stroke: "#FF5E18",
        strokeMiterlimit: "10"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M101.048 233.037C97.6098 241.682 91.148 249.942 83.0558 251.156C70.8732 253.11 69.1539 232.208 81.8405 219.802C95.8906 206.094 110.207 209.854 101.048 233.037Z",
        fill: "#FF5E18"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M154.492 220.631C165.933 216.634 168.957 225.842 169.461 238.188C169.589 241.381 168.976 244.561 167.67 247.478C166.364 250.395 164.4 252.971 161.932 255.005C156.003 259.831 125.147 279.816 118.299 281.651C109.199 283.931 103.894 273.243 114.268 264.923C120.73 259.624 124.257 254.383 127.696 241.978C128.548 238.044 130.43 234.407 133.15 231.438C136.914 227.559 149.69 222.348 154.492 220.631Z",
        fill: "#FF5E18"
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("defs", {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("linearGradient", {
        id: "using-erg-mine-it-light_svg__b",
        x1: 59.502,
        y1: 278,
        x2: 50.502,
        y2: 383.5,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          stopColor: "#141414"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: 1,
          stopColor: "#fff",
          stopOpacity: 0
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("linearGradient", {
        id: "using-erg-mine-it-light_svg__c",
        x1: 56,
        y1: 312,
        x2: 75.5,
        y2: 387.5,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: 1,
          stopColor: "#343434",
          stopOpacity: 0
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("linearGradient", {
        id: "using-erg-mine-it-light_svg__d",
        x1: 53,
        y1: 328.5,
        x2: 52.989,
        y2: 378.5,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          stopColor: "#141414"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: 1,
          stopColor: "#fff",
          stopOpacity: 0
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("clipPath", {
        id: "using-erg-mine-it-light_svg__a",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
          fill: "#fff",
          d: "M0 0h258v397H0z"
        })
      })]
    })]
  }));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgUsingErgMineIt);

/***/ }),

/***/ 483:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgUsingErgMineItLight = function SvgUsingErgMineItLight(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", _objectSpread(_objectSpread({
    width: "auto",
    height: "auto",
    viewBox: "0 0 258 397",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
      clipPath: "url(#using-erg-mine-it-light_svg__a)",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "m1.482 393.152 19.356.503c16.51-40.177 30.975-75.853 44.225-114.964 4.654-13.738 7.855-23.686 10.879-31.62 5.928-15.1 10.79-22.117 24.187-31.68 15.799-11.102 33.762-19.096 48.909-30.761 5.928-4.589 2.519-11.192-2.727-6.455a70.677 70.677 0 0 1-14.199 10.126c-9.752 5.625-19.711 9.711-32.131 16.076-20.127 10.274-29.197 20.725-36.548 47.372-15.028 54.447-33.85 90.449-61.95 141.403Z",
        fill: "url(#using-erg-mine-it-light_svg__b)"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "m40.965 394.217 23.239.562 12.508-40.413c5.543-17.972 6.61-31.443-10.552-42.545a90.663 90.663 0 0 0-19.8-8.883c-2.283 5.922-2.283 5.537-4.803 11.281 22.884 11.576 23.032 21.139 14.465 44.41l-15.057 35.588Z",
        fill: "url(#using-erg-mine-it-light_svg__c)"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "m42.506 394.217 6.136.177 13.96-38.726c8.893-24.573 5.01-30.288-20.926-41.716-1.453 3.523-.978 2.369-2.52 5.922 23.12 7.016 25.433 14.803 18.052 34.788l-14.702 39.555Z",
        fill: "url(#using-erg-mine-it-light_svg__d)"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M1.482 393.151c28.1-50.954 46.923-86.956 61.95-141.344 7.352-26.646 16.422-37.157 36.549-47.371 12.42-6.365 22.379-10.451 32.131-16.076a73.117 73.117 0 0 0 19.119-15.1c2.045-2.132 3.854-3.76 5.395-3.849 3.913-.237 7.114 5.477 5.395 12.583a31.177 31.177 0 0 1-8.596 13.649c-8.004 7.994-18.556 11.665-27.033 18.859-7.855 6.603-2.046 11.577 8.329 6.514 12.657-5.921 21.668-9.859 29.167-13.057 33.436-13.974 43.84-28.245 64.678-43.611 5.543-4.086 15.621-5.122 16.925 3.671 9.545-2.013 14.821 4.175 7.588 11.281l-7.351 7.105c5.573.178 8.093 5.922 2.55 11.991l-14.406 11.843c7.292.326 9.663 3.405 8.892 7.905-.593 3.435-6.788 7.757-9.485 9.8l-48.494 36.417c-10.522 5.921-21.075 11.842-31.627 17.764-44.877 25.225-43.158 30.88-54.363 80.59l-7.44 32.805",
        stroke: "#141414",
        strokeWidth: 3,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M246.054 167.96c-9.722 2.961-23.387 16.994-32.22 24.159a196.617 196.617 0 0 1-35.125 22.294M245.728 186.494c-7.677.829-12.271 4.885-17.785 9.474-6.699 5.537-18.881 15.011-25.432 19.6a128.522 128.522 0 0 1-21.342 12.405M236.243 210.269a26.69 26.69 0 0 0-13.487 5.773c-20.749 16.491-20.423 17.083-45.529 29.903",
        stroke: "#141414",
        strokeWidth: 3,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M123.753 217.345c-9.485 13.501-4.001 32.182-22.972 43.788",
        stroke: "#141414",
        strokeWidth: 3,
        strokeMiterlimit: 10,
        strokeLinecap: "round"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M74.222 251.896c-3.853 13.383-3.586 20.725 3.261 38.134-5.454-3.582-8.744-10.303-15.532-11.428l3.112-17.142 9.16-9.564Z",
        fill: "#141414"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M121.234 302.761c-.919-9.149 2.282-11.843 10.048-16.965l13.813-8.882c8.33-5.388 15.058-8.26 23.062-.237 4.416 4.471 1.808 7.165-2.046 9.475-11.352 6.928-22.557 13.856-33.85 21.05-3.824 2.842-10.138 4.885-11.027-4.441Z",
        fill: "#141414",
        stroke: "#141414",
        strokeMiterlimit: 10
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "m121.412 304.063 3.497 5.241h-8.833l5.336-5.241Z",
        fill: "#141414",
        stroke: "#141414",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M85.19 143.86a199.871 199.871 0 0 1 44.462-81.627l-1.719-7.283L149.66 33.22l9.812 3.434a94.47 94.47 0 0 1 8.269-4.885c-12.419-7.431-17.34-11.37-31.301.651-27.893 24.07-55.43 65.817-60.261 107.947-.89 8.734 7.025 10.688 9.01 3.494Z",
        fill: "#141414"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "m105.05 79.613.652-6.277 5.483-3.108 107.836 67.859-2.549 7.668-6.047 5.388-105.375-71.53Z",
        fill: "#141414"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "m162.851 116.503 5.928-8.882a5.134 5.134 0 0 1 6.966-1.48l41.261 27.683c11.53 7.52.178 24.84-11.353 17.32l-41.498-27.594a5.002 5.002 0 0 1-1.304-7.047Z",
        fill: "#FF5E18",
        stroke: "#FF5E18",
        strokeMiterlimit: 10
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M103.419 13.205a6.606 6.606 0 0 0 6.61-6.603A6.606 6.606 0 0 0 103.419 0a6.606 6.606 0 0 0-6.61 6.602 6.606 6.606 0 0 0 6.61 6.603Z",
        fill: "#141414"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M127.755 40.59c-24.662 24.723-47.16 62.175-51.487 99.776-.978 8.882 6.936 10.688 8.892 3.494",
        stroke: "#FF5E18",
        strokeWidth: 3,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "m155.914 105.815-26.173-16.64",
        stroke: "#141414",
        strokeWidth: 3,
        strokeMiterlimit: 10,
        strokeLinecap: "round"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M66.368 36.506h8.744c1.6 0 2.964 2.161 2.964 4.826v14.803c0 2.665-1.275 4.826-2.964 4.826h-8.744c-1.572 0-2.965-2.161-2.965-4.826V41.332c.119-2.665 1.275-4.826 2.965-4.826Z",
        fill: "#FF5E18",
        stroke: "#141414",
        strokeWidth: 3,
        strokeMiterlimit: 10
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M199.043 49.651h15.621a5.93 5.93 0 0 1 3.858 2.15 5.915 5.915 0 0 1 1.3 4.216v19.54a5.916 5.916 0 0 1-1.3 4.217 5.93 5.93 0 0 1-3.858 2.149h-15.621a5.927 5.927 0 0 1-5.128-6.365V56.017a5.927 5.927 0 0 1 5.128-6.365Z",
        fill: "#FF5E18",
        stroke: "#FF5E18",
        strokeMiterlimit: 10
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M202.155 56.253h9.248a3.469 3.469 0 0 1 2.965 3.76V71.53a3.463 3.463 0 0 1-2.965 3.76h-9.248a3.468 3.468 0 0 1-2.964-3.76V60.013a3.463 3.463 0 0 1 2.964-3.76Z",
        fill: "#141414",
        stroke: "#FF5E18",
        strokeMiterlimit: 10
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M211.73 67.77h9.218a3.432 3.432 0 0 1 2.964 3.76v11.518a3.432 3.432 0 0 1-2.964 3.76h-9.218a3.438 3.438 0 0 1-2.965-3.76V71.53a3.433 3.433 0 0 1 2.965-3.76Z",
        fill: "#141414",
        stroke: "#FF5E18",
        strokeWidth: 3,
        strokeMiterlimit: 10
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M117.292 128.109h7.114c1.274 0 2.312 2.517 2.312 5.626v17.083c0 3.109-1.038 5.625-2.312 5.625h-7.114c-1.245 0-2.283-2.516-2.283-5.625v-17.083c.06-3.109 1.038-5.626 2.283-5.626Z",
        fill: "#FF5E18",
        stroke: "#FF5E18",
        strokeMiterlimit: 10
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M117.292 128.109h7.114c1.274 0 2.312 2.517 2.312 5.626v17.083c0 3.109-1.038 5.625-2.312 5.625h-7.114c-1.245 0-2.283-2.516-2.283-5.625v-17.083c.06-3.109 1.038-5.626 2.283-5.626ZM183.244 3.582h10.375a3.675 3.675 0 0 1 3.349 3.938v11.843a3.675 3.675 0 0 1-3.349 3.938h-10.375a3.696 3.696 0 0 1-3.349-3.938V7.52a3.697 3.697 0 0 1 3.349-3.938Z",
        fill: "#FF5E18",
        stroke: "#FF5E18",
        strokeMiterlimit: 10
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M101.048 233.037c-3.439 8.645-9.9 16.905-17.992 18.119-12.183 1.954-13.902-18.948-1.216-31.354 14.05-13.708 28.367-9.948 19.208 13.235ZM154.492 220.631c11.441-3.997 14.465 5.211 14.969 17.557a20.706 20.706 0 0 1-7.529 16.817c-5.929 4.826-36.785 24.811-43.633 26.646-9.1 2.28-14.405-8.408-4.031-16.728 6.462-5.299 9.989-10.54 13.428-22.945a22.722 22.722 0 0 1 5.454-10.54c3.764-3.879 16.54-9.09 21.342-10.807Z",
        fill: "#FF5E18"
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("defs", {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("linearGradient", {
        id: "using-erg-mine-it-light_svg__b",
        x1: 59.502,
        y1: 278,
        x2: 50.502,
        y2: 383.5,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          stopColor: "#141414"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: 1,
          stopColor: "#fff",
          stopOpacity: 0
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("linearGradient", {
        id: "using-erg-mine-it-light_svg__c",
        x1: 56,
        y1: 312,
        x2: 75.5,
        y2: 387.5,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: 1,
          stopColor: "#343434",
          stopOpacity: 0
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("linearGradient", {
        id: "using-erg-mine-it-light_svg__d",
        x1: 53,
        y1: 328.5,
        x2: 52.989,
        y2: 378.5,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          stopColor: "#141414"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: 1,
          stopColor: "#fff",
          stopOpacity: 0
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("clipPath", {
        id: "using-erg-mine-it-light_svg__a",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
          fill: "#fff",
          d: "M0 0h258v397H0z"
        })
      })]
    })]
  }));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgUsingErgMineItLight);

/***/ }),

/***/ 5985:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgUsingErgStoreIt = function SvgUsingErgStoreIt(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", _objectSpread(_objectSpread({
    width: "auto",
    height: "auto",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 258 388"
  }, props), {}, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
      clipPath: "url(#clip0_1_1515)",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M1.45264 384.144L20.7537 384.648C37.2678 344.398 51.7659 308.656 65.078 269.473C69.7328 255.71 72.9348 245.744 75.87 237.795C81.7997 222.668 86.662 215.638 100.152 206.057C115.866 194.934 133.833 186.926 148.983 175.239C154.913 170.642 151.503 164.027 146.344 168.773C142.014 172.728 137.215 176.135 132.054 178.917C122.329 184.553 112.338 188.646 99.9149 195.023C79.8726 205.316 70.7112 215.786 63.3584 242.481C48.4157 297.029 29.5 333.097 1.45264 384.144Z",
        fill: "url(#paint0_linear_1_1515)"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M40.9741 385.212L64.1888 385.775L76.7597 345.287C82.2446 327.283 83.312 313.787 66.2345 302.664C59.9982 298.903 53.3277 295.915 46.3701 293.766C44.0575 299.698 44.0576 299.312 41.6264 305.067C64.426 316.664 64.6038 326.245 56.0058 349.559L40.9741 385.212Z",
        fill: "url(#paint1_linear_1_1515)"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M42.4269 385.212L48.5641 385.39L62.5582 346.593C71.4527 321.974 67.5391 316.249 41.6264 304.8C40.144 308.33 40.648 307.173 39.0767 310.732C62.2913 317.762 64.5149 325.563 57.1621 345.584L42.4269 385.212Z",
        fill: "url(#paint2_linear_1_1515)"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M1.45264 384.144C29.5 333.097 48.4157 297.029 63.3584 242.541C70.7112 215.846 79.8726 205.316 99.9149 195.083C112.338 188.706 122.329 184.612 132.054 178.977C139.23 175.063 145.72 170.004 151.266 163.998C153.223 161.862 155.031 160.231 156.662 160.142C160.516 159.904 163.777 165.629 161.969 172.748C160.385 177.99 157.427 182.712 153.4 186.422C145.366 194.43 134.9 198.108 126.332 205.316C118.475 211.93 124.286 216.914 134.663 211.841C147.352 205.909 156.425 201.964 163.926 198.761C197.31 184.761 207.776 170.464 228.529 155.07C234.103 150.976 244.154 149.938 245.459 158.748C255.094 156.731 260.283 162.93 253.049 170.049L245.696 177.167C251.27 177.345 253.79 183.1 248.246 189.18L233.836 201.045C241.219 201.371 243.502 204.456 242.731 208.964C242.168 212.405 236.03 216.736 233.332 218.782L184.768 255.266C174.214 261.198 163.659 267.13 153.104 273.062C108.216 298.334 109.936 303.999 98.7289 353.801L91.554 386.517",
        stroke: "white",
        strokeWidth: "3",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M246.022 158.54C236.298 161.506 222.659 175.566 213.824 182.744C204.558 190.133 194.634 196.657 184.176 202.231",
        stroke: "white",
        strokeWidth: "3",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M245.726 177.108C238.136 177.938 233.481 182.002 227.937 186.6C221.236 192.146 209.051 201.638 202.587 206.235C197.067 210.174 191.248 213.674 185.184 216.706",
        stroke: "white",
        strokeWidth: "3",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M236.208 200.926C231.264 201.57 226.595 203.572 222.719 206.71C201.965 223.231 202.291 223.824 177.268 236.668",
        stroke: "white",
        strokeWidth: "3",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M123.693 208.015C117.081 217.507 117.763 229.549 112.249 239.931C109.596 244.882 105.611 248.992 100.745 251.795",
        stroke: "white",
        strokeWidth: "3",
        strokeMiterlimit: "10",
        strokeLinecap: "round"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M118.149 27.9707H174.57V223.231L118.149 244.439V27.9707Z",
        fill: "url(#paint3_linear_1_1515)"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M74.1506 242.63C70.3852 256.037 70.652 263.393 77.5008 280.834C71.9565 277.245 68.6063 270.512 61.9058 269.384L65.0782 252.21L74.1506 242.63Z",
        fill: "white"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M121.203 293.588C120.313 284.423 123.485 281.724 131.253 276.592L145.069 267.694C153.43 262.295 160.131 259.418 168.136 267.456C172.553 271.935 169.944 274.635 166.179 276.948C154.735 283.889 143.528 290.83 132.232 298.037C128.377 300.885 122.062 302.931 121.203 293.588Z",
        fill: "white",
        stroke: "white",
        strokeMiterlimit: "10"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M121.351 294.893L124.879 300.143H116.103L121.351 294.893Z",
        fill: "white",
        stroke: "white",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M100.982 223.736C97.5432 232.397 91.0799 240.672 82.9859 241.888C70.8004 243.846 69.0808 222.905 81.7703 210.477C95.8236 196.744 110.203 200.511 100.982 223.736Z",
        fill: "#FF5E18"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M146.345 3.67822C146.034 3.68655 145.729 3.76784 145.455 3.91552L127.073 11.5385C126.557 11.7509 126.142 12.1548 125.917 12.6656L118.238 31.2633C118.059 31.7924 118.059 32.3655 118.238 32.8947L125.917 51.2847C126.011 51.5622 126.162 51.8167 126.362 52.0314C126.561 52.2461 126.803 52.4162 127.073 52.5305L145.455 60.1238C145.728 60.2676 146.037 60.3294 146.345 60.3017C146.633 60.3323 146.924 60.2699 147.175 60.1238L165.586 52.5305C166.14 52.292 166.577 51.8442 166.802 51.2847L174.392 32.8947C174.524 32.6432 174.594 32.3632 174.594 32.0789C174.594 31.7947 174.524 31.5148 174.392 31.2633L166.802 12.7546C166.545 12.2449 166.114 11.8447 165.586 11.6274L147.175 4.0045C146.932 3.82333 146.645 3.71065 146.345 3.67822ZM146.345 8.83931L162.71 15.6317L169.411 31.9751L162.71 48.3482L146.345 55.0517L130.008 48.3482L123.219 31.9751L130.008 15.6317L146.345 8.83931Z",
        fill: "#FF5E18"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M169.441 32.0641L162.71 15.691L146.374 8.92822L130.008 15.691L123.219 32.0641L130.008 48.4371L146.374 55.1406L162.71 48.4371L169.441 32.0641Z",
        fill: "#121212"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M144.565 35.5048H155.446V40.6659H137.212V35.9794L144.417 28.0598L137.212 20.5259V15.958H155.446V21.0301H144.802L151.444 27.9709L144.565 35.5048Z",
        fill: "white"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M146.344 0C146.041 0.0163927 145.741 0.0763659 145.455 0.178006L127.073 7.86028C126.805 7.95275 126.562 8.10495 126.362 8.30537C126.161 8.50578 126.009 8.74915 125.917 9.01707L118.238 27.4071C118.068 27.968 118.068 28.5666 118.238 29.1275L125.917 47.5471C126.013 47.8201 126.165 48.0696 126.365 48.2792C126.564 48.4889 126.805 48.6538 127.073 48.7633L145.455 56.3565C145.741 56.4582 146.041 56.5182 146.344 56.5346C146.629 56.521 146.909 56.4608 147.175 56.3565L165.586 48.7633C165.859 48.6514 166.107 48.4863 166.316 48.2775C166.525 48.0687 166.69 47.8204 166.802 47.5471L174.392 29.1275C174.523 28.8596 174.591 28.5654 174.591 28.2673C174.591 27.9691 174.523 27.6749 174.392 27.4071L166.802 9.01707C166.692 8.74925 166.527 8.50766 166.318 8.30826C166.108 8.10886 165.859 7.95619 165.586 7.86028L147.175 0.178006C146.909 0.0737367 146.629 0.0135803 146.344 0ZM146.344 5.16109L162.71 11.9535L169.411 28.2969L162.71 44.581L146.344 51.3735L130.008 44.581L123.219 28.2969L130.008 11.9535L146.344 5.16109Z",
        fill: "white"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M146.344 94.1748C146.042 94.1786 145.742 94.2286 145.455 94.3231L127.073 102.005C126.807 102.102 126.566 102.255 126.366 102.455C126.166 102.655 126.013 102.896 125.917 103.162L118.238 121.552C118.068 122.113 118.068 122.712 118.238 123.273L125.917 141.692C126.013 141.965 126.165 142.215 126.365 142.424C126.564 142.634 126.805 142.799 127.073 142.908L145.455 150.531C145.746 150.609 146.044 150.659 146.344 150.68C146.626 150.662 146.904 150.612 147.175 150.531L165.586 142.908C165.859 142.797 166.107 142.631 166.316 142.423C166.525 142.214 166.69 141.966 166.802 141.692L174.392 123.273C174.523 123.005 174.591 122.711 174.591 122.412C174.591 122.114 174.523 121.82 174.392 121.552L166.802 103.162C166.688 102.897 166.521 102.658 166.312 102.459C166.103 102.261 165.856 102.106 165.586 102.005L147.175 94.3231C146.908 94.2285 146.627 94.1783 146.344 94.1748ZM146.344 99.3062L162.71 106.099L169.411 122.472L162.71 138.756L146.344 145.519L130.008 138.756L123.219 122.472L130.008 106.099L146.344 99.3062Z",
        fill: "#FF5E18"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M169.441 122.442L162.71 106.099L146.374 99.3062L130.008 106.099L123.219 122.442L130.008 138.726L146.374 145.519L162.71 138.726L169.441 122.442Z",
        fill: "#121212"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M144.565 125.883H155.446V130.955H137.212V126.387L144.417 118.378L137.212 110.933V106.336H155.446V111.408H144.802L151.444 118.378L144.565 125.883Z",
        fill: "white"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M146.344 90.4077C146.05 90.3629 145.75 90.3629 145.455 90.4077L127.073 98.0306C126.805 98.14 126.564 98.305 126.364 98.5146C126.165 98.7242 126.012 98.9738 125.917 99.2467L118.238 117.666C118.059 118.216 118.059 118.808 118.238 119.357L125.917 137.777C126.012 138.05 126.165 138.299 126.364 138.509C126.564 138.719 126.805 138.883 127.073 138.993L145.455 146.616C145.75 146.661 146.05 146.661 146.344 146.616C146.619 146.661 146.9 146.661 147.174 146.616L165.586 138.993C165.859 138.881 166.107 138.716 166.316 138.507C166.525 138.298 166.69 138.05 166.802 137.777L174.392 119.357C174.522 119.094 174.59 118.805 174.59 118.512C174.59 118.218 174.522 117.929 174.392 117.666L166.802 99.2467C166.69 98.9734 166.525 98.7252 166.316 98.5164C166.107 98.3076 165.859 98.1424 165.586 98.0306L147.174 90.4077C146.9 90.3628 146.619 90.3628 146.344 90.4077ZM146.344 95.5391L162.71 102.331L169.411 118.616L162.71 134.989L146.344 141.781L130.008 134.989L123.219 118.616L130.008 102.331L146.344 95.5391Z",
        fill: "white"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M146.345 198.79C146.04 198.766 145.735 198.817 145.455 198.939L127.073 206.561C126.557 206.774 126.142 207.178 125.917 207.689L118.238 226.138C118.059 226.667 118.059 227.24 118.238 227.769L124.168 242.333L128.733 240.524L123.1 226.939L129.89 210.595L146.226 203.803L162.592 210.595L168.522 225.159L173.117 223.35L166.654 207.629C166.397 207.12 165.966 206.719 165.438 206.502L147.026 198.879C146.808 198.8 146.576 198.77 146.345 198.79Z",
        fill: "#FF5E18"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M168.744 224.69L162.755 210.156L146.419 203.364L130.053 210.156L123.263 226.5L128.926 240.085L168.744 224.69Z",
        fill: "#121212"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M144.565 230.439H155.12L141.956 235.6H137.212V230.943L144.417 222.994L137.212 215.46V210.892H155.446V215.964H144.802L151.444 222.905L144.565 230.439Z",
        fill: "white"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M146.344 194.934C146.041 194.95 145.741 195.01 145.455 195.112L127.073 202.794C126.805 202.887 126.562 203.039 126.362 203.239C126.161 203.44 126.009 203.683 125.917 203.951L118.238 222.341C118.068 222.902 118.068 223.501 118.238 224.062L125.679 241.858L130.749 239.812L130.008 239.574L123.219 223.201L130.008 206.858L146.344 200.066L162.71 206.858L169.411 223.201L168.61 225.248L174.54 222.875C174.509 222.679 174.449 222.489 174.362 222.312L166.772 203.921C166.663 203.654 166.498 203.412 166.288 203.213C166.079 203.013 165.829 202.861 165.557 202.765L147.145 195.082C146.887 194.991 146.617 194.941 146.344 194.934Z",
        fill: "white"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M177.987 223L117 246.551",
        stroke: "#FF5E18",
        strokeWidth: "3",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("defs", {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("linearGradient", {
        id: "paint0_linear_1_1515",
        x1: "51.4995",
        y1: "267.5",
        x2: "23.5438",
        y2: "368.512",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          stopColor: "white"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: "1",
          stopColor: "#25211A",
          stopOpacity: "0"
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("linearGradient", {
        id: "paint1_linear_1_1515",
        x1: "-43.3013",
        y1: "386.113",
        x2: "-26.4431",
        y2: "421.518",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: "1",
          stopColor: "#121212",
          stopOpacity: "0"
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("linearGradient", {
        id: "paint2_linear_1_1515",
        x1: "56.3319",
        y1: "320.343",
        x2: "56.3319",
        y2: "385.598",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          stopColor: "white"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: "1",
          stopColor: "#121212",
          stopOpacity: "0"
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("linearGradient", {
        id: "paint3_linear_1_1515",
        x1: "94.875",
        y1: "223.943",
        x2: "96.3588",
        y2: "54.873",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          stopColor: "#FF5E18",
          stopOpacity: "0"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: "1",
          stopColor: "#FF5E18"
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("clipPath", {
        id: "clip0_1_1515",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("rect", {
          width: "258",
          height: "388",
          fill: "white"
        })
      })]
    })]
  }));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgUsingErgStoreIt);

/***/ }),

/***/ 358:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgUsingErgStoreItLight = function SvgUsingErgStoreItLight(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", _objectSpread(_objectSpread({
    width: "auto",
    height: "auto",
    viewBox: "0 0 258 388",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m1.453 384.144 19.301.504c16.514-40.25 31.012-75.992 44.325-115.175 4.654-13.763 7.856-23.729 10.792-31.678 5.93-15.127 10.791-22.157 24.281-31.738 15.714-11.123 33.681-19.131 48.831-30.818 5.93-4.597 2.52-11.212-2.638-6.466a71.487 71.487 0 0 1-14.291 10.144c-9.725 5.636-19.716 9.729-32.139 16.106-20.042 10.293-29.203 20.763-36.556 47.458C48.416 297.029 29.5 333.097 1.453 384.144Z",
      fill: "url(#using-erg-store-it-light_svg__a)"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m40.973 385.212 23.214.563 12.571-40.488c5.485-18.004 6.553-31.5-10.525-42.623a89.757 89.757 0 0 0-19.864-8.898c-2.313 5.932-2.313 5.546-4.744 11.301 22.8 11.597 22.977 21.178 14.38 44.492l-15.032 35.653Z",
      fill: "url(#using-erg-store-it-light_svg__b)"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m42.428 385.212 6.138.178 13.994-38.797c8.894-24.619 4.98-30.344-20.932-41.793-1.483 3.53-.978 2.373-2.55 5.932 23.215 7.03 25.438 14.831 18.086 34.852l-14.736 39.628Z",
      fill: "url(#using-erg-store-it-light_svg__c)"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M1.453 384.144C29.5 333.097 48.416 297.029 63.36 242.541c7.353-26.695 16.514-37.225 36.556-47.458 12.423-6.377 22.414-10.471 32.139-16.106a75.073 75.073 0 0 0 19.212-14.979c1.957-2.136 3.766-3.767 5.396-3.856 3.855-.238 7.116 5.487 5.307 12.606a30.64 30.64 0 0 1-8.568 13.674c-8.035 8.008-18.501 11.686-27.069 18.894-7.857 6.614-2.046 11.598 8.331 6.525a898.703 898.703 0 0 1 29.263-13.08c33.384-14 43.85-28.297 64.604-43.691 5.574-4.094 15.625-5.132 16.929 3.678 9.636-2.017 14.824 4.182 7.59 11.301l-7.353 7.118c5.574.178 8.094 5.933 2.55 12.013l-14.409 11.865c7.382.326 9.665 3.411 8.894 7.919-.563 3.441-6.7 7.772-9.398 9.818l-48.564 36.484-31.665 17.796c-44.887 25.272-43.168 30.937-54.375 80.739l-7.174 32.716",
      stroke: "#141414",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M246.022 158.54c-9.724 2.966-23.363 17.026-32.198 24.204a193.636 193.636 0 0 1-29.648 19.487M245.726 177.107c-7.59.831-12.245 4.895-17.789 9.492-6.701 5.547-18.886 15.038-25.35 19.636a130.201 130.201 0 0 1-17.403 10.47M236.207 200.926a26.974 26.974 0 0 0-13.49 5.784c-20.754 16.521-20.428 17.114-45.451 29.958",
      stroke: "#141414",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M123.694 208.015c-6.612 9.491-5.93 21.534-11.444 31.915a30.105 30.105 0 0 1-11.504 11.865",
      stroke: "#141414",
      strokeWidth: 3,
      strokeMiterlimit: 10,
      strokeLinecap: "round"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M118.148 27.97h56.421v195.261l-56.421 21.208V27.971Z",
      fill: "url(#using-erg-store-it-light_svg__d)"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M74.151 242.63c-3.765 13.407-3.498 20.763 3.35 38.204-5.544-3.589-8.894-10.322-15.595-11.45l3.173-17.174 9.072-9.58Z",
      fill: "#141414"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M121.204 293.588c-.889-9.166 2.283-11.865 10.051-16.996l13.816-8.899c8.361-5.398 15.061-8.275 23.066-.237 4.418 4.479 1.809 7.178-1.956 9.492-11.445 6.94-22.652 13.881-33.948 21.089-3.854 2.847-10.169 4.894-11.029-4.449Z",
      fill: "#141414",
      stroke: "#141414",
      strokeMiterlimit: 10
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m121.349 294.893 3.528 5.25h-8.775l5.247-5.25Z",
      fill: "#141414",
      stroke: "#141414",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M100.98 223.736c-3.439 8.661-9.902 16.936-17.996 18.152-12.186 1.958-13.905-18.983-1.216-31.411 14.054-13.733 28.433-9.966 19.212 13.259Z",
      fill: "#FF5E18"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M146.346 3.678c-.311.008-.616.09-.889.237l-18.382 7.623a2.165 2.165 0 0 0-1.157 1.127l-7.679 18.598a2.559 2.559 0 0 0 0 1.631l7.679 18.39a2.082 2.082 0 0 0 1.157 1.246l18.382 7.593a1.6 1.6 0 0 0 .889.178c.289.03.579-.032.83-.178l18.412-7.593c.553-.238.99-.686 1.215-1.246l7.59-18.39a1.744 1.744 0 0 0 0-1.631l-7.59-18.509a2.37 2.37 0 0 0-1.215-1.127l-18.412-7.623a1.687 1.687 0 0 0-.83-.326Zm0 5.16 16.366 6.793 6.7 16.344-6.7 16.373-16.366 6.703-16.336-6.703-6.79-16.373 6.79-16.344 16.336-6.792Z",
      fill: "#141414"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m169.441 31.136-6.731-16.373L146.374 8l-16.366 6.763-6.789 16.373 6.789 16.373 16.366 6.703 16.336-6.703 6.731-16.373Z",
      fill: "#141414"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M144.564 35.505h10.881v5.16h-18.234V35.98l7.204-7.92-7.204-7.533v-4.568h18.234v5.072h-10.644l6.641 6.94-6.878 7.535Z",
      fill: "#fff"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M146.343 0a3.168 3.168 0 0 0-.889.178L127.072 7.86a1.862 1.862 0 0 0-1.156 1.157l-7.679 18.39c-.17.561-.17 1.16 0 1.72l7.679 18.42a2.039 2.039 0 0 0 1.156 1.216l18.382 7.593c.286.102.586.162.889.179.285-.014.565-.074.831-.178l18.411-7.594a2.229 2.229 0 0 0 1.216-1.216l7.59-18.42a1.958 1.958 0 0 0 0-1.72l-7.59-18.39a2.049 2.049 0 0 0-1.216-1.157L147.174.178a2.616 2.616 0 0 0-.831-.178Zm0 5.161 16.366 6.793 6.701 16.343-6.701 16.284-16.366 6.792-16.336-6.792-6.789-16.284 6.789-16.344 16.336-6.792Z",
      fill: "#fff"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M146.343 94.175a2.963 2.963 0 0 0-.889.148l-18.382 7.682a1.937 1.937 0 0 0-1.156 1.157l-7.679 18.39c-.17.561-.17 1.16 0 1.721l7.679 18.419c.096.273.248.523.448.732.199.21.44.375.708.484l18.382 7.623c.291.078.589.128.889.149.282-.018.56-.068.831-.149l18.411-7.623a2.225 2.225 0 0 0 1.216-1.216l7.59-18.419a1.959 1.959 0 0 0 0-1.721l-7.59-18.39a2.138 2.138 0 0 0-1.216-1.157l-18.411-7.682a2.585 2.585 0 0 0-.831-.148Zm0 5.131 16.366 6.793 6.701 16.373-6.701 16.284-16.366 6.763-16.336-6.763-6.789-16.284 6.789-16.373 16.336-6.793Z",
      fill: "#141414"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m169.441 121.136-6.731-16.344L146.374 98l-16.366 6.792-6.789 16.344 6.789 16.284 16.366 6.792 16.336-6.792 6.731-16.284Z",
      fill: "#141414"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M144.564 125.883h10.881v5.072h-18.234v-4.568l7.204-8.009-7.204-7.445v-4.597h18.234v5.072h-10.644l6.641 6.97-6.878 7.505Z",
      fill: "#fff"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M146.342 90.408a2.957 2.957 0 0 0-.889 0l-18.382 7.623a2.051 2.051 0 0 0-1.156 1.216l-7.679 18.419a2.73 2.73 0 0 0 0 1.691l7.679 18.42a2.054 2.054 0 0 0 1.156 1.216l18.382 7.623c.295.045.595.045.889 0 .275.045.556.045.831 0l18.411-7.623a2.228 2.228 0 0 0 1.216-1.216l7.59-18.42a1.907 1.907 0 0 0 0-1.691l-7.59-18.42a2.224 2.224 0 0 0-1.216-1.215l-18.411-7.623a2.58 2.58 0 0 0-.831 0Zm0 5.131 16.366 6.792 6.701 16.285-6.701 16.373-16.366 6.792-16.336-6.792-6.789-16.373 6.789-16.285 16.336-6.792Z",
      fill: "#fff"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M146.346 198.79a1.856 1.856 0 0 0-.889.149l-18.382 7.622a2.168 2.168 0 0 0-1.157 1.128l-7.679 18.449a2.558 2.558 0 0 0 0 1.631l5.93 14.564 4.566-1.809-5.633-13.585 6.789-16.344 16.336-6.792 16.366 6.792 5.93 14.564 4.595-1.809-6.463-15.721a2.373 2.373 0 0 0-1.215-1.127l-18.412-7.623a1.598 1.598 0 0 0-.682-.089Z",
      fill: "#141414"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m170 225.069-6.189-15.04L146.929 203l-16.913 7.029L123 226.942 128.852 241 170 225.069Z",
      fill: "#141414"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M144.564 230.439h10.555l-13.164 5.161h-4.744v-4.656l7.204-7.95-7.204-7.534v-4.567h18.234v5.072h-10.644l6.641 6.94-6.878 7.534Z",
      fill: "#fff"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M146.343 194.935a3.142 3.142 0 0 0-.889.178l-18.382 7.682a1.861 1.861 0 0 0-1.156 1.157l-7.679 18.39a2.964 2.964 0 0 0 0 1.72l7.442 17.797 5.069-2.047-.741-.237-6.789-16.373 6.789-16.344 16.336-6.792 16.366 6.792 6.701 16.344-.801 2.046 5.93-2.372a1.993 1.993 0 0 0-.178-.564l-7.59-18.39a2.04 2.04 0 0 0-1.215-1.157l-18.412-7.682a2.608 2.608 0 0 0-.801-.148Z",
      fill: "#fff"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M177.987 223 117 246.551",
      stroke: "#141414",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("defs", {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("linearGradient", {
        id: "using-erg-store-it-light_svg__a",
        x1: 51.5,
        y1: 267.5,
        x2: 23.544,
        y2: 368.512,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          stopColor: "#141414"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: 1,
          stopColor: "#fff",
          stopOpacity: 0
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("linearGradient", {
        id: "using-erg-store-it-light_svg__b",
        x1: 41,
        y1: 307,
        x2: 51.529,
        y2: 393.496,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: 1,
          stopColor: "#fff",
          stopOpacity: 0
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("linearGradient", {
        id: "using-erg-store-it-light_svg__c",
        x1: 48,
        y1: 318,
        x2: 53,
        y2: 369.5,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          stopColor: "#141414"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: 1,
          stopColor: "#141414",
          stopOpacity: 0
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("linearGradient", {
        id: "using-erg-store-it-light_svg__d",
        x1: 94.874,
        y1: 223.943,
        x2: 96.358,
        y2: 54.873,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          stopColor: "#FF5E18",
          stopOpacity: 0
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: 1,
          stopColor: "#FF5E18"
        })]
      })]
    })]
  }));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgUsingErgStoreItLight);

/***/ }),

/***/ 4167:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgUsingErgUseIt = function SvgUsingErgUseIt(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", _objectSpread(_objectSpread({
    width: "auto",
    height: "auto",
    viewBox: "0 0 259 412",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M126 137.842H218.415V3.05176e-05H126.119L126 137.842Z",
      fill: "url(#paint0_linear_2316_23249)"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M171.754 91.4067C171.25 91.3982 170.749 91.4785 170.273 91.6439L139.547 104.393C139.097 104.579 138.69 104.857 138.353 105.209C138.016 105.562 137.757 105.981 137.591 106.439L124.851 137.186C124.632 137.649 124.518 138.156 124.518 138.668C124.518 139.181 124.632 139.687 124.851 140.151L137.591 170.898C137.759 171.345 138.021 171.75 138.358 172.088C138.695 172.425 139.1 172.687 139.547 172.855L170.273 185.604C170.735 185.825 171.242 185.936 171.754 185.93C172.238 185.937 172.716 185.825 173.147 185.604L203.873 172.855C204.331 172.689 204.75 172.429 205.102 172.092C205.454 171.755 205.732 171.348 205.917 170.898L218.658 140.151C219.004 139.193 219.004 138.144 218.658 137.186L205.917 106.439C205.734 105.977 205.458 105.557 205.106 105.205C204.755 104.853 204.335 104.577 203.873 104.393L173.147 91.6439C172.703 91.474 172.23 91.3933 171.754 91.4067ZM171.754 99.9755L199.043 111.272L210.332 138.58L199.043 165.887L171.754 177.243L144.465 165.887L133.088 138.58L144.465 111.272L171.754 99.9755Z",
      fill: "#121212"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M210.332 138.579L199.043 111.242L171.754 99.9755L144.465 111.242L133.088 138.579L144.465 165.887L171.754 177.243L199.043 165.887L210.332 138.579Z",
      fill: "#121212"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M168.732 144.361H187.043V152.871H156.466V145.191L168.466 131.849L156.554 119.337V111.657H187.043V120.167H169.147L180.258 131.79L168.732 144.361Z",
      fill: "white"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M171.754 85.032C171.245 85.0549 170.744 85.1653 170.273 85.3581L139.547 98.1076C139.101 98.2755 138.695 98.537 138.358 98.8745C138.021 99.212 137.759 99.6177 137.591 100.064L124.851 130.9C124.645 131.331 124.539 131.802 124.539 132.279C124.539 132.756 124.645 133.227 124.851 133.658L137.503 164.612C137.665 165.062 137.925 165.47 138.263 165.808C138.601 166.146 139.009 166.406 139.458 166.569L170.184 179.348C170.66 179.527 171.159 179.637 171.665 179.674C172.144 179.643 172.615 179.533 173.058 179.348L203.784 166.569C204.245 166.408 204.666 166.15 205.019 165.813C205.371 165.475 205.648 165.066 205.828 164.612L218.569 133.776C218.895 132.886 218.895 131.909 218.569 131.019L205.828 100.183C205.643 99.7323 205.365 99.3254 205.013 98.9884C204.661 98.6514 204.242 98.3918 203.784 98.2261L173.058 85.4767C172.655 85.2475 172.213 85.0967 171.754 85.032ZM171.754 93.6897L199.043 104.957L210.332 132.294L199.043 159.601L171.754 170.868L144.465 159.601L133.088 132.294L144.465 104.957L171.754 93.6897Z",
      fill: "white"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2 407.183L21.3559 407.686C37.8663 367.51 52.3314 331.833 65.5812 292.722C70.2349 278.985 73.4361 269.037 76.4595 261.102C82.3879 246.003 87.2491 238.986 100.647 229.423C116.446 218.32 134.409 210.326 149.556 198.661C155.484 194.072 152.075 187.47 146.829 192.207C142.533 196.155 137.763 199.556 132.63 202.332C122.878 207.958 112.919 212.043 100.499 218.409C80.3723 228.683 71.3019 239.134 63.9508 265.78C48.9225 320.227 30.1002 356.229 2 407.183Z",
      fill: "url(#paint1_linear_2316_23249)"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M41.4827 408.249L64.7216 408.811L77.2304 368.398C82.7733 350.427 83.8404 336.955 66.678 325.853C60.4579 322.11 53.8101 319.128 46.8774 316.971C44.595 322.892 44.5951 322.507 42.0755 328.251C64.9588 339.827 65.1069 349.39 56.5405 372.661L41.4827 408.249Z",
      fill: "url(#paint2_linear_2316_23249)"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M43.024 408.249L49.1598 408.427L63.1209 369.701C72.0134 345.127 68.1304 339.413 42.194 327.984C40.7416 331.508 41.2159 330.353 39.6746 333.906C62.795 340.923 65.107 348.709 57.7262 368.694L43.024 408.249Z",
      fill: "url(#paint3_linear_2316_23249)"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M2 407.183C30.1002 356.229 48.9225 320.227 63.9508 265.839C71.3019 239.193 80.3723 228.683 100.499 218.468C112.919 212.103 122.878 208.017 132.63 202.392C139.804 198.462 146.267 193.358 151.749 187.292C153.794 185.16 155.602 183.532 157.144 183.443C161.057 183.206 164.258 188.92 162.539 196.026C160.921 201.25 157.957 205.957 153.943 209.675C145.939 217.669 135.387 221.34 126.91 228.535C119.054 235.137 124.864 240.111 135.239 235.048C147.896 229.127 156.907 225.189 164.406 221.991C197.842 208.017 208.246 193.746 229.084 178.38C234.627 174.295 244.705 173.258 246.009 182.052C255.554 180.038 260.83 186.226 253.597 193.332L246.246 200.438C251.819 200.615 254.338 206.359 248.796 212.428L234.39 224.271C241.681 224.597 244.053 227.676 243.282 232.176C242.689 235.611 236.494 239.933 233.797 241.976L185.303 278.393C174.781 284.314 164.228 290.236 153.676 296.157C108.799 321.382 110.518 327.037 99.3132 376.747L91.8732 409.552",
      stroke: "white",
      strokeWidth: "3",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M246.573 181.992C236.85 184.953 223.185 198.987 214.352 206.152C203.466 214.803 191.692 222.276 179.227 228.446",
      stroke: "white",
      strokeWidth: "3",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M246.247 200.526C238.569 201.355 233.975 205.412 228.462 210.001C221.763 215.537 209.58 225.011 203.029 229.6C196.331 234.41 189.184 238.565 181.687 242.006",
      stroke: "white",
      strokeWidth: "3",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M236.761 224.301C231.814 224.928 227.141 226.928 223.274 230.074C202.525 246.565 202.851 247.157 177.745 259.977",
      stroke: "white",
      strokeWidth: "3",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M124.272 231.377C114.786 244.878 120.27 263.56 101.299 275.166",
      stroke: "white",
      strokeWidth: "3",
      strokeMiterlimit: "10",
      strokeLinecap: "round"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M74.7404 265.928C70.887 279.311 71.1538 286.653 78.001 304.062C72.5469 300.48 69.2567 293.759 62.4688 292.634L65.5812 275.491L74.7404 265.928Z",
      fill: "white"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M121.752 316.793C120.833 307.644 124.034 304.95 131.8 299.828L145.613 290.946C153.943 285.558 160.671 282.686 168.675 290.709C173.091 295.18 170.483 297.874 166.629 300.184C155.277 307.112 144.072 314.04 132.779 321.234C128.955 324.076 122.641 326.119 121.752 316.793Z",
      fill: "white",
      stroke: "white",
      strokeMiterlimit: "10"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M121.93 318.096L125.427 323.336H116.594L121.93 318.096Z",
      fill: "white",
      stroke: "white",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M123.61 52.2047C127.261 52.2047 130.22 49.2487 130.22 45.6024C130.22 41.956 127.261 39 123.61 39C119.959 39 117 41.956 117 45.6024C117 49.2487 119.959 52.2047 123.61 52.2047Z",
      fill: "white"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M244.482 114.032H253.226C254.827 114.032 256.191 116.193 256.191 118.858V133.661C256.191 136.326 254.916 138.487 253.226 138.487H244.482C242.911 138.487 241.518 136.326 241.518 133.661V118.858C241.637 116.193 242.793 114.032 244.482 114.032Z",
      fill: "#FF5E18",
      stroke: "white",
      strokeWidth: "3",
      strokeMiterlimit: "10"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M91.6668 85.032H107.288C108.803 85.225 110.185 85.9948 111.146 87.1807C112.107 88.3666 112.572 89.8771 112.446 91.3975V110.938C112.572 112.458 112.107 113.969 111.146 115.155C110.185 116.341 108.803 117.111 107.288 117.304H91.6668C90.1571 117.104 88.7824 116.331 87.8276 115.146C86.8729 113.961 86.4114 112.454 86.5389 110.938V91.3975C86.4114 89.8816 86.8729 88.375 87.8276 87.1898C88.7824 86.0047 90.1571 85.232 91.6668 85.032V85.032Z",
      fill: "#FF5E18",
      stroke: "#FF5E18",
      strokeMiterlimit: "10"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M94.7791 91.6343H104.027C104.911 91.7597 105.712 92.2205 106.264 92.9209C106.816 93.6212 107.077 94.5071 106.991 95.3944V106.911C107.077 107.799 106.816 108.685 106.264 109.385C105.712 110.085 104.911 110.546 104.027 110.672H94.7791C93.8955 110.546 93.0944 110.085 92.5424 109.385C91.9903 108.685 91.7298 107.799 91.8149 106.911V95.3944C91.7298 94.5071 91.9903 93.6212 92.5424 92.9209C93.0944 92.2205 93.8955 91.7597 94.7791 91.6343Z",
      fill: "white",
      stroke: "#FF5E18",
      strokeMiterlimit: "10"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M104.353 103.151H113.572C114.459 103.27 115.264 103.729 115.818 104.431C116.371 105.133 116.629 106.023 116.536 106.911V118.429C116.629 119.317 116.371 120.207 115.818 120.909C115.264 121.611 114.459 122.07 113.572 122.189H104.353C103.467 122.07 102.661 121.611 102.108 120.909C101.554 120.207 101.296 119.317 101.389 118.429V106.911C101.296 106.023 101.554 105.133 102.108 104.431C102.661 103.729 103.467 103.27 104.353 103.151Z",
      fill: "white",
      stroke: "#FF5E18",
      strokeWidth: "3",
      strokeMiterlimit: "10"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M99.8004 150.032H106.914C108.189 150.032 109.226 152.549 109.226 155.657V172.741C109.226 175.849 108.189 178.366 106.914 178.366H99.8004C98.5555 178.366 97.5181 175.849 97.5181 172.741V155.657C97.5773 152.549 98.5555 150.032 99.8004 150.032Z",
      fill: "#FF5E18",
      stroke: "#FF5E18",
      strokeMiterlimit: "10"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M216.358 54H226.733C227.698 54.083 228.591 54.5432 229.218 55.2806C229.846 56.018 230.156 56.973 230.082 57.9377V69.7805C230.156 70.7453 229.846 71.7002 229.218 72.4376C228.591 73.175 227.698 73.6352 226.733 73.7183H216.358C215.396 73.6279 214.507 73.1655 213.882 72.4299C213.256 71.6942 212.943 70.7436 213.009 69.7805V57.9377C212.943 56.9747 213.256 56.024 213.882 55.2883C214.507 54.5527 215.396 54.0904 216.358 54V54Z",
      fill: "#FF5E18",
      stroke: "#FF5E18",
      strokeMiterlimit: "10"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M101.566 247.068C98.1276 255.714 91.6658 263.974 83.5737 265.188C71.391 267.142 69.6718 246.239 82.3583 233.834C96.4084 220.126 110.725 223.886 101.566 247.068Z",
      fill: "#FF5E18"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M155.01 234.663C166.451 230.666 169.475 239.874 169.979 252.22C170.107 255.413 169.494 258.593 168.188 261.51C166.882 264.427 164.918 267.003 162.45 269.037C156.521 273.863 125.665 293.848 118.817 295.683C109.717 297.963 104.412 287.275 114.786 278.955C121.248 273.656 124.775 268.415 128.214 256.01C129.066 252.076 130.948 248.439 133.668 245.47C137.432 241.591 150.208 236.38 155.01 234.663Z",
      fill: "#FF5E18"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("defs", {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("linearGradient", {
        id: "paint0_linear_2316_23249",
        x1: "117",
        y1: "17",
        x2: "116.926",
        y2: "224",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          stopColor: "#FF5E18",
          stopOpacity: "0"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: "1",
          stopColor: "#FF5E18"
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("linearGradient", {
        id: "paint1_linear_2316_23249",
        x1: "60.0195",
        y1: "292.031",
        x2: "51.0195",
        y2: "397.531",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          stopColor: "white"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: "1",
          stopColor: "#343434",
          stopOpacity: "0"
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("linearGradient", {
        id: "paint2_linear_2316_23249",
        x1: "56.5178",
        y1: "326.032",
        x2: "76.0178",
        y2: "401.532",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: "1",
          stopColor: "#343434",
          stopOpacity: "0"
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("linearGradient", {
        id: "paint3_linear_2316_23249",
        x1: "53.5183",
        y1: "342.532",
        x2: "53.5073",
        y2: "392.532",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          stopColor: "white"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: "1",
          stopColor: "#343434",
          stopOpacity: "0"
        })]
      })]
    })]
  }));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgUsingErgUseIt);

/***/ }),

/***/ 4824:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgUsingErgStoreIt = function SvgUsingErgStoreIt(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", _objectSpread(_objectSpread({
    width: "auto",
    height: "auto",
    viewBox: "0 0 259 412",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M126 137.842H218.415V3.05176e-05H126.119L126 137.842Z",
      fill: "url(#paint0_linear_2316_23248)"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M171.754 91.4067C171.25 91.3982 170.749 91.4785 170.273 91.6439L139.547 104.393C139.097 104.579 138.69 104.857 138.353 105.209C138.016 105.562 137.757 105.981 137.591 106.439L124.851 137.186C124.632 137.649 124.518 138.156 124.518 138.668C124.518 139.181 124.632 139.687 124.851 140.151L137.591 170.898C137.759 171.345 138.021 171.75 138.358 172.088C138.695 172.425 139.1 172.687 139.547 172.855L170.273 185.604C170.735 185.825 171.242 185.936 171.754 185.93C172.238 185.937 172.716 185.825 173.147 185.604L203.873 172.855C204.331 172.689 204.75 172.429 205.102 172.092C205.454 171.755 205.732 171.348 205.917 170.898L218.658 140.151C219.004 139.193 219.004 138.144 218.658 137.186L205.917 106.439C205.734 105.977 205.458 105.557 205.106 105.205C204.755 104.853 204.335 104.577 203.873 104.393L173.147 91.6439C172.703 91.474 172.23 91.3933 171.754 91.4067ZM171.754 99.9755L199.043 111.272L210.332 138.58L199.043 165.887L171.754 177.243L144.465 165.887L133.088 138.58L144.465 111.272L171.754 99.9755Z",
      fill: "#121212"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M210.332 138.579L199.043 111.242L171.754 99.9755L144.465 111.242L133.088 138.579L144.465 165.887L171.754 177.243L199.043 165.887L210.332 138.579Z",
      fill: "#121212"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M168.732 144.361H187.043V152.871H156.466V145.191L168.466 131.849L156.554 119.337V111.657H187.043V120.167H169.147L180.258 131.79L168.732 144.361Z",
      fill: "white"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M171.754 85.032C171.245 85.0549 170.744 85.1653 170.273 85.3581L139.547 98.1076C139.101 98.2755 138.695 98.537 138.358 98.8745C138.021 99.212 137.759 99.6177 137.591 100.064L124.851 130.9C124.645 131.331 124.539 131.802 124.539 132.279C124.539 132.756 124.645 133.227 124.851 133.658L137.503 164.612C137.665 165.062 137.925 165.47 138.263 165.808C138.601 166.146 139.009 166.406 139.458 166.569L170.184 179.348C170.66 179.527 171.159 179.637 171.665 179.674C172.144 179.643 172.615 179.533 173.058 179.348L203.784 166.569C204.245 166.408 204.666 166.15 205.019 165.813C205.371 165.475 205.648 165.066 205.828 164.612L218.569 133.776C218.895 132.886 218.895 131.909 218.569 131.019L205.828 100.183C205.643 99.7323 205.365 99.3254 205.013 98.9884C204.661 98.6514 204.242 98.3918 203.784 98.2261L173.058 85.4767C172.655 85.2475 172.213 85.0967 171.754 85.032ZM171.754 93.6897L199.043 104.957L210.332 132.294L199.043 159.601L171.754 170.868L144.465 159.601L133.088 132.294L144.465 104.957L171.754 93.6897Z",
      fill: "white"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2 407.183L21.3559 407.686C37.8663 367.51 52.3314 331.833 65.5812 292.722C70.2349 278.985 73.4361 269.037 76.4595 261.102C82.3879 246.003 87.2491 238.986 100.647 229.423C116.446 218.32 134.409 210.326 149.556 198.661C155.484 194.072 152.075 187.47 146.829 192.207C142.533 196.155 137.763 199.556 132.63 202.332C122.878 207.958 112.919 212.043 100.499 218.409C80.3723 228.683 71.3019 239.134 63.9508 265.78C48.9225 320.227 30.1002 356.229 2 407.183Z",
      fill: "url(#paint1_linear_2316_23248)"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M41.4827 408.249L64.7216 408.811L77.2304 368.398C82.7733 350.427 83.8404 336.955 66.678 325.853C60.4579 322.11 53.8101 319.128 46.8774 316.971C44.595 322.892 44.5951 322.507 42.0755 328.251C64.9588 339.827 65.1069 349.39 56.5405 372.661L41.4827 408.249Z",
      fill: "url(#paint2_linear_2316_23248)"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M43.024 408.249L49.1598 408.427L63.1209 369.701C72.0134 345.127 68.1304 339.413 42.194 327.984C40.7416 331.508 41.2159 330.353 39.6746 333.906C62.795 340.923 65.107 348.709 57.7262 368.694L43.024 408.249Z",
      fill: "url(#paint3_linear_2316_23248)"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M2 407.183C30.1002 356.229 48.9225 320.227 63.9508 265.839C71.3019 239.193 80.3723 228.683 100.499 218.468C112.919 212.103 122.878 208.017 132.63 202.392C139.804 198.462 146.267 193.358 151.749 187.292C153.794 185.16 155.602 183.532 157.144 183.443C161.057 183.206 164.258 188.92 162.539 196.026C160.921 201.25 157.957 205.957 153.943 209.675C145.939 217.669 135.387 221.34 126.91 228.535C119.054 235.137 124.864 240.111 135.239 235.048C147.896 229.127 156.907 225.189 164.406 221.991C197.842 208.017 208.246 193.746 229.084 178.38C234.627 174.295 244.705 173.258 246.009 182.052C255.554 180.038 260.83 186.226 253.597 193.332L246.246 200.438C251.819 200.615 254.338 206.359 248.796 212.428L234.39 224.271C241.681 224.597 244.053 227.676 243.282 232.176C242.689 235.611 236.494 239.933 233.797 241.976L185.303 278.393C174.781 284.314 164.228 290.236 153.676 296.157C108.799 321.382 110.518 327.037 99.3132 376.747L91.8732 409.552",
      stroke: "#121212",
      strokeWidth: "3",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M246.573 181.992C236.85 184.953 223.185 198.987 214.352 206.152C203.466 214.803 191.692 222.276 179.227 228.446",
      stroke: "#121212",
      strokeWidth: "3",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M246.247 200.526C238.569 201.355 233.975 205.412 228.462 210.001C221.763 215.537 209.58 225.011 203.029 229.6C196.331 234.41 189.184 238.565 181.687 242.006",
      stroke: "#121212",
      strokeWidth: "3",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M236.761 224.301C231.814 224.928 227.141 226.928 223.274 230.074C202.525 246.565 202.851 247.157 177.745 259.977",
      stroke: "#121212",
      strokeWidth: "3",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M124.272 231.377C114.786 244.878 120.27 263.56 101.299 275.166",
      stroke: "#121212",
      strokeWidth: "3",
      strokeMiterlimit: "10",
      strokeLinecap: "round"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M74.7404 265.928C70.887 279.311 71.1538 286.653 78.001 304.062C72.5469 300.48 69.2567 293.759 62.4688 292.634L65.5812 275.491L74.7404 265.928Z",
      fill: "#121212"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M121.752 316.793C120.833 307.644 124.034 304.95 131.8 299.828L145.613 290.946C153.943 285.558 160.671 282.686 168.675 290.709C173.091 295.18 170.483 297.874 166.629 300.184C155.277 307.112 144.072 314.04 132.779 321.234C128.955 324.076 122.641 326.119 121.752 316.793Z",
      fill: "#121212",
      stroke: "#121212",
      strokeMiterlimit: "10"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M121.93 318.096L125.427 323.336H116.594L121.93 318.096Z",
      fill: "#121212",
      stroke: "#121212",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M123.61 52.2047C127.261 52.2047 130.22 49.2487 130.22 45.6024C130.22 41.956 127.261 39 123.61 39C119.959 39 117 41.956 117 45.6024C117 49.2487 119.959 52.2047 123.61 52.2047Z",
      fill: "#121212"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M244.482 114.032H253.226C254.827 114.032 256.191 116.193 256.191 118.858V133.661C256.191 136.326 254.916 138.487 253.226 138.487H244.482C242.911 138.487 241.518 136.326 241.518 133.661V118.858C241.637 116.193 242.793 114.032 244.482 114.032Z",
      fill: "#FF5E18",
      stroke: "white",
      strokeWidth: "3",
      strokeMiterlimit: "10"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M91.6668 85.032H107.288C108.803 85.225 110.185 85.9948 111.146 87.1807C112.107 88.3666 112.572 89.8771 112.446 91.3975V110.938C112.572 112.458 112.107 113.969 111.146 115.155C110.185 116.341 108.803 117.111 107.288 117.304H91.6668C90.1571 117.104 88.7824 116.331 87.8276 115.146C86.8729 113.961 86.4114 112.454 86.5389 110.938V91.3975C86.4114 89.8816 86.8729 88.375 87.8276 87.1898C88.7824 86.0047 90.1571 85.232 91.6668 85.032V85.032Z",
      fill: "#FF5E18",
      stroke: "#FF5E18",
      strokeMiterlimit: "10"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M94.7791 91.6343H104.027C104.911 91.7597 105.712 92.2205 106.264 92.9209C106.816 93.6212 107.077 94.5071 106.991 95.3944V106.911C107.077 107.799 106.816 108.685 106.264 109.385C105.712 110.085 104.911 110.546 104.027 110.672H94.7791C93.8955 110.546 93.0944 110.085 92.5424 109.385C91.9903 108.685 91.7298 107.799 91.8149 106.911V95.3944C91.7298 94.5071 91.9903 93.6212 92.5424 92.9209C93.0944 92.2205 93.8955 91.7597 94.7791 91.6343Z",
      fill: "#121212",
      stroke: "#FF5E18",
      strokeMiterlimit: "10"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M104.353 103.151H113.572C114.459 103.27 115.264 103.729 115.818 104.431C116.371 105.133 116.629 106.023 116.536 106.911V118.429C116.629 119.317 116.371 120.207 115.818 120.909C115.264 121.611 114.459 122.07 113.572 122.189H104.353C103.467 122.07 102.661 121.611 102.108 120.909C101.554 120.207 101.296 119.317 101.389 118.429V106.911C101.296 106.023 101.554 105.133 102.108 104.431C102.661 103.729 103.467 103.27 104.353 103.151Z",
      fill: "#121212",
      stroke: "#FF5E18",
      strokeWidth: "3",
      strokeMiterlimit: "10"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M99.8004 150.032H106.914C108.189 150.032 109.226 152.549 109.226 155.657V172.741C109.226 175.849 108.189 178.366 106.914 178.366H99.8004C98.5555 178.366 97.5181 175.849 97.5181 172.741V155.657C97.5773 152.549 98.5555 150.032 99.8004 150.032Z",
      fill: "#FF5E18",
      stroke: "#FF5E18",
      strokeMiterlimit: "10"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M216.358 54H226.733C227.698 54.083 228.591 54.5432 229.218 55.2806C229.846 56.018 230.156 56.973 230.082 57.9377V69.7805C230.156 70.7453 229.846 71.7002 229.218 72.4376C228.591 73.175 227.698 73.6352 226.733 73.7183H216.358C215.396 73.6279 214.507 73.1655 213.882 72.4299C213.256 71.6942 212.943 70.7436 213.009 69.7805V57.9377C212.943 56.9747 213.256 56.024 213.882 55.2883C214.507 54.5527 215.396 54.0904 216.358 54V54Z",
      fill: "#FF5E18",
      stroke: "#FF5E18",
      strokeMiterlimit: "10"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M101.566 247.068C98.1276 255.714 91.6658 263.974 83.5737 265.188C71.391 267.142 69.6718 246.239 82.3583 233.834C96.4084 220.126 110.725 223.886 101.566 247.068Z",
      fill: "#FF5E18"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M155.01 234.663C166.451 230.666 169.475 239.874 169.979 252.22C170.107 255.413 169.494 258.593 168.188 261.51C166.882 264.427 164.918 267.003 162.45 269.037C156.521 273.863 125.665 293.848 118.817 295.683C109.717 297.963 104.412 287.275 114.786 278.955C121.248 273.656 124.775 268.415 128.214 256.01C129.066 252.076 130.948 248.439 133.668 245.47C137.432 241.591 150.208 236.38 155.01 234.663Z",
      fill: "#FF5E18"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("defs", {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("linearGradient", {
        id: "paint0_linear_2316_23248",
        x1: "117",
        y1: "17",
        x2: "116.926",
        y2: "224",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          stopColor: "#FF5E18",
          stopOpacity: "0"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: "1",
          stopColor: "#FF5E18"
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("linearGradient", {
        id: "paint1_linear_2316_23248",
        x1: "60.0195",
        y1: "292.031",
        x2: "51.0195",
        y2: "397.531",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          stopColor: "#121212"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: "1",
          stopColor: "white",
          stopOpacity: "0"
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("linearGradient", {
        id: "paint2_linear_2316_23248",
        x1: "56.5178",
        y1: "326.032",
        x2: "76.0178",
        y2: "401.532",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: "1",
          stopColor: "#343434",
          stopOpacity: "0"
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("linearGradient", {
        id: "paint3_linear_2316_23248",
        x1: "53.5183",
        y1: "342.532",
        x2: "53.5073",
        y2: "392.532",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          stopColor: "#121212"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
          offset: "1",
          stopColor: "white",
          stopOpacity: "0"
        })]
      })]
    })]
  }));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgUsingErgStoreIt);

/***/ }),

/***/ 599:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgWechat = function SvgWechat(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", _objectSpread(_objectSpread({
    width: 50,
    height: 40,
    className: "fill-current text-black dark:text-white",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
      clipPath: "url(#wechat_svg__a)",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M50 25.962C50 19.099 43.281 13.5 35.008 13.5s-14.946 5.598-14.946 12.46c0 6.864 6.72 12.462 14.992 12.462 1.6 0 3.108-.18 4.525-.587.412-.09.868-.045 1.28.136l3.702 1.986c.228.137.548-.09.456-.361l-.732-2.935c-.092-.45.046-.903.456-1.173C47.944 33.186 50 29.799 50 25.962Zm-20.338-1.625a2.036 2.036 0 0 1-2.057-2.03c0-1.13.914-2.032 2.056-2.032 1.143 0 2.057.903 2.057 2.031a2.036 2.036 0 0 1-2.056 2.031Zm10.1 0a2.036 2.036 0 0 1-2.056-2.03c0-1.13.915-2.032 2.057-2.032s2.056.903 2.056 2.031c0 1.128-.96 2.031-2.056 2.031Z"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M18.83 26.007c0-7.63 7.313-13.817 16.362-13.817h.686C34.414 5.282 27.011 0 18.098 0 8.09 0 0 6.592 0 14.765c0 4.516 2.514 8.578 6.445 11.288.274.18.366.496.32.812l-1.37 4.786c-.092.316.274.632.594.45l5.346-3.16c.366-.224.776-.27 1.188-.136 1.783.451 3.657.724 5.577.724.412 0 .822 0 1.28-.046a11.21 11.21 0 0 1-.55-3.476Zm5.347-18.196c1.326 0 2.422 1.083 2.422 2.393 0 1.31-1.096 2.394-2.422 2.394s-2.422-1.083-2.422-2.394c0-1.31 1.098-2.393 2.422-2.393ZM12.02 12.598c-1.327 0-2.423-1.083-2.423-2.394 0-1.31 1.096-2.393 2.423-2.393 1.326 0 2.422 1.083 2.422 2.393 0 1.31-1.05 2.394-2.422 2.394Z"
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("defs", {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("clipPath", {
        id: "wechat_svg__a",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
          d: "M0 0h50v40H0z"
        })
      })
    })]
  }));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgWechat);

/***/ }),

/***/ 7404:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgWiki = function SvgWiki(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", _objectSpread(_objectSpread({
    width: 34,
    height: 34,
    className: "fill-current text-black dark:text-white",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M1.401 33h31.2a.4.4 0 0 0 .4-.4v-2.295c0-2.395-1.523-4.437-3.65-5.223V4.271A3.274 3.274 0 0 0 26.08 1H7.888a3.274 3.274 0 0 0-3.271 3.27v20.825C2.507 25.889 1 27.922 1 30.305V32.6c0 .22.18.4.4.4h.001Zm15.2-7.466V32.2H8.388v-6.666h8.213Zm10.015-9.975c-.354 3.66-4.53 6.56-9.615 6.56-5.086 0-9.262-2.9-9.615-6.56a9.511 9.511 0 0 1-.024-.58C7.419 11.121 11.72 7.994 17 7.994s9.582 3.127 9.64 6.985a9.45 9.45 0 0 1-.025.58Zm-.919-4.848c-1.873-2.118-5.071-3.517-8.696-3.517-3.626 0-6.824 1.399-8.697 3.516 1.557-3.238 4.87-5.48 8.697-5.48 3.826 0 7.14 2.242 8.696 5.48Zm-8.696 12.208c3.345 0 6.325-1.191 8.237-3.039A9.646 9.646 0 0 1 17 24.516a9.645 9.645 0 0 1-8.237-4.636c1.912 1.847 4.892 3.04 8.237 3.04Zm8.612 2.614V32.2H17.4v-6.666h8.212Zm6.587 4.772v1.894h-5.787v-6.666h1.015a4.777 4.777 0 0 1 4.773 4.772ZM5.418 4.27a2.474 2.474 0 0 1 2.47-2.47h18.193a2.474 2.474 0 0 1 2.47 2.47v20.576a5.57 5.57 0 0 0-1.122-.113h-6.995c3.852-1.345 6.681-4.886 6.98-9.117.017-.186.03-.372.03-.56 0-.027-.003-.053-.003-.079l.003-.105c0-1.96-.544-3.795-1.487-5.363V3.866a.4.4 0 1 0-.8 0v4.496A10.426 10.426 0 0 0 17 4.431c-5.758 0-10.443 4.684-10.443 10.442l.003.105c0 .026-.003.052-.003.079 0 .188.012.374.03.56.298 4.23 3.127 7.771 6.98 9.116H6.573a5.6 5.6 0 0 0-1.156.122V4.27ZM1.8 30.305a4.778 4.778 0 0 1 4.772-4.772h1.015v6.666H1.801v-1.894Z",
      strokeWidth: 0.5
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M12.355 10.554c-2.68.918-3.542 3.144-3.578 3.238a.4.4 0 1 0 .749.281c.007-.02.76-1.965 3.088-2.762a.4.4 0 0 0-.259-.757ZM10.418 27.8h2.734a.4.4 0 0 0 0-.8h-2.734a.4.4 0 1 0 0 .8ZM13.151 28.866h-2.733a.4.4 0 1 0 0 .8h2.733a.4.4 0 0 0 0-.8Z",
      strokeWidth: 0.5
    })]
  }));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgWiki);

/***/ }),

/***/ 8128:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var SvgX = function SvgX(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("svg", _objectSpread(_objectSpread({
    width: 40,
    height: 40,
    viewBox: "0 0 300 300.251",
    className: "fill-current text-black dark:text-white",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M178.57 127.15 290.27 0h-26.46l-97.03 110.38L89.34 0H0l117.13 166.93L0 300.25h26.46l102.4-116.59 81.8 116.59h89.34M36.01 19.54H76.66l187.13 262.13h-40.66"
    })
  }));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgX);

/***/ }),

/***/ 3829:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgXHightlighted = function SvgXHightlighted(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", _objectSpread(_objectSpread({
    width: 54,
    height: 47,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M41.995 25.753c0 10.877-9.143 19.753-20.497 19.753C10.142 45.506 1 36.63 1 25.753S10.143 6 21.497 6c11.355 0 20.498 8.877 20.498 19.753Z",
      stroke: "#585858",
      strokeWidth: 2
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "m27.993 21.044-1.597-1.541-5.009 4.905-5.009-4.905-1.597 1.541 5.082 4.836-5.082 4.835 1.597 1.542 5.01-4.905 5.008 4.905 1.597-1.542-5.081-4.835 5.081-4.836Z",
      fill: "#585858"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "m46.576 10.032.336-.432 1.128-2.352.096-.96h.336l.12.96L49.72 9.6l.312.432 2.52-1.752-.312-.432-1.872-1.824-.888-.384.096-.336.936.216 2.592-.336.528-.168-1.008-3.024-.48.168-2.304 1.248-.648.72-.288-.24.48-.792.456-2.592V0h-3.072v.504l.48 2.592.48.792-.312.24-.648-.72-2.28-1.248-.504-.168L43 5.016l.504.168 2.592.336.96-.216.072.336-.864.384-1.896 1.824-.288.432 2.496 1.752Z",
      fill: "#FF5E18"
    })]
  }));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgXHightlighted);

/***/ }),

/***/ 8597:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgXWhite = function SvgXWhite(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", _objectSpread(_objectSpread({
    width: 43,
    height: 43,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M41.995 21.26c0 10.876-9.143 19.752-20.497 19.752C10.142 41.012 1 32.136 1 21.26 1 10.383 10.143 1.506 21.497 1.506c11.355 0 20.498 8.877 20.498 19.753Z",
      stroke: "#fff",
      strokeWidth: 2
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "m27.993 16.55-1.597-1.541-5.009 4.905-5.009-4.905-1.597 1.541 5.082 4.836-5.082 4.835 1.597 1.542 5.01-4.905 5.008 4.905 1.597-1.542-5.081-4.835 5.081-4.835Z",
      fill: "#fff"
    })]
  }));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgXWhite);

/***/ }),

/***/ 7503:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgXWhiteHighlighted = function SvgXWhiteHighlighted(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", _objectSpread(_objectSpread({
    width: 54,
    height: 46,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M41.995 24.803c0 10.876-9.143 19.753-20.497 19.753C10.142 44.556 1 35.679 1 24.803 1 13.926 10.143 5.05 21.497 5.05c11.355 0 20.498 8.876 20.498 19.753Z",
      stroke: "#fff",
      strokeWidth: 2
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "m27.993 20.094-1.597-1.542-5.009 4.906-5.009-4.906-1.597 1.542 5.082 4.835-5.082 4.836 1.597 1.542 5.01-4.906 5.008 4.906 1.597-1.542-5.081-4.835 5.081-4.836Z",
      fill: "#fff"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "m46.576 10.032.336-.432 1.128-2.352.096-.96h.336l.12.96L49.72 9.6l.312.432 2.52-1.752-.312-.432-1.872-1.824-.888-.384.096-.336.936.216 2.592-.336.528-.168-1.008-3.024-.48.168-2.304 1.248-.648.72-.288-.24.48-.792.456-2.592V0h-3.072v.504l.48 2.592.48.792-.312.24-.648-.72-2.28-1.248-.504-.168L43 5.016l.504.168 2.592.336.96-.216.072.336-.864.384-1.896 1.824-.288.432 2.496 1.752Z",
      fill: "#FF5E18"
    })]
  }));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgXWhiteHighlighted);

/***/ }),

/***/ 6107:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("svg", _objectSpread(_objectSpread({
    width: 45,
    height: 40,
    className: "fill-current text-black dark:text-white",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
      d: "M42.89 9.766c-.468-1.875-1.953-3.36-3.75-3.829C35.782 5 22.5 5 22.5 5S9.14 5 5.781 5.938C3.984 6.405 2.5 7.89 2.031 9.765c-.937 3.28-.937 10.312-.937 10.312s0 6.953.937 10.313c.469 1.875 1.953 3.28 3.75 3.75C9.141 35 22.5 35 22.5 35s13.281 0 16.64-.86c1.797-.468 3.282-1.874 3.75-3.75.938-3.359.938-10.312.938-10.312s0-7.031-.937-10.312Zm-24.765 16.64V13.75l11.094 6.328-11.094 6.328Z"
    })
  }));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgYoutube);

/***/ }),

/***/ 5742:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Jm": function() { return /* reexport */ BlogFacebook; },
  "pO": function() { return /* reexport */ BlogX; },
  "Mg": function() { return /* reexport */ DiscoverErgHero; },
  "_m": function() { return /* reexport */ DiscoverErgHeroLight; },
  "zP": function() { return /* reexport */ ErgoFoundationIcon["default"]; },
  "ef": function() { return /* reexport */ ErgoFoundationIconLight["default"]; },
  "Qj": function() { return /* reexport */ ErgoRaffle; },
  "Ey": function() { return /* reexport */ Github["default"]; },
  "Xd": function() { return /* reexport */ Heart; },
  "n6": function() { return /* reexport */ Linkedin["default"]; },
  "TR": function() { return /* reexport */ Logo["default"]; },
  "sY": function() { return /* reexport */ LogoBlack; },
  "uH": function() { return /* reexport */ LogoWithText["default"]; },
  "lp": function() { return /* reexport */ LogoWithTextWhite; },
  "AH": function() { return /* reexport */ PersonPlaceholder; },
  "by": function() { return /* reexport */ RoadmapInProgress["default"]; },
  "Ld": function() { return /* reexport */ UniqueErgo1["default"]; },
  "Lu": function() { return /* reexport */ UniqueErgo1Light; },
  "fu": function() { return /* reexport */ UniqueErgo2["default"]; },
  "H6": function() { return /* reexport */ UniqueErgo2Light; },
  "JL": function() { return /* reexport */ UniqueErgo3["default"]; },
  "qT": function() { return /* reexport */ UniqueErgo3Light; },
  "KV": function() { return /* reexport */ UniqueErgo4["default"]; },
  "B5": function() { return /* reexport */ UniqueErgo4Light; },
  "XO": function() { return /* reexport */ WalletCheck; },
  "UX": function() { return /* reexport */ WalletDesktop; },
  "sP": function() { return /* reexport */ WalletMinotaur; },
  "lb": function() { return /* reexport */ WalletMobile; },
  "YW": function() { return /* reexport */ WalletNautilus; },
  "VI": function() { return /* reexport */ WalletSafew; },
  "Xt": function() { return /* reexport */ WalletSatergo; },
  "$u": function() { return /* reexport */ WalletWeb; },
  "lC": function() { return /* reexport */ WalletX; },
  "_M": function() { return /* reexport */ WalletXGray; },
  "X": function() { return /* reexport */ X["default"]; }
});

// UNUSED EXPORTS: ArrowRightBlack, ArrowRightOrange, BlogLink, BpsaaLogo, CheckDark, CheckDarkHighlited, CheckGreen, CheckOrange, CheckOrangeHighlighted, Coingecko, Discord, Discourse, ErgoNode, ErgoWiki, Highlight, Highlights1, Highlights1big, Highlights2, Highlights2big, Highlights3, Highlights3big, LanguageSelector, LanguageSelectorWhite, Ledger, Line, LogoWhite, MenuClose, MenuOpen, Power, Reddit, RoadmapCompleted, RoadmapPlanned, Sigmanauts, Sigmaverse, Sync, Telegram, ThemeDarkBig, ThemeDarkSmall, ThemeLightBig, ThemeLightSmall, UsingErgBuyIt, UsingErgBuyItLight, UsingErgMineIt, UsingErgMineItLight, UsingErgStoreIt, UsingErgStoreItLight, UsingErgUseIt, UsingErgUseItLight, WalletLedger, WalletMark, WalletStatusWithMark, WalletYoroi, Wechat, Wiki, XHightlighted, XWhite, XWhiteHighlighted, Youtube

// EXTERNAL MODULE: ./components/icons/CheckDark.js
var CheckDark = __webpack_require__(346);
// EXTERNAL MODULE: ./components/icons/CheckDarkHighlited.js
var CheckDarkHighlited = __webpack_require__(6156);
// EXTERNAL MODULE: ./components/icons/CheckGreen.js
var CheckGreen = __webpack_require__(4793);
// EXTERNAL MODULE: ./components/icons/CheckOrange.js
var CheckOrange = __webpack_require__(6024);
// EXTERNAL MODULE: ./components/icons/CheckOrangeHighlighted.js
var CheckOrangeHighlighted = __webpack_require__(8512);
// EXTERNAL MODULE: ./components/icons/Discord.js
var Discord = __webpack_require__(4985);
// EXTERNAL MODULE: ./components/icons/Wiki.js
var Wiki = __webpack_require__(7404);
// EXTERNAL MODULE: ./components/icons/ErgoNode.js
var ErgoNode = __webpack_require__(6017);
// EXTERNAL MODULE: ./components/icons/Github.js
var Github = __webpack_require__(4193);
// EXTERNAL MODULE: ./components/icons/Highlight.js
var Highlight = __webpack_require__(8029);
// EXTERNAL MODULE: ./components/icons/Ledger.js
var Ledger = __webpack_require__(3265);
// EXTERNAL MODULE: ./components/icons/Linkedin.js
var Linkedin = __webpack_require__(1979);
// EXTERNAL MODULE: ./components/icons/Logo.js
var Logo = __webpack_require__(3715);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(9499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./components/icons/LogoBlack.js


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", _objectSpread(_objectSpread({
    width: 82,
    height: 82,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      className: "fill-black",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M38.396 51.536h15.871v7.376H27.732V52.21l10.442-11.56-10.392-10.83v-6.722h26.485v7.374H38.733l9.633 10.087-9.97 10.978Z"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      className: "fill-black",
      d: "m41 7.462 23.719 9.823 9.824 23.72-9.824 23.72-23.72 9.825-23.719-9.826-9.825-23.72 9.825-23.719L41 7.462ZM41 0c-.422 0-.84.083-1.23.244l-26.718 11.07a3.209 3.209 0 0 0-1.738 1.737L.244 39.771a3.212 3.212 0 0 0 0 2.457l11.07 26.719a3.203 3.203 0 0 0 1.738 1.737l26.719 11.07a3.191 3.191 0 0 0 2.457 0l26.72-11.07a3.208 3.208 0 0 0 1.737-1.737l11.07-26.72a3.212 3.212 0 0 0 0-2.457l-11.07-26.719a3.215 3.215 0 0 0-1.738-1.737L42.228.244A3.234 3.234 0 0 0 41 0Z"
    })]
  }));
};

/* harmony default export */ var LogoBlack = (SvgLogo);
// EXTERNAL MODULE: ./components/icons/LogoWhite.js
var LogoWhite = __webpack_require__(5204);
// EXTERNAL MODULE: ./components/icons/LogoWithText.js
var LogoWithText = __webpack_require__(6586);
;// CONCATENATED MODULE: ./components/icons/LogoWithTextWhite.js


function LogoWithTextWhite_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function LogoWithTextWhite_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? LogoWithTextWhite_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : LogoWithTextWhite_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgLogoWithText = function SvgLogoWithText(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", LogoWithTextWhite_objectSpread(LogoWithTextWhite_objectSpread({
    width: 213,
    height: 82,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      className: "fill-white",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M97.365 31.142v6.241h15.372v6.512h-15.38v6.795h15.704v6.506H90.213V24.638h22.856v6.504H97.365Zm31.099 14.55h-3.986v11.506h-7.154v-32.56h14.407c6.311 0 10.943 4.107 10.943 10.531 0 2.565-.745 5.026-2.489 6.95a9.442 9.442 0 0 1-4.29 2.677l7.713 12.4h-8.306l-6.838-11.505Zm-3.986-14.55v8.045h6.514c2.457 0 4.392-1.457 4.392-4.021 0-2.565-1.935-4.024-4.392-4.024h-6.514Zm44.39 17.808v-3.536h-9.189v-6.506h16.343v12.759l-.226.25c-3.489 3.86-8.15 5.876-13.35 5.876-9.726 0-17.04-7.039-17.04-16.856 0-9.818 7.32-16.808 17.04-16.808 5.49 0 9.991 2.305 13.141 6.793l.554.78-5.966 3.356-.454-.65a8.944 8.944 0 0 0-7.275-3.736c-5.851 0-9.751 4.535-9.751 10.255 0 5.72 3.887 10.303 9.751 10.303 2.169 0 4.722-.858 6.422-2.29v.01Zm10.117-8.014c0-9.667 6.898-16.807 16.624-16.807 9.726 0 16.622 7.14 16.622 16.808 0 9.667-6.898 16.805-16.622 16.805s-16.624-7.136-16.624-16.805Zm25.956 0c0-5.642-3.417-10.254-9.332-10.254-5.915 0-9.334 4.59-9.334 10.255 0 5.663 3.415 10.258 9.334 10.258s9.332-4.636 9.332-10.258ZM38.396 51.536h15.871v7.376H27.732V52.21l10.442-11.56-10.392-10.83v-6.722h26.485v7.374H38.733l9.633 10.087-9.97 10.978Z"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      className: "fill-white",
      d: "m41 7.462 23.719 9.823 9.824 23.72-9.824 23.72-23.72 9.825-23.719-9.826-9.825-23.72 9.825-23.719L41 7.462ZM41 0c-.422 0-.84.083-1.23.244l-26.718 11.07a3.209 3.209 0 0 0-1.738 1.737L.244 39.771a3.212 3.212 0 0 0 0 2.457l11.07 26.719a3.203 3.203 0 0 0 1.738 1.737l26.719 11.07a3.191 3.191 0 0 0 2.457 0l26.72-11.07a3.208 3.208 0 0 0 1.737-1.737l11.07-26.72a3.212 3.212 0 0 0 0-2.457l-11.07-26.719a3.215 3.215 0 0 0-1.738-1.737L42.228.244A3.234 3.234 0 0 0 41 0Z"
    })]
  }));
};

/* harmony default export */ var LogoWithTextWhite = (SvgLogoWithText);
// EXTERNAL MODULE: ./components/icons/MenuClose.js
var MenuClose = __webpack_require__(7983);
// EXTERNAL MODULE: ./components/icons/MenuOpen.js
var MenuOpen = __webpack_require__(5128);
// EXTERNAL MODULE: ./components/icons/Power.js
var Power = __webpack_require__(4802);
// EXTERNAL MODULE: ./components/icons/Reddit.js
var Reddit = __webpack_require__(3157);
// EXTERNAL MODULE: ./components/icons/Sync.js
var Sync = __webpack_require__(1745);
// EXTERNAL MODULE: ./components/icons/Telegram.js
var Telegram = __webpack_require__(5866);
// EXTERNAL MODULE: ./components/icons/ThemeDarkBig.js
var ThemeDarkBig = __webpack_require__(8357);
// EXTERNAL MODULE: ./components/icons/ThemeDarkSmall.js
var ThemeDarkSmall = __webpack_require__(5883);
// EXTERNAL MODULE: ./components/icons/ThemeLightBig.js
var ThemeLightBig = __webpack_require__(478);
// EXTERNAL MODULE: ./components/icons/ThemeLightSmall.js
var ThemeLightSmall = __webpack_require__(2650);
// EXTERNAL MODULE: ./components/icons/X.js
var X = __webpack_require__(8128);
// EXTERNAL MODULE: ./components/icons/Wechat.js
var Wechat = __webpack_require__(599);
// EXTERNAL MODULE: ./components/icons/XHightlighted.js
var XHightlighted = __webpack_require__(3829);
// EXTERNAL MODULE: ./components/icons/XWhite.js
var XWhite = __webpack_require__(8597);
// EXTERNAL MODULE: ./components/icons/XWhiteHighlighted.js
var XWhiteHighlighted = __webpack_require__(7503);
// EXTERNAL MODULE: ./components/icons/Youtube.js
var Youtube = __webpack_require__(6107);
// EXTERNAL MODULE: ./components/icons/ArrowRightBlack.js
var ArrowRightBlack = __webpack_require__(7390);
// EXTERNAL MODULE: ./components/icons/ArrowRightOrange.js
var ArrowRightOrange = __webpack_require__(1891);
// EXTERNAL MODULE: ./components/icons/LanguageSelector.js
var LanguageSelector = __webpack_require__(5713);
// EXTERNAL MODULE: ./components/icons/LanguageSelectorWhite.js
var LanguageSelectorWhite = __webpack_require__(3928);
// EXTERNAL MODULE: ./components/icons/Line.js
var Line = __webpack_require__(7810);
// EXTERNAL MODULE: ./components/icons/Sigmaverse.js
var Sigmaverse = __webpack_require__(7567);
;// CONCATENATED MODULE: ./components/icons/BpsaaLogo.js


function BpsaaLogo_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function BpsaaLogo_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? BpsaaLogo_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : BpsaaLogo_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgBpsaaLogo = function SvgBpsaaLogo(props) {
  return /*#__PURE__*/_jsxs("svg", BpsaaLogo_objectSpread(BpsaaLogo_objectSpread({
    width: 227,
    height: 102,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      d: "M20.542 48.487a107.336 107.336 0 0 1-2.059-12.136v-.185c-6-3.335-11.92-6.835-17.828-10.294l-.288-.175v50.664l.144-.134a10.5 10.5 0 0 1 1.781-1.482c7.771-4.344 15.44-8.821 23.212-13.186a72.594 72.594 0 0 1-4.962-13.072Z",
      fill: "url(#bpsaa-logo_svg__a)"
    }), /*#__PURE__*/_jsx("path", {
      d: "M2.294 24.801A35871.822 35871.822 0 0 0 43.663.87c.072 6.176-.124 12.352 0 18.59a24.063 24.063 0 0 1 0 4.22 45.003 45.003 0 0 0-24.982 7.206c0 1.76-.154 3.51-.103 5.27C12.577 32.82 6.658 29.32.75 25.86c.473-.37.998-.73 1.544-1.06Z",
      fill: "#8BE4EE"
    }), /*#__PURE__*/_jsx("path", {
      d: "M43.663.87c13.906 8.234 43.232 24.94 43.232 24.94s-12.3 7.03-18.26 10.417c.051-1.709-.062-3.418 0-5.147a48.492 48.492 0 0 0-25.065-7.39s.165-16.624.093-22.82Z",
      fill: "#92C8E2"
    }), /*#__PURE__*/_jsx("path", {
      d: "M18.617 30.895a44.26 44.26 0 0 1 24.704-7.206h.247v4.694a36.666 36.666 0 0 0-21.163 5.888c0 1.41-.103 2.83 0 4.251-1.235-.793-2.563-1.462-3.86-2.172v-.185c-.082-1.76.03-3.51.072-5.27Z",
      fill: "#8FB9D4"
    }), /*#__PURE__*/_jsx("path", {
      d: "M24.443 35.31a33.113 33.113 0 0 1 19.125-5.074v7.514c-1.524.453-3.253.813-4.241 2.193a5.352 5.352 0 0 0 .35 7.277 5.6 5.6 0 0 1 1.616 2.285c-5.64-3.2-11.24-6.515-16.85-9.758 0-1.503-.381-3.016 0-4.436Z",
      fill: "#8FB9D4"
    }), /*#__PURE__*/_jsx("path", {
      d: "M43.57 23.69a48.49 48.49 0 0 1 25.013 7.41c0 1.71.103 3.418 0 5.147v.134c-1.595.844-3.15 1.77-4.745 2.625 0-1.513.412-3.15-.072-4.601a19.658 19.658 0 0 0-4.354-2.327c-4.962-2.182-10.325-3.87-15.842-3.654V23.69Z",
      fill: "#829DB4"
    }), /*#__PURE__*/_jsx("path", {
      d: "M43.57 30.236c4.883-.077 9.72.947 14.154 2.996 1.523.71 3.016 1.503 4.508 2.285a26.652 26.652 0 0 1-.226 4.436 2.28 2.28 0 0 0-.052.258c-5.28 2.954-10.427 6.104-15.687 9.068.268-2.059 2.573-3.232 2.47-5.445.484-3.088-2.346-5.538-5.146-6.083-.02-2.502-.02-5.013-.02-7.514Z",
      fill: "#829DB4"
    }), /*#__PURE__*/_jsx("path", {
      d: "M63.805 34.384a19.658 19.658 0 0 0-4.354-2.326c-5.003-2.162-10.365-3.85-15.883-3.634a36.666 36.666 0 0 0-21.163 5.888c0 1.41-.103 2.83 0 4.251l.165.134c.617.37 1.256.71 1.894 1.03 0-1.462-.381-2.976 0-4.396a33.112 33.112 0 0 1 19.104-5.095c4.883-.078 9.72.946 14.154 2.995 1.523.71 3.015 1.503 4.508 2.285a26.654 26.654 0 0 1-.226 4.437l1.842-.67c.005-.099.005-.199 0-.298 0-1.513.443-3.15-.041-4.601Z",
      fill: "url(#bpsaa-logo_svg__b)"
    }), /*#__PURE__*/_jsx("path", {
      d: "M18.523 36.35c1.297.71 2.625 1.379 3.86 2.172l.165.133a56.011 56.011 0 0 0 2.059 11.529c2.604 9.974 9.007 19.63 18.96 23.438v4.385H43.3c-7.73-3.026-13.866-9.264-17.818-16.47a72.598 72.598 0 0 1-4.962-13.093 107.337 107.337 0 0 1-1.997-12.094Z",
      fill: "#3580B0"
    }), /*#__PURE__*/_jsx("path", {
      d: "M24.445 39.748c5.61 3.284 11.21 6.598 16.86 9.8a96.045 96.045 0 0 0-2.984 10.58h5.25v11.53c-9.13-3.81-14.885-12.836-17.386-22.08a56.307 56.307 0 0 1-1.74-9.83Z",
      fill: "#3580B0"
    }), /*#__PURE__*/_jsx("path", {
      d: "M63.88 38.986c1.595-.854 3.149-1.78 4.744-2.625-.36 2.059-.525 4.252-.854 6.372a63.818 63.818 0 0 1-6.29 18.899c-3.962 7.153-10.056 13.576-17.91 16.376v-4.807a27.04 27.04 0 0 0 12.774-10.746 35.94 35.94 0 0 0 4.334-8.667 56.934 56.934 0 0 0 3.18-14.503c.013-.1.02-.2.021-.299Z",
      fill: "#1D4D75"
    }), /*#__PURE__*/_jsx("path", {
      d: "M46.278 49.28c5.26-2.965 10.406-6.115 15.687-9.07a52.418 52.418 0 0 1-2.358 11.324 43.49 43.49 0 0 1-4.385 9.439A28.132 28.132 0 0 1 43.57 71.266V60.108h5.425c-.7-3.664-1.72-7.257-2.717-10.829Z",
      fill: "#1D4D75"
    }), /*#__PURE__*/_jsx("path", {
      d: "M39.34 39.944c1.029-1.38 2.717-1.74 4.24-2.193v13.145a103.88 103.88 0 0 1-2.285-1.39 5.6 5.6 0 0 0-1.616-2.285 5.353 5.353 0 0 1-.34-7.277Z",
      fill: "#86D2EB"
    }), /*#__PURE__*/_jsx("path", {
      d: "M43.569 37.751c2.82.546 5.65 2.965 5.147 6.083.102 2.213-2.203 3.377-2.47 5.445-.886.546-1.792 1.081-2.687 1.617.01-4.385.01-8.77.01-13.145Z",
      fill: "#84A7CE"
    }), /*#__PURE__*/_jsx("path", {
      d: "M86.874 38.862V25.81c-.113 0-12.28 7.03-18.24 10.417v.134c-.36 2.059-.525 4.251-.854 6.372a63.823 63.823 0 0 1-6.3 18.898c6.465 3.47 12.774 7.206 19.208 10.757 2.058 1.03 3.84 2.604 6.176 2.933.103-12.146-.062-24.25.01-36.459Z",
      fill: "url(#bpsaa-logo_svg__c)"
    }), /*#__PURE__*/_jsx("path", {
      d: "M26.226 49.567a56.3 56.3 0 0 1-1.781-9.82c-.638-.34-1.277-.68-1.894-1.03a56.002 56.002 0 0 0 2.058 11.53c2.605 9.912 9.007 19.567 18.96 23.376V71.645c-9.088-3.808-14.842-12.836-17.344-22.079Z",
      fill: "url(#bpsaa-logo_svg__d)"
    }), /*#__PURE__*/_jsx("path", {
      d: "M43.568 50.894c.895-.535 1.8-1.029 2.686-1.616 1.03 3.572 2.059 7.206 2.718 10.819h-5.425c.02-3.068.02-6.135.02-9.203Z",
      fill: "#225EA6"
    }), /*#__PURE__*/_jsx("path", {
      d: "M41.304 49.505c.752.473 1.524.937 2.285 1.39v9.263h-5.25a96.068 96.068 0 0 1 2.965-10.653Z",
      fill: "#30ADD9"
    }), /*#__PURE__*/_jsx("path", {
      d: "M62.016 39.953a2.28 2.28 0 0 0-.051.258 52.419 52.419 0 0 1-2.358 11.322 43.487 43.487 0 0 1-4.385 9.44A28.132 28.132 0 0 1 43.57 71.265v1.945a27.04 27.04 0 0 0 12.774-10.756 35.942 35.942 0 0 0 4.334-8.667 56.934 56.934 0 0 0 3.18-14.504l-1.842.67Z",
      fill: "url(#bpsaa-logo_svg__e)"
    }), /*#__PURE__*/_jsx("path", {
      d: "M2.292 74.744c7.772-4.343 15.44-8.821 23.212-13.185 3.952 7.205 10.087 13.453 17.817 16.469a34.86 34.86 0 0 1 .247 7.061v9.264c0 2.224-.277 4.488.36 6.66l.052.247a15.299 15.299 0 0 1-2.78-1.472A23369.302 23369.302 0 0 1 .48 76.185a10.501 10.501 0 0 1 1.812-1.44Z",
      fill: "#1F75B2"
    }), /*#__PURE__*/_jsx("path", {
      d: "M43.57 78.008c7.833-2.8 13.926-9.264 17.89-16.377 6.464 3.469 12.773 7.205 19.207 10.756 2.058 1.03 3.84 2.605 6.176 2.934h.164c-.103.968-1.101 1.246-1.801 1.698-13.793 8.019-27.535 16.058-41.328 24.004-.638-2.171-.35-4.436-.36-6.66V85.1a34.86 34.86 0 0 0-.237-7.03l.288-.062Z",
      fill: "#225BA5"
    }), /*#__PURE__*/_jsx("path", {
      d: "M98.658 65.605v-9.387h4.612c5.301 0 6.721.164 8.379.967 2.151 1.03 3.026 2.79 2.851 5.734a5.507 5.507 0 0 1-1.544 3.922c-1.421 1.42-2.821 1.811-7.041 1.966l-3.088.113v6.176H98.71l-.052-9.49Zm9.604-.453a3.508 3.508 0 0 0 1.184-.905 2.347 2.347 0 0 0 .566-1.78c0-2.379-.793-2.925-4.622-3.09l-2.583-.071v6.093h2.419c1.018.032 2.036-.05 3.036-.247Zm4.55 9.697c0-.093.339-1.03.731-2.059.391-1.03 1.214-3.088 1.77-4.498.556-1.41 1.873-4.787 2.892-7.39l1.853-4.777h5.322l.617 1.657c.793 2.059 2.852 7.33 3.706 9.48 1.904 4.87 2.697 6.928 2.82 7.32l.134.431h-2.316l-2.305-.061-.68-1.925-.679-1.946h-8.235l-.113.536a45.921 45.921 0 0 1-.679 1.976l-.567 1.451h-2.151a5.66 5.66 0 0 1-2.12-.195Zm11.261-11.076c-.721-2.059-1.339-3.778-1.38-3.809-.041-.03-.278.124-.823 1.689l-1.307 3.726-.752 2.161h5.579l-1.317-3.767Zm10.756 11.137c-.072-.061-.134-4.302-.134-9.438v-9.254h5.147c5.28 0 6.701.134 8.173.772 3.417 1.451 3.942 6.989.844 9.006a4.12 4.12 0 0 1-1.276.597c-.217 0-.062.175.411.433 1.03.587 1.699 1.688 2.172 3.551a14.679 14.679 0 0 0 1.266 3.85c.107.157.188.33.237.514-.731.15-1.479.2-2.223.144h-2.224l-.308-.617a17.985 17.985 0 0 1-.711-2.327 6.803 6.803 0 0 0-1.4-3.242c-.751-.834-1.286-1.03-3.602-1.03h-2.172v7.206h-2.059c-.717.02-1.435-.035-2.141-.165Zm10.293-10.293a3.085 3.085 0 0 0 1.03-3.757c-.453-1.03-.947-1.153-4.118-1.204l-2.985-.083v5.322h2.738a9.399 9.399 0 0 0 3.315-.33l.02.052Zm13.351 2.78v-7.649h-6.176v-3.53h16.747V59.8h-6.227v15.234h-4.344v-7.638Zm12.836-1.792v-9.387h2.223c2.213 0 2.213 0 2.532.525.319.525 6.567 9.387 6.887 9.758.092.113.494.7.905 1.328l.762 1.122-.031-6.403-.062-6.382h3.984v18.868h-4.313l-1.029-1.39c-.546-.772-1.133-1.585-1.277-1.811-.144-.227-.792-1.112-1.42-1.987-.628-.875-1.266-1.75-1.41-1.976a30.844 30.844 0 0 0-.875-1.215c-.33-.442-1.153-1.616-1.863-2.656l-1.308-1.924v6.474l.052 6.485h-3.757v-9.429Zm21.132 0v-9.387h14.534V59.8h-10.19v4.117h8.306v3.201h-8.306v4.334h10.375v3.582h-14.719v-9.429Zm17.365 0v-9.387h5.146c2.903 0 5.641.092 6.259.206 3.088.566 4.683 2.346 4.704 5.27a4.53 4.53 0 0 1-3.242 4.817c-.206 0-.073.154.339.38 1.246.66 1.771 1.607 2.44 4.437.204.868.476 1.718.813 2.543.226.473.432.906.463 1.03-.72.13-1.452.171-2.182.123h-2.265l-.288-.618a20.306 20.306 0 0 1-.792-2.49c-.865-3.418-1.627-4.036-4.941-4.056h-2.131v7.205h-4.323v-9.46Zm10.509-1.153a2.9 2.9 0 0 0 .793-.72 4.243 4.243 0 0 0 .226-2.625 1.477 1.477 0 0 0-1.029-1.163c-.721-.34-1.173-.402-3.489-.402h-2.677v5.281h2.79c2.429.02 2.861-.03 3.386-.37Zm-62.593-11.775a16.06 16.06 0 0 1-2.358-.474 9.956 9.956 0 0 1-6.062-4.796c-.958-1.977-.927-2.059 1.348-3.088 2.275-1.03 2.47-1.03 2.594-.299a5.945 5.945 0 0 0 2.378 3.006 10.117 10.117 0 0 0 4.416 1.183 6.776 6.776 0 0 0 3.757-1.255 2.421 2.421 0 0 0 .85-1.768 2.417 2.417 0 0 0-.747-1.814c-.742-.7-2.821-1.534-6.176-2.44-5.147-1.39-7.319-3.088-8.04-6.248-1.194-5.322 2.78-8.924 9.831-8.924 4.776 0 8.121 1.853 9.891 5.517.312.514.522 1.084.618 1.678a36.587 36.587 0 0 1-4.426 1.492c-.154 0-.36-.34-.494-.761a4.84 4.84 0 0 0-4.117-3.088c-2.45-.422-4.663.144-5.507 1.41a1.777 1.777 0 0 0-.062 2.213c.7 1.153 1.4 1.451 6.701 2.903 1.245.34 2.398.679 2.542.761l1.606.752a7.83 7.83 0 0 1 3.572 3.19c.339.71.391 1.184.391 3.089 0 2.12 0 2.326-.525 3.263-1.266 2.398-3.809 3.952-7.319 4.457a11.317 11.317 0 0 1-4.662.04Zm-59.064-13.31V26.523l8.163.05c8.039.063 8.173.083 9.387.516 2.996 1.09 4.241 2.83 4.241 5.867.09.912-.108 1.83-.566 2.625a5.735 5.735 0 0 1-4.117 2.923c-.618.165-.824.288-.546.288a7.971 7.971 0 0 1 4.437 2.059c1.132 1.163 1.317 1.75 1.317 4.2a6.366 6.366 0 0 1-.432 3.088 6.876 6.876 0 0 1-2.882 2.902c-2.059 1.03-2.532 1.03-11.065 1.153l-7.978.082.041-12.907Zm13.752 8.513a3.088 3.088 0 0 0 2.625-3.211 3.16 3.16 0 0 0-1.42-3.242c-.69-.433-.865-.454-4.993-.505l-4.323-.062v7.205h3.644c1.997-.03 4.014-.082 4.467-.185Zm.175-11.055a2.818 2.818 0 0 0 1.73-2.151 3.16 3.16 0 0 0-2.059-3.87c-.34-.062-2.265-.114-4.272-.114h-3.685v6.413h3.767c3.006 0 3.953-.051 4.519-.278Zm12.486 2.543V26.542h6.567c6.536 0 8.42.134 9.985.659 3.623 1.225 5.342 3.644 5.342 7.545 0 4.529-2.326 7.566-6.567 8.512-1.775.27-3.568.405-5.363.402l-4.117.113v8.43h-5.857l.01-12.835Zm12.887-.453c2.059-.597 2.852-1.812 2.852-4.118a3.295 3.295 0 0 0-.412-2.058c-.906-1.452-2.326-1.853-6.681-1.853h-2.789v8.307h3.088c1.32.068 2.644-.026 3.942-.278Zm33.917 13.124c.248-.882.564-1.742.947-2.574.093-.206.391-.957.679-1.698.288-.741.844-2.244 1.297-3.397.453-1.153 1.287-3.304 1.874-4.807.586-1.503 1.152-2.913 1.245-3.088.093-.175.566-1.39 1.029-2.635a659.836 659.836 0 0 1 1.812-4.766l.968-2.501h7.205l.494 1.184c.463 1.101 1.39 3.51 4.117 10.51a270.145 270.145 0 0 0 1.308 3.303c.092.216.586 1.441 2.902 7.556a70.32 70.32 0 0 0 1.03 2.583c.079.136.141.281.185.433-1.048.077-2.1.094-3.15.051l-3.088-.093-.607-1.698c-.319-.926-.752-2.151-.927-2.687l-.339-1.029H179.76l-.186.535c-.113.278-.545 1.493-.978 2.677l-.772 2.202-2.964.052c-.996.097-2 .06-2.985-.113Zm17.169-10.16c0-.134-.545-1.719-1.791-5.24a143.535 143.535 0 0 1-1.379-3.91 4.828 4.828 0 0 0-.638-1.473.185.185 0 0 0-.155.186c0 .113-.37 1.225-.823 2.511-1.647 4.601-2.759 7.792-2.759 7.926 1.254.139 2.517.183 3.778.134 1.257.049 2.516.004 3.767-.134Zm10.571 10.16c0-.155 1.719-4.632 2.059-5.404.093-.206.772-1.946 1.524-3.87 2.243-5.827 3.376-8.75 3.571-9.151.196-.402 1.163-2.944 2.316-5.98l.422-1.092h3.634c3.592 0 3.644 0 3.819.432.092.227.731 1.863 1.41 3.624.679 1.76 1.585 4.055 1.986 5.146.402 1.091 1.287 3.284 1.997 5.034.711 1.75 1.328 3.376 1.421 3.582.093.206.525 1.266.926 2.357.402 1.091 1.03 2.738 1.41 3.664.381.927.68 1.72.68 1.72a30.583 30.583 0 0 1-3.088 0h-3.181l-.545-1.514a58.335 58.335 0 0 1-.937-2.697l-.401-1.173h-5.59l-5.579.062-.432 1.225c-.247.679-.669 1.883-.926 2.697l-.495 1.45h-3.005c-1 .072-2.004.034-2.996-.112Zm17.17-10.232c0-.093-.463-1.503-1.03-3.15a380.348 380.348 0 0 0-1.513-4.323c-.267-.741-.607-1.73-.813-2.254l-.36-.947-.227.566c-.113.32-.483 1.38-.844 2.357-.36.978-1.029 2.903-1.513 4.241-.792 2.213-1.225 3.5-1.225 3.634 0 .133 1.699.051 3.778.051 1.252.06 2.506.001 3.747-.175Z",
      fill: "#1B639F"
    }), /*#__PURE__*/_jsxs("defs", {
      children: [/*#__PURE__*/_jsxs("linearGradient", {
        id: "bpsaa-logo_svg__a",
        x1: 12.925,
        y1: 28.116,
        x2: 12.925,
        y2: 73.757,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#39C8DE"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopColor: "#2EA3D8"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "bpsaa-logo_svg__b",
        x1: 63.239,
        y1: 34.147,
        x2: 23.414,
        y2: 34.147,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#7BC8E5"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopColor: "#7EEAFF"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "bpsaa-logo_svg__c",
        x1: 74.182,
        y1: 26.428,
        x2: 74.182,
        y2: 74.097,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#3A95C8"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopColor: "#3277C1"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "bpsaa-logo_svg__d",
        x1: 21.069,
        y1: 40.931,
        x2: 41.069,
        y2: 73.89,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#34D6FE"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopColor: "#36E4EE"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "bpsaa-logo_svg__e",
        x1: 64.898,
        y1: 41.611,
        x2: 46.494,
        y2: 72.604,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#2397C4"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopColor: "#1C8088"
        })]
      })]
    })]
  }));
};

/* harmony default export */ var BpsaaLogo = ((/* unused pure expression or super */ null && (SvgBpsaaLogo)));
// EXTERNAL MODULE: ./components/icons/Highlights1.js
var Highlights1 = __webpack_require__(2720);
// EXTERNAL MODULE: ./components/icons/Highlights2.js
var Highlights2 = __webpack_require__(1104);
// EXTERNAL MODULE: ./components/icons/Highlights3.js
var Highlights3 = __webpack_require__(4881);
// EXTERNAL MODULE: ./components/icons/Highlights1big.js
var Highlights1big = __webpack_require__(1191);
// EXTERNAL MODULE: ./components/icons/Highlights2big.js
var Highlights2big = __webpack_require__(7655);
// EXTERNAL MODULE: ./components/icons/Highlights3big.js
var Highlights3big = __webpack_require__(8283);
// EXTERNAL MODULE: ./components/icons/Sigmanauts.js
var Sigmanauts = __webpack_require__(9738);
// EXTERNAL MODULE: ./components/icons/UsingErgBuyItLight.js
var UsingErgBuyItLight = __webpack_require__(9140);
// EXTERNAL MODULE: ./components/icons/UsingErgBuyIt.js
var UsingErgBuyIt = __webpack_require__(417);
// EXTERNAL MODULE: ./components/icons/UsingErgMineItLight.js
var UsingErgMineItLight = __webpack_require__(483);
// EXTERNAL MODULE: ./components/icons/UsingErgMineIt.js
var UsingErgMineIt = __webpack_require__(2236);
// EXTERNAL MODULE: ./components/icons/UsingErgStoreItLight.js
var UsingErgStoreItLight = __webpack_require__(358);
// EXTERNAL MODULE: ./components/icons/UsingErgStoreIt.js
var UsingErgStoreIt = __webpack_require__(5985);
// EXTERNAL MODULE: ./components/icons/UsingErgUseIt.js
var UsingErgUseIt = __webpack_require__(4167);
// EXTERNAL MODULE: ./components/icons/UsingErgUseItLight.js
var UsingErgUseItLight = __webpack_require__(4824);
;// CONCATENATED MODULE: ./components/icons/PersonPlaceholder.js


function PersonPlaceholder_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function PersonPlaceholder_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? PersonPlaceholder_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : PersonPlaceholder_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var SvgPersonPlaceholder = function SvgPersonPlaceholder(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", PersonPlaceholder_objectSpread(PersonPlaceholder_objectSpread({
    width: 324,
    height: 342,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M81 81c0 44.658 36.342 81 81 81s81-36.342 81-81-36.342-81-81-81-81 36.342-81 81Zm225 261h18v-18c0-69.462-56.538-126-126-126h-72C56.52 198 0 254.538 0 324v18h306Z",
      fill: "#141414"
    })
  }));
};

/* harmony default export */ var PersonPlaceholder = (SvgPersonPlaceholder);
;// CONCATENATED MODULE: ./components/icons/DiscoverErgHeroLight.js


function DiscoverErgHeroLight_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function DiscoverErgHeroLight_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? DiscoverErgHeroLight_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : DiscoverErgHeroLight_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgDiscoverErgHeroLight = function SvgDiscoverErgHeroLight(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", DiscoverErgHeroLight_objectSpread(DiscoverErgHeroLight_objectSpread({
    width: 1011,
    height: 811,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M957.874 675.024c34.551-51.035-126.718-220.549-360.204-378.621C364.183 138.332 146.896 51.562 112.345 102.597c-34.55 51.035 126.718 220.549 360.205 378.62 233.486 158.072 450.773 244.842 485.324 193.807Z",
      stroke: "#FF5E18",
      strokeWidth: 3,
      strokeMiterlimit: 10
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M901.152 633.867c29.39-43.411-107.806-187.615-306.436-322.089C396.086 177.305 211.24 103.485 181.85 146.896c-29.39 43.412 107.806 187.616 306.436 322.09 198.63 134.473 383.476 208.293 412.866 164.881Z",
      stroke: "#141414",
      strokeWidth: 3,
      strokeMiterlimit: 10
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M643.606 659.4 516.499 764.525 646.3 736.572l37.009-18.493-39.703-58.679Z",
      fill: "#141414"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m321.589 281.487-137.428 46.09 11.068 183.138 136.276-35.619-9.916-193.609Z",
      fill: "#FF5E18"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M337.262 480.813 195.22 510.714c39.351-124.307 75.326-187.271 126.357-229.204l15.685 199.303Z",
      fill: "url(#discover-erg-hero-light_svg__a)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m404.878 172.318 90.59 61.529 114.407-85.079-88.923-64.339-116.074 87.889Z",
      fill: "url(#discover-erg-hero-light_svg__b)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m305.449 602.772 95.957 58.124-26.541-118.486-93.467-59.109 24.051 119.471Z",
      fill: "url(#discover-erg-hero-light_svg__c)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m525.826 334.33 92.236 62.835-54.995 74.744-93.753-61.083 56.512-76.496Z",
      fill: "url(#discover-erg-hero-light_svg__d)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m357.865 515.355 95.957 58.124-26.615-118.493-93.42-59.08 24.078 119.449Z",
      fill: "url(#discover-erg-hero-light_svg__e)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m402.268 246.335 90.38 61.634-.007.074-90.448-61.715.075.007Z",
      fill: "#FF5E18"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m398.183 255.08 90.59 61.529 114.454-85.049-88.896-64.362-116.148 87.882Z",
      fill: "url(#discover-erg-hero-light_svg__f)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m487.021 293.207 91.383 62.628 39.667 41.331-92.237-62.834-38.813-41.125Z",
      fill: "url(#discover-erg-hero-light_svg__g)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m547.018 387.792 93.217 62.504-4.434 42.15-94.095-61.939 5.312-42.715Z",
      fill: "url(#discover-erg-hero-light_svg__h)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m330.27 554.461 96.795 57.182.494.321.592.332.581.18.656.188-96.766-57.229-.653-.213-.582-.18-.525-.25-.592-.331Z",
      fill: "#FF5E18"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m332.623 555.438 96.766 57.228 119.708 32.398-97.41-58.588-119.064-31.038Z",
      fill: "url(#discover-erg-hero-light_svg__i)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m541.707 430.509 94.094 61.94-128.578 34.983-95.001-59.506 129.485-37.417Z",
      fill: "url(#discover-erg-hero-light_svg__j)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M618.789 466.336 713.413 529l70.491-170.914-91.11-65.996-74.005 174.246Z",
      fill: "url(#discover-erg-hero-light_svg__k)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m521.833 161.55 88.785 64.475-.081.067-88.754-64.547.05.005Z",
      fill: "#FF5E18"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m561.674 269.383 90.897 64.054-74.167 22.398-91.383-62.628 74.653-23.824Z",
      fill: "url(#discover-erg-hero-light_svg__l)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m514.33 167.197 88.896 64.362 107.283 15.411-89.133-66.056-107.046-13.717Z",
      fill: "url(#discover-erg-hero-light_svg__m)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m463.993 583.26 97.242 58.772 142.199-100.361-94.855-62.337L463.993 583.26Z",
      fill: "url(#discover-erg-hero-light_svg__n)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m333.787 395.906 93.42 59.08 61.561-138.378-90.59-61.529-64.391 140.827Z",
      fill: "url(#discover-erg-hero-light_svg__o)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m566.599 229.125 90.12 64.604-4.15 39.707-90.897-64.054 4.927-40.257Z",
      fill: "url(#discover-erg-hero-light_svg__p)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m694.189 277.998 90.766 66.212-43.128-129.008-88.407-66.86 40.769 129.656Z",
      fill: "url(#discover-erg-hero-light_svg__q)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "m419.895 287.104-17.454-11.628-53.927 118.844 67.946 44.936",
      stroke: "#FF5E18",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m692.789 292.092 91.111 65.996.362-.914.288-.921.287-.92.239-.926.213-.928.16-.883.164-.933.083-.865.083-.866.011-.897-.048-.803-.063-.905-.123-.81-.126-.761-.201-.768-.275-.775-90.766-66.212.201.768.201.768.122.81.07.83.041.878.07.83-.082.865-.034.871-.142.959-.087.915-.238.926-.216.952-.286.897-.315.943-.288.92-.416.959Z",
      fill: "#141414",
      stroke: "#141414",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "m380.41 415.192 40.355-90.995 6.942 5.955-39.926 90.163M626.635 198.21l-85.559-11.634-49.551 34.811 9.776 6.851 26.067-18.118",
      stroke: "#FF5E18",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m642.849 447.305 94.624 62.664 70.486-170.865-91-66.11c-24.694 58.096-49.398 116.2-74.11 174.311Z",
      fill: "url(#discover-erg-hero-light_svg__r)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m726.235 133.825 21.971 16.054-10.48-31.3-21.433-16.202 9.942 31.448ZM674.047 481.385l20.131 13.382 15.011-36.371-19.387-14.109-15.755 37.098Z",
      fill: "#141414"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m679.98 526.274-42.19-27.747-36.573 26.721 31.58 21.79 11.056-7.826 20.177.908 15.95-13.846Z",
      fill: "#FF5E18"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "m535.657 309.641-13.744-9.975 57.34-17.895 18.091 12.787M604.574 299.641l17.279 12.16M607.506 225.18l-30.236-23.832 52.755 8.095M509.381 516.109l-63.096-40.854 84.28-24.55",
      stroke: "#FF5E18",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m608.583 479.337 94.854 62.336.799-.522.759-.626.788-.674.687-.658.746-.752.696-.757.669-.734.63-.838.602-.816.627-.814.559-.894.553-.821.486-.902.517-.973.412-.909.443-.981-49.635-32.877-44.989-29.787-.443.981-.493.976-.51.899-.493.976-.56.895-.56.895-.609.89-.701.806-.627.814-.672.759-.75.802-.696.756-.739.678-.811.647-.734.628-.805.597Z",
      fill: "#141414",
      stroke: "#141414",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "m434.259 192.323-29.38-20.007 65.81-49.801",
      stroke: "#141414",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "m295.431 552.626-14.052-69.325",
      stroke: "#141414",
      strokeWidth: 3,
      strokeMiterlimit: 10
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "m547.014 387.793 46.599 31.214",
      stroke: "#141414",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "m550.055 299.991 38.27-11.859M449.13 410.815l-35.617-23.674 21.972-50.429",
      stroke: "#FF5E18",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m653.422 148.345 88.407 66.86-.215-.619-.336-.657-.29-.626-.343-.582-.376-.51-.425-.515-.432-.441-.479-.47-.513-.373-88.326-66.928.513.374.432.441.43.465.425.515.35.508.344.581.289.627.265.624.28.726Z",
      fill: "#141414",
      stroke: "#141414",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m590.211 696.241-12.816 14.221-13.557-131.069c-1.131-10.09 12.788-11.578 14.074-2.595l12.299 119.443Z",
      fill: "url(#discover-erg-hero-light_svg__s)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m686.425 205.033 50.412 36.745-23.964-71.622-49.1-37.168 22.652 72.045Z",
      fill: "#141414"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "m347.041 414.719 23.453 118.939",
      stroke: "#FF5E18",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m451.68 586.476 97.41 58.588.314.105.347.033.314.105.42.041.322.03.42.041.322.03.353-.041.403-.036.346.033.401-.011.335-.118.428-.034.4-.011.336-.118.432-.083-97.378-58.66-.36.115-.401.011-.36.116-.408.085-.353.042-.403.036-.351.016-.403.036-.321-.03-.42-.041-.329.044-.42-.04-.315-.105-.346-.033-.321-.031-.414-.115ZM457.608 586.368l97.378 58.66.336-.117.432-.084.341-.167.434-.108.415-.16.34-.167.44-.158.34-.167.439-.157.348-.242.422-.234.372-.239.421-.234.373-.239.419-.209.379-.313-97.242-58.772-.427.284-.372.239-.421.234-.38.313-.422.234-.365.165-.421.234-.42.209-.367.19-.415.16-.365.164-.415.16-.414.16-.361.116-.414.159-.408.086Z",
      fill: "#141414",
      stroke: "#141414",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m736.962 482.39 8.612 5.716 6.433-15.581-8.285-6.008-6.76 15.873ZM898.238 129.281l-196.841 68.702 30.635 191.725 195.583-49.307-29.377-211.12Z",
      fill: "#FF5E18"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m937.552 351.583-205.519 38.124c47.836-141.513 94.897-207.658 166.206-260.427l39.313 222.303Z",
      fill: "url(#discover-erg-hero-light_svg__t)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "m412.221 467.926 82.031 51.351",
      stroke: "#FF5E18",
      strokeWidth: 3,
      strokeMiterlimit: 10
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "m381.166 534.73-17.342-90.753 21.452 12.884 17.871 87.31",
      stroke: "#FF5E18",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "m525.83 334.328 66.796 45.476",
      stroke: "#141414",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m469.316 410.852 77.7-23.058-5.312 42.715-129.495 37.516 5.626-38.169 58.793-79.746-40.51-43.982 5.271-36.031 125.223-40.87-4.951 40.255-74.654 23.824 38.836 41.151-56.527 76.395Zm44.321-278.933-129.575 98.575-.652.562-.725.529-.682.609-.59.692-.682.608-.616.69-.59.692-.622.764-.546.747-.622.764-.471.753-.555.845-.472.754-.431.857-.429.832-.405.835-72.445 157.176-.438.931-.355.84-.362.913-.281.847-.206.854-.239.925-.208.878-.076.792-.085.89-.149 1.558-.071.742-.079.816.053.754.077.756.127.761 25.827 135.063.201.768.209.694.205.718.258.699.296.552.337.656.35.508.425.515.425.515.432.441.511.398.513.373.568.329.525.25.604.208.656.187 119.061 31.063.396.038.667.064.347.033.395.038.347.033.741.071.396.038.322.031.42.04.322.031.432-.084.321.031.421.04.335-.117.408-.086.439-.158.336-.117.439-.158.415-.16.34-.167.439-.157.341-.167.446-.232.422-.234.341-.167.446-.232.355-.316.444-.207.347-.241.429-.308 144.71-103.915.806-.596.731-.604.813-.671.739-.678.672-.759.75-.802.697-.757.602-.816.701-.806.634-.888.56-.894.559-.895.493-.976.486-.902.517-.974.416-.958 74.079-174.239.443-.981.288-.92.288-.921.288-.921.238-.926.214-.927.089-.94.09-.94.086-.89.083-.866-.048-.803-.064-.904.076-.792-.12-.835-.201-.768-.201-.767-40.794-129.659-.257-.698-.287-.652-.265-.624-.368-.584-.351-.508-.425-.515-.432-.441-.429-.465-.514-.374-.567-.328-.518-.324-.661-.663-.599-.257-.668-.064-.655-.187-.668-.064-120.764-14.056-.346-.033-.322-.031-.668-.064-.272-.026-.346-.033-.575.269-.346-.033-.321-.031-.347-.033-.333.093-.36.115-.322-.031-.36.116-.358.09a23.06 23.06 0 0 0-6.266 3.668v0Zm.688 35.304 107.049 13.691 34.874 115.641-65.544 153.119-126.971 91.712-105.847-25.979-24.075-119.473 64.366-140.83 116.148-87.881Z",
      fill: "#F6F6F6",
      stroke: "#FF5E18",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m656.926 707.168-28.562-32.207 8.275-40.56 25.423 15.461 21.246 68.217-26.382-10.911Z",
      fill: "url(#discover-erg-hero-light_svg__u)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "m701.396 197.982 30.636 191.725 119.056-22.069",
      stroke: "#141414",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M630.738 727.773 516.49 764.528l.9-18.531 94.713-98.07 24.528-13.524 20.286 72.767-26.179 20.603Z",
      fill: "url(#discover-erg-hero-light_svg__v)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M542.908 710.482a69.82 69.82 0 0 0-9.754 30.985c.04.855.168 1.703.382 2.532 1.228 4.111 3.682 3.247 6.562 2.101l83.651-34.143-78.473 21.761c-.811-7.689-1.568-15.423-2.368-23.236Z",
      fill: "url(#discover-erg-hero-light_svg__w)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M543.096 733.207c-3.183-2.202-2.538-11.024-.071-22.717l69.752-48.226 10.951 49.837-75.404 20.982c-1.727.309-3.636 1.225-5.228.124Z",
      fill: "url(#discover-erg-hero-light_svg__x)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m655.036 700.351-31.261 11.632-12.419 5.125-9.17.894c28.401-25.556 33.859-30.175 84.83-50.101l-31.98 32.45Z",
      fill: "#141414"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "m340.432 557.457 85.678 22.377",
      stroke: "#141414",
      strokeWidth: 3,
      strokeMiterlimit: 10
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m371.127 401.573-14.831-9.83 11.554-24.498 13.891 9.74-10.614 24.588ZM502.551 198.188l-6.918-5.679-79.316 59.24 7.645 5.124 78.589-58.685Z",
      fill: "#FF5E18"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "m487.816 405.358 40.953-54.227 11.721 7.91M514.485 504.667l-40.917-25.654 70.152-20.86M410.775 528.354l-11.474-54.28 14.793 8.928 10.578 48.779M435.242 490.719l8.551 38.153M593.503 238.215l8.262-6.796 36.421 5.109",
      stroke: "#FF5E18",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "m541.074 186.576 62.152 44.981",
      stroke: "#FF5E18",
      strokeWidth: 3,
      strokeMiterlimit: 10
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "m566.598 229.125 58.778 42.162",
      stroke: "#141414",
      strokeWidth: 3,
      strokeMiterlimit: 10
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "m614.705 393.449-36.304-37.615 44.379-13.371M497.788 583.451l111.875-80.779 67.97 46.761",
      stroke: "#FF5E18",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "m453.628 324.974 23.009 25.038-58.794 79.746",
      stroke: "#141414",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "m438.231 291.855 3.166-21.858 97.867-31.958",
      stroke: "#141414",
      strokeWidth: 3,
      strokeMiterlimit: 10
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M374.454 459.644a1.34 1.34 0 0 1 1.039-1.473 1.248 1.248 0 0 1 1.451 1.012l.885 4.827a1.186 1.186 0 0 1-.145.947 1.177 1.177 0 0 1-.795.535 1.234 1.234 0 0 1-.942-.174 1.232 1.232 0 0 1-.538-.791l-.955-4.883Zm12.679 53.172a1.252 1.252 0 0 1-.174.941 1.249 1.249 0 0 1-.792.539 1.268 1.268 0 0 1-1.455-.963l-.952-4.908c-.048-.325.03-.656.219-.925.188-.27.471-.458.793-.525a1.265 1.265 0 0 1 1.475 1.014l.886 4.827Zm-2.306-12.15a1.29 1.29 0 0 1-1.015 1.475 1.243 1.243 0 0 1-1.398-1.032l-.956-4.883a1.29 1.29 0 0 1 .966-1.48 1.292 1.292 0 0 1 1.45 1.012l.953 4.908Zm-2.351-12.204a1.191 1.191 0 0 1-.938 1.458 1.27 1.27 0 0 1-1.475-1.015l-.96-4.833a1.344 1.344 0 0 1 1.015-1.476 1.226 1.226 0 0 1 .947.165 1.22 1.22 0 0 1 .533.801l.878 4.9ZM404.153 284.724a1.212 1.212 0 0 1 1.14-.746c.162.003.321.037.469.102a1.294 1.294 0 0 1 .662 1.685l-1.983 4.552a1.214 1.214 0 0 1-1.164.709 1.221 1.221 0 0 1-.465-.116 1.206 1.206 0 0 1-.68-.676 1.187 1.187 0 0 1 .038-.958l1.983-4.552Zm-29.527 73.814a1.245 1.245 0 0 1-2.033.398 1.226 1.226 0 0 1-.349-.872c.003-.162.037-.321.101-.469l1.986-4.576a1.187 1.187 0 0 1 1.609-.645 1.208 1.208 0 0 1 .675.665 1.221 1.221 0 0 1-.006.947l-1.983 4.552Zm14.922-34.134a1.245 1.245 0 0 1-1.634.642 1.175 1.175 0 0 1-.679-.661 1.168 1.168 0 0 1 .035-.948l1.983-4.552a1.243 1.243 0 0 1 1.611-.669 1.239 1.239 0 0 1 .667 1.636l-1.983 4.552Zm9.96-22.705a1.249 1.249 0 0 1-1.645.629 1.248 1.248 0 0 1-.629-1.645l1.983-4.552a1.22 1.22 0 0 1 1.636-.667 1.276 1.276 0 0 1 .67.709 1.26 1.26 0 0 1-.032.974l-1.983 4.552Z",
      fill: "#141414"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "m193.988 490.332-9.825-162.755 94.652-31.742",
      stroke: "#141414",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M595.205 529.414a1.24 1.24 0 0 1 1.716.314 1.181 1.181 0 0 1 .292.901c-.015.162-.064.32-.143.462a1.182 1.182 0 0 1-.314.368l-4 2.936a1.317 1.317 0 0 1-1.756-.168 1.206 1.206 0 0 1-.217-.939 1.214 1.214 0 0 1 .534-.802l3.888-3.072Zm-82.98 63.356a1.29 1.29 0 0 1-1.741-.317 1.245 1.245 0 0 1 .314-1.717l3.999-2.936a1.267 1.267 0 0 1 1.744.292 1.267 1.267 0 0 1-.168 1.756l-4.148 2.922Zm20.092-14.623a1.207 1.207 0 0 1-.921.218 1.218 1.218 0 0 1-.798-.507 1.314 1.314 0 0 1 .292-1.744l4.017-2.86a1.242 1.242 0 0 1 1.731.166 1.266 1.266 0 0 1-.168 1.756l-4.153 2.971Zm10.057-7.298a1.18 1.18 0 0 1-.927.217 1.19 1.19 0 0 1-.79-.531 1.224 1.224 0 0 1-.217-.92 1.204 1.204 0 0 1 .507-.799l3.994-2.887a1.269 1.269 0 0 1 1.756.168 1.217 1.217 0 0 1-.316 1.742l-4.007 3.01Zm20.117-14.62a1.267 1.267 0 0 1-1.756-.168 1.29 1.29 0 0 1 .168-1.756l4.024-2.933a1.241 1.241 0 0 1 1.731.165 1.195 1.195 0 0 1 .053 1.375 1.208 1.208 0 0 1-.342.345l-3.878 2.972Zm20.089-14.597a1.266 1.266 0 0 1-1.756-.168 1.218 1.218 0 0 1 .317-1.742l3.999-2.936a1.22 1.22 0 0 1 1.396-.034c.138.092.256.211.346.35a1.18 1.18 0 0 1 .217.927 1.206 1.206 0 0 1-.531.79l-3.988 2.813ZM601.013 591.711a1.337 1.337 0 0 1-1.716-.314 1.2 1.2 0 0 1-.292-.902 1.18 1.18 0 0 1 .457-.829l3.13-2.196a1.313 1.313 0 0 1 1.744.292 1.208 1.208 0 0 1 .217.939 1.202 1.202 0 0 1-.184.456c-.091.138-.21.256-.349.346l-3.007 2.208Zm19.359-13.744a1.266 1.266 0 0 1-1.755-.168 1.294 1.294 0 0 1 .168-1.756l4.066-2.855a1.232 1.232 0 0 1 .933-.219 1.235 1.235 0 0 1 .811.511 1.312 1.312 0 0 1-.292 1.744l-3.931 2.743Zm20.301-14.453a1.188 1.188 0 0 1-1.378.033 1.193 1.193 0 0 1-.339-.347 1.195 1.195 0 0 1-.053-1.375c.089-.137.206-.254.342-.344l4.069-2.88a1.108 1.108 0 0 1 .905-.228 1.112 1.112 0 0 1 .762.537 1.267 1.267 0 0 1-.168 1.756l-4.14 2.848Z",
      fill: "#141414"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "m333.787 395.906 64.391-140.827 116.148-87.882M656.226 296.528l-65.541 153.095-126.949 91.739-105.869-26.007",
      stroke: "#141414",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "m581.175 456.449-39.468-25.94-129.485 37.417",
      stroke: "#141414",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m593.473 675.493 19.321-13.349 28.129-12.281 15.914-23.907 8.214-12.29c-5.602 2.733-10.663 5.293-15.248 7.824-32.399 17.787-39.779 32.054-56.33 54.003Z",
      fill: "#141414"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "m516.499 764.524 114.248-36.754 26.18-20.603",
      stroke: "#FF5E18",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "m551.524 732.042 50.61-14.072",
      stroke: "#322C24",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "m541.127 728.802 1.903-18.31 69.739-48.352 5.474 24.931",
      stroke: "#141414",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "m516.491 764.527.901-18.531 17.456-18.119 8.03-17.399",
      stroke: "#141414",
      strokeWidth: 3,
      strokeMiterlimit: 10
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "m547.945 721.468 43.707-19.125 9.784 8.848M628.201 721.687l-26.619 9.031-3.807-2.46-39.671 14.245",
      stroke: "#FF5E18",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M593.473 675.491c25.168-33.502 34.021-42.562 71.582-61.876",
      stroke: "#141414",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "m640.926 649.786-28.16 12.352",
      stroke: "#FF5E18",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M537.854 440.447a1.243 1.243 0 0 1 1.462.888 1.242 1.242 0 0 1-.821 1.544l-4.793 1.313a1.319 1.319 0 0 1-1.566-.849 1.295 1.295 0 0 1 .896-1.536l4.822-1.36Zm-87.856 27.227a1.234 1.234 0 0 1-.957-.125 1.238 1.238 0 0 1-.605-1.244 1.185 1.185 0 0 1 .483-.794 1.17 1.17 0 0 1 .431-.195l4.798-1.363a1.148 1.148 0 0 1 .924.105 1.15 1.15 0 0 1 .54.759 1.158 1.158 0 0 1-.085.924 1.159 1.159 0 0 1-.732.57l-4.797 1.363Zm23.952-6.717a1.207 1.207 0 0 1-.946-.084 1.208 1.208 0 0 1-.598-.737 1.23 1.23 0 0 1 .084-.946 1.225 1.225 0 0 1 .738-.598l4.8-1.387c.322-.076.661-.025.947.141.285.167.496.437.589.755a1.265 1.265 0 0 1-.871 1.538l-4.743 1.318Zm23.871-6.649a1.394 1.394 0 0 1-1.537-.896 1.27 1.27 0 0 1 .896-1.536l4.743-1.318a1.225 1.225 0 0 1 .946.084 1.22 1.22 0 0 1 .597.738 1.239 1.239 0 0 1-.821 1.543l-4.824 1.385Zm23.904-6.746a1.178 1.178 0 0 1-.929-.115 1.182 1.182 0 0 1-.56-.751 1.293 1.293 0 0 1 .824-1.568l4.815-1.286a1.265 1.265 0 0 1 1.543.821 1.225 1.225 0 0 1-.124.957 1.227 1.227 0 0 1-.772.58l-4.797 1.362ZM564.063 460.297a1.271 1.271 0 0 1 1.568.824 1.24 1.24 0 0 1-.896 1.537l-4.75 1.392a1.29 1.29 0 0 1-1.537-.896 1.234 1.234 0 0 1 .125-.957 1.238 1.238 0 0 1 .771-.579l4.719-1.321Zm-63.88 20.513a1.342 1.342 0 0 1-1.536-.895 1.34 1.34 0 0 1 .871-1.539l4.817-1.311a1.17 1.17 0 0 1 1.467.839 1.244 1.244 0 0 1-.822 1.544l-4.797 1.362Zm47.829-13.439a1.27 1.27 0 0 1-1.543-.822 1.25 1.25 0 0 1 .124-.957 1.25 1.25 0 0 1 .772-.579l4.725-1.395a1.232 1.232 0 0 1 .979.104 1.219 1.219 0 0 1 .582.795 1.178 1.178 0 0 1-.105.924 1.184 1.184 0 0 1-.736.567l-4.798 1.363Z",
      fill: "#141414"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "m697.832 317.856-55.017 129.446 35.698 23.607",
      stroke: "#141414",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M588.803 303.298a1.241 1.241 0 0 1 1.551.748 1.209 1.209 0 0 1-.063.935 1.225 1.225 0 0 1-.709.613l-4.745 1.592a1.265 1.265 0 0 1-1.483-1.759c.14-.293.387-.521.69-.638l4.759-1.491Zm-39.474 15.313a1.24 1.24 0 0 1-1.543-.822 1.24 1.24 0 0 1 .747-1.55l4.762-1.516a1.211 1.211 0 0 1 .935.063 1.217 1.217 0 0 1 .613.709 1.243 1.243 0 0 1-.747 1.551l-4.767 1.565Zm23.649-7.719a1.264 1.264 0 0 1-.936-.102 1.248 1.248 0 0 1-.546-1.645c.139-.289.385-.513.686-.625l4.762-1.515a1.24 1.24 0 0 1 1.55.747 1.267 1.267 0 0 1-.749 1.575l-4.767 1.565ZM478.707 222.01a1.222 1.222 0 0 1 .914-.293 1.227 1.227 0 0 1 .842.461 1.241 1.241 0 0 1-.166 1.731l-3.957 3.015a1.265 1.265 0 0 1-1.719-.289 1.22 1.22 0 0 1 .168-1.756l3.918-2.869Zm-42.162 34.795a1.192 1.192 0 0 1-1.731-.166 1.239 1.239 0 0 1 .165-1.731l3.957-3.015a1.234 1.234 0 0 1 .913-.282 1.254 1.254 0 0 1 .843.45 1.22 1.22 0 0 1-.168 1.756l-3.979 2.988Zm9.947-7.458a1.267 1.267 0 0 1-1.756-.168 1.194 1.194 0 0 1 .166-1.731l3.933-3.018a1.266 1.266 0 0 1 1.755.168 1.159 1.159 0 0 1 .304.903 1.167 1.167 0 0 1-.469.829l-3.933 3.017Zm9.923-7.46a1.266 1.266 0 0 1-1.756-.168 1.217 1.217 0 0 1 .168-1.756l3.958-3.015a1.246 1.246 0 0 1 1.731.165 1.22 1.22 0 0 1-.168 1.756l-3.933 3.018ZM559.897 323.417a1.215 1.215 0 0 1-1.551-.747 1.318 1.318 0 0 1 .723-1.553l4.762-1.516a1.295 1.295 0 0 1 1.541.847 1.225 1.225 0 0 1-.084.945 1.222 1.222 0 0 1-.738.598l-4.653 1.426Zm11.824-3.859a1.22 1.22 0 0 1-1.551-.747 1.292 1.292 0 0 1 .755-1.625l4.762-1.516a1.27 1.27 0 0 1 1.606 1.31 1.21 1.21 0 0 1-.887 1.08l-4.685 1.498ZM591.465 588.277a1.208 1.208 0 0 1-.934.229 1.216 1.216 0 0 1-.809-.521 1.193 1.193 0 0 1-.206-.447 1.235 1.235 0 0 1-.012-.492 1.214 1.214 0 0 1 .534-.802l3.105-2.199a1.217 1.217 0 0 1 1.756.168 1.293 1.293 0 0 1-.168 1.756l-3.266 2.308Zm9.168-6.609a1.266 1.266 0 0 1-1.756-.168 1.37 1.37 0 0 1 .317-1.742l4.066-2.855a1.253 1.253 0 0 1 1.39-.045c.139.088.26.202.354.337a1.208 1.208 0 0 1 .218.939 1.214 1.214 0 0 1-.534.802l-4.055 2.732Zm20.293-14.379a1.224 1.224 0 0 1-.939.217 1.202 1.202 0 0 1-.456-.184 1.199 1.199 0 0 1-.346-.349 1.264 1.264 0 0 1 .165-1.731l4.067-2.855a1.213 1.213 0 0 1 1.744.291 1.295 1.295 0 0 1-.292 1.744l-3.943 2.867ZM699.933 348.626a1.213 1.213 0 0 1 1.139-.768c.162.001.323.034.473.098a1.29 1.29 0 0 1 .667 1.636l-1.934 4.557a1.191 1.191 0 0 1-1.634.642 1.19 1.19 0 0 1-.754-1.14 1.19 1.19 0 0 1 .11-.469l1.933-4.556Zm-33.161 85.718a1.255 1.255 0 0 1-.679.675 1.232 1.232 0 0 1-.958-.008 1.194 1.194 0 0 1-.642-1.633l1.86-4.564a1.26 1.26 0 0 1 1.199-.751c.167.005.332.044.484.113a1.242 1.242 0 0 1 .644 1.609l-1.908 4.559Zm6.006-17.643c4.465 1.85-4.532-1.931-.05-.004l.05.004Zm3.574-5.273a1.264 1.264 0 0 1-1.641.717 1.27 1.27 0 0 1-.637-1.683l1.909-4.559a1.22 1.22 0 0 1 1.636-.667c.297.137.53.383.65.687a1.27 1.27 0 0 1-.008.947l-1.909 4.558Zm9.675-22.856a1.297 1.297 0 0 1-2.402-.979l1.909-4.559a1.26 1.26 0 0 1 1.152-.825c.168-.005.335.024.491.084a1.242 1.242 0 0 1 .642 1.634l-1.792 4.645Zm4.816-11.468a1.242 1.242 0 0 1-1.633.642 1.204 1.204 0 0 1-.669-.666 1.188 1.188 0 0 1 .024-.943l1.859-4.564a1.242 1.242 0 0 1 1.612-.669c.157.058.301.147.423.262a1.257 1.257 0 0 1 .402.89c.005.168-.024.335-.084.491l-1.934 4.557ZM708.789 356.462a1.207 1.207 0 0 1 .674-.686 1.211 1.211 0 0 1 .962.019 1.201 1.201 0 0 1 .754 1.14 1.21 1.21 0 0 1-.11.469l-1.936 4.581a1.201 1.201 0 0 1-1.14.754 1.273 1.273 0 0 1-1.125-.782 1.27 1.27 0 0 1-.013-.939l1.934-4.556Zm-28.371 74.248a1.245 1.245 0 0 1-1.636.667 1.215 1.215 0 0 1-.642-1.634l1.909-4.559a1.265 1.265 0 0 1 1.641-.716 1.292 1.292 0 0 1 .644 1.609l-1.916 4.633Zm4.817-11.468a1.267 1.267 0 0 1-1.636.667 1.264 1.264 0 0 1-.717-1.641l1.934-4.556a1.206 1.206 0 0 1 .669-.659 1.208 1.208 0 0 1 .94.014 1.219 1.219 0 0 1 .669 1.612l-1.859 4.563Zm9.682-22.931a1.255 1.255 0 0 1-.679.675 1.25 1.25 0 0 1-.957-.008 1.193 1.193 0 0 1-.645-1.609l1.859-4.564a1.219 1.219 0 0 1 1.612-.669 1.247 1.247 0 0 1 .743 1.619l-1.933 4.556Zm9.674-22.857a1.27 1.27 0 0 1-1.636.667 1.215 1.215 0 0 1-.658-.67 1.22 1.22 0 0 1 .014-.939l1.94-4.631a1.242 1.242 0 0 1 1.612-.669 1.316 1.316 0 0 1 .667 1.636l-1.939 4.606ZM664.923 169.984a1.21 1.21 0 0 1 .074-.962 1.222 1.222 0 0 1 .75-.606 1.243 1.243 0 0 1 1.548.772l1.444 4.73a1.21 1.21 0 0 1-.35 1.335 1.218 1.218 0 0 1-.424.238 1.265 1.265 0 0 1-1.598-.777l-1.444-4.73Zm33.572 98.745a1.228 1.228 0 0 1-.084.946 1.229 1.229 0 0 1-.738.598 1.208 1.208 0 0 1-.962-.074 1.207 1.207 0 0 1-.606-.75l-1.449-4.681a1.318 1.318 0 0 1 .78-1.622 1.343 1.343 0 0 1 1.617.828l1.442 4.755Zm-3.67-11.981a1.32 1.32 0 0 1-.829 1.618 1.205 1.205 0 0 1-.945-.084 1.208 1.208 0 0 1-.598-.737l-1.518-4.738a1.226 1.226 0 0 1 .073-.962 1.235 1.235 0 0 1 .751-.606 1.226 1.226 0 0 1 .951.094 1.217 1.217 0 0 1 .59.752l1.525 4.663Zm-7.491-23.676a1.201 1.201 0 0 1-.054.94 1.198 1.198 0 0 1-.718.608 1.264 1.264 0 0 1-1.6-.752l-1.442-4.755a1.184 1.184 0 0 1 .074-.951 1.198 1.198 0 0 1 .748-.592 1.24 1.24 0 0 1 1.55.747l1.442 4.755Zm-3.686-11.808a1.269 1.269 0 0 1-.822 1.544 1.243 1.243 0 0 1-1.543-.822l-1.516-4.762a1.265 1.265 0 0 1 .821-1.543 1.188 1.188 0 0 1 1.326.386c.102.128.176.276.218.435l1.516 4.762Zm-7.415-23.694a1.342 1.342 0 0 1-.829 1.618 1.244 1.244 0 0 1-1.543-.822l-1.516-4.762a1.225 1.225 0 0 1 .084-.946 1.222 1.222 0 0 1 .738-.598 1.225 1.225 0 0 1 .945.084 1.225 1.225 0 0 1 .598.738l1.523 4.688Z",
      fill: "#141414"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "m616.962 536.165-35.514 26.348",
      stroke: "#FF5E18",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M786.033 640.245c6.214.595 11.734-3.961 12.329-10.175.595-6.214-3.96-11.734-10.175-12.329-6.214-.595-11.734 3.961-12.329 10.175-.594 6.214 3.961 11.734 10.175 12.329Z",
      fill: "#FF5E18"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M172.451 25.186a64.815 64.815 0 0 1 67.776 61.566 64.837 64.837 0 0 1-61.665 67.767 64.592 64.592 0 0 1-61.627-37.098 64.572 64.572 0 0 1-6.043-24.533 64.575 64.575 0 0 1 16.723-46.632 64.587 64.587 0 0 1 44.836-21.07Z",
      fill: "url(#discover-erg-hero-light_svg__y)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M824.433 507.961a9.39 9.39 0 1 0 1.79-18.694 9.39 9.39 0 0 0-1.79 18.694Z",
      fill: "#141414"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M704.435 594.574c-64.581-30.564-139.331-73.507-216.208-125.513-97.117-65.822-179.562-133.958-235.053-191.428",
      stroke: "#fff",
      strokeWidth: 3,
      strokeMiterlimit: 10
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M654.004 591.966c-57.212-30.882-118.773-68.22-181.557-110.765-95.979-64.94-179.764-131.857-242.666-191.683",
      stroke: "#141414",
      strokeWidth: 3,
      strokeMiterlimit: 10
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("defs", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "discover-erg-hero-light_svg__a",
        x1: 216.205,
        y1: 465.432,
        x2: 300.664,
        y2: 300.073,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#F6F6F6"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "discover-erg-hero-light_svg__b",
        x1: 415.914,
        y1: 138.91,
        x2: 571.38,
        y2: 105.128,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#F6F6F6"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "discover-erg-hero-light_svg__c",
        x1: 255,
        y1: 535.498,
        x2: 396,
        y2: 588.998,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#F6F6F6"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "discover-erg-hero-light_svg__d",
        x1: 450.498,
        y1: 447.002,
        x2: 605.998,
        y2: 385.502,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#F6F6F6"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "discover-erg-hero-light_svg__e",
        x1: 343.998,
        y1: 467.502,
        x2: 437.998,
        y2: 473.002,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#F6F6F6"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "discover-erg-hero-light_svg__f",
        x1: 430,
        y1: 299.5,
        x2: 547,
        y2: 209.5,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#F6F6F6"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "discover-erg-hero-light_svg__g",
        x1: 498.998,
        y1: 308.5,
        x2: 572.998,
        y2: 357,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#F6F6F6"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "discover-erg-hero-light_svg__h",
        x1: 523.998,
        y1: 416.999,
        x2: 612.498,
        y2: 426.999,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#F6F6F6"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "discover-erg-hero-light_svg__i",
        x1: 378.724,
        y1: 579.566,
        x2: 490.23,
        y2: 613.948,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#F6F6F6"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "discover-erg-hero-light_svg__j",
        x1: 439.002,
        y1: 498.501,
        x2: 573.002,
        y2: 464.501,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#F6F6F6"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "discover-erg-hero-light_svg__k",
        x1: 603.537,
        y1: 460.085,
        x2: 754.45,
        y2: 343.513,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#F6F6F6"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "discover-erg-hero-light_svg__l",
        x1: 481.998,
        y1: 326.5,
        x2: 558.998,
        y2: 268,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#F6F6F6"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "discover-erg-hero-light_svg__m",
        x1: 602.998,
        y1: 256.499,
        x2: 626.998,
        y2: 176.999,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#F6F6F6"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "discover-erg-hero-light_svg__n",
        x1: 519.013,
        y1: 639.163,
        x2: 639.067,
        y2: 532.115,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#F6F6F6"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "discover-erg-hero-light_svg__o",
        x1: 433.5,
        y1: 460,
        x2: 483.5,
        y2: 300.5,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#F6F6F6"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "discover-erg-hero-light_svg__p",
        x1: 564,
        y1: 234.501,
        x2: 642.5,
        y2: 289.001,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#F6F6F6"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "discover-erg-hero-light_svg__q",
        x1: 717.679,
        y1: 154.069,
        x2: 734.032,
        y2: 309.114,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#E7703D"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#F6F6F6"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "discover-erg-hero-light_svg__r",
        x1: 777.077,
        y1: 433.027,
        x2: 680.356,
        y2: 387.581,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#F6F6F6"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#FF5E18"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "discover-erg-hero-light_svg__s",
        x1: 583.218,
        y1: 571.987,
        x2: 596.122,
        y2: 693.963,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#141414"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "discover-erg-hero-light_svg__t",
        x1: 858.264,
        y1: 125.453,
        x2: 785.297,
        y2: 360.192,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#F6F6F6"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#FF5E18"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "discover-erg-hero-light_svg__u",
        x1: 661.554,
        y1: 636.786,
        x2: 654.04,
        y2: 715.277,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#F6F6F6"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "discover-erg-hero-light_svg__v",
        x1: 514.763,
        y1: 774.769,
        x2: 653.746,
        y2: 730.675,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#F6F6F6"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "discover-erg-hero-light_svg__w",
        x1: 539.928,
        y1: 733.506,
        x2: 587.795,
        y2: 741.832,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#141414"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#F6F6F6"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "discover-erg-hero-light_svg__x",
        x1: 587.91,
        y1: 659.884,
        x2: 565.894,
        y2: 735.988,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#F6F6F6"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("radialGradient", {
        id: "discover-erg-hero-light_svg__y",
        cx: 0,
        cy: 0,
        r: 1,
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "matrix(24.33296 50.8246 -50.8245 24.33292 175.543 89.863)",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 0.464,
          stopColor: "#FF5E18",
          stopOpacity: 0.875
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#FF5E18",
          stopOpacity: 0
        })]
      })]
    })]
  }));
};

/* harmony default export */ var DiscoverErgHeroLight = (SvgDiscoverErgHeroLight);
;// CONCATENATED MODULE: ./components/icons/DiscoverErgHero.js


function DiscoverErgHero_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function DiscoverErgHero_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? DiscoverErgHero_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : DiscoverErgHero_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgDiscoverErgHero = function SvgDiscoverErgHero(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", DiscoverErgHero_objectSpread(DiscoverErgHero_objectSpread({
    width: 1011,
    height: 811,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M957.875 675.025c34.551-51.035-126.718-220.55-360.205-378.621C364.184 138.333 146.897 51.563 112.346 102.598c-34.551 51.035 126.718 220.549 360.204 378.62C706.037 639.29 923.324 726.06 957.875 675.025Z",
      stroke: "#FF5E18",
      strokeWidth: 3,
      strokeMiterlimit: 10
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M901.152 633.866c29.39-43.411-107.806-187.615-306.436-322.089-198.63-134.473-383.477-208.293-412.866-164.882-29.39 43.412 107.806 187.616 306.436 322.09 198.63 134.473 383.476 208.293 412.866 164.881Z",
      stroke: "#fff",
      strokeWidth: 3,
      strokeMiterlimit: 10
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M643.605 659.401 516.498 764.526 646.3 736.573l37.008-18.493-39.703-58.679Z",
      fill: "#fff"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m321.59 281.487-137.428 46.09 11.068 183.138 136.275-35.619-9.915-193.609Z",
      fill: "#FF5E18"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M337.262 480.813 195.22 510.714c39.352-124.307 75.326-187.271 126.358-229.204l15.684 199.303Z",
      fill: "url(#discover-erg-hero_svg__a)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m404.879 172.318 90.59 61.529 114.407-85.079-88.924-64.34-116.073 87.89Z",
      fill: "url(#discover-erg-hero_svg__b)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m305.448 602.773 95.957 58.125-26.541-118.487-93.467-59.109 24.051 119.471Z",
      fill: "url(#discover-erg-hero_svg__c)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m525.827 334.329 92.236 62.834-54.995 74.744-93.753-61.083 56.512-76.495Z",
      fill: "url(#discover-erg-hero_svg__d)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m357.865 515.353 95.957 58.124-26.615-118.493-93.42-59.079 24.078 119.448Z",
      fill: "url(#discover-erg-hero_svg__e)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m402.267 246.336 90.38 61.634-.007.074-90.447-61.715.074.007Z",
      fill: "#FF5E18"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m398.183 255.08 90.59 61.529 114.454-85.049-88.896-64.362-116.148 87.882Z",
      fill: "url(#discover-erg-hero_svg__f)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m487.022 293.208 91.383 62.628 39.666 41.331-92.236-62.835-38.813-41.124Z",
      fill: "url(#discover-erg-hero_svg__g)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m547.019 387.793 93.217 62.504-4.434 42.15-94.095-61.939 5.312-42.715Z",
      fill: "url(#discover-erg-hero_svg__h)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m330.271 554.462 96.795 57.182.494.321.592.332.581.18.656.188-96.766-57.229-.654-.213-.581-.18-.525-.25-.592-.331Z",
      fill: "#FF5E18"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m332.623 555.438 96.766 57.229 119.707 32.397-97.41-58.588-119.063-31.038Z",
      fill: "url(#discover-erg-hero_svg__i)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m541.707 430.509 94.094 61.939-128.578 34.983-95.001-59.506 129.485-37.416Z",
      fill: "url(#discover-erg-hero_svg__j)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M618.79 466.336 713.414 529l70.491-170.914-91.111-65.996-74.004 174.246Z",
      fill: "url(#discover-erg-hero_svg__k)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m521.832 161.55 88.785 64.476-.081.067-88.754-64.548.05.005Z",
      fill: "#FF5E18"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m561.675 269.383 90.897 64.054-74.167 22.398-91.383-62.628 74.653-23.824Z",
      fill: "url(#discover-erg-hero_svg__l)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m514.33 167.198 88.897 64.361L710.51 246.97l-89.134-66.056-107.046-13.716Z",
      fill: "url(#discover-erg-hero_svg__m)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m463.992 583.262 97.243 58.772 142.198-100.362-94.855-62.336-144.586 103.926Z",
      fill: "url(#discover-erg-hero_svg__n)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m333.787 395.907 93.42 59.079 61.561-138.377-90.59-61.529-64.391 140.827Z",
      fill: "url(#discover-erg-hero_svg__o)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m566.599 229.125 90.12 64.603-4.15 39.707-90.897-64.054 4.927-40.256Z",
      fill: "url(#discover-erg-hero_svg__p)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m694.189 277.998 90.766 66.213-43.128-129.009-88.407-66.86 40.769 129.656Z",
      fill: "url(#discover-erg-hero_svg__q)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "m419.896 287.105-17.454-11.629-53.927 118.844 67.946 44.937",
      stroke: "#FF5E18",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m692.79 292.091 91.111 65.996.362-.914.288-.92.287-.921.239-.926.213-.928.16-.883.164-.932.083-.866.083-.865.011-.898-.048-.803-.063-.904-.123-.811-.126-.761-.201-.767-.276-.775L694.189 278l.201.768.201.768.122.81.07.83.041.878.07.83-.082.866-.034.87-.142.96-.087.915-.238.925-.216.953-.286.896-.315.943-.288.921-.416.958Z",
      fill: "#fff",
      stroke: "#fff",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "m380.41 415.193 40.355-90.994 6.942 5.955-39.926 90.162M626.636 198.211l-85.559-11.635-49.551 34.812 9.776 6.851 26.067-18.119",
      stroke: "#FF5E18",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m642.848 447.305 94.624 62.663 70.486-170.864-90.999-66.11c-24.695 58.096-49.398 116.2-74.111 174.311Z",
      fill: "url(#discover-erg-hero_svg__r)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m726.234 133.826 21.972 16.053-10.48-31.299-21.434-16.202 9.942 31.448ZM674.046 481.385l20.131 13.381 15.012-36.371-19.388-14.109-15.755 37.099Z",
      fill: "#fff"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m679.98 526.274-42.19-27.747-36.573 26.721 31.58 21.79 11.056-7.826 20.177.908 15.95-13.846Z",
      fill: "#FF5E18"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "m535.658 309.642-13.745-9.976 57.34-17.894 18.092 12.787M604.574 299.642l17.278 12.16M607.506 225.179l-30.236-23.832 52.755 8.095M509.381 516.107l-63.096-40.854 84.281-24.549",
      stroke: "#FF5E18",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m608.583 479.335 94.854 62.336.799-.522.759-.626.788-.673.687-.658.746-.753.696-.756.669-.735.63-.838.602-.816.627-.813.559-.895.553-.821.486-.901.517-.974.412-.909.443-.981-49.635-32.877-44.989-29.787-.443.981-.493.976-.51.9-.493.976-.56.894-.56.895-.609.89-.701.807-.627.813-.672.759-.75.802-.696.757-.739.678-.811.646-.734.628-.805.597Z",
      fill: "#fff",
      stroke: "#fff",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "m434.258 192.324-29.379-20.007 65.81-49.801",
      stroke: "#fff",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "m295.431 552.626-14.052-69.325",
      stroke: "#fff",
      strokeWidth: 3,
      strokeMiterlimit: 10
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "m547.015 387.792 46.599 31.214",
      stroke: "#fff",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "m550.055 299.99 38.27-11.859M449.13 410.813l-35.617-23.673 21.972-50.429",
      stroke: "#FF5E18",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m653.422 148.344 88.408 66.861-.215-.62-.337-.656-.289-.627-.344-.582-.375-.51-.425-.515-.432-.44-.479-.47-.514-.374-88.326-66.927.514.373.432.441.429.465.425.515.351.508.343.582.29.627.264.624.28.725Z",
      fill: "#fff",
      stroke: "#fff",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m590.21 696.241-12.816 14.221-13.557-131.069c-1.13-10.091 12.788-11.578 14.074-2.596l12.299 119.444Z",
      fill: "url(#discover-erg-hero_svg__s)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m686.424 205.034 50.413 36.745-23.965-71.622-49.099-37.168 22.651 72.045Z",
      fill: "#fff"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "m347.04 414.719 23.453 118.939",
      stroke: "#FF5E18",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m451.681 586.475 97.41 58.588.314.105.346.034.315.104.42.041.321.03.421.041.321.031.354-.042.402-.036.347.033.4-.011.336-.118.427-.034.401-.011.335-.118.432-.083-97.378-58.66-.36.115-.4.011-.361.116-.407.085-.354.042-.402.036-.351.016-.403.036-.322-.03-.42-.041-.329.044-.42-.04-.314-.105-.347-.033-.321-.031-.413-.115ZM457.608 586.368l97.378 58.66.336-.117.432-.084.341-.167.434-.108.415-.16.34-.167.44-.158.34-.167.44-.157.347-.242.422-.234.372-.239.422-.234.372-.239.419-.209.38-.313-97.243-58.772-.426.284-.373.239-.421.234-.38.313-.421.234-.365.165-.422.234-.42.209-.367.19-.415.16-.365.164-.414.16-.415.16-.36.116-.415.159-.408.086Z",
      fill: "#fff",
      stroke: "#fff",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m736.963 482.391 8.611 5.716 6.433-15.581-8.284-6.009-6.76 15.874ZM898.238 129.28l-196.842 68.703 30.635 191.724L927.615 340.4l-29.377-211.12Z",
      fill: "#FF5E18"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m937.551 351.584-205.519 38.124c47.837-141.514 94.897-207.659 166.207-260.428l39.312 222.304Z",
      fill: "url(#discover-erg-hero_svg__t)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "m412.222 467.926 82.031 51.351",
      stroke: "#FF5E18",
      strokeWidth: 3,
      strokeMiterlimit: 10
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "m381.165 534.729-17.341-90.753 21.452 12.884 17.87 87.31",
      stroke: "#FF5E18",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "m525.829 334.329 66.797 45.475",
      stroke: "#fff",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m469.317 410.852 77.699-23.058-5.312 42.715-129.495 37.516 5.626-38.168 58.794-79.746-40.511-43.983 5.271-36.031 125.223-40.869-4.951 40.254-74.653 23.824 38.835 41.152-56.526 76.394Zm44.32-278.933-129.574 98.576-.653.561-.725.53-.682.608-.59.692-.682.609-.615.69-.591.692-.622.764-.545.746-.623.764-.471.754-.555.845-.472.753-.431.858-.429.832-.404.835-72.445 157.175-.439.932-.355.839-.362.914-.28.846-.207.854-.238.926-.209.878-.076.791-.085.891-.149 1.558-.071.741-.078.816.052.754.078.756.126.761 25.828 135.064.201.768.208.693.205.719.258.698.297.553.336.656.351.508.425.514.424.515.432.441.511.398.514.374.567.329.525.25.604.207.656.188 119.061 31.063.396.038.668.063.346.034.396.037.346.034.742.071.395.037.322.031.42.04.322.031.432-.083.321.031.421.04.336-.118.407-.085.439-.158.336-.118.439-.157.415-.16.34-.167.44-.158.34-.167.447-.232.421-.234.341-.167.446-.232.355-.315.444-.207.347-.241.429-.309 144.71-103.914.806-.597.732-.604.813-.671.738-.678.672-.759.75-.801.697-.757.602-.816.701-.806.634-.888.56-.895.56-.895.492-.976.486-.901.518-.974.416-.959 74.078-174.238.443-.981.288-.921.288-.921.288-.921.238-.925.214-.928.09-.94.09-.939.085-.891.083-.865-.048-.803-.063-.905.075-.791-.119-.835-.201-.768-.201-.768-40.794-129.658-.258-.699-.287-.651-.265-.625-.368-.584-.351-.508-.425-.514-.432-.441-.429-.465-.513-.374-.568-.329-.518-.324-.66-.662-.6-.257-.667-.064-.656-.188-.668-.064-120.764-14.056-.346-.033-.322-.031-.667-.064-.272-.026-.347-.033-.574.27-.347-.033-.321-.031-.346-.033-.334.092-.36.116-.322-.031-.36.115-.358.091a23.082 23.082 0 0 0-6.266 3.667Zm.689 35.304 107.048 13.692 34.874 115.64-65.543 153.12-126.972 91.712-105.847-25.98-24.075-119.473 64.367-140.829 116.148-87.882Z",
      fill: "#25211A",
      stroke: "#FF5E18",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m656.925 707.169-28.561-32.207 8.275-40.56 25.423 15.461 21.245 68.217-26.382-10.911Z",
      fill: "url(#discover-erg-hero_svg__u)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "m701.396 197.983 30.635 191.725 119.057-22.069",
      stroke: "#fff",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M630.739 727.772 516.49 764.526l.901-18.531 94.712-98.07 24.529-13.523 20.286 72.767-26.179 20.603Z",
      fill: "url(#discover-erg-hero_svg__v)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M542.908 710.48a69.812 69.812 0 0 0-9.754 30.985c.039.855.167 1.704.381 2.532 1.229 4.111 3.682 3.248 6.562 2.101l83.652-34.143-78.473 21.761c-.812-7.689-1.569-15.423-2.368-23.236Z",
      fill: "url(#discover-erg-hero_svg__w)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M543.097 733.208c-3.183-2.201-2.538-11.024-.071-22.716l69.751-48.226 10.952 49.837-75.404 20.982c-1.727.309-3.636 1.224-5.228.123Z",
      fill: "url(#discover-erg-hero_svg__x)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m655.035 700.351-31.26 11.631-12.42 5.125-9.169.895c28.4-25.557 33.859-30.175 84.83-50.102l-31.981 32.451Z",
      fill: "#fff"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "m340.432 557.458 85.678 22.376",
      stroke: "#fff",
      strokeWidth: 3,
      strokeMiterlimit: 10
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m371.126 401.575-14.831-9.83 11.554-24.498 13.892 9.74-10.615 24.588ZM502.55 198.188l-6.918-5.679-79.316 59.239 7.645 5.125 78.589-58.685Z",
      fill: "#FF5E18"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "m487.816 405.359 40.953-54.227 11.721 7.91M514.486 504.668l-40.918-25.654 70.152-20.86M410.776 528.355l-11.475-54.279 14.793 8.928 10.579 48.778M435.242 490.718l8.551 38.153M593.503 238.215l8.262-6.796 36.421 5.109",
      stroke: "#FF5E18",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "m541.074 186.576 62.152 44.981",
      stroke: "#FF5E18",
      strokeWidth: 3,
      strokeMiterlimit: 10
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "m566.598 229.125 58.779 42.162",
      stroke: "#fff",
      strokeWidth: 3,
      strokeMiterlimit: 10
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "m614.705 393.448-36.304-37.616 44.379-13.37M497.788 583.452l111.874-80.78 67.971 46.761",
      stroke: "#FF5E18",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "m453.629 324.973 23.008 25.037-58.793 79.746",
      stroke: "#fff",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "m438.232 291.855 3.165-21.858 97.867-31.958",
      stroke: "#fff",
      strokeWidth: 3,
      strokeMiterlimit: 10
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M374.453 459.643a1.34 1.34 0 0 1 1.04-1.472 1.239 1.239 0 0 1 1.45 1.012l.886 4.826a1.187 1.187 0 0 1-.145.948 1.185 1.185 0 0 1-.796.534 1.233 1.233 0 0 1-.941-.173 1.249 1.249 0 0 1-.538-.792l-.956-4.883Zm12.679 53.172a1.253 1.253 0 0 1-.174.942 1.228 1.228 0 0 1-.791.538 1.266 1.266 0 0 1-1.455-.963l-.953-4.907a1.293 1.293 0 0 1 1.012-1.451 1.268 1.268 0 0 1 1.476 1.015l.885 4.826Zm-2.306-12.149a1.29 1.29 0 0 1-1.014 1.475 1.242 1.242 0 0 1-1.399-1.033l-.955-4.883a1.292 1.292 0 0 1 .965-1.479 1.29 1.29 0 0 1 1.451 1.012l.952 4.908Zm-2.35-12.204c.039.157.045.321.018.481-.027.16-.086.313-.173.45a1.204 1.204 0 0 1-.783.526 1.268 1.268 0 0 1-1.476-1.014l-.959-4.834a1.345 1.345 0 0 1 1.014-1.475 1.213 1.213 0 0 1 .948.164 1.22 1.22 0 0 1 .532.801l.879 4.901ZM404.153 284.724a1.212 1.212 0 0 1 1.14-.745 1.2 1.2 0 0 1 .469.101 1.293 1.293 0 0 1 .662 1.685l-1.983 4.552a1.21 1.21 0 0 1-1.164.709 1.203 1.203 0 0 1-.465-.116 1.191 1.191 0 0 1-.642-1.634l1.983-4.552Zm-29.527 73.814a1.235 1.235 0 0 1-.679.675 1.249 1.249 0 0 1-1.354-.277 1.216 1.216 0 0 1-.248-1.34l1.986-4.577a1.201 1.201 0 0 1 1.14-.754c.162.004.322.042.469.11a1.227 1.227 0 0 1 .768 1.138 1.218 1.218 0 0 1-.099.473l-1.983 4.552Zm14.922-34.134a1.238 1.238 0 0 1-1.634.642 1.159 1.159 0 0 1-.679-.661 1.165 1.165 0 0 1 .035-.948l1.983-4.552a1.243 1.243 0 0 1 1.611-.669 1.239 1.239 0 0 1 .667 1.636l-1.983 4.552Zm9.96-22.705a1.246 1.246 0 0 1-2.274-1.016l1.983-4.552a1.22 1.22 0 0 1 1.636-.667 1.276 1.276 0 0 1 .67.709 1.26 1.26 0 0 1-.032.974l-1.983 4.552Z",
      fill: "#fff"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "m193.987 490.333-9.825-162.755 94.652-31.742",
      stroke: "#fff",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M595.204 529.413a1.241 1.241 0 0 1 1.717.314 1.192 1.192 0 0 1-.166 1.731l-3.999 2.937a1.318 1.318 0 0 1-1.756-.168 1.217 1.217 0 0 1 .316-1.742l3.888-3.072Zm-82.979 63.356a1.291 1.291 0 0 1-1.742-.316 1.241 1.241 0 0 1 .314-1.717l4-2.936a1.268 1.268 0 0 1 1.744.291 1.266 1.266 0 0 1-.168 1.756l-4.148 2.922Zm20.092-14.622a1.223 1.223 0 0 1-1.72-.29 1.318 1.318 0 0 1 .292-1.744l4.017-2.859a1.241 1.241 0 0 1 1.731.165 1.268 1.268 0 0 1-.168 1.756l-4.152 2.972Zm10.057-7.298a1.206 1.206 0 0 1-.927.217 1.191 1.191 0 0 1-.79-.531 1.207 1.207 0 0 1-.218-.921 1.218 1.218 0 0 1 .507-.798l3.995-2.887a1.267 1.267 0 0 1 1.756.168 1.214 1.214 0 0 1 .033 1.395 1.214 1.214 0 0 1-.35.346l-4.006 3.011Zm20.116-14.62a1.266 1.266 0 0 1-1.756-.168 1.29 1.29 0 0 1 .169-1.756l4.024-2.934a1.244 1.244 0 0 1 1.731.166 1.196 1.196 0 0 1 .052 1.374 1.18 1.18 0 0 1-.341.345l-3.879 2.973Zm20.09-14.598a1.267 1.267 0 0 1-1.756-.168 1.217 1.217 0 0 1 .316-1.742l4-2.936a1.214 1.214 0 0 1 1.395-.033c.138.092.256.211.347.35a1.197 1.197 0 0 1 .033 1.377c-.091.136-.21.251-.348.339l-3.987 2.813ZM601.014 591.711a1.341 1.341 0 0 1-1.717-.314 1.183 1.183 0 0 1-.239-.421 1.197 1.197 0 0 1 .405-1.31l3.13-2.196a1.319 1.319 0 0 1 1.744.292 1.206 1.206 0 0 1 .217.939 1.214 1.214 0 0 1-.534.802l-3.006 2.208Zm19.359-13.744a1.269 1.269 0 0 1-1.756-.168 1.288 1.288 0 0 1 .168-1.756l4.066-2.855a1.232 1.232 0 0 1 .933-.219 1.228 1.228 0 0 1 .811.511 1.312 1.312 0 0 1-.291 1.744l-3.931 2.743Zm20.3-14.453a1.188 1.188 0 0 1-1.377.033 1.184 1.184 0 0 1-.34-.347 1.193 1.193 0 0 1 .289-1.719l4.069-2.88a1.12 1.12 0 0 1 1.668.309 1.266 1.266 0 0 1-.168 1.756l-4.141 2.848Z",
      fill: "#fff"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "m333.787 395.906 64.391-140.827 116.148-87.881M656.226 296.528l-65.541 153.095-126.948 91.739-105.87-26.007",
      stroke: "#fff",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "m581.174 456.448-39.467-25.939-129.485 37.416",
      stroke: "#fff",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m593.473 675.492 19.321-13.349 28.129-12.281 15.914-23.906 8.214-12.291c-5.602 2.733-10.663 5.293-15.248 7.824-32.399 17.787-39.779 32.054-56.33 54.003Z",
      fill: "url(#discover-erg-hero_svg__y)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "m516.498 764.526 114.248-36.754 26.18-20.604",
      stroke: "#FF5E18",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "m551.524 732.043 50.61-14.071",
      stroke: "#322C24",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "m541.128 728.802 1.903-18.311 69.739-48.352 5.474 24.932",
      stroke: "#fff",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "m516.49 764.528.901-18.531 17.457-18.119 8.029-17.399",
      stroke: "#fff",
      strokeWidth: 3,
      strokeMiterlimit: 10
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "m547.944 721.469 43.707-19.125 9.785 8.848M628.201 721.689l-26.62 9.031-3.807-2.461-39.671 14.246",
      stroke: "#FF5E18",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M593.474 675.49c25.168-33.502 34.021-42.562 71.582-61.876",
      stroke: "#fff",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "m640.927 649.786-28.16 12.352",
      stroke: "#FF5E18",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M537.854 440.448a1.242 1.242 0 0 1 1.463.889 1.24 1.24 0 0 1-.822 1.543l-4.792 1.313a1.316 1.316 0 0 1-1.566-.849 1.296 1.296 0 0 1 .895-1.536l4.822-1.36Zm-87.856 27.227a1.251 1.251 0 0 1-.957-.124 1.239 1.239 0 0 1-.579-.772 1.197 1.197 0 0 1 .135-.919 1.188 1.188 0 0 1 .754-.543l4.797-1.363a1.148 1.148 0 0 1 .925.106 1.143 1.143 0 0 1 .539.758 1.166 1.166 0 0 1-.816 1.494l-4.798 1.363Zm23.952-6.716a1.225 1.225 0 0 1-.946-.084 1.222 1.222 0 0 1-.597-.738 1.207 1.207 0 0 1 .084-.946 1.208 1.208 0 0 1 .737-.598l4.8-1.387a1.29 1.29 0 0 1 1.536.896 1.269 1.269 0 0 1-.871 1.539l-4.743 1.318Zm23.871-6.65a1.395 1.395 0 0 1-1.537-.895 1.271 1.271 0 0 1 .896-1.537l4.743-1.318a1.228 1.228 0 0 1 .946.084c.144.077.271.182.374.308.102.127.178.273.224.43a1.243 1.243 0 0 1-.822 1.543l-4.824 1.385Zm23.904-6.745a1.194 1.194 0 0 1-1.489-.867 1.293 1.293 0 0 1 .824-1.568l4.815-1.286a1.269 1.269 0 0 1 1.543.822 1.231 1.231 0 0 1-.124.957 1.231 1.231 0 0 1-.771.579l-4.798 1.363ZM564.062 460.299a1.265 1.265 0 0 1 1.569.824 1.231 1.231 0 0 1-.125.957 1.222 1.222 0 0 1-.327.367c-.132.1-.283.172-.444.212l-4.75 1.392a1.295 1.295 0 0 1-1.537-.896 1.245 1.245 0 0 1 .452-1.324c.132-.1.283-.172.444-.212l4.718-1.32Zm-63.879 20.513a1.341 1.341 0 0 1-1.537-.896 1.342 1.342 0 0 1 .871-1.539l4.818-1.311c.151-.045.31-.059.467-.04a1.156 1.156 0 0 1 .798.456c.095.126.164.27.202.424a1.24 1.24 0 0 1-.822 1.543l-4.797 1.363Zm47.829-13.44a1.265 1.265 0 0 1-1.543-.822 1.25 1.25 0 0 1 .124-.957 1.235 1.235 0 0 1 .772-.579l4.725-1.394c.161-.052.332-.07.5-.052a1.213 1.213 0 0 1 .854.491c.1.137.171.293.207.459a1.2 1.2 0 0 1-.105.924 1.188 1.188 0 0 1-.737.568l-4.797 1.362Z",
      fill: "#fff"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M697.833 317.854 642.816 447.3l35.698 23.607",
      stroke: "#fff",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M588.803 303.299a1.243 1.243 0 0 1 1.551.747 1.214 1.214 0 0 1-.357 1.313 1.208 1.208 0 0 1-.416.235l-4.744 1.593a1.27 1.27 0 0 1-1.543-.822 1.267 1.267 0 0 1 .749-1.575l4.76-1.491Zm-39.474 15.312a1.238 1.238 0 0 1-1.543-.821 1.243 1.243 0 0 1 .747-1.551l4.762-1.515a1.209 1.209 0 0 1 .935.063 1.21 1.21 0 0 1 .613.709 1.24 1.24 0 0 1-.747 1.55l-4.767 1.565Zm23.649-7.718a1.27 1.27 0 0 1-1.544-.822 1.239 1.239 0 0 1 .747-1.55l4.762-1.516a1.243 1.243 0 0 1 1.551.747 1.265 1.265 0 0 1-.75 1.576l-4.766 1.565ZM478.708 222.011a1.213 1.213 0 0 1 1.756.168 1.241 1.241 0 0 1-.166 1.731l-3.957 3.015a1.268 1.268 0 0 1-1.719-.289 1.222 1.222 0 0 1-.293-.914 1.226 1.226 0 0 1 .461-.842l3.918-2.869Zm-42.163 34.795a1.206 1.206 0 0 1-.901.292 1.192 1.192 0 0 1-.83-.458 1.242 1.242 0 0 1 .166-1.731l3.957-3.015a1.239 1.239 0 0 1 1.38-.141c.144.077.272.182.376.309a1.22 1.22 0 0 1-.168 1.756l-3.98 2.988Zm9.948-7.458a1.267 1.267 0 0 1-1.756-.168 1.194 1.194 0 0 1 .166-1.731l3.932-3.018a1.269 1.269 0 0 1 1.756.168 1.173 1.173 0 0 1 .304.903 1.174 1.174 0 0 1-.47.828l-3.932 3.018Zm9.923-7.46a1.266 1.266 0 0 1-1.756-.168 1.22 1.22 0 0 1 .168-1.756l3.957-3.015a1.241 1.241 0 0 1 1.731.165 1.222 1.222 0 0 1 .293.914 1.226 1.226 0 0 1-.461.842l-3.932 3.018ZM559.897 323.416a1.217 1.217 0 0 1-1.551-.747 1.32 1.32 0 0 1 .074-.911 1.32 1.32 0 0 1 .649-.642l4.762-1.516a1.287 1.287 0 0 1 1.541.846 1.228 1.228 0 0 1-.084.946 1.229 1.229 0 0 1-.738.598l-4.653 1.426Zm11.824-3.859a1.22 1.22 0 0 1-1.551-.748 1.293 1.293 0 0 1 .755-1.625l4.762-1.515a1.265 1.265 0 0 1 1.543.821 1.229 1.229 0 0 1-.073.962 1.227 1.227 0 0 1-.751.607l-4.685 1.498ZM591.466 588.278a1.213 1.213 0 0 1-1.744-.291 1.221 1.221 0 0 1 .316-1.742l3.106-2.198a1.211 1.211 0 0 1 .914-.293 1.227 1.227 0 0 1 .842.461 1.295 1.295 0 0 1-.168 1.756l-3.266 2.307Zm9.168-6.609a1.27 1.27 0 0 1-1.756-.168 1.363 1.363 0 0 1 .316-1.741l4.067-2.855a1.24 1.24 0 0 1 1.744.291 1.221 1.221 0 0 1-.317 1.742l-4.054 2.731Zm20.293-14.378a1.221 1.221 0 0 1-1.742-.317 1.266 1.266 0 0 1 .166-1.731l4.066-2.855a1.221 1.221 0 0 1 1.394-.052c.139.09.258.207.35.344a1.29 1.29 0 0 1-.291 1.744l-3.943 2.867ZM699.933 348.627a1.223 1.223 0 0 1 .664-.675 1.228 1.228 0 0 1 .947.005 1.294 1.294 0 0 1 .667 1.637l-1.933 4.556a1.206 1.206 0 0 1-.676.68 1.19 1.19 0 0 1-.958-.038 1.187 1.187 0 0 1-.645-1.609l1.934-4.556Zm-33.162 85.719a1.242 1.242 0 0 1-1.636.666 1.188 1.188 0 0 1-.642-1.633l1.859-4.564a1.263 1.263 0 0 1 1.2-.751c.167.006.331.044.484.114a1.243 1.243 0 0 1 .644 1.609l-1.909 4.559Zm6.007-17.643c4.464 1.849-4.532-1.932-.05-.005l.05.005Zm3.574-5.273a1.269 1.269 0 0 1-1.641.716 1.276 1.276 0 0 1-.406-.287 1.277 1.277 0 0 1-.231-1.396l1.909-4.559a1.217 1.217 0 0 1 1.636-.667 1.268 1.268 0 0 1 .642 1.634l-1.909 4.559Zm9.675-22.857a1.297 1.297 0 0 1-2.402-.979l1.909-4.559a1.26 1.26 0 0 1 1.152-.825c.168-.005.334.024.491.084a1.242 1.242 0 0 1 .642 1.634l-1.792 4.645Zm4.816-11.468a1.245 1.245 0 0 1-1.634.642 1.19 1.19 0 0 1-.754-1.14c.005-.162.042-.322.11-.469l1.859-4.564a1.242 1.242 0 0 1 1.611-.669 1.254 1.254 0 0 1 .714.667 1.273 1.273 0 0 1 .028.976l-1.934 4.557ZM708.788 356.462a1.22 1.22 0 0 1 1.636-.667 1.204 1.204 0 0 1 .669.666 1.2 1.2 0 0 1-.024.943l-1.936 4.581a1.178 1.178 0 0 1-.666.669 1.188 1.188 0 0 1-.943-.024 1.264 1.264 0 0 1-.669-1.611l1.933-4.557Zm-28.37 74.249a1.245 1.245 0 0 1-2.305-.014 1.205 1.205 0 0 1 .027-.953l1.908-4.559a1.269 1.269 0 0 1 1.641-.716 1.289 1.289 0 0 1 .645 1.608l-1.916 4.634Zm4.816-11.468a1.267 1.267 0 0 1-1.636.667 1.264 1.264 0 0 1-.716-1.641l1.933-4.557a1.23 1.23 0 0 1 .67-.659 1.22 1.22 0 0 1 .939.015 1.207 1.207 0 0 1 .675.664 1.221 1.221 0 0 1-.006.947l-1.859 4.564Zm9.682-22.931a1.245 1.245 0 0 1-1.636.666 1.187 1.187 0 0 1-.754-1.139c.004-.163.041-.322.109-.469l1.86-4.564a1.223 1.223 0 0 1 .664-.675 1.225 1.225 0 0 1 .947.006 1.233 1.233 0 0 1 .714.652c.069.151.107.314.113.48a1.26 1.26 0 0 1-.083.486l-1.934 4.557Zm9.675-22.857a1.267 1.267 0 0 1-1.636.667 1.224 1.224 0 0 1-.659-.67 1.226 1.226 0 0 1 .014-.939l1.941-4.631a1.243 1.243 0 0 1 1.611-.669 1.312 1.312 0 0 1 .667 1.636l-1.938 4.606ZM664.923 169.984a1.211 1.211 0 0 1 .074-.962 1.21 1.21 0 0 1 .75-.607 1.243 1.243 0 0 1 1.548.773l1.444 4.73a1.21 1.21 0 0 1-.35 1.335 1.269 1.269 0 0 1-2.022-.539l-1.444-4.73Zm33.571 98.745a1.22 1.22 0 0 1-.083.946 1.21 1.21 0 0 1-.738.597 1.211 1.211 0 0 1-1.343-.386 1.213 1.213 0 0 1-.225-.437l-1.449-4.681a1.321 1.321 0 0 1 .779-1.623 1.346 1.346 0 0 1 1.618.829l1.441 4.755Zm-3.669-11.981a1.315 1.315 0 0 1-.829 1.618 1.225 1.225 0 0 1-.946-.084 1.218 1.218 0 0 1-.597-.738l-1.518-4.737a1.209 1.209 0 0 1 .073-.962 1.225 1.225 0 0 1 .751-.606 1.205 1.205 0 0 1 .951.094 1.228 1.228 0 0 1 .59.752l1.525 4.663Zm-7.491-23.676a1.198 1.198 0 0 1-.054.94 1.198 1.198 0 0 1-.719.608 1.266 1.266 0 0 1-1.6-.752l-1.441-4.755a1.184 1.184 0 0 1 .074-.951 1.195 1.195 0 0 1 .748-.593 1.241 1.241 0 0 1 1.55.748l1.442 4.755Zm-3.687-11.808a1.264 1.264 0 0 1-.821 1.543 1.242 1.242 0 0 1-1.544-.821l-1.515-4.762a1.267 1.267 0 0 1 1.304-1.606 1.198 1.198 0 0 1 .843.448c.101.129.176.277.218.436l1.515 4.762Zm-7.414-23.694a1.339 1.339 0 0 1-.829 1.617 1.242 1.242 0 0 1-1.543-.821l-1.516-4.762a1.21 1.21 0 0 1 .084-.946 1.208 1.208 0 0 1 .737-.598 1.23 1.23 0 0 1 .946.084 1.212 1.212 0 0 1 .598.738l1.523 4.688Z",
      fill: "#fff"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "m616.962 536.165-35.514 26.348",
      stroke: "#FF5E18",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M786.034 640.243c6.214.595 11.734-3.96 12.329-10.175.595-6.214-3.961-11.734-10.175-12.329-6.214-.594-11.734 3.961-12.329 10.175-.595 6.214 3.96 11.734 10.175 12.329Z",
      fill: "#FF5E18"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M172.451 25.186a64.814 64.814 0 0 1 67.776 61.566 64.835 64.835 0 0 1-61.664 67.767 64.594 64.594 0 0 1-46.637-16.76 64.59 64.59 0 0 1-21.034-44.87 64.594 64.594 0 0 1 37.041-61.637 64.591 64.591 0 0 1 24.518-6.066Z",
      fill: "url(#discover-erg-hero_svg__z)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M824.433 507.959c5.162.495 9.748-3.29 10.242-8.452a9.39 9.39 0 0 0-8.453-10.243 9.39 9.39 0 0 0-10.242 8.453 9.39 9.39 0 0 0 8.453 10.242Z",
      fill: "#fff"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M704.435 594.574c-64.58-30.564-139.331-73.507-216.208-125.513-97.116-65.822-179.562-133.958-235.053-191.428M654.004 591.967c-57.213-30.882-118.773-68.22-181.558-110.765-95.978-64.94-179.763-131.857-242.665-191.683",
      stroke: "#fff",
      strokeWidth: 3,
      strokeMiterlimit: 10
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("defs", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "discover-erg-hero_svg__a",
        x1: 216.205,
        y1: 465.432,
        x2: 300.664,
        y2: 300.073,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#25211A"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "discover-erg-hero_svg__b",
        x1: 415.915,
        y1: 138.91,
        x2: 571.38,
        y2: 105.128,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#141414"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "discover-erg-hero_svg__c",
        x1: 254.999,
        y1: 535.5,
        x2: 395.999,
        y2: 589,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#141414"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "discover-erg-hero_svg__d",
        x1: 450.499,
        y1: 447,
        x2: 605.999,
        y2: 385.5,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#141414"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "discover-erg-hero_svg__e",
        x1: 343.998,
        y1: 467.5,
        x2: 437.998,
        y2: 473,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#141414"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "discover-erg-hero_svg__f",
        x1: 430,
        y1: 299.5,
        x2: 547,
        y2: 209.5,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#141414"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "discover-erg-hero_svg__g",
        x1: 498.998,
        y1: 308.5,
        x2: 572.998,
        y2: 357,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#141414"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "discover-erg-hero_svg__h",
        x1: 523.999,
        y1: 417,
        x2: 612.499,
        y2: 427,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#141414"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "discover-erg-hero_svg__i",
        x1: 378.724,
        y1: 579.566,
        x2: 490.23,
        y2: 613.949,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#141414"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "discover-erg-hero_svg__j",
        x1: 439.001,
        y1: 498.5,
        x2: 573.001,
        y2: 464.5,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#141414"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "discover-erg-hero_svg__k",
        x1: 603.537,
        y1: 460.085,
        x2: 754.45,
        y2: 343.513,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#141414"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "discover-erg-hero_svg__l",
        x1: 481.999,
        y1: 326.5,
        x2: 558.999,
        y2: 268,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#141414"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "discover-erg-hero_svg__m",
        x1: 602.998,
        y1: 256.5,
        x2: 626.998,
        y2: 177,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#141414"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "discover-erg-hero_svg__n",
        x1: 519.013,
        y1: 639.165,
        x2: 639.067,
        y2: 532.116,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#141414"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "discover-erg-hero_svg__o",
        x1: 433.5,
        y1: 460.001,
        x2: 483.5,
        y2: 300.5,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#141414"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "discover-erg-hero_svg__p",
        x1: 564,
        y1: 234.5,
        x2: 642.5,
        y2: 289,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#141414"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "discover-erg-hero_svg__q",
        x1: 717.679,
        y1: 154.07,
        x2: 734.032,
        y2: 309.115,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#E7703D"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#141414"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "discover-erg-hero_svg__r",
        x1: 777.077,
        y1: 433.026,
        x2: 680.355,
        y2: 387.581,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#141414"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#FF5E18"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "discover-erg-hero_svg__s",
        x1: 583.217,
        y1: 571.987,
        x2: 596.121,
        y2: 693.963,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#141414"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "discover-erg-hero_svg__t",
        x1: 858.264,
        y1: 125.454,
        x2: 785.296,
        y2: 360.192,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#141414"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#FF5E18"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "discover-erg-hero_svg__u",
        x1: 661.554,
        y1: 636.787,
        x2: 654.04,
        y2: 715.278,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#141414"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "discover-erg-hero_svg__v",
        x1: 514.763,
        y1: 774.767,
        x2: 653.747,
        y2: 730.673,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#141414"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "discover-erg-hero_svg__w",
        x1: 539.928,
        y1: 733.504,
        x2: 587.795,
        y2: 741.83,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#141414"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#fff"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "discover-erg-hero_svg__x",
        x1: 587.91,
        y1: 659.885,
        x2: 565.894,
        y2: 735.989,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#141414"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "discover-erg-hero_svg__y",
        x1: 657.575,
        y1: 612.5,
        x2: 613.8,
        y2: 665.708,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#141414"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("radialGradient", {
        id: "discover-erg-hero_svg__z",
        cx: 0,
        cy: 0,
        r: 1,
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "matrix(24.33296 50.8246 -50.8245 24.33292 175.543 89.863)",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 0.464,
          stopColor: "#FF5E18",
          stopOpacity: 0.875
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#FF5E18",
          stopOpacity: 0
        })]
      })]
    })]
  }));
};

/* harmony default export */ var DiscoverErgHero = (SvgDiscoverErgHero);
// EXTERNAL MODULE: ./components/icons/RoadmapCompleted.js
var RoadmapCompleted = __webpack_require__(6804);
// EXTERNAL MODULE: ./components/icons/RoadmapInProgress.js
var RoadmapInProgress = __webpack_require__(8657);
// EXTERNAL MODULE: ./components/icons/RoadmapPlanned.js
var RoadmapPlanned = __webpack_require__(3027);
// EXTERNAL MODULE: ./components/icons/ErgoFoundationIcon.js
var ErgoFoundationIcon = __webpack_require__(9082);
// EXTERNAL MODULE: ./components/icons/ErgoFoundationIconLight.js
var ErgoFoundationIconLight = __webpack_require__(7623);
// EXTERNAL MODULE: ./components/icons/Discourse.js
var Discourse = __webpack_require__(9199);
;// CONCATENATED MODULE: ./components/icons/WalletDesktop.js


function WalletDesktop_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function WalletDesktop_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? WalletDesktop_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : WalletDesktop_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var SvgWalletDesktop = function SvgWalletDesktop(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", WalletDesktop_objectSpread(WalletDesktop_objectSpread({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M0 3a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v9a3 3 0 0 1-3 3h-3v.75a.75.75 0 0 0 .75.75h.75a.75.75 0 1 1 0 1.5h-9a.75.75 0 1 1 0-1.5h.75a.75.75 0 0 0 .75-.75V15H3a3 3 0 0 1-3-3V3Zm10.627 13.5a2.26 2.26 0 0 1-.127-.75V15h-3v.75c0 .262-.045.515-.128.75h3.255Zm4.373-3a1.5 1.5 0 0 0 1.5-1.5h-15A1.5 1.5 0 0 0 3 13.5h12ZM16.5 3A1.5 1.5 0 0 0 15 1.5H3A1.5 1.5 0 0 0 1.5 3v7.5h15V3Z",
      fill: "#fff"
    })
  }));
};

/* harmony default export */ var WalletDesktop = (SvgWalletDesktop);
;// CONCATENATED MODULE: ./components/icons/WalletLedger.js


function WalletLedger_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function WalletLedger_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? WalletLedger_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : WalletLedger_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var SvgWalletLedger = function SvgWalletLedger(props) {
  return /*#__PURE__*/_jsx("svg", WalletLedger_objectSpread(WalletLedger_objectSpread({
    width: 34,
    height: 34,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M28.085.844H13.126V20.79h20.076V6.033c.009-2.802-2.297-5.19-5.117-5.19Zm-19.553 0h-2.51C3.203.844.792 3.126.792 6.042v2.493h7.741V.844ZM.791 13.204h7.741v7.692H.791v-7.691Zm24.678 19.947h2.51c2.82 0 5.232-2.282 5.232-5.198v-2.485h-7.742v7.683Zm-12.343-7.683h7.741v7.691h-7.74v-7.69Zm-12.335 0v2.494c0 2.801 2.297 5.197 5.232 5.197h2.51v-7.69H.79Z",
      fill: "#fff"
    })
  }));
};

/* harmony default export */ var WalletLedger = ((/* unused pure expression or super */ null && (SvgWalletLedger)));
;// CONCATENATED MODULE: ./components/icons/WalletMark.js


function WalletMark_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function WalletMark_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? WalletMark_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : WalletMark_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var SvgWalletMark = function SvgWalletMark(props) {
  return /*#__PURE__*/_jsx("svg", WalletMark_objectSpread(WalletMark_objectSpread({
    width: 11,
    height: 11,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "m3.76 10.516.336-.432 1.128-2.352.096-.96h.336l.12.96 1.128 2.352.312.432 2.52-1.752-.312-.432-1.872-1.824-.888-.384.096-.336.936.216 2.592-.336.528-.168-1.008-3.024-.48.168-2.304 1.248-.648.72-.288-.24.48-.792.456-2.592V.484H3.952v.504l.48 2.592.48.792-.312.24-.648-.72-2.28-1.248-.504-.168L.184 5.5l.504.168 2.592.336.96-.216.072.336-.864.384-1.896 1.824-.288.432 2.496 1.752Z",
      fill: "#FF5E18"
    })
  }));
};

/* harmony default export */ var WalletMark = ((/* unused pure expression or super */ null && (SvgWalletMark)));
;// CONCATENATED MODULE: ./components/icons/WalletMobile.js


function WalletMobile_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function WalletMobile_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? WalletMobile_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : WalletMobile_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var SvgWalletMobile = function SvgWalletMobile(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", WalletMobile_objectSpread(WalletMobile_objectSpread({
    width: 12,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M10.6 0H1.4C.7 0 .13.577.13 1.286v15.428C.13 17.424.7 18 1.4 18h9.2c.7 0 1.27-.577 1.27-1.286V1.286C11.87.576 11.3 0 10.6 0Zm-.158 16.554H1.56V1.446h8.883v15.108Zm-5.235-2.05c0 .214.084.418.233.569a.788.788 0 0 0 1.121 0 .809.809 0 0 0 0-1.137.788.788 0 0 0-1.121 0 .809.809 0 0 0-.233.569Z",
      fill: "#fff"
    })
  }));
};

/* harmony default export */ var WalletMobile = (SvgWalletMobile);
;// CONCATENATED MODULE: ./components/icons/WalletStatusWithMark.js


function WalletStatusWithMark_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function WalletStatusWithMark_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? WalletStatusWithMark_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : WalletStatusWithMark_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgWalletStatusWithMark = function SvgWalletStatusWithMark(props) {
  return /*#__PURE__*/_jsxs("svg", WalletStatusWithMark_objectSpread(WalletStatusWithMark_objectSpread({
    width: 55,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("ellipse", {
      cx: 21.997,
      cy: 26.253,
      rx: 21.497,
      ry: 20.753,
      fill: "#585858"
    }), /*#__PURE__*/_jsx("path", {
      d: "m20.022 31.657-5.637-5.338 1.53-1.468 4.107 4.003 8.283-8.006 1.531 1.468-9.814 9.34Z",
      fill: "#807e7e"
    }), /*#__PURE__*/_jsx("path", {
      d: "m47.076 10.532.336-.432 1.128-2.352.096-.96h.336l.12.96L50.22 10.1l.312.432 2.52-1.752-.312-.432-1.872-1.824-.888-.384.096-.336.936.216 2.592-.336.528-.168-1.008-3.024-.48.168-2.304 1.248-.648.72-.288-.24.48-.792.456-2.592V.5h-3.072v.504l.48 2.592.48.792-.312.24-.648-.72-2.28-1.248-.504-.168-.984 3.024.504.168 2.592.336.96-.216.072.336-.864.384-1.896 1.824-.288.432 2.496 1.752Z",
      fill: "#FF5E18"
    })]
  }));
};

/* harmony default export */ var WalletStatusWithMark = ((/* unused pure expression or super */ null && (SvgWalletStatusWithMark)));
;// CONCATENATED MODULE: ./components/icons/WalletWeb.js


function WalletWeb_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function WalletWeb_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? WalletWeb_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : WalletWeb_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var SvgWalletWeb = function SvgWalletWeb(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", WalletWeb_objectSpread(WalletWeb_objectSpread({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M14.36 12c.08-.66.14-1.32.14-2 0-.68-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2s-.1 1.36-.26 2h-3.38Zm-1.77 5.56c.6-1.11 1.06-2.31 1.38-3.56h2.95a8.03 8.03 0 0 1-4.33 3.56ZM12.34 12H7.66c-.1-.66-.16-1.32-.16-2 0-.68.06-1.35.16-2h4.68c.09.65.16 1.32.16 2 0 .68-.07 1.34-.16 2ZM10 17.96c-.83-1.2-1.5-2.53-1.91-3.96h3.82c-.41 1.43-1.08 2.76-1.91 3.96ZM6 6H3.08A7.923 7.923 0 0 1 7.4 2.44C6.8 3.55 6.35 4.75 6 6Zm-2.92 8H6c.35 1.25.8 2.45 1.4 3.56A8.008 8.008 0 0 1 3.08 14Zm-.82-2C2.1 11.36 2 10.69 2 10s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2 0 .68.06 1.34.14 2H2.26ZM10 2.03c.83 1.2 1.5 2.54 1.91 3.97H8.09C8.5 4.57 9.17 3.23 10 2.03ZM16.92 6h-2.95a15.65 15.65 0 0 0-1.38-3.56c1.84.63 3.37 1.9 4.33 3.56ZM10 0C4.47 0 0 4.5 0 10A10 10 0 1 0 10 0Z",
      fill: "#fff"
    })
  }));
};

/* harmony default export */ var WalletWeb = (SvgWalletWeb);
;// CONCATENATED MODULE: ./components/icons/WalletX.js


function WalletX_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function WalletX_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? WalletX_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : WalletX_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgWalletX = function SvgWalletX(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", WalletX_objectSpread(WalletX_objectSpread({
    width: 44,
    height: 42,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M42.497 21c0 10.876-9.144 19.752-20.498 19.752-11.353 0-20.497-8.876-20.497-19.753 0-10.876 9.143-19.753 20.497-19.753S42.497 10.123 42.497 21Z" // stroke="#fff"
      ,
      strokeWidth: 2,
      className: "stroke-black dark:stroke-white"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "m28.495 16.292-1.597-1.542-5.009 4.906-5.009-4.906-1.597 1.542 5.082 4.835-5.082 4.836 1.597 1.541 5.01-4.905 5.008 4.905 1.597-1.541-5.081-4.836 5.081-4.835Z" // fill="#fff"
      ,
      className: "fill-black dark:fill-white"
    })]
  }));
};

/* harmony default export */ var WalletX = (SvgWalletX);
;// CONCATENATED MODULE: ./components/icons/WalletXGray.js


function WalletXGray_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function WalletXGray_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? WalletXGray_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : WalletXGray_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var WalletXGray_SvgWalletX = function SvgWalletX(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", WalletXGray_objectSpread(WalletXGray_objectSpread({
    width: 44,
    height: 42,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M42.497 21c0 10.876-9.144 19.752-20.498 19.752-11.353 0-20.497-8.876-20.497-19.753 0-10.876 9.143-19.753 20.497-19.753S42.497 10.123 42.497 21Z",
      stroke: "#585858",
      strokeWidth: 2
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "m28.495 16.292-1.597-1.542-5.009 4.906-5.009-4.906-1.597 1.542 5.082 4.835-5.082 4.836 1.597 1.541 5.01-4.905 5.008 4.905 1.597-1.541-5.081-4.836 5.081-4.835Z",
      fill: "#585858"
    })]
  }));
};

/* harmony default export */ var WalletXGray = (WalletXGray_SvgWalletX);
;// CONCATENATED MODULE: ./components/icons/WalletYoroi.js


function WalletYoroi_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function WalletYoroi_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? WalletYoroi_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : WalletYoroi_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgWalletYoroi = function SvgWalletYoroi(props) {
  return /*#__PURE__*/_jsxs("svg", WalletYoroi_objectSpread(WalletYoroi_objectSpread({
    width: 43,
    height: 38,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      fill: "url(#wallet-yoroi_svg__a)",
      d: "M0 .5h43v37H0z"
    }), /*#__PURE__*/_jsxs("defs", {
      children: [/*#__PURE__*/_jsx("pattern", {
        id: "wallet-yoroi_svg__a",
        patternContentUnits: "objectBoundingBox",
        width: 1,
        height: 1,
        children: /*#__PURE__*/_jsx("use", {
          xlinkHref: "#wallet-yoroi_svg__b",
          transform: "matrix(.00415 0 0 .00482 0 -.004)"
        })
      }), /*#__PURE__*/_jsx("image", {
        id: "wallet-yoroi_svg__b",
        width: 241,
        height: 209,
        xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAPEAAADRCAYAAAAdZ1Q/AAC1bklEQVR4XuxdBWBcVda+b+aNu8Q9adrUvRR3l8XdobguLLvssssutrAsi0ORFinF3a1IoaXUqHvTuEwm427v/859M22Alh9pQ5Pm7YY0yWQyc9/97rHvfEd45YvuihkzPjirpUl7sMk+pDackpwpFVOpTAJLCwJTSDaWjquZLmNlelFkimSUxUKtTJlxMUEnsIzWzhIKFR4nMiYpmCAJjDEFU2TwNS6lgv6bYZKQYUxIs4wiha/T/GdM0jAxY2exqMTUKsbU2iSLhFojOqP/s8OPGPngySeY5pYIQkh+8MA1sAK/zwosd0kV33zDxs3+uvuyDpdiD53eRlBgwShjBlMM+zqOfa/GNtcAF9jwEr6FD7r49qcvsPcJB9nv4F9KPFZgyjgenskAEVEmaNJMY9QypUbNYvh+IMyYRsNYNMGYiCdS49/4hK9YgCWZn8U3zf3zRVXXEuLYyjbJ9r/7vj5s3oLGoyzOwWO6AvHiSFqyWp0F+AtKlkplWCIE8CUSzKzTMLtJA5BGmT/kZ1E8e1pQysAFiL8HZLx2hYLeBr14ejMAMQczAZlALDKzPo+FsBoKvBKtTsFiMQ8LBps7bNbk/OpK3ayb/nr0GyPzhebf5/YN/NVdeQX8kqT5ZgGr+PSzpqMXLmo/UhALRhnNZY5oXMnCkSSQlWZ6PTAlJJiQUQMTsESSCpglY4Z9j70uZPe7gqWw9yVgBIaPUIefE140wE46mWLxVITFM3hOBUAj4nmYmqXwT7VKB9jRIZFkRqMYyWRCrnDI3TBp0ogPLjlHmF7rFNwcxHThBSs+/NRV95cbX7pKpR65Z0nFHpVuf9jojTYxURtlKk2cKZUAX1JgUlLLVGknU6pEFhP8eD04Npggv/AcmPkBhBfKQdzzIkDnQJ1iSjHDotEwziUNM+rMsNwaFo2EYP0jHpUytl6tDM2/5spjHzj4ANbm1AqRXXlTDbz33luB+nbJ+dkXiUHvf7jqgmjCNjmVNg9JSFpVHAYtJQG8Rg0z2zTM7w3K+xzGjowSfE98BhbIHGOfCwrZaMGv5d4oPRZQ5nghj1SlIguNR2cM3GCmcxZcmQY2YOl1MKJJ/Eo8Huj2NLQbdYElJ5068YGj/8AW5StwemSf6Xsrs7xBctxy65wLly5PHq63VAxSGZXmOAuYIulOlkhH8OdEphZt+C+sNP6rUAW4O8GfjL+AHJjlQ0WhELPgpp/9ANB4DbGEB4cD3pagwcGlYpkUrDxcE5VCxzRKhT8W9rR73RtXHHroyCcuu3TQdyMqhK7eu5UDf2lXWwFfVBI7Xaxq+rT2/RYubj0mmbGNszuriiV4nN1+GDFsamsewkcYy6AP4ARwaZ/zK/c5t2jAKXmYUs6VJoBkw03CQgbgVmnTLJkEwNMGppRxzWCYOZZUOA8cNvjZyYgnGmxZN6zO8faJJzpeHTdUaOl5XzZb4p7fDEqS8ulnN42b+uRXV4VCxRNtBbWVKrOg8UW9LAqzrzYAaDD5sVgE7kDu1JFBK4NZflp6IUolxcv01Q9iZnwvo0izRDLAtHo1E0U1S8aTLJmgQ0DL1AoT3qbILHpjNBX3dXW6Vq2qrlZ/NOWi/V46fl+hfVfbXAPvd8evgC8tGb/8lFU9cN+ymwWhaLQzPy8vkWGWYCzFoukQPFIkizRaloHFjMMGphMSMyEv9KMr+y1ymymW5SHk5itryLD/0xR9woCFonAwUyLTIehFZM2SCLPhqTPALBKPujxKxaZ5x/1h0D2nnupYYhQF/PT711ZBnHvIx/PCQ+6++/PLunyWCXHJVKe22m1JMSl4wl0srYwys8XIMgi+eTDPL/nF4ozZDGJypze72Uh2bU58cdcbQFfj0ZkUS2cS/LdUKhVTq3UIn1UsBQNPC2U0aDJ6TcrV0b6iMSO1fn3KaftMP/usmtYqHXz5gWtgBbbDCmwKSYX331N/8Fefuc4ryh8/LJ1R5cFOKeJkGQFChTbBrW8oHEXOBoZMY2H5DiOMpOwY0yXxBFYmC1pK5sLD/F44mX1kdu8TyGnXJxIpphG1zGyAAcOeD2NXKzMsbDXEWszG9vnnnVt1y7ixrN6k/t5psPld/ySI6VFrO9KFz72wZPwbb3de7I/aJuidNmtKndKlVVGm0+lYMogMG89Ek+9PMJRjAfq3QkIOTqnkb5LHDT8EMU40ldaKLFyIRaIevPIUklvIiOMdpBEcpJIZlucoZJ6ubpYGoovzbaFMJtza2rx62YjhFW9dftFeHx4+QejeDvdw4Cl20RXolCT9K2+wwS/O/PQsvbZslM00aKjLlURRRMvjU5WW56BYAoncZDrOc05qnZpJ8DaT0SQyOXgAt0YU85IfLCewKP7NCNjz2aSvHC//MD9EaEGiC0ZQh7BTjYdEA0yKRVydRXmJpbW1yjemnF/0gV7LWoosWwcw/9M/5965EpLuvfejI2a+suj8VRu9u+vtBaVaq84RCeN0koxyVg7AlTPP2VR69rOYzU7nMnbkWpM15i42Yt8UXOc4IndBTDGdnmLsFLLhMbgsSX6KpVJpfgCoEOWLAn4uSJJKoWyPRUMbAt2r5v3zr8c+PmGMuWFoMf+DA9fACvzsFXAlpfwbb/ae4OpW7B+PJ4cnklIJcjMWpQIABrC0GpFFIjAmvASE/Qgjo1BLPBmbgecoIX2sUxjlZBXAKymQXUYWOo3NLWegYcCQqJUBDC+UfxPA5j4n4AsMpBBCplMppkZOSFSmwkzyNhcVZOYedljZ/YcezNZbFQIKWT99/SwQ01MEcPSsbWRljzy64MjPv2o8Ua3PqzFZi0o93XGlweSAG6xkwXCAWWxmFo6FeVauq9vF7DYLAEvnjRwjcxDjTdBnOqkEhZK/YTljJ8f93BknTNLCIBNI/86Bn6fyaXEyol8pRFv83cu+2n/fwc+cfvpuqw4cISDLNnANrMBPr4AnJem//JwVT3u68/pI2rFnShALsdcsTJlAfSiGPZnN63DugwZ7kz5jY/I9CX+XqjG8NiygSqPnwCQAy5Y4DRAD5MhSSzBSGrWZdbsDzKC1MINBwSJB1ILVSgbrygLeEMs3GREzppKBYHOrUtm5csLk/OePPrp69uAa1moWctXm7QTi3NN4JMnw8suxsY9MfetiZO7GFhWPKG/p9JoEuM15Bfmsua2VFZQUMJfbzUxmIzLjdJAAtJRu56dP7t9yqUlAYE9gRkkOP5XrbPyc4vEFTjuK4wVYavwenWbKNJ1sKKrTZ+SyjSahta116VqrOfzRdVcf/8qRB2rbHUKuED2wnQdW4PsrsKFTKnns8fZxs790nWt1jhwLhoIjLTAzWQlBgb2mAOkChCSZ80DlIvKnaV/i39k9mQOyAGutygDEvCaM6FaZ5BlnCfs5g71Ke9pi0vPcjruL9r7ESgqo7MpYJJxkBhWTol3doVS8o6myRpx96JF10/Y7QFzv0P4yY/SzLXHPpQjhiGlpZqU33jTrwlXrAntX1I4ta21zFcVSabXFkcc8gSAzmC2IIci9llPWVOwmIFK9jP+bx83kRoMAQieZpMeHjrNeOKi5ax7HZ8oc4NSjx2OxlPg5y+gQPhv4aReJh5jNpvEZ9an1m9bOW7Dn5KoZ//zbHuvrnAOx8gCAt6yAPy2pP/sM1vfJNZe7fcKkguIiZzQjFUfTCmuah3zYkwRk2qOouPD4lcpHPFTMJWfJQySikhw2EtCV2Iv8wh6lastmEAP4EiJmZJhZZwdjejxNUSFia5wT7k5USaVwwmZkrUYWWrvP7lXPHXSkYW4FrK82W/v9JffuV4GY/kCHR1IZTUz/+DPh3afPePdMvckxxB+KV4oaszOBN6BQ65lGZ0IdmFwQOdklW2MAFwsGnhdfEAWPH8iH1nEQkzWmR3KqJndRqDaNWIMeS4kxgJg+FLR4WGS1UY9kg4J1dbTH8q36hkigdT1Ld82/8tJjnjrhONZmRxD9SxZk4LH9bwXWu6SiF1/01H7+xaazFELlXoJoKExkfFaT3cT80SgYh3KIJ4MX/0YyKse+orwNWdzN12YGFvYvrLMS4Z38S9jHsOAZnuDCsxENE+52wMeY0wYQ48tYkDznANzpcLdSGWyXku1Lr7pw3/9OnMCabbZfb3R+NYhzb6qhWzJ2eZntX7e+dn5Dq2+ypLTU6c0lpUlJJ8ZR+0IEkI0niHJGC5UDMZ1oRPIAaCkIASCRMuCxsZwgI/cZC0IJBXzmngwWjTjaRAqhRaZYWqFRsE5XN6ssHswS0XQi7A8ElEJwk0rV/fW+e5U/f821VRuqTAKWcuDa1VagGznQpUtZ8cMPbrx47Trv3pU1w4qVWsEeCAWt6RQovkgqaWAEaL8pyLgQr5+zqxAaZz0+Mi5EuuJFF57YwYcCNEsBtVUiO6VN8s+oHgyj80MQIz/LHBZYX1cS1jiaLikSNjQ3L2quqNB//a+bJz2Fn7XoODfz11+/GcS5P92VlsxPPbtpzIyXPjnXYK4Y649qqt2euNmRV45TiVwS+bRSoDJGLjW3xpToQiqfqGpyMgvWl9aLG0/5pUmUFOPJsGxSjH4nm9kja53CD5UKNevuirHCggqmUxlYl7s9rNclWvz+datrqpVvXnvlYZ9MHs86rL9xsX79Mg/8Zm+vwOJWyTH7a1f59McX3VBWvte4RFpTgPPdYrEjtsX/w8EMLKIBpUzyCGn3ye40zxpT40+WB02WWHat5S0ph4GU2MI+5gYFdEn6Lfwu0Y9ld5p2puyKw+Fm/m43K8rTB6RUZ0c8um7x2Wft/+Axx6hXINoMO8TfXlXZbiCmN9KFk2/FOlZ84z9evrKzWxivN1dUpjOG4oykUVOwLye1AOCsNabfAU+Fx7pyd5NcX5MXTU5ySVgIIQMLnHXFldTtQVl3hUyj1mnBSwMZXavXMX+AGp4UzGy1gU2WSJt02k6vu3WDSgjOPvTAEc9fPKWosdI2wL/ubUD15t/zhCXxu1Ws4K0PWvb6dPaS08oqhw5FeFeoUhnNiTjYUcE4yENWTijq7kLyVU8glPcbGA/8pZJXzYFB1GQkumTQyhVMbqH53pQ/E1+RrIyEx0mw0BkAeTOIKeGVzMSsZp2rq32Va1C17svrrh0+rbyEbYJB+RHz6teu03YFMb0IuDCK7gDLf3z6xomvv/nNaWZL7dAUM1cAyDZK1ctpeIpxZbca/KwtjBd5meRF5SchFdXlzijeEUKxMRaLl86yIBYzRpkYgg4QnQH1PTwqHIqjhcsCGpsJllnr6Wzb1J5KdC6ZML5o2qmnjPrumD0H3Otfu2F25t/b0C453ns/VPvmO8vO8wa1u5dW16EbL+RQqgUWBz85SS19SgN3lzP0BRF7+f7CHiSrykGKD3yLp1JojynCACYBmbxE2pdy7oZxC0wlUjmZRd4hWfNcswP3NIV4t5QItKuVgdUnn7zHI0cdwZaChulH6eg3uc8/vAfbHcS5P9DokcxoTrJPufita1Sa6gkpIW94OKm0hlMJFkkjnkDvsNWMSCTQDTxT3GtA04MBlleN4B9nIjqkdGh7jCUi3ErLDBg5CUaf6aK2LhEFd14OwCUnxOiDCs/yv1NIB+blWwPRaHd3c/OqDaWlhvdOOfXwNw8+lLWMtvx2V2Zn3tS7ymtrz0jiqlWs6OWXNx22fGnHkQZj+SiNrrDA64/olWhUl7072ju5XItcz1XAwxOYXm4j5BwG1Du4twgDQ+4yUTzSMexFuNSgaqGvCLksLbYWJV9hUtIgO6HbiDcwREWUjHRMj22HM0PSCLGuUHDNunGjza8dd2z1u8OGsyaVKHcdbe9rh4GYXmiXT1JFwJa894E1B3zy+bqTNObyOrUlvzCUzOgIzOlUiBVasTDxOE5JnGUp/JviCBBAiEMtglcdT4RRPKeMH9JcVHqipaWjkqBKKX5YYbA0e4C3J70tww8Cn7+LmSxagNnS3tHZ2NTR2bx03/32fOOqCwvm71EhgO85cPXVFVgflhyvvcHGfDJrxRnRcGaUxVRciXKlI46eX2prBS2ZA1jCHiJLmaEufO4JAk+8RESMKwrXyBigNZYDmfw52VhSP28K6eskAE8IjKWTLJ7G4zRonkXKOYFuhTQqMA6Dg4l4Wjx9Oh7s6DBrPcuPPGTwgyedLC4yIE0jbIP3vD3WfYeCOPcCOxOS6Y13Gwc98/yXZ3V5zZN1xsGD0lJenlKpZvFoN1OBcsnZWXCJiaGlRE8WJReIn0pJK5kxI8crVIuTb4IsLCCkcZryonzWCvPHbSkJUK+yESIGWj2SZ1IMNwTsVCHZCmrnCpZwz7n2vKNeOfd4Tdv2WMyB5+jdFVjWIJXe98Ta4za1xPcHeWKkzVJYJKqMBr83AZKRgAPchMNfVpjh7YC5UI7AzCmSlOOiJn7Zq5MrIHKzPm/aIW4/QBwJx2CbUfXVIgmrIgss14RVUOCgODsdg9VORTLlhabWQPf6Vqcl+e0VF42bOmYka9JodnwOpldATIsFppdyTSMruf+hT46aO8d1lNE0arROX1rs86EV0SCCaJ5Ev7IPJ2eQA1mgpizEKlq1LVtakgvySl4zpnia2Fx4CJWaeEIiGzvzpuwtIKYacgaHQzKFemAmhu4TPLNGkUmmYl2xkLdZI6W+OvjAEc9dellNwyDTgFXuXRj+ur8GAQvDN7NZ5T33fnJVXGUZLomGWiSZ8jNpxLWwvmpUKKgikkQfoVJFzD4CcU9eP4GYyBrkOssQkEMyAjIZDPqQWVop8JrhiJP54OURqpZAF4DvN/IYDVoNMxlYIBnr7Ghp+mbDqSdPfuSSCwu/FiUWNoi9wxzsNRDnbleHJBmffa5l5IsvfDMlEs2bKKiqBotag1rUBVlS8rEwRAJScJFVSgu6OlBgS2v5AiukBOAJdRGAmFyenEICLTH1ZcogJlTn3Gn5ranVsPbxCK83q+Ce80QEQE3gRiIsHI8lwRBtWmszRT6/9aaTnj1irAB+zcC1s65Ae0gquuc/nmM/+uC7U4cMn1CZ0SpsvhBEK2KIXQFg7rmRVcVnFQDMWYObr2z1g8fI8vdBnORg3tLzS3TJbPYZP4+gh95shpHRpMBDiLF4BHkYhY1p8bfQLpCAhlyo07W8rbwiM+fPfx79wKBqnnn+f5sWtuf69jqI6cXDKovLVrGKBx/+6MzVGzWHROL6wQpVwqk1kbsisRiJCyGFr9GaOO+Uyw5liAqSwme42zxukW9DEqAkxo3sQssu0GbXGt9JQBfMajXz7GI4AraMRsVsYOqEQgHW0NLKnCUVdEN96kyo3t2yaOEfDql95Ja/7bfBquTV/IFrJ1kBVD00c7+NDLrvrm9vSEQrJw8ZUqVtaE6Ux1mIIdcErSs9b3uNgoEVChFVV8C9Bh8f1rLn1ZO+R9sGkTM//HNNOJzzTLaAp6phOMCHRnMg9mCMd9GpBTMa9o3QnINtiEUCgtCy5rgTBt9x3PFsJf58V7Fx+5WOfu7S/y4gphfXkQwrokm99ZEnv9t9yRLfqZsaIhNETX6FzligCyfjcJbReK0l+hqK8MgeKtPgS0MoAF1gADDcas6pTqBhe4vw2GYQb3atFcxkkgELew2rLMKtTvCv6d+WvALWAroZ1ZjTEV/copY6lLHAklJn+oNLpuzz5uH76jt/7kIOPG7HrcB6v5T/yINL9//4o41nV1ZNGKRSFxe1NIVNZquFJ6yUaA9MoAoRQ7MN3VcT/Ns0vC2/38973umSKxfZwz7rOlPCS8klcxCSof5LxoBADq8ctiDAy0tWq5Z1d7hZKqSESCTqy5KYSkaCXRp1qj3Pnllw2aVV9w2qZa0FJgGkyt/n+t1AnHu7sMq6199xD335pQVnd7iUE5iqsDacZnlIPKCzU4t+Y9L0pO4lqH0g/iUBAg5ikD4oNk7n+pc3u9FZtzoLZOLBJnEoZNATqqIWMPSAieQHwUKHYyhzFZSy5tZ2KCtIzGlGM0ss6o4FmjYU5AXemTgu7/Ubrt29wajo/dP199kOO9dfReyrnTs/Uf7cc/NPW7tWOryoaGQtKhNGTyCiViosqF4gc4z7KKL4qkJJkodK4DmmkXiiQ5t3yWX50FvKj1lvjWJazhiEiw3rm8HeIhATTZqrznIQx+EyK1iw28+0aNCxm4zBRKizXSX4Vh9y6MhHzj5DvQQhcZeRnwS/3/W7g5jeOrqixOZWVvTUs8vGffT52lNTzDlSbyurSGRUxu6gn9nAIKdSEyUZzAb0fUCQ1+8JMZNRB4VMSkcgU701EOO5Jd6Inb0219jleIjfPE77lPtFBTBzFIoAHRAh3OAmFYssHjHUOfPcs0bO32vYQNKrN7fpso1S4YcfpcfPmtV4YZqZRqFH14Fme4uEjiPu+gI3lPwUIDAntwnKXHs5Ay13yskgpledJRD9sIJBXUpUXMJzpSlZigIvCXGEURdNgvdv1MGio65k1rFMIhIMRAJrNtTViu+fesrYZ/bcgzVZdpKW150CxLnNEQKt68NPEzWPTvvgwtVrY7vb8ocOMTqLbDEofaSVMQiKBeAyRZjDWQglTCvraG1jdiOsM1Xwcjco5zZlVQUpmygjVmZ9bbmotRFuOk5YHhNRbI0in6REdpw/XpdBwsOdCHc2aFWuLy65cJ/HTj+2sBFJiwEFkR2I5o6IZFi/llW++Hzg9IXzPUcYLRXVaaVgTqtIGjmK+0QUXZkdRSCmBgTy0LYN4twWz1UveuZORFQ/VBCv8ED8MclMkKANIJ5OJeE66wuYFmc8ZiUkPd0uv1rZvPyQQ2ruO/N064LBecJOFWbtVCDO7Y3VzVLJSy+7Js54ae4lOlPliISkzI8pIyqNEYkFgxpuMMU/KihhIsmAYrsIob0tteEt5SUC52YQ96gd5/4OEdRVSFIQMyeFTZJCEgMqD0iWyd1UVPBPx2Nhq05oC7g2zttvcuW0W/46dmmxeYC2uSNw3ByQ8t95g4148bmNf1eqquosdoXCG4nZM2JUTCuppEi8e8qByC4xUleb+33lNCfxqHqUkqj4mGsv5CdzTyDLrL5AKMzyi5wIr9zYV0FmNTo58SjkkwBkXTAabmurqJA+OfGk8vv325c128ld28munRLEtEZrGyTznG8TtVOfeP8SpaF4VFrUV/rjyfwQ5AUFZJjVIK5rQYUTIpSx3vaqckGQH10y0Cm+1qSpSwVgFUMsAdIJInGAmE57stRQ6Fci64kOM4Oo9HS3rVivF+vfu+Ha458+9sj8NsPvHAvtZHvpV78cN0QmmlpZ+YP/++q0+XMVJ5QW71kJEpRZg/M1mIBnJFKJkO4Z+MuUbCaNtowWgM6BEt/LUivlBrgtJSRZplF2qPmVU1nlulgZCMAbWGNLI1xnI7NZ7BgjFMU9Z0hjxTtaW5Y0H3boiHtPPqVw3tiqnVfvfKcFMa13OCMpILCff+U1r525YrXisMpBe9U1u/1F/mRAUVgJpU1oYLMg3GlkreU79eP8whZL3GOPZXWxlXC1Vfig7UF9z2gxZUm41MTVlqmd4G9rbCzQDf0yeOxOizYUjzQ3+X3LvzrokIrHbrz20IZBdsH7q3fvwC+yhqDkfOOd7sHPTZ9/rck8eJjO4HQ0trY57Pk2VHSomkAAlLnK/ODlljXbnkrkC86pl8uQ3wNp9svNIM7+PEenlPEMghGcKg0aZRJ+Kh3pmFqZift9Kxorq32vn3jS8OmHHezchIaF7NyhnfOG7dQgzi1ZKC3pH33MN/mJp7+4yuSsHaq22vJb3JusWnQt6RDTyrrWdGXNbg8wbxXE/A7iNCdKOxLPRCbJkDwQJTmQkUxD1VDWSMIBoYAlxjSKGJQ903DbdRopnpS6OhWq1hUVeZm3bjzvhDf22m3nPaV3zm0nv6qV66Sy/z767Rn1zcr9VOKgsaFQJk/UZwSTXce6PO1MZ4RGW5TCmqywBIEY/+NCi7zvl0TpiH2FO5dVksy5zPKeoOZCbHFKgnEQZ93t7D6h8hTpYpFqq1FVkMrEEr6Ir6F5wgTr82efU/H8HiOFPkHH7RMgpuVH0ku1bA0r/ue/P7ti9YbEgcUlu9eGYxKy+ygF5MKUHm5UzipztcytXlkaJ+9jJv0vehBxZqn4L0+4I3oJ2lRYKBJhBrhdIiRMfVD2VqFMpdHqfbGuNfWajtkfXXHWIdNPP3O3er1t+7aY7cwA/C2vzeuVjB+8v6zyxVcXnR1T7n5wSlFaHUmEDc4CJ3qCJNbm6gJHAOUjVCOofESlI96LzgUhSN2F7hMqCvgGDTHgvegctNSIL89E4veRPzrnThPLj8jRctaaDnDyviAnhQMceu2+1Y0FztBnJx07ZuqhB6mai3W/TKzut6zHb/3dPgPi3Bttj0m2Bx5o3ffNt1ZfmVcwrDYUzxSj/IB7JUuJyv3KcjxLN/V7JSZ+NsvxEokM0OEt1xGz7We8qwWuOW/8plgZCS78XER9OUHPTZjWqZg/kmBB6A+YlbFgUaZ+I4s0fjNyRO3MU884bPXekwdKUT+1KZetlQpnPv/lbosWrj0xxUpGiabdq6IpvSmjBAUK+Q7yetRg6iVAlMqAnadAa5CCGl6y1pdKQgqQfygjTbLIaZGy1sSqyg4zy907ribDC0icT0D6c5TApItPIUFMjR0Sj8VC6GLr3DhmvOnJU06s/mifoX2PdtvnQEw3IZaWVN9+6x/+t389f1Eks9eeekftYF+oXqvSI0YWCcgSCwTAlRaNKNabMToS95jiXxTuMXcOX4NcgyBXDTG/JOkGk7AfF/CT3XG5gyVbisi2PfJaIrnZ2BAUh9E+IMuggagSaKBtAb+7wWpJf37sseNmnHqqs7lSt/NlMX/rif9bfh+65eJb7/oqZ7644JJA2LSbzVFd7Q0lHBmFUiML1eHifEdqfCE+sxwiySKJPbKT/PtZITsssUYX5vO8qOavVEEvCwBPpgByAZ6TSIcw4l5knpOpTmazGpC0MjJfFw6HVDFzmBPN8dDrb5xz5vjHjjlmCI1J2W5qG79lrX7p7/ZJEOfeZEObVPnIc579X3pz8XnFZflO3K5qqCxo3D4o91nzIdGDsRiRDJT8IdDNE1iY66TDJAm4X5GwD0wuAFsNHVE6tbk6g9xz2jOTSYwvOtG5t51tZePuG4EZv6c3lkAcHNZAinoFydckKju/mTS+cMYZp+256pBhCt8vvSH98fHrW6T8x6YvHjF7XsN5zuJxo7sDqor2zph50JAajPDBbLzsfF8CJ4YCyMMBsoko+Z7IIM6VlnJWF93mYN8hr4jfV8CCg6OBiQ04x6GdpUP5kfSzMDgXe8DDCvJNONi7WDwUSZYUlXcIabWXxdd9959/Trx5xGBFY19e9z4NYlr4TVHJvGwtK7rpzy/8VZJKxhhNFTXJlGTo8uPkdVo53ZK40bEIbibI8TrUDyQkqOj7JiP0ucJkVYkIIs+QJRBvznRyd0ye5pgzFHxDZXtTKYNNG8cIxUSJ+XA4xCKKTKLN39W1tqyw4IOjDt7jvXPOUjfaVb8vLe/32qBRzOiZOwdqk48subrDLe1lchYX13dssumtNk1J+RDWBJqeDn3ecrY5O6g+Kw8rb0xaa1l7Tb7IUpMqqmyNyUpD7YZFMXFErbLjw8KnFarBhVRjZGgY+QuKq016J+tui0H32RqDiGx3a/vsBceeUnXXVVOGL8+TZSv79NXnQUyr34Tes7CHFd52y3dnz/6y6fiSslHVGoPBFo5FlJ6ACwR5wBM+tVqnZRaLBaM0IrDEcYjOO9CKQrX7LQQBTuHEJQOZQJzrivp+NwxtLGqBNDscrKW9HhMiBWaD2r+vK4g2LGWrSjK2ejpbN+6316CH/35TzYrKgr6TKNkeO9oXk+x33bV8whefdU4pKp44we3PlEZTabGgws66/B3M5fGywYMHgz7r/9Gfk2u9OfDSvdniTm8WiOCaWClmMauZt9uH0MjKBfBCIG/EQADSYzAfJTWd9jzm7QzG8iwmV/2mTYnCwtCcP9808p9D6lhzfj9h3/ULEOd2AZop9O+8kxxxyy3P/8VgGDlWbywsV0I2OIH5qwEoiKSxGSzmAsAPrGiAmI9d5TFXlnObzVrKpQgyADwXysFMbt6W7LX8PSKEpEAQMaLTxe1ugwxqhJVBNlcl6dIBd8Jr0qjciXjneoPOM+ua6w6deez+gnt7AGRnf45vlkoV/7lr2Q3tnWw3jcFciCl5Fo3BakS/CfN64QIjy2+0AoLQr2Ko8ZOqBtdNy0rHbqFQkpdEAP6+Jc51q/EMNfTY4FQxrRZxMO5HIOjmXDsb/qwGPYqxYColKiNIeM9ffspp4++acpFtMVhXfd769twD/QrE9MY6IFnq87Piv9/07dWNzYlJgtpYq9abnClksH3hMJq80xifakKJyMBdLYFYHLlTn+Jionjl2D8czFTSIMUHuawh6xHLJQwanJWCIok36GUWuOY6xN4+xMcazMO0Y4xNLBTwG3UKALmrzeVasfDEk/Z87MKLalurjAJp6/a7ixQ3pk3fVDvj2fk3GEwTd1OItkKNSaX2BNxYOPwf7LdEBB1HkLXRG9J8ThcOPH4gcnkmfpjS/SAFyR8C+McSTJShjkI/Wm43BOcZAow6DALXYxB4IpRJh/wBH5pZOsor2JzLrxz675GjWZNN0f/KgP0OxDlk+NDiOO3ZlaOfn7nkKp/fPNFoqa42WJ0KHxJaMciVqulGY6SqjuRbNoesWbpe1jJTJ0w2Rw1cy9ItBGIBGVT6TCAWTFhCqCEGfWmut2SAy06jOtIZD7NbSIMJ7WwKVbdepW9t2LRmQ9Ugw9vX33DQe4eN7j9WOZCSxPoNrOh/9605fdWG9v0KSqsqgql4Ab5t7/JgGL05nytCUjnPjno7KWSEgwmEH06WiuUIOuBG87E9sn6aDGI5pOFthDxmpvXffEe4d2TEYYyiA+Jf5CRQPTDp4VL7vLFwoKvDZovO32ffvIfPPLt8Vbml/6z3D0//fgtieqOwDIpFS1jNAw9/esHKVZH9C0tGDEpJCrsXRV4l3C+lEkBE6MUZW9wa5GKvLdrYSmwsIgmQkggXsadZUNT9BDeQ0zQ1IFaDw62UoEKSRBzG9a9BvBe9mCjvwjR5J2tvQVY0KkZKi0vcsVhXo8e/4duj/jBu+vVXD6kvgzhxXzbJ/qhke3Jaevg7by+7XKF1jtCa9YXuSLcjLoSAMfCrlE6AF4kmEZx08KBjUR8z6fTgvdtZLIC5vCLiHV6zB4Ahvk71fjoctwA4p3eVJXJwQo7Mo5ZJH5TgggWHhprNCrconQw0bFrcUVOj++ySSybft/vurGF76zzvbPerX4M4t9iNccn8zDPrx7344vzLMumS3bSG/OJYKioaTGa4wE7m6vTyjKfBYEL4JqI0hWaIdARJMOhex/2cKEA8a7LGNECLixNgtCoUdlkCQ9G5xheRDHIbjJeiSOQe0xxRjpKTZVxFEYQkpQe7tR0bca1G6Jx9198PmLH3eOHH2Z2dbads5fVsaJKKr7589Z+SmZIxaTFQlBKj9qQilZei4fAAbgpztiR8yPZUrsPTYUgSw1xuGOsognRBF6lPEuWV3Gka0k1sOaK+ysQbqJWKVPcVUGVA0SgUhNusZg7QMz3dEHSAjhrk6jKBQEenxBpW7LNv4UOnnjZ4PpoWdgm9tF0CxLRJaDLFkhWs4uZ/vHHtxnr/7rVDxhZDmam4rd3PCotruCucBOsgiuxLAp3gjnzEtABwWoLCLayEEooR3JGDBabNpwCICbxJtFCl4MblEmE5gQE5ziNuNrmHWa1j/L5A0xzTRh/LmCNq5tugzSx78ZzT9n77sCPs7SWOvhGvuSOgTb7rLXnttRUXRoLjDktKhvKMuludVPm11JdNrZwZxLppAaJ1XO9Z1tXYDF4+4pbWFAU8Pt+X+rlB0uFApqFk1JBCMTCNsUXNF7kGiLmgwwjjeiC/Y0UIk4ilmcvVgJ/FU3qd6FYr1d12m7Rgn32KH/nDcZpVRYb+lbz6qTN9lwFxbhFakpJp+rSVE55/dv6VdkfdOK0xL3/Dpjad1VwEkoAF4a2ZD2lr64CIXgFc5IyfK36Q8AB3q4nhSZpfnFuNrcgtMdH6sl4x515j89G0PKpl0goTEYgGWHM6KH5OI0DS5oSYyfhUiY56tdj9RWW17o0LLx6/ap/RO3fSa95qqeCJqcsO2bguephCWTAyozDD8opOxLAixbGUZZbdYRpNS8kqWgByhWkkbVbjmTwUvE1yo0m8nYczWB+Kh9NoSOCTMVFBoHEpUMxiaMzHd1RMC83nDAQiElEPCDwSs1s1wUjQ7QmHNy0fM8H2wkWXTP6yqoy1Q3HjJ5pT+4CL8wtf4i4HYloflKJUSxez8n/8c+Y1La7Y+OKSYdW+gFRgNpchIWVgvmCM2QvgZne3gtYHS0Lzn5DFJt7WZhDDEtNIGQlWmBRBZGub5WxzEBNLDLpgZFHwfbI8ZGW4LhtnJqGhHaP0zGpDOJPytEdiDStTUsMnF19y8GuXnlC0UylH0JphWJ7+1dc8lc889fVlglQ2RiOWD9UazfpAvBPWF+8b6yZPv8wNiIdFpVCCJw1hh7PhBq+/c2INSnzcOlNikQBPdFm40miBkIfOy240S+mg145mCAi0J6IYXq9Loe9XSCRTnu5Ad2Orwy4unDLloP/tvR9rxoTBPkmb/IWY/dHDd0kQ51Zhbadkf+jxz3af+23zWZmMbUIiaSo3GCtVGkM+a0aRM6/AgfpyF7ZUdpQltxzyfGSKiflFfGoi4OcmyPOaZpYDTNYHs35oA3Nrg81KFpsGdCmgpEh16HBAxfLzC8PBYLtfIXg3plPts8aNKXzt8sv3XD+hbOdIei1plfIffGDtfou+6zgNc45GppnOqddbIVjXBboyTaeUQUyg47Ojufh6lvtMqOUhRbbbiNaMT7u08EQh11fnFhiWePN8X3pKGcQKcrehQ65Fb7EWvPhkvDUYj7Y1W8zJRUXFwqeXX3zIx+MH7xqx77bAvkuDmBbFBWL+a2+1j3z8ibenJNPOcUZj7WCPX2HTmZ0sHEVXjYayMDKIeQ6buL3YYDkQC3ycZa7dMVeikr05eqzAkLjJjcPk4m7YrEqokyiCiBlFUEFNsGAaZrVgmFwqGFCL0eaAt36lyRB647qrTvn4xP2QCPudrra4pPryS9Amp75/uT9g2ddix7RntdlGbV0udydmEaHsJhJvAp4GXxNZjZRKceSx8EQfJ3HAKishrMCbR/BovF8pY+ZgFsl7IRDDnZaTW9SM2LMRQkvy7igFwlVPuL1B/7qNNnNk9uFHjHv6uGMq6qvsu07sOwDi/wcI85ql4ocfnn/snHmtJ1kdg4fG09qCMCbJq3WUoJIHcNF+lC2xDGJuZKD9JBP0c51PZIjljUlZac7s4z60fF7Sf2VbjXEgyOBKGjuAoIdF9jADeN0QKcfAqKDbok2t6u5YN+voI3d76ahDBrfsPrp3Bfq+/FayvPdJfe37H827qKRq5BhvJFMhKY15ap1V8CPBJGoRLtA7R2lHbtInmSQqxSGnjLcvJ7HwwWPi7CA8LBF1LFH2mZr5KVYWSa2S1oQGdJMlzia2eCcTrHoqIbBCuxWedIenu3P1+vFjHc9fdNGEt/eq6xsN+71x/u7ylrjnIm8KS5ZXX/eMfvrZjy4OhHXjqoeMKXR7I1be/5RbqR4aTbxkQuJt1KyebV2k5vWcWJuCkmEUL2Z7l8nFpGYLLjaAf6dRflGbCkDaz/CylgSNbRO6rBLREEtFQp7SAtvGhg3Llg6psb983NGTF194qrl7R28KTLJUvPGmVPH+p4uPbG4LHl5QVlnr8gXLBQ1aRzBRAbImIMmQqD+mAkLSlaiTPEHFm/ZBaAUHEgm7zV+TfgqfS01NoCg9EYhJkJDnEXhJDlpZ5F7zEy7rydA/qQQlQdJdKfnbmla7nXbp25NP2OuRY4/RrqmyDUgi9dwHAyDeCio+/CZQ++LL3xz6xRcNx9cNO3hYqytdIKEvWY1upYyICXlwhRMZL7pmUEpBF5QIFpFsjdJ8AxOQqR7KNynfwGra5ly3K4WPXPZW3sSI+Xg5ikosMuWQW3ZO7RQiDpPF1Vi/utGgjX507JETXzvxhPyNY8t2jFVe0iQZn3t+07C33p13HlM6xw0buQeV4ErJ7ZfdCBlkMjWVrCkSUWrEuviuEn3ZIkQHvzelIysXzNuEFfBLqIkfHxn8m4hXNLI2I5FErALjUfJAwTSgdAddrTCsO5oYivLV7Q0bv26YMD7/tRNOGPvq/vurmiHkv0tlnn/OoT0A4m2s0uLVmYKly4K1997/wZ+LyvYY5fYLmPuDzazPMF/cxTQmuJTkM2KEJoGY+NX0pTxmhva47DQraEQIQEBWl0AsW6IsLxjWRkXkETyUa17DlSQ3k1v9bGInAw3kAofdG/C0dna0Lls4cWze9Cuu2G8paJvbNVae+ZFUMu2Zt45q7YgfXD14wrA0sxauWN1oy8+v5F4Dr5ShWEsqG1QzpyHcBMKEimJYmbhBOQCKhZVYD3kN5MWVy01E6MiBmATu6DCDF0O/j/eYgOChSZOH/BcBOh11mjPN7S0LNpxz5uTbJ0/WrB4zfMD6bgvQAyD+iaMOtE3x8y9Y3cOPfXiF26udoNTm1USwuwmIPvQ+WqyoYyKWI7kXEjFXpmjqPLmH5EQijsbPiO1F9VJ5zg9lqAnIsnvOs7PEw86CWI4JSaSP4msiOqCMlYBlwqiSPIshbDGmO5saF64LBdZ9etJJ+77xl+snbSr4jbK5y5sl49PPrhv2+ewFR2v1eXvrTMWD2l3RonhKo3AWlMPVp3ieQCz3W1OIQJMp6d/UDZZkDvm9QP+AhgHS0Due0AOphd4f9zK4UyIrU3I2FiWvKInFFTqMLOALM4sJs7ZQoNcp9KBdu5qdNs/Hl146/v6xo1iL07BjPI+fY+X6wmMGQPwz7tLGgOT8333fHjTnm/oTBXXRyETCWGkwFqoDIYjmYeQlz87ycSJUEgEji8wOT24B4Cid0OcMucrYtpz8wLnasoKFitdP5TopCaQTWYLqz6QBlUG8mI6LqI1CzC0RhSqFmxn0MU9Bvmq9JHV96Pcs//afN5228JCJRV0/42187yGYtCAsX+kpu+XWd47UGofsAVmbcd5AvFwS9UYj2vjiGN7ucvswUMwme9I8Z0z0UxnIFDoQGSMt5fNDh8bfMEzP4K2dhFnq9tqc7EMWm2Rns1JHOPH4AUchQzpswHxfI1pDmyJqVaglFXOv22Ny1Yxrr62cVWoSdngO4Jeu2874+AEQ/8y7Atqm+Np7a+qemf7NFel0zQQpVTUKrXaqGKbxEUmBaIMUz/LyCM14yhIfeIkFdWEGITgCM8GXE/ipdkz1Zi4NlAUx7+Ih1hM9iiwxDQwjrrYaLiamX8ANF6HuKLBgPJ30tKSTofXJcGDRtX88+Ymj/sBa85Q/Tx+5IYCmhccah3/5+cYzw0ntJIXKXKpS6xzwEBRJmNUkWV7M91VgVifPLnOyimyJaZgdAVhBPEguTmfKEjNorhWhnTwPEi2MZA8uErYjphaU4LNtnFw7mtYCltqosOI9xiKComU9E9d+fvZ5Ix4++vCKBozL2am1nn/mtumVh/UaiJesdqn1epuhpFwMGvrwDVq0SSp/9KHvTl36XfSYWMwxXGsotPJkjRiQa6F8XjLcZZAUMjTwi1sfbHokwzh9E5aM45qDmNxpslhwM3vGxAQTah6gXluQKGR2F4CMhBAnnqDWDHJSGl92Q1LM4+5eu3jYyMz0yy4/cPmBI0XXtnYO2jOVn8/1Vv7vnvdO8XWXHmUwDarDJA1TIpkWqS2TMkYSScSit48ATKN9iUdOiSwOXABZSYk7flTJErKUuKP3KcEtpiy0nLgiZVCqC+O90ouBxyHy2J9iZhpiJrd0YtZ0OBP1d6vVgY2jRltenHJZ8dtDSvo2cSMAEceGBqavrGIBM41c7IWr10B8879fGd7U5B55yVUXLB5cp2qPQrO7GBmMXniP2/1PdAQl+1uvh0e/9PLCi6PJ6n1STF+ELh4AOcR1kClxRZrGRGrg84K48BtlrOVB6TIQqJaK7ZwFMW187k7nGgBgeYl6mElhFCsUGrUqKHcqEIPGY2jSoMmNCfC88ftqpTedivnjIV+D2ZD49tADh7x05pnOTZXWLfOioDSpgOiI/e6710z+4JPV59ictcMUGoMzkRbtybga5V1qGYTDi4Z6pQpQBcWU5IzACsUhkpWL5UAmxppc6+YHEWXj8cHjfHq/9BWflUTAJstM41YQHyMZJirQ/okSGiUBURtOCckC5LJDHXrt6vdOPmXUI0cfq9to6MO0SeRPlNCYsHz1Jat68vHp+9z/wPnP1BRu3+TjtjZyr4A4gk007YmlY5997p0/J6SodNHll8w86ZSyuagiBEv6qLRrNxRE3G5WOeWyz/+VkJzDYYHKIP9jT4H7SyCmcgptZJrcR7EyzVemDb25hgqLytvyyCXlrAgZxNRMwRNA3KVGHEnyNZhCQS51CjVaynqTFKsI0DE8NhwPQajPLJlFRyTQ3elORBpX7Tm56PVTTq39dswY1kg3/q23XEOen/nd6d6AbU+DZVA1BtTZokJAAQKybOmp2YB6cuFFiGgyUOKFJTJEcQzLsjf8dcovkw4e2jS8l5cOJE6blMfeyJBGdxfDLFAKB6gejq/IA1Gh4UEEiFUSmj4yKo8yZfCJCteyRx4a8w+7g7UatX23dOTJSEaobOZNnbr+pO++de0dCXUEXnr1hGvzDcI2vaLtaVmyBcDt+ZQ/fi5olykzkt2k1VZXBP1e279ueaZ8yfJj5lx15agnYCWoabvPNcY7DDxm2+BKSZc9+kTLPi++8PWlYHqNkFK6snA4gspTmOUV2ZnH50bmtYAT/VMRksvFJEaAJZXCB4ZhU3cOyekCqVmhe4oX6WtyRZHP5mKQUR53K9GGx9v2kDxKEV0ZP9cZ0eWDh3bHvQalCLibi3Qr10RL77jtmyalMu5JJTPAn8aRlIqrVTqDI5yMWzEwDgIZACEUSWRfiEpG5EwjM47yUQpqoARJNTqF+BAqegmcD03ic3JiDoaHf44lk8wIgcBUMsSi8BL0BurRtvC2TgkHVSzpZinI8EhJzLUymMKpUMAnMdd3J5489t5zzipeahZ37q6t/w8Z3RnJ+sZbbP9PPp13gqs9Va1l5XbcvPpEnE7v3rl6BcTgrqPX3gG3zaGyWgscKYWv+NMv1pTN/XbRiGsvOfx+APkrALlP6k7li4IfU/3eP3D/U9f861+f/C3qU481aQ1VJrXFFMYgdJvRygLeMETbMNlAtECWJgBRe4mZTLBaGP2XAUY2K4tweVzZX6XEETVMULaXPiPTJCeSeIwty9zzIel82Bh9G664mNKlMgoQRQ35iYy5DuhNp9KYVITkMDClIiUS2dJnG+55KVu2pJwMyj/LsW9O9ZPyyrLVpRg4p/hJQCYSC8rmmIfl9XmYEZpi+U4jDi1k0ROkPqlmfug8F+bD0mtYEPG8t61xhWvo4LzP/nT9ng8OGsxacc97JWbcEVBqjScQbKjs9z3UdOqyZb7j4ZVVacQSg0pdLiUSKT2VFHvr6h0Qg7CkgDp/JKIWRaNFb88r1MbSUUMg2Gp6+MnPjV/NyZvdmZDuw7xnr40CqD52OWXp0/Vo17vikanNhz0z49OLTKaaoXZDUVEqqlKWWM3MF4A+Mjqi7E4TxPqCrLUTFtpoYVrByEs0XEuZT7wnIHOccsvIwZNrcSQBOdmZlT8oyw15ET6WBCLplAXPkDtPFhMtA4h0VZT9gqC+XMKiPl9KQlGLJMpX/KI6N+/Soj+aHYHD/wpeUZb7vNl95nI48t+V2/yRYoMkkdlaBv1uBnH2GNMaEPWngywJcYXSPDuTYgJyZkGPK7Dom3POmXjXBefVrkW/L15s371QqVCuXscGPfPM4gubWpQHdLkzg1SiTa9XF5BP5U2k1Tqe8+ulq1dAjE4y3El4kWo9Gsf16hjE0QQMzLLlV5uj/q7dF68IFB989JOD//n3C+7CAq11CH1ToxlC5KHmiPT+5Annrfznze/9I+hSjLfaKkv9XV6dxYFyEf7X3LYS3T8aVlhWxILeKCc/UNIri6gsr1o2jLLNRd2Y21qZ5UVtfvLXsj0WaMA6bR3E05yAAaCTPE4GzQj8CACIZdzT75N7TE0ZeCxPWBEgqUFjy5QFTvXmHr28B0l9I0sBzR4e2UOEymI0o1AFT0CJ0SlwKVLw8SlcMGj1LB7pTkT8zd2ZaLi9sEj59Z23nn73biOElj+e30s7ewf9GRzUphdeiY5/7dVFf4rGzaPyiqqdBksEnZLkPetp6ogmkcqoebmtl65eATGosApfIGCMp+KC1gRnDad0HPGTgnw8db5CqS6oSiZ02mtvePCOo44c+xwW6m1Ein7UCvscT7ZML1CD7erOgHTdX29cf9WcuasPsRWUlId8XXZJkxJqavOZJxBmbW4XKy2sYlEP2h35zc5Z16y+NRJIfDgc76LvkcSHtSZJexmAVOoh5RE6CCgxRVaXeNqUJaaYlYexQCRZa0o0yZK8JHDASNaLS/FymytbdRm/3KXPieeTO03fzeluc/83e1u4Lpndwtau38jybCZWVmxnHY3tcOtZym4xtLS3rViw//75993wl31W5usEDMDquxeEJBSr1rGKv/x1yWlLloSO1RtGjjCYLDo/NncYhxel81Q4HNWCWqnQpJPEsu2td9srINaA2KNQQVglFRXETEKhNSNbi10SRXY0mlCx9rZuVuhEGqjQoJ89u9FyxDcP7vG/f195rx9SF5Y+WnZAYrfz/ntq73jquYrP3v1oztmezo4RRr1zkN8PaheyzRa7HcohQaZHlllB6ufZcTF8nAmPf7NjVrn1ld1cfqLxWDTbq0sdU8j4chBD15lE6UhJhEpGlBYjWykA2FRdJg43AZbATkAm9pV8EMgDzHJXzyi1Zyuh/POe5oVIKRmGgeBs0NAa1tq8hrnWr0/VFJZ5gl0tLvzxr+649dS79tqbNRv6eNOCNyaZX3/NUzfzpblX+QK28UbriEpBtGhp2RJolSSKD2pmWFvU75F9VGpScVGbpa71ApJ7BcSUeLVYtWGjSZXOCFEpHA3hvwEWQrFYpS5mztISFvT7UdqwWlBTGZ9JWeyXXHyf9bwzD57W2CktrygQMHWrb13lRdxHDYQk6dOh4/fa8OwLXx81b3HHcUmhqE5SaQsV6B3OL4ZL7WqURQW4iQNLKmsVcyNYBQ5wWeJHtpXkTsvxMydgwC1WAKjIQMNgA5BK2d0m150riVAWmmeUs+wwjAulRgYlJ40Ql5tAvIXj3BPEuZh48wGSc4w4M0228naonyxevpiVFhhD1YMczd0d8xbvu3/t9MsuGLt8aHHfHr7e1iKJcHZK/3Nb2x++mNtwisE6YUh+Yb49hNbROEpw6RgYAsgBaJHM0UC0IIVBUIl4UkhJwQREFHstadcrIKZ9E4yEtZEkLLFGzW2KBr2pegMa4qGf5PN4kL2F0DqMg0GXp0gntTXOIqv5yRlflnz+9YJZXyxMPT9hvLLJ2AcTInjNhML6jV7p2edfblv91rvfXRyIJeusZiEvE07lEyxJ2pUexjPSCKY4WLklzuabcomtLHBko0jtiuT5ykkxAQkxYkJl8HsEPt4KSZMgyeWm+DobpAnUAwjQ8plGdPGOKrLQuUOSS+tygPOLJ7GoaYG6q8j6UtzNaR/4YYaFPRvCIyu1HX5fYyemyy286uKDHz7+aNt6jErptU28I473hmbJ0trFiv9648f/UuuHDHfk7zYY9XURc/lYFOw2SYVymkmD5g0PSnFYPx0NFEB9n4eKmAeFGW874nVt7Tl7BcR4N4KoNECnnZrJQWggekESfbRwRTJSiFnUtCHlECKC3lKagBSNSHkK63BLQ3fIefGfnh12xmmHPA0pnbl4wb6+uEFqbIIPUwI/339M8foXXnxzz+Ur3j+a6asnKM17VLT5UqKQ9oKVRWBLMA14y1qM58wkARqc+OTEclkbWiAuPicrZJDrTIwwhGs8kYWUMLe6IvAj31j+m/xDdp/lJ6ImCwluNCXBJDToZ4jHTE34BHR8P0Mi+dzNVrJgJIYJgxAvMGJ+FVQ84tDjVmEMjgDOs02bDKkDK79TBZrn7j1uMAgmB28cVSd0X9hbu3cH/Z3VrVLxtBfb9nj59bkXF5VMGByTTAVSMimmad1wkKnQb8qr6qDBGVE/E7D2CXiVNJFRJ2qw1/UYS9DPLDE/kymWI3VIXoukRAvJvtJpTnkgAjBiC656gawItwI0X0ejNhrzhigzDtuDU98tn/tt6ee3/uvIaUh8NSET3OcIIjquCscaogGp6/mZn2185JlZl4ZjtoTdMawmldSpM8k4c+SBvBFJQBS9Ay6aBjEWlYIohqW1o84hmQhCYSYRMKhkxONpXpkjgGeLUARsXm/OCvQhDuYY5XVm+j25zsuPhqylz3UZwQPH4SpnxI02FYAbZR1d3cxZ5ICEUB5ieX9CVPqiXd7GhjFO/xunnbzfm0efNHjT7f/cQajqpacNpSTVx1+w2iuufe9qX0g/pqx2r+pwVO2kUIVvVb4z5eF7lHXgHg/3bABuPnBPztjDS1HCwem1/HSvWOKsSeB2YKv3Y7O7KG8cHqvx/xIzSMHcrkB+UclQQ3tHt/mMM+6rOP+cI58CkOcjCgz0xREdOrMQBkNk4fAJ+//95vvfuKjTt3xvtaJwpEZrsvk9XdgeGAVj04IFBePKxQHoNtEGouwymFtkdWmFOHMqW2POEkPkQ5JAKIOU16C5G5wVG8jN9+WlI7iAqP+RmgZ1Xcl8Z9nqE6WTT7EwwsKEvayitoT53TEW8UjJArPVnZFalw4ZbnjpT+ef8sHwob1DL9yRWG73SPZ771816rOvVp2p0BaPE0UdDlbBzMOJnEOTXVF5G+dQKmfvf3D1aijRmyDe6rulN8959vQPbrJzQCb/ESNV4mlWUTGEuTubDGgZr8vPG2p59LF3SufOrfzikbuPf1KKSW2Ctu8RRCxOjramBrd0z70PLvjmy89XnStYK4frlNri9m6/JYVGCpuzCHpWVP+VSz70oSYLiqwJKrQ865zi+TOyDtRkn+1OkGEsl47oc64kxPcarS8BlH4GtxncbB7/ZlVHZNkcuRGDiCDhoA8uooq1NrWymtLq9rgi2BXyblxz0ZQDbzv5WLbOoup7HlFPwAXCknLhd6z8uus+Pq+lMzherS8exgRbcVVVjbqhxQunJQdQSlDIe1OWYspVP384t3pHHjVbf+7eAjGH6NZegiwmTptIHpDFEyf8gfIJmEZcSOqKKo0Dw8ElBop/UX7hWFOnK2I+5tgnB91304V3dzVIm/Iq+6Z8S6VT8MZT0iez9hlaf+c9r13i91bsW+gcXuNLBlFXR7yqlkcaK5NmNBDQxEWCMdVtad0ANEjGcsBlxfe4a81LShT7yukpSkKRveaRHKdwEtcTVpZ0sVM2nrmW0ApJ0xfSOFtIyI73BCMm1mmqWBLtyxaN0l2/cvG6A/d13nvdlQfOGVQsuKf0/n7drn8xkpD0j0ztGjfrs3WXRuI66GmbykR1sVWFyYorVjfgEC1myRSBl9ZaFn+QQ78cmPmd2dpr4rt6u77Yn3iy3gIxd9C2+sZ4JpRrQ/Ah4LJVyGZqEUMbLTbW1e5GQ7zICvKrsIYR8HM7jJmkYoRWKLBNueZxx+UXnfQ4JjjMxsiebp2i77U3akRCFQgifumfN9+24ogv5y89z14yuCqcYs4Y5qTIzfY43MDO4plhdDRR8kngmeUs95k33MuzkyXSsgIQeZ9y9kBEm6vclM83o2xlaanJzZbXnD7Tc1EJCveBN/KLKY1KFUZtwSWl3Mv/eM1Rd5xyDFth0/Zt6xvNSMKy5az0kivf+8PatcpjS8sn1EX9wQJQSkV/GKDEtInyqsGssbmFgdCxGbSy8K4c7Ml5nmwG/8cA65fuNL3NH7vTfBGyXGG+gWRA84vHIeiSgZRrUWkRrHCMtXd5mNWoY2ZbMcatJBQGrarMr3Oa7pj+Xv4bc6wLLp9y+OOoyy5HWadPjvMosAheNIO8+PpHhkVPPb3iColV7paJ5g9Fws/AVGBmYWpEmgBGmSdO0MiWiqjUBKXIHGkDcwO5peWi93TxsTIkwZ4djUJdS7zBAhCHpA6fe0RuOpFB8PRimgTvjXDak76Yv3713nsUPXHeOXvPGlLO2sGi69UNur2tmSsqme5/tHX4hx+uvTwSzRtfUjG8qL0raFVprejdpvVAoU6rgTRRNysqKWGBoD/7EuSSXi4XIX9z1wLxtm88ZyjloCsnZWSuEf0DfFzUUrrcbcyCiQwW0cw8HjczCXoMqzYxN2p0aAeymoxDNRvdHYZb//eqc/Xq0TM7uqVvC6ysRfiNInLbewP9nOdDoo6M5xooiNz22BPL9l+6pOv8lGQdhrnKNnCUdXKiBQDk858g2M5BSsJ0MqDl4dxynZc+c5+ODkte283VgGlDUrUANpmsORX95PoVWp2o3sw8ikyoW6XwrLr06t3/us+erKHSzOmkffqatbSz8oabv9pn/reBs1Tq6jHFJUOdm9pdTAf97AQJNgC8KRxu1FJJbZ8+fzcxVmXrm3WQObc8u+byPzZnvXquTa+50vRHe8WdpspSBiyGdBqVNiIn0ebCN2nINx1+FL9xBURK1fP/yUR++hftR7VGjYX18c2opxY+UA0xC4+PFI3RplUodAZb8aB4LOl48fX68kXfNM4979Tdn5Li0jJB0ze1msZjtm5Ykl6eObNpxRtvrbu4tcNxiMVRUxVVhMRQyg9vN4LJgGALKXRo3ud0DCJrQU4HBAzULNGZgOkVeqKByJRMgJzX6LHgVJ5SQViAdLQiFPOB8aXGMll1prgQFYKeznWbdhtveeaKyya9Pr6u77HlfnjSNHslw6zPUoPu+d+ii9c2JHY32YdVYBqmrTXoZTqLXk4I4gN5eB7KCTQyBhRKLmNCXg6dg1kCjCylTZ4QpfEBIMgYpagHG7IeRK6jpRZFlJR7Eca9AuLc2bXVYxyWWCYT0cKQxcjqMvHcKtFDKEFDOk+wMhTD8SehcguWHllUWkBqUE9D3F3SmG3RoGhbUd/tePKFpfYlq2yvxJLSxzg4ojpt33MDoUVGVnn5hkbp1rv+s65h7uJFxzkqqkv8sXBBd8CtzXcW0MBPmFMFJHv8KEdhfq/JwJx5NmwqBaY7hrCxMpjniwHd0MsOwLKk0K2u1+ihyKFnCSQN7Q4za2lrZGa70SOlujui/o76c06ZdN9ll9jnmdR9f87Rkg1S0dQnGiZ9Mst1dYIVjy4qz7eiE1gRxohU0YQuBYzqIbkkOe/AKRz4LDuO8iSP3N7MxsGbXWgZpbxuT3gmA7TF3+zVkKO3QExvijbk997c5pokX4/vH105yNGJJicUZAqIXE6hxaWZwBlmg5UOx5HwSWEMCtQHJChd+BPpioUbE5b6Lnfdetd3k6dcMPZZaCBtQB9rlra01eNkp/3moAqhE1b5gTc/sH18y13v3aDWVY0aXju0yOdJOoPdGYBSzcwmLYa/QXkLFiQU6UR8h1nL0OYSUCKJRIKwEH5mMKCN3QCZHxiZTBw1Yrg5na1N8bqawo62+o0+szU++857D7t34kjWqOuDHWQ9b6A7IBlnfSYNuvGvX1zu8VvGZJTVdRab0widehxu3SyJGrhZpUV6gRhruW2Z85Xlz5sjXo7T72eh5XBP/oscyN+/+i2Iczn6H7zfXF34h++b+LzZyQN8pbL/4QtHPrk888cAdxKEVWhCobaJOFFlNDODWADKosKaENMjP5i3yrlo7ct1F5wz+RH0Ks/rq73KsMp0AC1b0S798dY75529cPnCwxy2obVmc2k5Wds4LHEi7sZBBu8FAgwKtNFQqKKCwgZltRU0cgUUzngUwUpUx0yqImhKG8JSYOOmlQve2njWKUc99pc/ls92KPu+9cWBbfzvXWv3/ejjpitCcdNwa35FgU5vV/tAfAZ/HxRShCEAcDwSQlghM616Xj3TVZxrLkP1+/uWnCTuYn/f+OQm1/wY1zvORvSWJc4yDH7cY8k7eDZLxGzpY5UXiJoA5Lqn7G7LFjjDsw3ymFHJB64waqcKkRrdwzhhk6Bki9C40rFYWlSpbVXl/pRL/7+pn+ct/q78o3kbpZdGVLMGZLD7HG2TtsGIIsHVnZYenDGzcc6LLyy9xtWR0DicFQUGsxHU6W5k86NMA/kfJZEUsF6kdUWxMuldSUC1BslBjckZyYSFdFfLpvbBtezF+2+7bMbY0awZnkqvWpDtva0DKUm3fCkrP/rIObekFGKxxlFRqRMdBTjCVJGMiynUSWZSQ32UEqkgEQlQRUEyOutGb4GuDFz5a7mvmi4Ca9btzoKenkdCKY7ncba402n8u1c1s3sTxGRJqHhJH9kGVgIlxSAy75fHItn6G5eB4awkIuLLOk+5lj2qsFAtk74HWWQu5YqVgzVKsBgGdKHbBKtPw7+1zGKxsFjI5sR4FOOnXzcWrF83Y9gFZx37OOSAlheo+2arHKwlHUDffPOd5P73fxf/o9PTODIYihQbTEa7VtApAxGUopCcsdocLBzGwQa5CR2ss0GnZZFAxOsJNHaWFwrrxw4vef6v1w15z6Lv2w37BDFPSrL88451R8362HcFEle1Cl1Gr9SpdJhqCW8E7GekDnTo3ZYg9g91fFm9EwJGlI0mzr7cNZYDbo7W0POYyZU+c73+lPSS92jPC9uQNnO831liE9pq7nwiThsvgI8QPmzyG6dyCFEA5ekC8oG3ZXEUJDjO1SDlnlg+gZ6LvKFUkvViRIid44jlBHSiIyqQuYb6DVPp4VpjQHgk4uXnglLUaM0FI2p8iaD59oc/qvhm5bj3l7il54rVrDXf3Ddj5d3HCuvX+6Q/PvPimr3ee2ftuZ4u60izeXCZSVUDeWdYYMyGUiNGVqEuosbBlgj6QhE0MDvzYrOPOtky7czjjCthfXtNgeJ7u307fQHrq/l8Dqs8/pQ3r4BCzCCFTZUXVga08aheR0L1Bms+wowQ86LdNQ29bptewfKsWBfss2CUxuZA5B/7jCwtb8HsAeYc341P6OD7LRv68a+JEEPcdSLQbE5s0cR1VKt490ivrWtvWWJkQ/1eFfN9q5T0ZhAWNKIipqfEFImpy2k9WQI1d1FumoTduOriZpd6S7YQA0W4gwPcIs1Pv42SStZ2k56UADnYVBTxD07ZOBoGBMHA9ZAVKk2eUWs3LFjaYT/zgoVjXn7k5L+1u6XOItAft9O+6tWnqbUKXW1p6b0hlYWNr7yydMratfV7GgyDytU6u9HbHlKS6qSUTsRgrQM6nW/T8ceOvfuCC5xfDLII3Vf16ivd/n8MXUeGW/6z6aDFy7rOSGZKR4RjYqG90Gnp8iYUGsjJWFA+8nphM5AvsZjMzOS0wOHzQ4Wzm8+2EtUoL0EPrGdcuyXClfciWWcCLHcSN2eq6SckviBbbBJmEBUJSJilPBrB1aEQujfA0vca4ajXqlntfkn57EvNQ19967OTu7oTh5ospYN0Opu9saWZlZUPAkdaA6WPNNPqIRIQ9LAwZE9LyovAm/ZnV2+Lu0NLyGVUKbn1g8QCl3flFp78Jd4UtsXtyR0S/DFpqJml3N2Nzc0Xn3fk4xdfan5Lo2LddrldsE9eK+qlwpkvLJ781jurzo3E8msrq8Y4ySo0Ny1vryiT5l104f4PHH2kuK6vz/jFqBRx2QpWMu3ppadtbM4cnpTMg3Ho2yHSTZ3puO/yaBm6iHMgz1OW6aRy2TInXgRDwZVQaLidDFiu78tnQ8sgJgoNjbKhyRgKWAsFBPGS6IOPxsC0xiA4DeqX8bAbxiHQHI20LrVbMl9fcPZBL594hGpTb22iXgNx7g3Nmi+V3P/wm39YtLT+MIutfHhxyfDCDRva9BosiM1hZ26/lys06sxa1h3wYPHkmENOuXzf5cnykuR63jYuDuJtXHQQoP0+Fgl0NOc7Q9/cfssf7hk9jG20KfpuhralW9J+NddX/c77q49YsLB+nzTGPJxz3jFPnHOm/Vs0W4Di1rcvd1yyvvx6ZChkga9MSfbhKn1ZJdJ1Zr47OMMC9jE7BI6DeLOSKAG55z6hf1MoRr6wrKIiGwYZxLnElsViYB5vF0RL/KyouJShrMx8vjgzGwuhVooea2MmomTe5oBv43d77VEz45qrBi+ymZkLveO9liTsdRDTwnbEJf1zzzcNm/70J+d6fcVHFpUPKkmwFlU05eZkha7uMAuFRFZZOYwFwhRC0wJnNZizjBluaPmN++m1+ikQU0ItlnBTj09SLzg9LB5YedZpkx874xTzVxhq0AWRvj5rlRc3SpZFS9ZaCvPyMyNG2FxVfTTuzx05oaSkcoHOfOt/vjvxm/n1hxWUDKmJJsUCQTAayJJuBm8OzLn2y54g5kjfAmTe3skFKnJhHAGaEqly6YhYg/FUEML4Kky5UDPIdzKd1sLUKhtrafKzypI8Xyq8epVR4//6/PMOmHbwAazdou79JOHvAuLcjZm9Wir+7/2rT1q1ru1kSfQUqg1StcvTDRfYwKyWKhYKI60lImbByUhuEDlHXGuZN8fLN4SmGfzU9VMgpnY7tQVc2TDKU7E8JiYwpz7dXZ9vCy64/bZj/1tTyRoLdX1zMkXftrfff/VIXhnffpcNv/fB9/6SEqy1zqKqwnA8bMcuACUlJ5qQtcC/AMTEqlSR4CBRUklUn1Q5+AB4uZRJHWIKZLZp3E4CAnAlaIhwuVzM7/eGqisq25o2LVm751jnE5dfPGZBaTHrdPxOrMDfFcR0q9ahtvfP2+ZN+PKzlWebjEWTMEmvJJlKOVQY5JVM0cmIZASfOk8TBrG41AfLOa5y8i9H9t/Wpv0pEGdIUF2rYGFkLSVwX3U4PFhYCyKE2hPxb1p14Xn7PHDJFNsHwaAvWma29Vq2sT8B8Le8F3R0iRsbWMn99y8986uvfScUFI2t0VnMRpevTRFjLgySA0sNg+p4i2UP8MputXx9z53u+WIoX4LtpAVtkPaWlDGRcrQ8JUMZQYnOh72FWctE6U2qmdNSAaOCoXCKYHcoumF1mm387MzT93/+5CMqmiqMv+9Ei98dxLSuTeiB+2IOq773v6+c4Xan9srLL6sKxcIVgWBMZTBCEBIg5u10nMua7YXN1pVlbcieHJvvb5ufBDHefQCnrBaUxVjMxyw6G/N3oodZtLFSpyO5esUnDcOHxd579KEz7i11sHYQRPrciJnfAqLf83dbIpJlybJk+dSpcy5vd5n2ykglVSqtQx+FGCBUFjEuJsmS+LeY3uIObx6I/nNAjDdH0y20IArRIUA6WiQ+SIIIfFY05isTHTMezkC0EErKKHYY9UK7P7ByUXUNe+Xyq/b97MDBO8cs5Z0CxLnNsjYsWaY+vH7kW28uPl8QiiabbYWl0UTQlAZxgy65KI8F58EwlZ1pTlFPudUfb7v/zxKTVHMkkWR5zlLW0tDOXSafO4Cnl1ih3Q6OSMyzad3sDTdcd8S/ppxX8FV3R3ekugjaaQPXDlkBcMSV7iBzzpjh2+/Jp764qqB0bJXZmmcJxDz6YNSH+NSEJg4R/eVqZIfR9JKh4e1yNSdngeXP8i3aCq958+tWpjVovYSnR+x8zJem2dIkTcRbOjE0nQyHGkKFiajHl0q0btBrXJ+dcPyI6SefVNSCSR9UE94prp0KxLQi4Dcr3nmLVT3z7DenNzSHDjRYzFVoyClLK6EmxWfgUuySk54BoR8p/l+bnabYxxsJMBDjQQhQMw1a97y+Ts7yoib6WCDFSu2Qp4m4k52tXyybONbw0U03HvPs0BrFenCZt50S3ylubd97ERB00L37YXzYE9O/vKKpRbNbUfm4ClRy9CHwwtWGKFovUe7BUC8BogVqBn48XOEMcYeyXJ1fCmIFPDxF2i6DXUTtGNY3zYX84fWlrDQ1I65SJDuj4frlNRWRF087dcKs4/cVd7pBBjsdiHNbb1Wb5Hjk0VWj3/1w9ZSK6vGTgql4oTfs11PYiomgaLvTMT0kXTXQU05CqRu9yvxXqRmA/k0WmATqc9/f+pZGbhKUTYqr6WAgdypN4yr4g+W6dDwUZ3lE3Qx6056ONW3DBum/OPfcfR477DDbkhLNznMa9z3IbnnFiH0Vbg8rnvlceL+33103xRsShxhsFhPo7+iZhGXks6YwwQIMKdLGpnkXfJIjgQ9svdxsjG2tAU3BoHnQlJwi8ovBAE1v7BM/xrAm4hoMUsef0dD8Z+pxB/0IG0xIi2GjNr2py7V4zlmnT3r4hONMDYOsvZ95/jn3dacFMb349pgkfvQJG/zP256+OJYx7lYxeHhZm7erOI6bqVabeXkg5u9iOjX4WpjORzeLbgJ9TmL4dQycYbpp27y5yHqL2CfcnaIuH6S8qZubPsszgdHmh+mNGbjWihROZ7jdIU9Tt9kSmH/UMYOnn3rS6HnjCoSWn7PQA4/Z+grA89J+MKt70KuvrJ2ycZ20t0JVOVhnchoELXrFcUYmwLDiRyoSWErEv8R5phE0SgzO5EKKGA2LOvE2l5fcaQKsCgPVaV/QoU6f6fth6HtXUgmiyYPWTcyMNhvAbqPKR6RDpfCviEfXz7nxz0c8MXoka6sy9l7d95fulZ0axLk3s9ov2a//83tHzZ7bekbloL2HdQdiRZG4T2m1gjFDqhSQVCVXKg56dhRUS7pBOp2Of1ADwDZBDM6sRsI0A6LWoa80hVOfhnBz1UeKjXDf6Dm83gB4yAZwbvM42TPg6wyIyuDGfEfs28vO3/Phw/ZzroH2VJ+tKf/STbM9Ht8ckpRaAzM89Gjo4Dnzms7aUN9UZ7E78xwFpdZIPKUIBJFcAmDVaBmkTapE2KQEVwDHMz7DavIxZvgKw+koq/zjS052itgbtCfoPtJBHw7Jo5GhvsEi8OAklQRLbEVjhBEHujKVSnR3RsIrv95nH8s91/5xQn2dSejeHu93Rz5HnwAxLUAn5o488YxrzP/uff0yi71mlBVTFKOJeGEsCqlVCKDTTSGrSxY4Eonwrym2JWD/XBDzrCSKFxzIJBcES5xTHcEBjXoiBmehlU+NHuYYspbRwMZ2rbhi7rln7Hf/JRdNWIKpFH16fOeO3Gg9nxvWV7WhnpU/8tg3J69YYT45pXDWqPVJHaYJinGIO4QxOkapMDIDpGNT8ILkQetRgBdCEBzE8r3gI1zRS5jrQvr+65dBrEOeI7cf6HCPRuIc0LRXun1dzOoEpz6djsLJBqW6s12n8s8/44zd7jv9ZOU69J73ibxHnwEx3RDcfGF1Pcu/6W/PHNu0STwGYB6dUotOZJc1pHEk63bJ5A+5vxPl+5+kXZI7bcwSR2RRASKAcLE5PuYEzeNatO9hQFYaLY5cZBLp7Aw0oHWKSlDv4NgFv+0Ule2rigus8/941dHPjB7BNtkVfVNtszdA3JWWzG+9nRr57AtvndveqRhfVLxfdTKtt4QTXswy8oP+jDYVA2JUBUTrcE8ZAZfGhmb1r4iYIWRgnfHBJ07xltMeTtBm9lWW+wxuNO0DUuag56N/0+FOB397awMrLbX7RUWoIeBv/HboEOvzl07ZbeWkGkEW++4jV58CcW5NodygefihdaOee+HLc0LKgj015oJKuEpWcpso5qGEFoGXrHLPwv/W7gmJ9dElk+Tp4OVUsM30OxVAHE9Aq0oKM1FDMbcOiQ8Mn41aSP2PFTvpdz2Rtpb17YlI+7rrrj7rgbNOsX0b8LJgZdGAi51bc7Cu1K2drPiJ6Q0HffDpotNUGmeVPX9QXixuMNKUjxTUWWi6oFZLh2eG5zNisQgmZ9I4PkpaZvWxSWsN7jMJ3/P7tllQIvuXfgDiaBTTC/VQOkFTBAGYDmVyq0OhCAsF2jx6VfcSg9736QnH7fHi6acUNmJYX5+wvj33cp8EMb2BQFwS5i31Vtxw2xcXdofth+EGleJm5eEGKciFpkwkJTDIrd7WRXEwU5NWAamEZFlh2By8jzlbCU7GocUERjsdCh4fkAm9Ki2mBOqMSJSgFBEN4IxHok1EeUKvDrtD3evWjh1Z+PkN1x797PA61qBVDRBEMA1S98nnbPADj7x5VWO7NKGodHQ5Uzqt3f4gB648CA6fyQMi1UjEvtQnTocxzaOihtU0gTBLieRzpXDvqCuJaBrEvPoe4SerCkPfjcVk9zmNxBXtBZKnDQQCCRz2vopyxddW/aonLjxn38X7jNC6+ojh/dHL7LMgzr2TloRkuuu+9gNfe+2DE9UaywhnQVmZPxC3J7AZLKRsEYVccvZ0pjcry63InaAkSCChtMDHnXD6nvxBZQyZmw2ZTNSRSYiA3DslhkmLyIQzETEz82FjoNE+AkI8epVFyAMZtEkk2kJxd+eapgKHYs5Jx+3z1Dlnli0yirtmKSqWksRIklluvXPBUa+/980pjry6Gnv+0GJXV8IYiaiZzWZFxgrZZxB3SLwvjtmgGqyx0UiN+pDeDaMfHMqcFPtS8z3dJ6LK0tgaCfRbaikkxhUxr4jnLGtuy6evnMugMa9oIYSObMhPskXQBlUr3B1tm1rNFsWCww6tm3b5lPyVpX1c2aTPg5huFUgCqk9mBar/fstjpwcilt3UhqJRgtpchMG6aC1VQWdKAsCQwECJKAlQa6kvFAAlSx2HVEsGp3x2FGAPkMvaX4rsQC2+kbIC7PKAMrmVjQZ75/TAuEWnXlWQDzBhuUMphFaPG1X53rlnD32zrpY1IvG1y2Swo5hz9Nq7bPzDT8/+S0xhrk6IQh6sqQ3rhbAXwANbihpZBBHVBGq6xyEqt5rKIKS6MG8R5ONwZbqtPJ2Q6voEZJSZ4AFpKKuMCkUSM6moJEWyRBhaBS5BintjJIhnwHwfraRHc0uyMxHuWFmYl3nnxBPGvX/YoeqWvq4rJh9V/eiC0oP+5tu/nfT2h0vOV5sqJsQkfVlK0BoFBVxhyLMUFuQzm0GHNrJ60OmUzOFwInNJUXDO5c7Jr+TE+4g0QiCnx9DkhSztkwOXYmmAFqUounKJsFxbnDxvIRqOR12tGtG/4pILj37otOON89E7t9PQ9XbErccAMgFy1/m33b32rPc+XXOSvqCuKq7QOZKqFPrtaa4vWHaEMwIyPkvwYDiI+Swpas6nxd7SlC9wIUV5iFluuiMnd+B3qP9Xk42NqaKQUaOigJJRBvcsAT+c4mqjBl6SlHIhA9kU9TUuPuqQUY//6Zq6NfZ+RNTpVyCmTQn2j+r9TyODrv3T1CtV2upJjqLhtY0tneayygKoMQQAWlCDSvJZFHVIcteojihbUtmiblkQWcBPiVN9y+ahx6DjhWh5HMSANjpe+AbLZrNlEJONJpcdGynikiyGdFvQs375fnsOe/3mvx/0mg3szv5gAX54CLSHJNv8eaz29ts/+48lb0hJQiEWBaKdGlBmRUnIdRqR0gaNnaHcAw1/o1g4K5ZIbYFpUF4JyDTwjbLSHMDy4SnPjkJtl5+aCH34pBDw3BHupBIWcHEQ9qgQ9yK7LSqJOskSMbQeBbrXNuTnd7xx803HPXvYeLFpRxxev+dz9jsQ02I2eCQBk02sN9z4yYmLlnUcUV41ZtjG5pYSHfh2JouJNbVg4oHZijFOBsw/DmWTWLJ1FfjEdwK1nK1WQiFR/ndOZClrhbn6A4CqJPI9WXDKqhJlk+qX8jPQJlPCUiszEWbUJgNdHWs36hTRRddfd/FjfzjCuMYKf/v3vPnb62+jaUEIxVje4890HPjWOy1X6UyDR3a43QaDhYaXd8H60gQPuM9UHgLg5LnJ8uwoUjOV2XFyPV/OOpOllUt9RK7hHhC1C5JVpkFxXHcNv8fnKAdRPUij7GeFd+XAh4kCYikTT/qkdLBDSLqWHXhg5Yyrr3TMqzDv/MSNX3NP+iWIcwvhAkHktXfqa/9zz4unB8P5e1kcQ4YxhdGphH5pdxCFfjtlP4nWR6c9aXEBxIjVaIOA/M7dOhFJEbqIryuPj+mpk00CfHIzBs3yzYFYtsPyfw3QDPN3d+B5Q8xh1mZiYXerr6t97YEH7PXhn64f++qwYqHx19y4neV3/BFJ1dTCSv/yj4W3rW6QJmnzi0uiioROUoZAWcUaEPUVS6bB4cjru7CgnKOOww+94/iauoVIMZKkWqKYK++TLXPW41FgJjMHPaxwLiaW21ExzRGgDiOnoYbLrEI2W4ojXg6b02JK9KiEaIOoaPwCrKuH9pjMXKWG/lu779cgzm30eY2S8993v7XPN/M7TzNYBk9Q6RzFGoNe7QZjR1TLblsuUUVgVJBES7bkRDOLFPge32N8dAyNDM2ODuVEfFljk+I02cKQRSZjIC8tZURVSKDFIPgnof+VeN7peMSPQ6G1ID/z5RXX7P/o0KHqTYPNfdMqf/LZJuct/37rbxnFvge0h8x1ulKbOoOMfzjZzoLoCCsy2JkmhawwuOcKOiDBVZdAzkiqIMRAhyNEH3h4wgUfIhgUhykWfLoCjVeFyywhO82nPGbrxGSpuVvt45lqva2EbapvQAKLsaqSss5gZ8jX2bSx/pD96p64+sqi2aOr+6f17XmI7xIgpjcM2qbivw/NHfrc899cqtXXTtDqB42IJ0UDUS0p00klCw5m0sCmGJna1KjcBIlsit+U5AqSciIxK2FlBAV5wiRlSlP1srIufGWp3CHnqelKY0phHONDrJBM1YKEHw0GmQ6eAD6SPneXz9XeuOmSSw+/54JLTB9XagSYob51hcKS6bq/fH3KFwsajx2z51Els5esr4spFFpbHt4jVFNSoTB6+NFthr5dJZ+RDI+FWHHo35VBDPeXD0ZHgpBnoHuWiahjSfaQcjmL3OqQl0MWvaWzlY0ePTamzojhdSsXtxY4Au9jZM+0PxylbckT+6/13SVBnHvTHy6TSv93/7vHrloRPbKwZNQwbyRdhn5l1DZgBZA04bEZxWjcGoPdw6y8/EHutWyNIQ+EUb008FuuN8v0P8434HRNOS8j1ylBNoBAuQotk5R1VYsagFcPUMeR8AIpn3SPE2IqHN64duSY6EvnXzDxlf0nFq7ta4O8QbwxfviVNOiGm/93oSV//Fhn8ehBTR3efJpA4YMiJNXcVfwgBBQ5hZI+csMC5HCFl414chEjmCkQAYedH6r4JVKgpJiYDw/gByc+Z6j7TMKo26Sns2OTS8ywpr33rJ5x+imOj/cdIfRZ4savOcJ3GUvcc3E2BSTzzJnrhjw67cOL9JbJ+6QFa41Sk1Rq9CDIJ31IdoW5zjA1oGvQ8piGzjAR7tUiLDNpGieRqME21MCHQ9tLFrTcieabUW6ckNl7lMiRs6vygG++IbO9ymRNlNjhGGbo72hp9pv1oaUXnLP7vaefWvpdkb7vWeV5G6Jld9z+/gnLV7Kj8osOGp8WzdYk8JZC3dwX2oD1ijEzsBcD8UJENtliQEY54+HxMLnUXE0jbZWTg8j6k0SOVpvG/QggYUUsOnoyWPIkgB63MZNeFUilNyy3OXzv7L1X2RvHHF3UWlfQv0t4WwP5LgliWojmgKRYuSZdcuV1M69KSkW76Q2mmng6UwTxemS2E6BYdrPyqjKUpEKcFBILY/JiLAWX2IQ4F+1vmAmMpCwTUZckF1y2vHLnE30tW2M58SUTSegiIOfIIeQqJlGr1rGNa9DVYR7EtGiSbW2cu26/fYve+NOfDn1xcCVr6GsKIuGUpJw61bvXnf+d/feh4/5QG5SYI6KMG0RrNwuGNoFok2JmjQVUGDCzkJBKM698+EnUqA/PBO415aTl0AYdalKA2W06FoQGuYKGwxFJJKPrNmkL/T73xvUjhwnTTzxp2JdHHSh0/hor1h9+Z5cFce7mrfdI1gceWjb6+Rc+uaSgYMRwla60KhjKGG15+ay1qwmKDyAMmFGHTIMRBKurI9E0mJc05Hz0OjP/3pYumi0gll1EAnFPOS4ijPAfyIDGFg4FOtmg6mrW2ebFrCQkZwoGRdtbNnmMutCi88/f74HTz1TPQU2510aCbK9N3dgk5Z1/xaIbGr2GvRR266CgotXkLDRokmg86G7HAWkvx4jVNOr0nPEB8GplUg3caL5GCGUopIHAB2tDt1FBHsALFlYskO4WMukNBl16zgH7VD8/5TzbxkJ73/Nattc6c29vez5ZX30uV1wSP/kkMuh/97x2rttr3b2kfOyQLl+kIL+0iLm8m5BXCUNkvhvT9RTMbLCyEIgi8YgAC1H4g37lLKtoMy0TIIa7nO2LkkkKtD/5qhOIU6y4wMHWrFrBLGYnK7RVMlcrqYjpcViwyKaNszccdmThtD//dd/XhuULrX1tff0xSX37A+593py16IKYqB4hKdUl0BG3WfRm5nd3ouTmxEwkSlxRYpAAjIQXkoY8U50x8JpxPAKRLfCpg/62ZEWJvUlKhNYJkm/2lCkHP3fYwazdLPbtgXDb454OgLjHKq6ql5z/u2/pPp98sf7MiprxIzt9kWqT06iIZTBVL9AOECYg4UIcX8R1YPYroe8kkuhXj0FwWxY0FxMT40uuM+dAnJuwxwX+QA/U640gaEJkABvWoLXx502jjVItwm4FGpv1Os+C668/9r5DDzStQsa1z81VfuTV9UOfmL78KlE7eDcmWmq8Aa+5qMwEhZQwRPsdPFeQUXXzCoF8wMn0Vwo9NGguyUTTYa0outwdy+cddHD5/X+7ceLaIsOubX17gn8AxD84Cv0JSfvaO1LtPQ+9dHEsbRwTSipqTTZnvg49qYlUHIL2EZ7QIq0BanNT8NGruSkUPYa+5TqneswFkjennImlzCotfjQQRtcOkmcg86cpg62F9B+I+6QkQpP8FMl0JhVzd7k7F684/aQ9HrvsorFz8yyszajaeTWftmZdGl2S7Z+3rz3587kbTqkaNrYmmArndbmDOqumSCbDZUke1FxIawN0kxhAym40tnS3t9UbNGzBDdce9Mj++7EWZO/7XM/v9rC423qOARBvY2W+bZYK73/k44nLVgVO6vaq9zAYyyuMJqfoD0GfGILzBhNRCuH+IVNNF19ITgqRE1d81i2+21OUgBJdOTqnbGkUzGHKY+3tsPLollLpRUyDjHAgqzCa09cNnWWUoYxqkVk1Cm/T+gWNNcXCl3++/ozpe+8prtGIfWuucgjCh2/OYsP/89AnN3WFbROrBo0oDHgakZxHLoHHwIiLOYhJjicO1R1fm8+zeu4pJ+1+74Xnl68bbOib42d3JIA3770d/Uf66vOTrtdzr7QPf+yJjy6qr48dWFUzrkgQdcYACAykNUBcXr2elCfk+bV8QflndOPkunLIkc4elZzIQPxfxMJkjal+GvUnmdNmBw0RFEIoiCg1oCcC0FH01qKlFlMprCzsDTI9Sluleaa4r2NtW0fbkhUnHDf52b/85YDP8ox9b9LhF8ulykefbrpgzry1B+Xn2fORdChkaTMKfLIyqUApPkWkRalwz/3j9fvcMmY0axlqGrC+A5b4N5wkn38nlcyY+fnuX85dd7qoKZ5gsVeUhGOge0DyVAeXNw0lilQSaiJJ7D1kVzWQf4HthB4XAAkhN7rkQV0peUQItc1RrzInQVD9U2644F14Od9oszsuk0yod5ZiaFJ6FIS4D5aqXlR0LXjkf6feWZzPOoqNfSuD3eaTjC+8vGn4S69t/KPVPnxcPB61ZdIxuDDhDlfXxqW7TRz83D9uHjcHWs++33DrdolfHXCnf+ZtbuiSLM8+v7LuvU+WnuMLqvdQa/MqJaXVkoLCeRRiAxJca60OgvUYc02yMUS3zHBSErG5iOwBkgKMCVfR5N034GEDnCJ3wXvOktpSU5atUk6ONfuYzShnCbXga1Em188546S9njr5uNpV5da+VStt7ZAU65tZ5W13Lri+u6vFCbWNQDjSUX/uuce+fPoZBQ0QHNxlRBR+5jbc6sMGQPwLVs+DOUELFrHS+x5555RlKzbtZYZ0LlOXVyRhcTMSTWukxBbUMwFShaYTvcbQsoaoHlEG5UtuY+QeNycz0DhOTtTkcJWv7w+H2wLi3AvdAmaKJRM+tweEr3Ujhzs+u+qqfZ8aWcc29jXaZotf0j/5+PySteuX6S+44PT2g3Yz7FK0yV+wBQdA/FsXK/f7TTHJ9Oa7bYPv/t/My0Xt8N0kpb0arEAtV1SkBA3xg0U/XGkYEprYRn2zfNg1YmXS8spls6m9DkDnXTtbA3FWnub7wN4CYoK91Whn0VB3PBVvQ0G7acEFU3afevaJI5ZCM7lfK4hsr3vZH55nwBL/yru4KSwplq5KVt140wuXW+zDJ0mCusblbi+MprpRS3aAmlmBCQPEjYbyB0q7pCdFgm4kQ6PEQDA+Exern1aRWL2c4f6eJe5Zovqehd5iqck9TyFGtpqNYH5hSkVa4Y564x27T6h4/083lE21oRRVaex7deVfeUt22V/rVRCjgVs0qPpXnNMAQbg771q+34svfXKhwZI3uLyqvDoQFXV+DwTcNCYoZIJLCRKDEpY4l6BSAshCGnN/fjOIUyyQCPC6cqGzAkNIkGSLGFmge1OXxbph1uWXHnDfCcdYVuYr+mav8i6Lyl/4xnsNxI8//XFFOJYu3v/gQ7yV1YoGxG19jg+8rbVFrKyYv4hV3HvvexfPnx87sqB0ZK05z6jp9LcxUZutPYEHTONHUD6Rx5BwdUcUm9AQQE3ym6/vJbmoC+qHt+j7ljjBwDVGw0AypkWHkANT/uBFp9IJi9YUaWlc0nD+2Xvee+Shttn7DBcafuHeGHj4r1gBH/aCq6tLPzg/v9ekl3oFxPGMpHj8yTnj73ngyRvHTdyj65obpkwdUsfqofzo/xXrtNP+ysLVUuGLLwYPeP29+ecH08GyskGDioKxtIl35dBFtWGStOVWWVZs3CzJ+gPw5t7ktidYyCUrHerU/mAE0y5IAlYJogjonWjXU6YdrMhpia9Z+XH96OGmWSceM+K5Yw7PX1tkHCjZ7KgNhMNcjfNZN/WBD8eeeuT45TWD8ntlGNu2xyNsx3caRg99PGF2mE115StWh4ZeOOWBupPOOva1NkmagYgtUqTtH3HbhKFCR3dcerOqbvjSl15ffM7KdesOLi6bPCycSKtVBozpTEdYBJ07JL6nUkPMXIO+WWJCowYss7u2dDzlwLvVSfdctEDOaifRIqlFqySEQvAVEmVEmIBCJ1N6WGegS1NeW1u5bPWm45o2rJvctN7x9PJ66b2R1QNWeTtub/5UsMCmr6H0+czjyy5bOn+D9dzjD7t6e/+NbT1fr4AYWnNCIqlXJdI2rcaYX+ANhUtfem1uweIly8fe/a8jb+1KSJ156v6RTXVoIPvB2MrPl0n3vvlu+7evvrn0qvziupouf8gpYYyE1WpnYTS5x6GA6e7wsUJ7mUzVJEgiSJbBuw1qcE/SUpYlpoQAnZL6mdEBlCbjTjVq0qRCPTqDLLjHr9RV104qCbnj+U8+98n1y9eZhn+6WHp03Fi2EXOH6LUOXL9hBaLwMpMZZnzsqZZDp0/7+uxC64HlQ2qPakL/ytbmrf6Gv7TtX+0dEKM0qjflx5SiM6XRlWqMYlrvjXUNWbzCYz31zOklN1x95gOdKWlugdj3KITbWtr9RwntDSHp/dKK1MYnpn11hRCpO9jiKC9LJVyCAudVLB5kRaUFLBMm9v8PwUuCAz8A8vdYh/LPZKWQ7AfvIgAjDCQSSP3JM3uhlqEQrKzN1c1szqhqaFmBc/mG1iNOPXf6uJNOPODZTVHp5Spd35oAuENQ8CuflAb7dXtZ3rlTXvhnfXukbtTIoy3uFruzvqmxy+Ss7LVus14BMfYoZKjUqRCGoEX8KXUC4yYFqDvo1OaCgD+4/7V/frz0qDmjXvmuQ5pRXsAaUOPsF0wdlHdIJHnJwibp5ttuW9G4aPnCQ4xObYGQiVWWOAtVUZSgqCFetsIkILAFvD/KZ23eaFuz0rK4ugxsdEDBmJP0D6d2inGI9Gnhynez+lavUWfMMw4pH2Vdsipy5eFHv3TQWwsyfxszQmio0PHXOnD9jBVww2XyelnxMy82jp7+2IdX55eMqrTmp8zL1rVrh1fkdxt1w6Uuby4R8jOe8Dc+pFdAjIF0gi/gQ9QGHWaDNp2AIlo0g7lI0K4qLKgVdSbH0Dc/WHjOyrUrqy+5+JAnNyWk76rUkPbvJ9eEcqG1NSX99/lX4u88/dQ3F6hSxbtlJGtdvr3c1OVBHy3eJ58Qw4Esv2lyrbko3PdaGXsuCI2XIRpnTqoeulM0eBsja3ifMvHHSNBP7WNxDB0T0k4I2Bfi7ySYO+CzJKIpnZSy6a++9oFbrv/jGQ+2xKWlpZr+lWjcEdunNSIZV61ipdOemXP+6tVte9uKRlava3Ln6Z35mdKaIUk4PVZva3e5Slu6I/78Vp+zV0CchF2FVUhrjJqM0WpSpMA1FqFRRaMm27xuZsbM2OLKMRWbWlaob7rp2eK1px30BGRzvi6yoW+2n/SOloiyVZ61VLr73ns/Pn3jpo4DE0rVCGC3AKkuQQYwXBbuWveU9Ol5375vhQnnKQIxZbaJg83lXenfpMKJD/yMNMCkDJ4PyTOS1qXZv0QSETVatVJbWC6mBc1//vOq4+P3q+d++p30zLjRjDjLJMQ9cP1gBdojkvWTWWzk9BkfXxeOKEcxZWWFwVKjsCY6oHAsKT1hbyYZKjJhhHUHZrj12hr2CogLNUL6tidb4vFUONPta2c+gDiGJnADemX1dgtzd7mYwsdYefHEIjEZsc2YvqJk+byOWZdeeNRTG1ql9YNK+o+FOHC00NQRkh59embTF49Oe/sSg3PU7mlmrgCyNKT9kQOybIW3BWAZ5KThRZaY/sfjY2hjKyFrI/8aXGlQQDOoRyN6YWodcljosIphvk0qhgYMCRramFckisUFNofZuLHeVXTzv14vOuLAkc82uaXl5c7+k5/4radRDGoNbV2s/N57lh3x2dcbTzKaB4/S6+wOCSNj6hvCzFIAQUVVG5RKOlR2Z1FUEYn5Q4nNU/p+65//f3+/V0BMrwLzZjH8O6pI6WPYOwpmENVMhY0kSWFmtqBBAHVOfzDF1BmdNq9k/JB2j1t7/d+mFp1y8u5TN3RJSwfl9a0OnZ9a+UIjP5TmzV0rNV5y3QyUIvImZSTtEIjXFiFXAmhSxxNZTmqOJ/VMqivLwCWiCC9HIStN2Wg+j3cz2OUZR7IoAWkCkbwu3eIEi2bA7EojXobLLaqgow1pEgFaOKFIhpl1eQaD01Hr8zQYn3npm+KGZterXy6VZu07eqAUhUmbhlffDox6+fUvL/D4lGMt9tpBiaTRjMEDXNnFZHRCyG8TU+dFmQ0GKeUPK2Oh9owkDfp/wbe9HtBrIBbTKgUGRivSqrRCAROjx1iPDBrfBWVWVylDZRIVSwhqSODQVtRXKM1DTI88923J6sbgG5+tkF4eM5w1oSzSL5JedAP3GCK0d6Skf95y16xJL7/09RXO/FEj7Y66qtauIAahYEi63QS9ZhczG0k4nSwoyB1KPdedSsYklKogTG8BhRM9jbIHLmeoCZw8zgbwFZjFzJNe0HQWwQwjWSH5kaSXDeKJWs0C6IX2RQWlyTykVGksc774wcJBC9Z27Pboe8Fpxx5h/K6IBi7vYlcX4hqIMliOPnn2E6mMY0iG1ZWnVYIlFSd/CeuGtdTpaBSrj9lNKpQMNSzmg0gEbkVSEpRI+eQ0m3b4yvUaiOWeWWIZyUNOxDTeIwmBU6M8KULSCA9eGiHLAysDqRbYE3vNsL3rZn294MKFi+8bccO1507tiEvL8fBgvrZ/KD0UYtQIiAJfH7Lv3p133Pn8hetXf71vVe3k2kAibQ0HwxAY0LBAIAShdYBXo2G+Lj+KR1ADMRfCRdazIET8COBypxMNfKNisUzNlBscZTPNZW+y4gN8YBk36Bmm0dPAdUhrhtIsgoKn2ZyvLa6aWOMONYqPPv2leemqgpdmN0kLB5exlsJtB+s7fKP25h8AgNVfzmMjHnxw9i1xqXgskpDF8mxqLhuEl0KD5GlSCBpbsFcFeJQk2iDRyFbZTcpNw+2Vl91rIM6+m21lbLI/ll1HWix5UyrY+o2N5qLiKoNejAo3/e3uko/fH/HhP/9+2sv+lNRm6YPKj1u7q1nht7WrO6U7H566dM4LL39xpbNo7DCrzp4fTUUUFquVBYJugCzB8guLWRyjYZo9zRhhgmFvmi3yPwRSeQB3jl/dU+Mrt/S0GWmzyYqS0YiXaXRaNGowyO96WDCIQ0KlFjQqR2Vns9v8Xmtr7aIv2xdee+XRD7ZFpE3F+v5BytkWuhp8UsGDD3bu/+4HCy5OCpZqrT5myyD6kTBehveCQ4lFQTkrmsXF5yrTOJkfXXRy9gqlmf5yb4L4R2+M8xM2v/9s7AcfhmJB+VJgbKUeFEWz0tXlra6smWCt3+QynnzK7cMvPv/MZ11haWF+P5IuHVogdLfFpA8mTBjc8J97Xr8y1N09zmyvqPB1hmx6kx21dYk1t7eh1dHACqryWFd3FyiX6F+WzSoHJsXS/KvNXOyteXUEZFkSKI04OegPgIONMTXgXQf87RA1UDGbqYTZjPn2iC9ikdJS3l+uf632pOMnPtbYJX1VkSe09YqJ6cU/AqOgWbCQDf7z9Sv/urbePd7oqCwCRI2UYk4T5x0Du7jIPa0aTcdEqU6eJ/Wjuj3tc5lH20tXr4A4CZLHf6e5ft4by06G54uFjUazZxuaO1hJXjH6c4N2lbLYpDPYnVOnf1y6du3wVz1h6SXsw3CerX90RRXLPPIlKzukv/77ji+P+/CjlecWFo+tS8dUlrQqwYorSpgn0MYawSaorKzm7rUsbC0PVpVnLec+y9/nVzackcGdK0ZjXJzRytzeDu78GI0qJL5i0AtLI5wJsRDIKDq9XRkLx8vqhh2oe+2N2f+YN2/el58vku4dN47VYzJF7o/10nbdMX+mKSDlT32MHfHii3OvTjFDhbWg2hbPeHmYl6IBbzReBll/njDkg/RiADPNUN4mVPulJc6mTbd2OhFtMEtO4DaYLLK8N/gaIROTX1DCWlpbWFGek2kNOpW3y1WpN9lsn8/ZVLD3/gsm3HH7pQ+GJGkNasr9hnU0vFDo9Gekp6c+7l713gerzmvqiE0y2gtLIv6ERcQsKIvNwFphlfWiEYtKVoJsgjwlma8dxyllrnNKnFtaGLeAmuSCMKlRZcXAMhL7g6wQiO56g8hUGAQXikdYPIwEm97ONra0OIeMmKSFgsgBZ551X+kJJ+49tTUofVNi6rsysvXNUe0ml7b8L3/97vrly/272+yDatOCWhPC1EoBhd44RvQoMUSPz5ymPQlKK8oo8pwtuNakkSZ7PlvluvcvS5w9r7ZiiQnA8rhKOY4jy0ELQrEGbTWkY9DpQ6n8ikHVzAsdZk9rF7NbbFCNVFoKK/NVrrb1+itueKxorz2Gfzp/vfRG3SC2ydxPEjAWBfcuZn+8pKPlyWkLDvx20YoTFWLVeKY1ORKQt7VbnOhionWixZIBK09jzH3IP1H0MMg5W8YhjV+Jh+NQH4FkEOl14QiMJ5Dt1qmQ8BKY2UoEEsZCvgZWVFHIusNdxqA3XFNcto9t9lexsq++fG3hrAXSbUPrWHNxH5SUXbe2w3rHvSv/mBYr99FaVNaUqkOh0RWwSEBAbsDEbA4nH99D0xkFBTwe8mowY5kPC8iYs/uW9m+v0aRzt+97n3vFnd42iGkj0QQ8bJVsfy2dblyfGUCmDj3wQlgwgoaBWIQ5rA641xoWQmJHDwvd7PLp7QXVFcF2heXjrxsqOjxvV55y8rBpTUFpY7mJpoH3j+uQMYXgFEidM55bsezFV9Zc5fEZJljzSgqFqM6sQGmO45EnBGGTcRhyIG8Gc5aEyYG8JdfA3W58TwOFznhcpsAqQTXSYRB6MhFjwVQK9eQM6qCMaTFQrtW9kWnVBmZx5omJqCJfUDltatFunnLZNPUFFx50H8bF1leZ+xYpB6W5OFIubd5ooBuyKOiyU5hDXh+yV3ZmMlkxhUPehxgije0JCithmMIWeC8kfsh9Hrlw3/PqVVea/nCvgBjtrtwzpouoluSuxGICs2E+bQQui/zT3Aajz2RVwCiCRQGUmcEov8xQzMuZSUpMoI8z1JdBGqnv7hIKy6tsybBdM2fpmhNaWgOVHpdpen2XNL86r+8NIdvWsVNp4Fnhb9+c1/TPp6Z9d8LyxZ5T9PqaEaIuLkaSIYaRrLCeGojOR7gGNs00SqIfTqeDO0iHItE6s54OOSoyRwTgBQlEgVnM6DPjmVdS68QsQl5HxthClLeCuHEY8mZQ4zmSLJQiAUByMRWqlCSWGPMmHjj1qW+Lvpi7/OM59dJLe1YLzX3l6Dz0gGpvhyT959b/LVr95Uee84y6oXDirLpgGHtLakPohh2Y8IOiqkTGXs5Cp1CGS6MITKKIxGYA6QFrhsMTm5z2Jv1PqVRmYGP+n0rM9lulXgFx9uVu/U1x5Uc5JpazqzKgc/+myrHsWuMkIC8GTKVcYiaNhdSDELGhrZVZtFp93Zi99YF27/533v1O7ddfFbz36kee6UceYlur60cEkWMnl69vD0lPTHs0uuqRqR9eay+Do+vMK4rGY9qoPwQxe5hOLJQvGKT8AV+33Hbio1ZhjTn5iye8aG3hQ/PRMySr24OHnbM0yMJSLZ/cbVk3m/4NLx/eU1oSISeiLbYUDdO7/D77qWc/PvxfTzY+fOHZ5StL1H0jP4Had6xFkt4sdXZ3PT9j/qUmQ93EAoeloL2rWa8RDcykNWI5UYqLItEX9mH4PJKBlnyAGAQPTMeUst1jWxVv2H44/cln6i0Q047Z5sm0RQ/9+0kCLmNDnja9BeLk46STx6DIOQNKNqSwI21OCybHC6yp3c3UacHgLB1es7EhfOKN/3hjaFPLnv9tC0jLrUbWreccxr5/QWKnu9UlfTxhtz+svPfhjy9q6/LtD3pBjUart4cBZAEEkXyHDWuDaA1TF6nFkZO5NidgZMssS+XmchGUh5DJCxI2KD9U6Xeymtk8gZPVypYwxYLiQEqjRWJJwarPs4lCyTCtQV808/kNlcu+c72+tE16bXRx3yhFlQq84eOL+S3S+jtv/eCE+g2qo4eU7TXe5Y7bJJQ+kooAwrgUy8/HUHTsoFjCi+keUVhnkifekjDkQM5uzd7cZT9IWe7QP50rqm0GM8/ycVzlviVjTIFgWB5Ihs/wC7lxzmlSyfDlHyQDm4HLSGBXiyq4jnqmhlsp6PSipLGXZ9Qlkx6Y+vFNl1z1zFXIh5UF4lSx7x9XSb4QO2wf5cZ77znsf+NH2x8OeFfPTSfb6i2GdDwZA2kj0MXUKrh7BMTsB71zgD27AFmrSyCFiB+/eAaWkjggMihIpZOkdulxWUtN1ponIinuxiGAbC0JAXZ5O1k4ktKZLGXForZy4vJV0SmnnzPj7zM/iw5rw5TJvrLik0qF1kcfPnzqaScPv7W9ed6XqkywUS+KYSVqxMkomIUJoluiNR5nnCAC95ifRd5JTyvMD0f+0XvvujctMZ12ubTpFgYCNo7Ee2L5FsuWNeV6Oe/MgSlW0GQxKqCg7EEUQ3mGLX8EUyH5kEEMKIAjrFJgLChibF/cyzB9FNxjo8PbUTG5sU1XdthRj0+66c/n3YWyzbfI+vYbYfVhpUKnLy29/Ma7g1fcc+/j53k8rgn5hUNqUON1xmI+gA6lEBolgzXjByIlvihs4REyWWhiIpGVJdearDG5yuR2y/cAg4MJ3fJjAGKJYkH+OLjV+B0rRr7qQa12dzWywsFmkEViBklhHVzg2N/695tm1e69R9nMtW7pwyFOob33tvWv/0tQlyGe+Ox3P5faZsxYeNryFcEjzPayWoexxB5jYSEU9vBRPFR6otwCiDD8j+XAi6XKxim//jX80t/sFUusVHFzSzVcAnKPBgbKotKXZKTpo8fxxWcUyeR9ElynD3nSIGhvsAb0wYeMxdPMRPFyOMy6XS2wNDGUQwqY1qJl61qamb10sM4TNwxSWYZO/Nvt024/88Ln/rqqQ6oEmLPm55cu2c73eKtSiJ73B9uid9694W977zn4vo72VXMx7m1TJOTBAmddZwA4gwOR4CvvOrl3WbasubOc7geNl8E+hhUm95r+TftSnjYDuiZZ7gy6oOgD2tkxTHXUIBU2etgQ1ti4nlkdZma252k2tQbLHEXjJ23YpL725NNevfO1z6VhASIX95HrqP2FDbfcOuGxAw8qvMNs8n/i7mptwHjqiMlQiO5vC0vGibpKW4g4098zu2l8jS6m/pnYohOOhNkooMoOJ6JEFhofYIlz7rM8sDtbP+YN8jmjTRuM775sJpsmBKL8AXJC3BtCPVnBKoqdLCMqWFdXFzqhJJZfUsE60AUkIIZLppM2jTW/rtOn1R953AMjrrr0rEdhwb4GAOA79o+rCi2OGMf62vOvTWqZOu3dKYJgQsUzVQMHENkuWjo6s8nVo1yDfH6TS8w1vrJOknwfshflILjdpjM4dx+yXVGk34XnMSL50wXSSag7wgoKClkKjK/6pgZWWlLN/DGfSZlO15j1dZY/Xf98wQnHjHvIF5NmW7V9Q7VlSIngQnPKe88+39E8Y+biiz3u5L554tAqi65cG00F0asN5hYy1Xwds0DG5xyie63brtdORmDFr2K+tYq0tjSZSZuUmKrNJyLkUl487sp12pDVwMpQbfNHuaism8ddQZBBkNpXGY0sBYseQwYRJBBsNz40BQX7ICsrL2Z+rwelPqp5Flo73V6j1lidN33mx5ZPPxfnBtLSHeZ+BGRoedOu+nr2WmnT0zOWHb7wu4YT0Zs0PM00xcikos2Y3GMi8uOgxOHJuwyJG8zXn0pMtCVzdWbanHC6eWMF3Q/ZjmeyjDq6NaKoZSUlZSwYCqFsGGPRZIxVVpWB1+2ChpoeB6han5TU5cVVu5k++nLtjes31Y/+bIH0/KQJrAEMu16MHH/dQZ1tTlny9Srp9senbVr49ZwVF2oMBYMcTqctiQF79A7kthNqAU1H1cpuT4r5W7A7e4092GvUsGXrJcNNtz+z9xdzN5xXVj56nEKyViZRIwolfCD0o0snhKplSmBWZx66dSLMDwuqI7GAzVxgGbyU4KJkDf0bmX8mIl6Wy1FyrMzPBB73yRaF6ne0KXkONivazgXc0b4NG96pFSLL/vGXM+7ab1+2DAJ9/apvFg3tujvumjf+o1mLz4wmzZN0xrIaUVdgbu0II7NqAdGDZjm1MCOaHzRiHiY4atCSmOBjYcD4RwIHBySSC3zcTG6+Ms1Wpg8lKJo4CNSY+kiyuXIFQbbZPasNBh1cbgiPa9QY+6qSfO6uhlaFEF15/PGHvHjlZeZPSoS+4wlt6pKM738QqHvtjTkndnen9y4qGzooqTA6UpmkUqmKhz2ujc1iJvDZqcdPnnbmaaXLC029I3PUayCmewxZGvOM5zbWPvLYa+fa8wbv0eVJ1Si0RotKq0dNE0PBUGR3w2oaLUamN+tYt9fFCQxcvYJfOStMO4XqyjSkO5cM2/pJK4N46xfAnzKpNZ51q751nX3mgXfedvO4N2HJ+k3SK/eul62Riv9684sXNLUl91Dqy0ZpDKXF7R0RpoPYgMGSZD5PJ0vElFylQg3VD2JwkZGkOnMC7C0aM8PnKvMh6ej4xmcuKAC0ikn0ffPa/dYvEB+4hVahvmo2m1kqlUp4PB4vEpZdRc7w7HtuO+DOAluirdqm6TPNFF/OlyrfeGPl+I8/X3qCo2zYKH8kpAv7WprGjip577wz9n579HDWWmrrvX3UqyDO3eZ5GHfyx+ufPNMdMhziSxVPzKg0VlHjZiY9nD61ioX9MXB61cxocIACSNlreRNRSxhJ0pDFpdIUwVOF9P+PmW9bNtRPgZgsdCgYYJVlBa7m+nUdJXmqb279x1n37TWJz/jtNaGzbSJgO/7An5T0Tz/vnfTYtDcuZKJjbF5BZTmok8ZVqzuhf10CwMZwaLYAwJC4BTddJZqxNhFkYWFbs0kubmGpp5YnG8lLopCGQr9tl9/VUA6BNBNaHmWMEqjpnoBN5mFxf6c63vXdlZcedc+JJ2uWYc17LY78rUv73RrJ+vkcb/WzL79/sN5sjB1xyJ7fnHScszXPwTp7W33mdwExLWBnXDLc8t+lY2e+t+ZyQWudpNYErEImbCf3WC2g7JFAF0kUIj06KwctMYVIFC4FSyD/mzisADFElilLva3rp0BMLrgGdEJPFxQ3dbY4To6OZKh9zakn7fHYVZeN+Krc2L+E1T3o7Vy5hpX8+W9PXxSMpCeL6orhomZ0UTACkmUGLcIi1YhhaYE3kXjUoGzG0WhBGWsF0TCpqIeMtJCGGAE+k9pFBjVl6q/d1gXLy7RQM6X7QBaZwEzAJssManbUIKn87s5VK4aPFGfeevuR79bl9a01f+nzeGEikxYmT9B5ay2/Tzvs7wZiuukuTJD7ZiMruvqGx89tXB88auSwic5At780EgpoHRAdCwUxr0jl5KoKaWSpyfpmlBG4dMQNlg9tFbpKtjTA/3gr/TSIIUmDvlnqW9YwKzOqzCwWCEUjvqaGPXYr/AATBZ87YC/dcvTN9hkL8XMsDORnNLf/+6O93/tk+bmBeO3uemN1hVavUSaRaU1QxhVAVuCwpPKSCpaYcgnk7SjTGvQJGDiAFQAy52crg/x+bOsiwJJ1Jx433Qv6mmr/BG4JrY8mjSaBpgsPSMmd4WDLknPP3ee+s84yrehta/Zz1m1nfczvCuLcoqyWJP29dy2ZMH3aO5eVlAwdYrcXFnV0dRRowMDKUFM2z1oTTYbKS0RGoPol1TOpDJp167axwj8FYrLs5KarNToWDeGASIjMYYSCRiaeDHka24V00/Jbbj7l3xPHWepHFOn7BFnh5240Lw7QD77orPvvQx+emxTKJiUT5hHxhNqBSR2c8J9GExjRCzVa1OMJxGnU5lGnV6WoPgwZ3BQaJuAKxZVUEdg2iG02G/P5fOAeR7lF5g0Z5IDD41KKaPmD7rhOZWKJiCpm0mm608nWhaNGmp+9/Iox8yZW9Q3a5s9d8x31uJ0CxPTmmqOS+MXX7rJb//PyKfUt0vElVZOqIynJwZAFJcDmrIGKxnaiFCdKIJ+Tew0LzQeI/QoQkxaGBO1lb8DLTHCraUxoLIw2R/Sn6VRGyd/ZFuhsXt566kl7TZty7h7vjB3ONhr6iZj95gM0Kpn+e/+sPd5+bcMVOv2wcUg4FnsgzAfRHlZQYkEXk4dn/6kSoITHIiIpQUPSySKTZ5RUwkXmzfJbv3Ki+Nx9xgeBNxKhUazUXJ9hefkO1tzczHRYc4cpLyCmdDF3W1OX3ZJafO55e91z6OHCmhpb/5ia2e9BnHuDKzyS9eY75+3++gdLrygdNHZIOBEpQF3SqEQChXIsalgENcVs2AyyO0flj20vz08mtlAbTSMxBlcSLXwetDr60UdqQkINogMxNUvDwFi1hmRrw4q2Ikdy8dmn7/3o6SeVLiy09F01i62t1PqYpH3/nfa6GTO+vXhjg7RfftGIclGv17d3daDkB1kagFRBUrj4ZT6FEQtPn+lKweWW+e9bv3IjWikWJhea7gepdlJLKvwgFk1jfCDKTzQVJBPDAZEwo3PIEjarlZ6gf/WCffazP3jBhXXLhxcLvTLrd0cBbUc+705jiXu+ScwtVj31Vsvg+x5580ylZtAhTGGp8Xu8FifaDnWI1ejgjweh/4QaZBjdJNF4iMda5K5RjTO3WbjLlhNa3soqkneughWXhQjkw4DYY3LeW3YfFeizVQPsQXdbQMh0bjz84OqZF1+855uTaoWNO/LG/B7P/fX6dNkdt79/6vKVmWMLi/ccmRH1pg5/PTjoYGfh5PRiiphR62BR1H11YMiFgl5oYlt+8qX+VIserXUKs5qprk+0WkpQUuwtoiCBzz5RSvmD3a7Oulrr+yeeOOaFww5TbMzX9Y9OtO15f3dKEOfe4FedkuMvf3/1uBWrPH8oLRk6uK2ju1KrUqvTpI9shIwK3DI1JFszUF4gwNKGoZOewEwXZUN/6qJYj/QZOIhBI0zhd9PEL8Y3uHUBBVSpMDINFCW1cLuTUVe8272kPs8Z/vr8C/d+8OyTdlud18+SXjTt/tGprsl33/PuX0eOO3RwQlAUtLs79QpthjkKnXB9W0GvLGDd3Z3MajayTPSn6/Q/DWKSHqfueXmiBVF0oDPC6Zwc0BlV0q4vCK9ftaw7z5b6+rQz9nz0uOOMa2oL+5aCyPYE7Naea6cGMb3gNb6U+e33vyu/5Y6Xry4q3XN8ihXUeUMJXTTth4CeAxY5yPSoLdNFQKYPssT0QVaYLPS2LiVEv/VwE4lWmGbIgIOOCKE0PqSMiA0ZJL1SKcR8yNqa9AZm1GlYONCVDAU62goLzYtHD3O+cPPfDv6wRtd/pIBya7XaLRVdevnzF65brzuietCedU1dHdYkKgOOYjXz+tElps2DJhfWD11Nsnj91q+fAjGNq0njgOQdVjxhKcvA0vPRwUpAdrW62YjakV1wtaNtjeuaRo/Oe+3iS0e8etBuQsuOBkdfef6dHsS5hZy3Xsq7/I9Tz1pZnzipvHZieVwBIST0PxCIJcx9oZiLMp8EWsqE0tdGcKo5hXAbF7luYB7yWA+pMp4gI0tMbjWnGgLEyRQRHmAraMIgvqcGV5isRsgXDwX9GxvHj1K//KdrTn1h0jjzRljlfiE6kFsuzOE1THvSs9vUJz++Um0sHhpMJAr1dpUlxVuKsdZKrAXGyWzuJN3KOv80iOnwpVIVEUqoh5noxhTMkHWXm2DUOFSlGDSxmTFl0mmD0Uh7WzS2/qtDj6x+5Jprx68pFvsXKefXHBx9BsT05uDqae989IuR9zzwxnWllQeOSCT1lXlOuyEUCrAwWhEpiUJJE7LAPVlC21oYisM0GZPMvVYGeA2aWiMpa81LW7DMWmRNoyA8pNJh1E7hZgPh6QTcbMHKDFoWS0bWrPV71q2/4NzTHrnhj2Pm5vP5Hv3naglJqpZ2VvSnG2desqlJ2Fuprxxuy8+3STofRAwjTIqgrxbaXL/GElNnlJDTDIAQnYS5XFSJIJItZ4ThHqiVaMCCnEYs7Aa+w/CGFB6wZTsMOvPqyjLnK1ddWT1r4qC+RRDZ3rujT4GY3jysg7hoRbzgssvvOUdSlOwVSGhGiBpzMayukqxuIBDgMTF90L8NBmRXt7nDkExh9HNqRSEliyjgiywpJbtQC6X5RWq1FrF3CIJyYTynGocEJFpAMCE2GamKJCNdqRF1pU0dbWsanDbFvJv+fMa0yeNZA4QH+pVVbgpJ1qlPbpzw/EtLr7UVVA6NKSNF6FzSGnWOXw1iWbtFVh/hCqfZEIZiZIl6dcEN0OvMLBL2IpnWgbWXmN1sIcZYLObXRxVSoh6iTF+cd+5B0047VbnRITf073JXnwNx7g6FQVa45sZndpu1MHNRU6fyEJAKzFar1QhyPbfEDoeDu9I/5U5zaRXykfnJT5losgyytlS20wnWJsrLTqSlFApFoBwCFxxqFlQiAeGIWaBT7IJQX55TFRRZd0PIs2rhKSfu/fi1V0z+zi5Pc+g3VzvkLb9bzir/dvMrN/j8BXvZnVVVkaQfWcRt9y78lDtN7XsqxMK05sTKA5GM5yXoEKUGCwkifWptGjOVg7L8Ek3uDgssgRYVvcaOIXM6d8Db0On3rVsyflz+i1dese/8PUcIrn6z4D/zjfRZENP7A5CVL33sH/bfB985rbGx64CampGlsaSqJBSJMb1RByEAmsebPZyJtJ8DaLYpitM41eS+AbjEB8ZQblIToYQXRBA5M4xrNSthmdGHy91sLhiHHluSy4a1iAbp8RQkRuDqJWLpeGtrAJtqvz2Hv3L9NSd+Pram/22qZe1S+TNPeQ596/0Fp2sctkoQboqwtvB/5QOQLgKoLJVLDomcfeZieznRAa5oitp/lm5MAJbZeQAyaRwDxMQEU0Ggzudzo29cxyxGcH8kA0IZzIXEPe7qbGO1NRX+ZKzbGw61rM13SF8cf8z4104+sWiTU9O/qLI/hec+DeLcG1vYlCi+7763xn348dpzHXkTJmhNeUVtvlY13wQQciNrIDL0z9IEuxSsBiR9NBgDqEEiLIBTXuKSmrIAHN+EuP988h3tAyiH0CUPZJV7lTmYZYUqPD6rR0VqP/R7SNAILO4GfWGTkkWX3nDdmY9MxNyiEY7+VRZpbJdMjV2s4LRrn/y7yjJ4jEFjLxMzGlsapI1YBFrWUoTp9YAyNM9IOECBeUZJMHOIp47mW9SdaeuB7kEkDwI7iv9Eg6W15WU+Gp2CD5kskitByT3hNF6UlMdpvVNg8Bl0FgjEqEAzi7cnQp0r9titeua1V1V9Cf2xXYIg0i9ATCDzo7752psdNf/+78vnh5Km3Uprhpc1tLsqtcg+8Y45EjRDggTMYF7zhQ46J+aTwJ4svNeTukkpa1mck9qRZVXOrOAA16PC7/DPVNeM8giOkmBUMpGJInwmEvhH0c721tUtp5584MNXXDzqy6I81g551J1ezeJnenGsvjMteEVF4V0PrDnhi88WHYXafa0ZgsHJZAq1fOpYSqKOjzowLT3AlkrSCqnhIkPoHpMmaAA62k2ysTDRMKlPmUg3YHNlrTLXseK94zJ4cUDiM9Yc/6ZwSIuBcPE4uqJSRhYgiSCzzRf2Nm1USM3v/fMfJ0w/+EDWblb071i534A4t/E2BCXrTf+auffLLzVdO27CKXXBqLZIEhMsJm1ClrmbKz5qoBdMrnUsluDZ7OxQQU7u4I0W1HLHLTLohpAmzXVMUbIFCXIuY5MbO0Obim8oJMUIyJlUgfz70CoWkCwz6qROV9umTSZRueLvf73gkaMO0y5DKarPNMD/HEC3xCTTq2901T393Nvnuj3KSSZrTQ16lm0qCK9HQLiRKO5FuCFlAEAajQIFFzGFdcf0BLWBpJjIAssHo9zsQussJxY5iLNSulyklMapcK1F2SOKA/gJTHG0aK1MBVfc3x5IOwxmd4FV19yw4ZtZxx077NUpF41YV1XYN3S9fs56//Axvaax9Wte3K/5nUEmwdctSR+ffCxbefkVM/6hMdTtFk6kSjPquFGPBJVCB/AiM5KiDYVxMDAQ3NTKkj+kM0Vf02bC+ZatF8uF5KxJ7iEkJ4vby3K6cjskxc4APReVo1+GtVGqC2zWUrMinbRc96e7ir/8YuRDDRFpbqW+/7jXpVpOdlkwb43U+b9HPjhi9rxVx2pNQ0dklIbiaEIJrUM9uqEgzwO3OhPH2qN5hYa8aTG4DQN9OBgZ8hF8xhE/SElil7wZOiApp0HzkChHiLMvQ2sLoNOECrjf0TjEJCwm5vP6WZ45H9MiHUpfl09vNegcZRWDap6Z8cI+vtDgDvxS4Nfsp77wO/3OEvdc9NnrpIJrrnv4WKao2S8ULdzHE4wXxQWvoLEgK6qL8wHbLC0ns3IXV3vkCTAe8SLxQsCWAcpjs54g5hPjSc0HP0ub+WaURB9/qgym5nFZXWw0nRrJGc+aTJHT2pYICs0aRWbllVed8ugfDmfLobbZrxREulKS/okZa0c899KSKwLRvN30puoqZCBUSEFA+ieJRgcPykUeDGdTMIsFXVIhJBC5/C2Nn8FUGK6BDZArsI5ocxTQJcVrdaSPTXOCsc5wojnYM0q469Y4c6FRwygWsLA3yewGOysvsLg625csVSub3j7jrDHvn3760BZnP3ap+zWI6d6jAV515z2LRk99fMH1cckxqWRQoS6tThQGkx2wkgApBojJ41XpoowqiegRb5oaIED8Z/g5JzOQtUYSi6tDyq2RfOgbVZFoQ2WsPEZjSp+sCEmjL+F6G/Va5nY1s7ISMJMSceZ3gW2ciHfqDfFlh+w/8tm/Xjn860KH0NkXTvxf8ho/WyFVPTz129PWbkgeEwhr69DyadFjTpQAQk046sZahZH4QqIxS+pQoD9ZwQe6kTcDYIvdCEd8yFkg8cgtNcCbxhqnHYiXDTwEohjaH+nkJUADhP/UCtwVSP60ty6ZP2yI5pU/XnvMFxPGs7b+xqT74X3o9yCmNwyml2L+MpZ3y50vnzB3/sbTSwYNK7YV5Rd1dHbBoSayB5U0CJQAJI0x4XVP1IxJwSJTIEvSZDeXQLGuEMFvyKUrYhbxxBd0qOTNhgFclL2mVitssmAgjLlIhQyNVgyS2PhJgKWTyYRObQl4Ozq668rzFl1z9b637HcgWweCSL9JetHatAcl2933LNxj2crAaZua0nsKWme5xmpSJBUxllB6oaZJ7DdqQKH2Rqw3ylC0nuTzUMKQx78iecG4HxQjY23TdFhSEpEPiiI6ph3UTCX4AK6kUnRtiISXf/yHPwx//k9X77Ec7Llek439JQfc9n7sLgHi3KKt9kuOGS+uH/L0zI/P9IeFvQbVjS/q6oo7uagAJaa4IFzWu6UEC9w8pWSVP9N8KCLoQ2EV0xXwb1lzXsi60Rm4fmStJb7JENNBtoYsNSXOwkHUQ/E8KiW4wJowwEyzfTQQvtfGY6HuLrXKt+i444bfP2VKzaLyPiKs/nM3YgyjE995PzB05svzz9zQktwzo7bVpFRiXlJMKgVw0iUe49LhJndD8fGgSD7yET60ovxwldU1eRWBhPoIxJRvQG1fFTeh2pD2pVnjco2+8a1zzpn47vHHVG/ob8nDn1rvXQrEtBCYR6t4693WyudfmHP0/IWtpw4avk9lh7u7kIl+xMnkVsMyA7RpbBCibsZTHnyP5GnUsA6wFLTJYEkUyi55c6Vkt5kGjNHj5DIJtTJmmWDZzxRX842ZFciXf5piBpMY9HvdnpDH550wtvzTKy7Z98m9J7L10JjqV7TNepeUP+P5VSPf+3jVOcGYabzGkFcGMReTyx9kDqh7pDE5Ip0KMKNJkpU/wipWlFeH6RJprn8tar3M49/AisswKADc9XSsgOkEc1gVjbSJrPPr8ZONz5x17vg1k6r7X2jy/x2YuxyIcwsya6Hk/PSLDcPue+z166qHjKrCKMEaUP70FMv6/GixM0K2FTXOlOTlbjbFydCzABCJ+QUXELEdnzhI8TJcQF43JgBTEwXAya0xACyTFUgbTC6LkPXgxBLiCcPqh5N+Lm5Q6qjytTVu7AZtc+ON1518xwVnls6HmH2/cgcxi0nx6cepIY8+9sE569b6J9kKh9WmTXkF/lhEpTNi9TUx5g+2gwwiMrOhHNx0MzyYPBb0eaHG2cFGjS5lS5fNRlJMzayG8o5wt3tDoSn6waknTHrliGOcTWWW/kVz/f/Am/v5LgtiWoAGt6T7bF575X0PvXqmt8t2oMFQPUxQwxaAZtnhaYFlhi4UGh4Eim/R5UTxspKmAcJSs2SR3GnDRftyRpOYR/S1XAbmpWYCcbYMRd+j2meuxkwWW9IiuYbYsAPD36w6W7LCWevZsGJF57Aax6InHj3wpqGF/U8srrtLsr04wzN66vTPLk1aRuzuSSXLRIObFULTS6Uxs5Z2D1hfCvSLFyDWDTCr0QS2nYFtWtfAnBYHUhChzkhk7Tf771vyyGXnT145tqpvTFz8uaD8pY/bpUGcW6zV7VLebf+ac9i381pO1FlLhqcVymLRIOo6wNnVgF3EheAAYoFE+2jKE2Wek6UyiDn5gL5PsRsN7pbrxrmvCcT0PZ6Hya52bjQr/z5kbjrdnay0uJjpVTbWuNLPzBpbsjjP1tXZMmfJvfee9qdRwxSbah39yyrT2s/5VBp07R2fXMtM+ZMwFqY4EIsVp1EtUOktfHh8MIy1MEMayROANLGJFVgKI1Is1OF2LV1409+PufWQQ8T6CiOyjLv4NQDi7AYIY27RS6901tz/0HtTwinrHqLWOURnN5jckUZ4v1SrJIYQ6pgZGwytPNSRpmnJ7KGcu0xGV1YZyc375SCmL4lAwpM0ssojJzRABD+ZCeJw0KC1UQMbjbGgBitLxpIs5PfFtMpEl90kLZ48ofDZ664ZNQszfv39bb8ig22/5i9vHb5sWeaUguKJk1rdgYIkxBhsRTo+0sdmLEH9N8G0GdSkkl2rB1ckX/r3HXvMrCveta1vz30wAOIfoGLBSqnoP/d9ctzC5R1HxSTlULVVUQEdADjIpJdMDepW2UUmywwLzGcw8pqxbGo3jzfJTQ7kCa8s24vrZiey5RFyszF5IRliBlieCBI5kRjUSMxaWf0ROmI6lTaZCidQV25fn4ot/ea+/17ywEF75W2AmH2/KkUhVlbPeDY2duq0WZcJOud4SaMraPe1mqzOfKWQMEgGrabL07Z26QVn7H3/1ZcY5vSncbTb41AeAPFWVrE9IZlmvLRh+PTnPjszkS7YKyHZB8HNQ9GYRPSIpQUCPlQoqN1O5D5yluGV7UfmCSxeOsH3+Xxl2b2W3egs4Mm2I1utUxqYHxlajQHHgV5k/jBcR+hfU5OA2+1m+RYn3Mkuf6FN29yyYdG6Yw4ded/d/z5ynkPVv5hetDKL6qXCm25775gla7wHOApHjAvHktpkwr22uIDN+tdNh786vJq1lWsG3OcfbtkBEG/jKOxAfdPjY/YTTnrq6qRUtFeKWerSTJkHYWRUmeT2OTKISt4XSyDN9dJmB6ZzHnCWwE9VUK5ckR0fT1rNeA6u6IgOHOroCSehXpEOoitHiww3WMNomVRA3CAejbNCWx5LR9IJrZDujgebVzkdsU8uvfTAl888pGrT9jjJd6bnAO9dnPGiZ8RjT35wmD8YVp19zhEfnXpaaf0Y+64twfNT92gAxP/PDnbHJPODjywZ/vSzH51tsNXslswYasNxtTGBurHVifomgJdMB5geljQS7gaZg5hZpEJhZy5XCImxPLnRHRxsioWpx5k6njJcCghOegr1Z4BZBnk2OcZpDvJgby06rhRw30P+CMgimBcsZrrb2+rdJjObf8TBY57+zz8mfolSVL/qiqJbsmJjxgDdNGm3UaZdPnH1/x2yAyD+/1YIP4/CKm9oZPZLrnjywob21EF6Y+VwUZuf7w3QcLcUM2MYOvGBM1KUWUx6LpcbjaSY3YGkTJisr1wzpkmOfMYvElrEQCLdazWysDSWZnPqmr+eXMMFkuAY7UoqnilYZpId0mBulN/vj0PN01NZrF9iVre8ecXFR71/zO76AQnXn3Ev++NDBkD8C+5qo1+yPfDwqt1eemPW2Xpj4RiM/C1HH42BJjaqVEoGjS/W1tYBcT1R1r7GHBijhfphiUcNF5onuMC1po4c0DXpEjlXu6e+W06cQP4cR6aaGgUEUhQB2HNqntD7SoX8ri5V2tPstEmzzzxjvydvOGvQ2l/wdgYe2k9WYADEv/BGNoYl3bLlzHnjzfee6w8p900I+cPV2vxCrZZaEUWAuBOWU4NEFTVVQLNaRb2z1AsLkgi12WXk+b4MUrn8QqsdAXzL9X0Qi+jhI/ldBUS9+BAyAJla+FJorm9rbWCFBSavlPY3Bjwta0aPKHr1+j+e8tXBw/qfrtcvvE271MMHQPwrb/fGkGS84z/vj3/9vTVXOvNHjQ0GMuWROBNrh9Sxdlcb8wabWWV1AQsE0VJHxH7qzskOI6OKM1lfSmynoC9HX31fHijnUiMmJt1riOGTuiYBOBqFCCAsM4nkd/vamdGGfqpYLCUljF0RX6jLblZ8O+W8Qx75y1nGJb/yrQ38Wh9bgQEQ/4Ybhl5l8dV3g6P+d/+rp4fDmj0N5rJBwUjaKcC1Li7PYytWL2bOPCunWdKAbiop0XRHmjdErXaUzEopzFym9ceXbJGJr01aYLnpFmEMM6M6NY0JjcQx9xetjRYL2vGkQkmR0kbBM/b4ulet32fvvHuu/+OR3x5YO5DV/Q23uE/86gCIt8Ntmt8kFdx33yd7f/jpynMLi8cOD0SUJV6UR4aMqGOdXZhNTnxrQJUDGHK46H5FdCxL5aahwJmGBOu2LoqtyZ1WI0vNx4H2mPQYjoaYNd/COlwuZK0N4BjTfKRMVErF/WpFdGMy1jzvXzed8eCkcay1zrbrSLhuh1vap55iAMTb6Xa1RiXjm2+3DrrvkbfPD8ftu5mstVXxtCqP+pmorkwNSaTSSOClgWGyzA9lrbN6zNt4HbnBcOmUxJNl5EabzVC5AJj9mEOlEKgNEsO+MaFCCaUSjRqTCpMqyG0rI+iz7Wisn7N2yvn73Xr+WaPXTijrf7TN7XT7+vTTDIB4O9++jxcHq5546ou9580PniIpysboLaVFgYgPbcR+iLiJPEY2G8wM3H7OnxZVXM0627Iov5gtnU/4CZWftnWRWAH6mXmNWdWFwyLMJzlSBpylrBSHh9Ei7XO7Vm0oyQ99cOP1J7946gG2xu38lgee7ndegQEQ74Ab0ABZmpnPNw958ukvz4rErXs4CiurwcYyu30uVlZZyhqampndWsTFrEnmR5YDyoI3+3oEWX7zJ0FMPG1Vws4flxE9LC2GOJEkzaWvZf0qKaFIa0UhiDlR9etWfrn6pOMn3n3bPw8g2dx+xb/eAbexzzzlAIh34K36ao2U/+//vn3YylWhE5TqsomRlLooCrE8R6GVedD8rtOISGmRWsiW25ATAsmBWto85+jHQh9KZLtFCMyRkB9luNNQf0wrw6BthlhaRdpUiKUVJsw7srCm+u7YqMFD3Z2dq9dlpKa3/nvPpS+fNFFNUq4DVx9fgQEQ7+Ab2BSWDFOfXDnivvs//uPQEQfWhZKswuV1WUQ9klsYlarGjCGSzJUVQLjt/Z5r3VNw4PsvFZJBiKtJhJ2DGBJBZIElSAelITUkqbxcvE+nwmQEb4aV5I9g7s6AlElHPYlkZ0M8ueGTKy877skppw+pL1cPWOUdvA126NMPgHiHLq/85BgxIyxfw/IvmDL1okjStp/JUTQkGO8uySssQqcSqMF86oRsaXNg3ozpHqoh8rNtsciUHCNrTNqQVMaiOVF8YDfJAyGZRh8pWH5qbaRSFc1A8npCzGiw+vIced0rl85eM7Ra+eTUh6Z8MalC8PXCUgz8iR2wAgMg3gGLuq2n7ExKuj//7av9Xnp91kVDR44e7PJEaxTqPEzdhTXtYQw363IRqLOx8Rbwbk0/L1tTJu2u7AQFDmxY9XjCz7R6AQm1LvQqm5jNUsg6OgIsElJmSvJt3kxs49JEpPHriy48beZfzi9Y14vLMfCnttMKDIB4Oy3kz32ajpSk+uJrf/UNN953bloo2F1lqBwKWb78LVY4Z5HlZ/w+iHsAOCsFRM0U1KdMbDBSFVEimcWFCYghButstZlYU/MGjDoBwOG+pzJpiBCYwfyCvY4nJJsOAtCpQEtH66oVu08c9Ozt/zpy3siKgVLUz72fO8PjBkD8O92FdV2S+b5H5u02a86G0xLMvAfaFSuhmAkEUt2YvOOe7rUsMkA3i4/2RLKLhrgRgFPQsIbyiDxkBkAmeieXCKImC4qZ0fmkFGlQt18WawfhJBSMAMh2WGU7a29qZWa9PmnRK11dnRvWmnWROddcdcrTF5xkrP+dlmbgz/7CFRgA8S9csO358BCGpL/+safunodeOm3dxvBRxcXDyiSVwR5HbTiNaYxkNRUCGiCSsLIJPdMhCWbSQoAe9eAUxtBEYuiAQr8yhnxz1U2JasS4ZD0wAnJ2xhRve6ROKplkQiCnqRZ8ygV6mYm2GfbBoqdTMa0q3REOb5y/++SCJ//614kLhuUNxMrb857viOcaAPGOWNVf+JzLXJLj9js/3PuzL1ed6SwcOjImacu9oZiWepvMZisolxgkFsMEwGCIiQC2zYj6MOYVRWLQvtaYuCJ2Tm2Eir800YInuUgmKDu3VeCUTxnEsog95gajvJVESjsSSkNtsxZsMD1rqF+Hod0pb74zvqSzY+FX/737iukn7qkaIIj8wnvamw8fAHFvrvZP/C2SpXnvY8+Qm25++kJBVb23M3/80FZXSB9LR5iojzGDMYi2xgRLRdN8OoJWKGVGIzqcEsAXtTrSxECaV0RsLZrzy2f+UgMFruxIFNlGyxRQhjEz8jRXG4tDlE+jwWiUdJqFAtD7UmNkt0oTjAZcDaLk/eTg/Ye99ujtu8/fSZZq4GX8YAUGQLyTbYllLZL5L39755SFCyOnmOyDR9gLCy2eUIc2mAJYRdK4Rl8xCB4sWci0aIjQqNy8K4oGudH4Gf5Blrln6ZdUOPnI0NzQOBpWBkII3O8gBpoZLMTFBtMrAYkDESoiqHqJGX2q1JnnkuLd9a6OJTOF1Lo31y28d4AcspPtF3o5AyDeCW8K6sriMzObR95935uXxROFEw3W8kFqi9kQAbpCCR9sKZooYDmRp2JGxLdiTkCTj1/NlZuy4gLZr78vXC/reaXA8Apm6PnikBUCswsxdzqqZCaNjSkhNOlqbey06KPzA76V7059+Ko3/rC3wbcTLtcu/5IGQLwTb4FPFkbLb771pdPbOnT7RdOO0eaC8kKmVzJv1AUAoqHCjDZGT5KJaYwGJUlrLoMrS2DnLlkOW9a9zsXJnFuNi0CcEtHXrEyzFGJurQri9TorC3uCyVjQ1+qwKD8eXGV48e7/7L1gsDk7BnInXq9d9aUNgHgnv/MNAck4/dnvhr3w0tqL3GHzPpaCykrMb1IF022IgYOYDEhCA7LoAM868/iXYl95MgUHMRxuRL1ZwT7oX6M0RXE0udPReIZZrHksEgDPGn3NVpM+2tGyst5iirxx/LETXrvm0ro1RQJN/R64dtYVGADxznpnfvC6nv80VvPoE5+d9M2S1hNNjpJSY54xLxz1K7QYyKZASYpGpipQLqJmCp6BztE4iY7Jv0I2mrLWeF5qVyTVTaoum7VW5vNGIChgY4l40O1qW7N2n30GPXn11Xt8NqKWNQPAA91OO/keGQDxTn6Der68NX7J+vCjC0e8+sbiCzOsaHJecU1pe3enwWSFMAALQUyPpH8kyNySS41EF4CdjEMiF+UlgwlNjwkaHRpmBYUVzKgvYG2Nbcwo0tzlRDQacrWYLIlZxx07bvp551eur9UP1If7ytYYAHFfuVPZ19mZwYzfTzNVD97/3jnrG6IHlteNq+j0dhWbrGnBF+7gQC3IL2XBgALNDlFWVFiMbHYE+tddTItRrUaDhYW8UBuBaEBVSZnkaV3Z4elas3xIne29iy8++p3DDhEaIUbfrwac97Fb/Itf7gCIf/GS7Ry/sHSDVHDbXZ/t/sFnHZfVjdlrWKdnvSMpBbUGC8Tl/2/fvgFvogA2j4E1MvAUHwbgxRHABRzAwS8g+wdwYQcz8JpQxr/8/39/ffGEg/nmluwM15kx8bJ3xdlGB68GR+yS5orRTExaeA0q1Z/+/mdbs4lBtaN/bcbXH3+NBcTEFX8zskj8AWbaF2+Bu5ZA87/As7nYWIBXwfwBNrR//gXuP2Zg4GRhesfK+O8hC+OrrR2tgTPcLRmfDiqPjTqGpBAYzcQkBdfgVHwOeNpmV8dBrzPnP8Qyc8oafvr9S4BLFHiy9X/g4fXAddUczIIMrx/8YOBn42aQEWV9+eje/iN6BsyLp05JPijLN9r3HZyxSryrRjMx8WE1qFV+/Pefddb8T1ZTZ+3I/srAZcjKyy7OwcvJ+xe4xenn558MItwS3z6/evyU5dfDA5WlgZOio0Svcw7Di9gGdSSNOm40BIgJgT03/svaJmys5jJaclHC+dh7w+jHP+Rc9z1lVWveGZi1KvL26/+ixJgzqmY0BEZDYABD4D5wJ0TLgi8eEiaLVspabz2i5rxyWueiG3rATRag3RGjYDQERkNgqITAuWv/xWKzt3nceP5fYKi4edSdpIcAAGnDw1v3gBFkAAAAAElFTkSuQmCC"
      })]
    })]
  }));
};

/* harmony default export */ var WalletYoroi = ((/* unused pure expression or super */ null && (SvgWalletYoroi)));
;// CONCATENATED MODULE: ./components/icons/WalletCheck.js


function WalletCheck_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function WalletCheck_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? WalletCheck_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : WalletCheck_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgWalletCheck = function SvgWalletCheck(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", WalletCheck_objectSpread(WalletCheck_objectSpread({
    width: 33,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      filter: "url(#wallet-check_svg__a)",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("ellipse", {
        cx: 16.499,
        cy: 13,
        rx: 13.466,
        ry: 13,
        fill: "url(#wallet-check_svg__b)"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M15.262 16.384 11.73 13.04l.96-.919 2.572 2.508 5.188-5.016.96.92-6.148 5.851Z",
        fill: "#fff"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("defs", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "wallet-check_svg__b",
        x1: 16.499,
        y1: 0,
        x2: 16.499,
        y2: 26,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#FF7C44"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("filter", {
        id: "wallet-check_svg__a",
        x: 0.528,
        y: 0,
        width: 31.943,
        height: 31.011,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("feColorMatrix", {
          "in": "SourceAlpha",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("feOffset", {
          dy: 2.506
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("feGaussianBlur", {
          stdDeviation: 1.253
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("feComposite", {
          in2: "hardAlpha",
          operator: "out"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("feColorMatrix", {
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("feBlend", {
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_162_1998"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("feBlend", {
          "in": "SourceGraphic",
          in2: "effect1_dropShadow_162_1998",
          result: "shape"
        })]
      })]
    })]
  }));
};

/* harmony default export */ var WalletCheck = (SvgWalletCheck);
;// CONCATENATED MODULE: ./components/icons/ErgoRaffle.js


function ErgoRaffle_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ErgoRaffle_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ErgoRaffle_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ErgoRaffle_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgErgoRaffle = function SvgErgoRaffle(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", ErgoRaffle_objectSpread(ErgoRaffle_objectSpread({
    width: 211,
    height: 63,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M74.964 11.796v5.757H92.56v2.878H74.964v5.757H92.56v2.879H71.547V8.917H92.56v2.879H74.964ZM113.409 22.85l3.804 6.217h-3.974l-3.587-5.872h-11.13v5.872h-3.416V8.917h15.617c4.515 0 7.609 2.648 7.609 7.14.018 3.54-1.884 5.93-4.923 6.792Zm-14.878-2.533h10.789c2.158 0 5.623 0 5.623-4.26 0-4.261-3.465-4.261-5.623-4.261H98.531v8.52ZM132.832 18.388h12.409v10.68h-3.406V25.67c-2.017 2.187-5.254 3.686-9.568 3.686-7.326 0-11.927-3.916-11.927-10.365 0-6.418 4.601-10.362 12.778-10.362 7.951 0 11.812 3.396 12.13 8.031h-3.407c-.285-1.905-1.619-5.153-8.713-5.153-8.348 0-9.369 5.067-9.369 7.484 0 2.448 1.05 7.486 9.369 7.486 6.532 0 8.713-3.57 8.713-5.212h-9.002l-.007-2.878ZM147.512 18.965c0-6.42 3.748-10.335 12.494-10.335 8.713 0 12.494 3.944 12.494 10.335 0 6.418-3.776 10.392-12.494 10.392-8.746 0-12.494-3.944-12.494-10.392Zm21.582 0c0-5.557-3.011-7.448-9.088-7.448-6.077 0-9.086 1.872-9.086 7.448 0 5.613 3.038 7.513 9.086 7.513s9.088-1.93 9.088-7.513ZM90.891 47.501l3.578 5.872h-7.382l-2.954-5.037H77.8v5.037h-6.246v-20.15h15.617c4.514 0 7.61 3.051 7.61 7.543 0 3.108-1.476 5.554-3.89 6.735Zm-13.09-4.519h7.951c1.164 0 2.782 0 2.782-2.216 0-2.188-1.618-2.188-2.782-2.188h-7.951v4.404ZM114.13 49.429h-10.251l-1.709 3.944h-6.9l9.256-20.15h8.946l9.226 20.15h-6.872l-1.696-3.944Zm-1.989-4.547-3.137-7.225-3.152 7.225h6.289ZM129.848 38.578v3.627h13.061v5.355h-13.061v5.814h-6.246V33.223h21.014v5.355h-14.768ZM152.113 38.578v3.627h13.062v5.355h-13.062v5.814h-6.246V33.223h21.015v5.355h-14.769ZM188.573 48.02v5.353h-20.444v-20.15h6.246v14.796h14.198ZM196.237 38.145v2.995h14.762v4.317h-14.762v2.993h14.762v4.923h-21.015v-20.15h21.015v4.922h-14.762Z",
      fill: "#fff",
      className: "dark:fill-white fill-black"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M60.995 30.14 52.69 9.812A2.238 2.238 0 0 0 51.494 8.6L31.437.174a2.183 2.183 0 0 0-1.708 0L9.683 8.59a2.207 2.207 0 0 0-.717.486 2.242 2.242 0 0 0-.479.726L.172 30.14a2.267 2.267 0 0 0 0 1.732l8.305 20.325a2.238 2.238 0 0 0 1.196 1.213l20.056 8.42a2.194 2.194 0 0 0 1.708 0l20.05-8.419c.268-.112.512-.277.717-.485.205-.208.368-.455.479-.727l8.312-20.334a2.266 2.266 0 0 0 0-1.725Zm-20.502 25.1-8.461-3.553 3.506-8.577 8.46 3.553-3.505 8.576Zm-19.805 0-3.506-8.578 8.46-3.552 3.504 8.577-8.458 3.552ZM6.678 41.036l3.504-8.577 8.46 3.554-3.504 8.577-8.46-3.554Zm14.01-34.276 8.455 3.56-3.506 8.578-8.46-3.554 3.51-8.584Zm19.806 0 3.5 8.584-8.456 3.548-3.51-8.571 8.466-3.561ZM25.304 21.09c.019.066.041.13.068.194l3.076 7.55L21 25.705a2.511 2.511 0 0 0-.191-.07l-3.171-7.76 7.666 3.214Zm-5.363 6.694c.06.031.121.06.183.086l7.447 3.128-7.447 3.127a3.616 3.616 0 0 0-.183.088l-7.663-3.211 7.663-3.218Zm.876 8.575c.066-.019.13-.042.192-.07l7.447-3.126-3.085 7.55a2.835 2.835 0 0 0-.069.192l-7.656 3.217 3.171-7.763Zm15.063 4.55a2.908 2.908 0 0 0-.069-.192l-3.09-7.55 7.447 3.135c.062.027.125.05.19.069l3.172 7.763-7.65-3.225Zm5.356-6.686a3.533 3.533 0 0 0-.183-.088l-7.447-3.133 7.447-3.128c.061-.026.123-.055.183-.087l7.656 3.215-7.656 3.221Zm-.877-8.576c-.065.02-.128.043-.191.069l-7.447 3.12 3.085-7.549c.026-.064.048-.128.068-.194l7.656-3.214-3.17 7.768Zm-6.603-5.435c-.03.06-.06.12-.087.185l-3.076 7.55-3.075-7.55a3.002 3.002 0 0 0-.087-.185l3.152-7.768 3.173 7.768Zm-18.623-2.796 3.504 8.577-8.457 3.554-3.504-8.577 8.457-3.554Zm12.277 24.39c.031-.061.06-.123.088-.187l3.075-7.548 3.075 7.548c.028.063.057.126.087.187l-3.152 7.754-3.172-7.754Zm18.623 2.795-3.504-8.576 8.46-3.554 3.513 8.57-8.469 3.56Zm4.955-15.056-8.46-3.552 3.504-8.577 8.47 3.546-3.514 8.583Zm-.273-18.896 3.152 7.715-7.644-3.21-3.168-7.756 7.61 3.196a.083.083 0 0 1 .051.049l-.002.006ZM30.55 2.182a.088.088 0 0 1 .068 0l7.61 3.195-7.646 3.203-7.644-3.21 7.612-3.188Zm-20.097 8.46a.082.082 0 0 1 .047-.048l7.61-3.196-3.166 7.75-7.644 3.209 3.153-7.715ZM2.149 31.037a.097.097 0 0 1 0-.07l3.148-7.714 3.166 7.749-3.166 7.749-3.148-7.714Zm8.305 20.333L7.3 43.656l7.644 3.21 3.166 7.74-7.61-3.196a.087.087 0 0 1-.047-.04Zm20.16 8.468a.093.093 0 0 1-.068 0l-7.61-3.196 7.647-3.218 7.644 3.21-7.613 3.204Zm20.102-8.468a.082.082 0 0 1-.048.049l-7.613 3.186 3.166-7.748 7.644-3.21-3.149 7.723Zm8.305-20.333-3.152 7.712-3.166-7.747 3.166-7.749 3.152 7.714a.096.096 0 0 1 0 .07Z",
      fill: "#FC3F27"
    })]
  }));
};

/* harmony default export */ var ErgoRaffle = (SvgErgoRaffle);
;// CONCATENATED MODULE: ./components/icons/Heart.js


function Heart_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Heart_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Heart_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Heart_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var SvgHeart = function SvgHeart(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", Heart_objectSpread(Heart_objectSpread({
    width: 20,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M0 5.4A5.4 5.4 0 0 1 5.5 0 5.991 5.991 0 0 1 10 2a5.991 5.991 0 0 1 4.5-2A5.4 5.4 0 0 1 20 5.4c0 5.356-6.379 9.4-10 12.6C6.387 14.773 0 10.76 0 5.4Z",
      fill: "#FF5E18"
    })
  }));
};

/* harmony default export */ var Heart = (SvgHeart);
// EXTERNAL MODULE: ./components/icons/UniqueErgo1.js
var UniqueErgo1 = __webpack_require__(2838);
// EXTERNAL MODULE: ./components/icons/UniqueErgo2.js
var UniqueErgo2 = __webpack_require__(9510);
// EXTERNAL MODULE: ./components/icons/UniqueErgo3.js
var UniqueErgo3 = __webpack_require__(7548);
// EXTERNAL MODULE: ./components/icons/UniqueErgo4.js
var UniqueErgo4 = __webpack_require__(2435);
;// CONCATENATED MODULE: ./components/icons/UniqueErgo1Light.js


function UniqueErgo1Light_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function UniqueErgo1Light_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? UniqueErgo1Light_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : UniqueErgo1Light_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgUniqueErgo1Light = function SvgUniqueErgo1Light(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", UniqueErgo1Light_objectSpread(UniqueErgo1Light_objectSpread({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 290 150",
    width: "100%",
    height: "100%"
  }, props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M211.629 0a75.117 75.117 0 0 1 53.108 21.914 74.777 74.777 0 0 1 22.001 53.064 74.516 74.516 0 0 1-22.001 53.04A74.904 74.904 0 0 1 211.629 150a74.86 74.86 0 0 1-53.085-21.982 74.496 74.496 0 0 1-22-53.04 74.755 74.755 0 0 1 22-53.064A75.096 75.096 0 0 1 211.629 0Zm51.485 23.581A72.583 72.583 0 0 0 239.5 7.795a72.64 72.64 0 0 0-27.871-5.52 72.64 72.64 0 0 0-27.858 5.524 72.59 72.59 0 0 0-23.604 15.782 72.524 72.524 0 0 0-15.8 23.595 72.47 72.47 0 0 0-5.524 27.846 72.524 72.524 0 0 0 21.324 51.487 72.62 72.62 0 0 0 51.462 21.306 72.596 72.596 0 0 0 51.485-21.306 72.543 72.543 0 0 0 21.325-51.486 72.508 72.508 0 0 0-21.325-51.441Z",
      fill: "url(#unique-ergo-1-light_svg__a)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M174.228 46.956a1.783 1.783 0 0 1-2.377.368 1.714 1.714 0 0 1-.324-2.373 50.66 50.66 0 0 1 18.42-15.128 49.851 49.851 0 0 1 23.056-4.94 50.034 50.034 0 0 1 19.077 4.272 49.991 49.991 0 0 1 15.979 11.254 50.064 50.064 0 0 1 13.779 35.718 50.09 50.09 0 0 1-15.561 35.025 50.007 50.007 0 0 1-35.903 13.652 49.065 49.065 0 0 1-22.777-6.16 49.818 49.818 0 0 1-17.637-15.967 1.708 1.708 0 0 1 .443-2.354 1.711 1.711 0 0 1 2.355.487 46.737 46.737 0 0 0 16.289 14.896 46.091 46.091 0 0 0 21.298 5.762 46.62 46.62 0 0 0 33.357-12.836 46.572 46.572 0 0 0 14.511-32.686 46.528 46.528 0 0 0-12.848-33.33 46.622 46.622 0 0 0-32.669-14.497 46.104 46.104 0 0 0-21.561 4.685 46.082 46.082 0 0 0-16.907 14.152Z",
      fill: "url(#unique-ergo-1-light_svg__b)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M103.655 148.895c40.859 0 73.981-33.094 73.981-73.919 0-40.824-33.122-73.918-73.981-73.918-40.859 0-73.981 33.094-73.981 73.918 0 40.825 33.122 73.919 73.981 73.919Z",
      stroke: "#121212",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M33.164 1.487A38.683 38.683 0 0 1 61.821 8.8a38.62 38.62 0 0 1 15.096 25.413 38.594 38.594 0 0 1-7.31 28.647 38.678 38.678 0 0 1-25.443 15.092 38.728 38.728 0 0 1-28.66-7.32A38.665 38.665 0 0 1 .39 45.226a38.647 38.647 0 0 1 7.333-28.643A38.71 38.71 0 0 1 33.164 1.487Z",
      fill: "url(#unique-ergo-1-light_svg__c)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M275.986 125.044c7.519 0 13.615-6.09 13.615-13.603 0-7.514-6.096-13.604-13.615-13.604-7.52 0-13.615 6.09-13.615 13.604 0 7.513 6.095 13.603 13.615 13.603ZM207.237 33.398a6.58 6.58 0 0 0 6.582-6.576 6.58 6.58 0 0 0-6.582-6.577 6.579 6.579 0 0 0-6.582 6.577 6.579 6.579 0 0 0 6.582 6.576Z",
      fill: "#121212"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M157.055 81.555a6.58 6.58 0 0 0 6.583-6.577 6.58 6.58 0 0 0-6.583-6.577 6.58 6.58 0 0 0-6.582 6.577 6.58 6.58 0 0 0 6.582 6.577Z",
      fill: "#FF5E18"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("defs", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "unique-ergo-1-light_svg__a",
        x1: 196.12,
        y1: 38.22,
        x2: 241.139,
        y2: 144.103,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#FF5E18",
          stopOpacity: 0
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 0.4,
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#FF5E18"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "unique-ergo-1-light_svg__b",
        x1: 215.663,
        y1: 104.659,
        x2: 246.7,
        y2: 34.453,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#FF5E18",
          stopOpacity: 0
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 0.54,
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#FF5E18"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("radialGradient", {
        id: "unique-ergo-1-light_svg__c",
        cx: 0,
        cy: 0,
        r: 1,
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "matrix(0 38.6222 -38.656 0 38.656 39.718)",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 0.609,
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 0.969,
          stopColor: "#FF5E18",
          stopOpacity: 0
        })]
      })]
    })]
  }));
};

/* harmony default export */ var UniqueErgo1Light = (SvgUniqueErgo1Light);
;// CONCATENATED MODULE: ./components/icons/UniqueErgo2Light.js


function UniqueErgo2Light_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function UniqueErgo2Light_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? UniqueErgo2Light_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : UniqueErgo2Light_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgUniqueErgo2Light = function SvgUniqueErgo2Light(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", UniqueErgo2Light_objectSpread(UniqueErgo2Light_objectSpread({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 148 151",
    width: "100%",
    height: "100%"
  }, props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M73.838 150c40.228 0 72.838-32.583 72.838-72.777 0-40.193-32.61-72.777-72.838-72.777C33.611 4.446 1 37.03 1 77.223 1 117.417 33.61 150 73.838 150Z",
      stroke: "#121212",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M73.84 120.081c23.691 0 42.896-19.189 42.896-42.86 0-23.67-19.205-42.859-42.895-42.859-23.69 0-42.896 19.19-42.896 42.86 0 23.67 19.205 42.859 42.896 42.859Z",
      stroke: "#121212",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M68.121 38.242a39.519 39.519 0 0 1 29.276 7.467 39.435 39.435 0 0 1 15.421 25.955 39.408 39.408 0 0 1-7.475 29.243 39.493 39.493 0 0 1-41.363 14.582 39.479 39.479 0 0 1-13.894-6.64 39.43 39.43 0 0 1-10.29-11.448A39.384 39.384 0 0 1 34.68 82.89a39.44 39.44 0 0 1 7.478-29.232 39.525 39.525 0 0 1 25.964-15.416Z",
      fill: "url(#unique-ergo-2-light_svg__a)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M73.84 124.475c2.457 0 4.45-1.99 4.45-4.446a4.447 4.447 0 0 0-4.45-4.445 4.447 4.447 0 0 0-4.45 4.445 4.447 4.447 0 0 0 4.45 4.446Z",
      fill: "#FF5E18"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M92.694 28.179a1.327 1.327 0 0 1-.789-1.793 1.326 1.326 0 0 1 1.794-.789 55.299 55.299 0 0 1 25.78 20.31 55.173 55.173 0 0 1 9.616 31.37 55.082 55.082 0 0 1-9.687 31.189 55.238 55.238 0 0 1-25.78 20.328 1.343 1.343 0 0 1-1.068-.007 1.353 1.353 0 0 1-.727-.782 1.379 1.379 0 0 1 .79-1.793 52.501 52.501 0 0 0 24.488-19.323 51.95 51.95 0 0 0 9.275-29.613 52.05 52.05 0 0 0-9.203-29.702 52.773 52.773 0 0 0-24.489-19.395ZM55.02 126.212a1.387 1.387 0 0 1 .885 1.261c.004.182-.029.362-.095.532a1.366 1.366 0 0 1-1.794.789 55.231 55.231 0 0 1-25.78-20.328 54.961 54.961 0 0 1-9.617-31.19 55.052 55.052 0 0 1 9.706-31.244 55.303 55.303 0 0 1 25.78-20.31 1.346 1.346 0 0 1 1.794.79 1.325 1.325 0 0 1-.789 1.792A52.773 52.773 0 0 0 30.55 47.52a51.953 51.953 0 0 0-9.204 29.756 51.74 51.74 0 0 0 9.204 29.667 52.503 52.503 0 0 0 24.488 19.269h-.018Z",
      fill: "url(#unique-ergo-2-light_svg__b)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M95.8 15.523a7.764 7.764 0 0 0 7.768-7.761A7.764 7.764 0 0 0 95.8 0c-4.29 0-7.768 3.475-7.768 7.762 0 4.286 3.478 7.761 7.768 7.761ZM20.056 137.094c5.985 0 10.836-4.847 10.836-10.827 0-5.979-4.851-10.827-10.836-10.827-5.984 0-10.836 4.848-10.836 10.827 0 5.98 4.852 10.827 10.836 10.827Z",
      fill: "#FF5E18"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("defs", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("radialGradient", {
        id: "unique-ergo-2-light_svg__a",
        cx: 0,
        cy: 0,
        r: 1,
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "matrix(0 39.4357 -39.469 0 73.75 77.278)",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 0.557,
          stopColor: "#FF5E18",
          stopOpacity: 0.589
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#FF5E18",
          stopOpacity: 0
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "unique-ergo-2-light_svg__b",
        x1: 58.501,
        y1: 80.862,
        x2: 57.605,
        y2: 25.294,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 0.34,
          stopColor: "#FF5E18",
          stopOpacity: 0.46
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#FF5E18",
          stopOpacity: 0
        })]
      })]
    })]
  }));
};

/* harmony default export */ var UniqueErgo2Light = (SvgUniqueErgo2Light);
;// CONCATENATED MODULE: ./components/icons/UniqueErgo3Light.js


function UniqueErgo3Light_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function UniqueErgo3Light_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? UniqueErgo3Light_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : UniqueErgo3Light_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgUniqueErgo3Light = function SvgUniqueErgo3Light(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", UniqueErgo3Light_objectSpread(UniqueErgo3Light_objectSpread({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 151 150",
    width: "100%",
    height: "100%"
  }, props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m90.883 89.643 59.321 59.255-1.151 1.102-59.305-59.255 1.135-1.102Z",
      fill: "url(#unique-ergo-3-light_svg__a)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M74.413 74.305c28.653-28.63 59.881-43.919 69.714-34.141 9.834 9.777-5.516 41.026-34.185 69.656-28.67 28.629-59.881 43.966-69.715 34.14-9.833-9.825 5.5-40.962 34.186-69.655Z",
      stroke: "#121212",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M115.318 56.858a41.69 41.69 0 0 1 16.251 27.418 41.667 41.667 0 0 1-7.873 30.879 41.694 41.694 0 0 1-58.346 8.371 41.624 41.624 0 0 1-8.379-58.296 41.69 41.69 0 0 1 43.677-15.39 41.685 41.685 0 0 1 14.67 7.018Z",
      fill: "url(#unique-ergo-3-light_svg__b)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M103.198 76.621a.764.764 0 0 1 0 1.103.766.766 0 0 1-1.135 0 122.774 122.774 0 0 1-24.448-35.355C70.244 26.68 66.422 11.168 65.958.83a.846.846 0 0 1 .8-.83.832.832 0 0 1 .847.75c.432 10.257 4.142 25.562 11.465 41.01a120.714 120.714 0 0 0 24.128 34.86ZM76.256 100.89a.847.847 0 0 1 0 1.15.848.848 0 0 1-1.151 0 116.492 116.492 0 0 0-34.138-23.82C25.889 71.222 11.034 67.835.753 67.34a.783.783 0 0 1-.751-.83.767.767 0 0 1 .847-.751c10.441.48 25.583 3.914 40.821 11.055a117.707 117.707 0 0 1 34.586 24.06v.016Zm6.747-6.07a.814.814 0 0 1 0 1.134.816.816 0 0 1-1.15 0 226.818 226.818 0 0 0-31.884-26.648c-13.144-9.17-25.184-15.513-32.987-18.42a.768.768 0 0 1-.447-1.007.784.784 0 0 1 1.023-.496c7.995 2.956 20.067 9.394 33.338 18.596a232.666 232.666 0 0 1 32.107 26.824v.016Zm6.748-6.04a.782.782 0 0 1 0 1.103.848.848 0 0 1-1.151 0C74.8 76.094 60.73 61.908 49.697 50.836 42.95 44.062 37.45 38.503 33.164 34.237a.782.782 0 0 1 0-1.102.816.816 0 0 1 1.151 0c3.342 3.339 9.306 9.298 16.485 16.567C61.433 60.39 75.01 74.049 89.75 88.763v.016Zm6.731-6.087a.75.75 0 0 1 0 1.103.798.798 0 0 1-1.135 0 227.707 227.707 0 0 1-26.91-32.288c-9.386-13.58-15.99-26.04-18.948-34.013a.75.75 0 0 1 .48-1.022.768.768 0 0 1 1.007.447c2.91 7.876 9.45 20.226 18.74 33.71a231.91 231.91 0 0 0 26.767 32.048v.015Z",
      fill: "url(#unique-ergo-3-light_svg__c)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M85.464 85.329c8.779-8.819 18.117-13.756 20.787-11.056 2.67 2.7-2.255 11.982-11.08 20.77-8.827 8.786-18.117 13.755-20.787 11.055-2.67-2.7 2.254-11.903 11.08-20.77ZM129.515 34.476a6.815 6.815 0 0 1 0 9.745 6.896 6.896 0 0 1-9.738 0 6.863 6.863 0 0 1-1.501-7.51 6.865 6.865 0 0 1 1.501-2.235 6.894 6.894 0 0 1 9.738 0ZM59.495 142.905a4.003 4.003 0 0 1 1.19 2.844 3.99 3.99 0 0 1-1.19 2.844 4 4 0 0 1-5.645 0 3.987 3.987 0 0 1-1.197-2.844 3.97 3.97 0 0 1 1.197-2.844 4.034 4.034 0 0 1 5.645 0Z",
      fill: "#FF5E18"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M93.841 66.428a1.216 1.216 0 0 1-1.678-.223 1.198 1.198 0 0 1 .223-1.598 86.72 86.72 0 0 1 22.849-13.548c6.7-2.428 12.073-2.38 15.031.623 2.958 3.004 3.006 8.324.623 15.018a89.993 89.993 0 0 1-13.495 22.83 1.278 1.278 0 0 1-1.727.223 1.196 1.196 0 0 1-.176-1.677 87.85 87.85 0 0 0 13.144-22.159c2.078-5.831 2.206-10.32 0-12.557-2.207-2.237-6.748-2.125-12.568 0a85.21 85.21 0 0 0-22.226 13.068Zm-5.692 48.903a1.268 1.268 0 0 1 1.727.224 1.181 1.181 0 0 1-.224 1.597 87.12 87.12 0 0 1-22.88 13.484c-6.717 2.429-12.041 2.381-15.047-.607-3.006-2.987-2.99-8.339-.576-15.033a88.554 88.554 0 0 1 13.495-22.814 1.199 1.199 0 0 1 1.68-.224 1.198 1.198 0 0 1 .223 1.598 84.808 84.808 0 0 0-13.143 22.207c-2.079 5.767-2.207 10.256 0 12.509 2.206 2.252 6.747 2.109 12.52 0 6.395-2.125 14.118-6.646 22.225-12.941Z",
      fill: "url(#unique-ergo-3-light_svg__d)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M80.972 80.823c16.885-16.87 34.794-26.345 39.974-21.184 5.181 5.16-4.365 23.037-21.25 39.94-16.885 16.903-34.745 26.344-39.974 21.184-5.228-5.16 4.35-23.053 21.25-39.94Z",
      stroke: "url(#unique-ergo-3-light_svg__e)",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("defs", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "unique-ergo-3-light_svg__a",
        x1: 129.946,
        y1: 140.526,
        x2: 100.527,
        y2: 110.475,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#fff",
          stopOpacity: 0
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 0.505,
          stopColor: "#DBDBDB"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#FF5E18"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "unique-ergo-3-light_svg__c",
        x1: 29.212,
        y1: 33.486,
        x2: 81.136,
        y2: 83.854,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#25211A",
          stopOpacity: 0
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 0.515,
          stopColor: "#824E38"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#FF5E18"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "unique-ergo-3-light_svg__d",
        x1: 83.577,
        y1: 75.822,
        x2: 117.929,
        y2: 106.206,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#fff",
          stopOpacity: 0
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 0.526,
          stopColor: "#FF5E18"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "unique-ergo-3-light_svg__e",
        x1: 102.136,
        y1: 103.416,
        x2: 81.196,
        y2: 84.186,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#121212"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#121212",
          stopOpacity: 0
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("radialGradient", {
        id: "unique-ergo-3-light_svg__b",
        cx: 0,
        cy: 0,
        r: 1,
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "rotate(48.745 -54.38 144.783) scale(38.2633 38.253)",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 0.578,
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 0.97,
          stopColor: "#FF5E18",
          stopOpacity: 0
        })]
      })]
    })]
  }));
};

/* harmony default export */ var UniqueErgo3Light = (SvgUniqueErgo3Light);
;// CONCATENATED MODULE: ./components/icons/UniqueErgo4Light.js


function UniqueErgo4Light_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function UniqueErgo4Light_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? UniqueErgo4Light_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : UniqueErgo4Light_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgUniqueErgo4Light = function SvgUniqueErgo4Light(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", UniqueErgo4Light_objectSpread(UniqueErgo4Light_objectSpread({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 140 151",
    width: "100%",
    height: "100%"
  }, props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M63.343 26a44.072 44.072 0 0 1 32.623 8.35 44 44 0 0 1 16.27 46.085 43.948 43.948 0 0 1-7.414 15.49 44 44 0 0 1-28.994 17.178 44.07 44.07 0 0 1-32.655-8.33 44 44 0 0 1-17.2-28.959 44.013 44.013 0 0 1 8.366-32.635 44.084 44.084 0 0 1 29.004-17.178Z",
      fill: "url(#unique-ergo-4-light_svg__a)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M69.643 1a68.706 68.706 0 0 0-48.54 20.11A68.59 68.59 0 0 0 1 69.618a68.525 68.525 0 0 0 10.303 36.094 68.6 68.6 0 0 0 27.777 25.266c7.35 3.68 14.58 1.773 17.554-4.287 3.598-7.208 3.497-16.88-4.325-20.611a40.383 40.383 0 0 1-16.814-14.895 40.336 40.336 0 0 1-6.247-21.567 40.314 40.314 0 0 1 11.826-28.544 40.382 40.382 0 0 1 28.569-11.816 40.375 40.375 0 0 1 28.545 11.824 40.301 40.301 0 0 1 11.799 28.536 40.336 40.336 0 0 1-6.247 21.567 40.386 40.386 0 0 1-16.814 14.895c-7.823 3.714-7.873 13.403-4.342 20.611 3.04 6.06 10.255 7.967 17.621 4.287a68.64 68.64 0 0 0 27.734-25.282 68.567 68.567 0 0 0 10.279-36.078 68.514 68.514 0 0 0-20.06-48.504 68.607 68.607 0 0 0-22.255-14.88A68.659 68.659 0 0 0 69.643 1v0Z",
      stroke: "#121212",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M88.515 20.311a1.283 1.283 0 0 1-.76-1.688 1.351 1.351 0 0 1 1.69-.742 55.744 55.744 0 0 1 25.764 20.256 54.803 54.803 0 0 1 9.765 31.482 54.674 54.674 0 0 1-9.681 31.245 55.576 55.576 0 0 1-25.764 20.257 1.373 1.373 0 0 1-1.69-.743 1.316 1.316 0 0 1 .76-1.688 52.912 52.912 0 0 0 24.549-19.328 52.557 52.557 0 0 0 9.241-29.743 52.634 52.634 0 0 0-9.241-29.895 53.346 53.346 0 0 0-24.633-19.412Zm-37.793 98.463a1.314 1.314 0 0 1 .724.69 1.3 1.3 0 0 1 .02.998 1.278 1.278 0 0 1-1.187.838 1.291 1.291 0 0 1-.503-.095 55.748 55.748 0 0 1-25.815-20.256 54.948 54.948 0 0 1-9.63-31.33 55.048 55.048 0 0 1 9.698-31.28 55.575 55.575 0 0 1 25.815-20.256 1.282 1.282 0 0 1 1.69.743 1.247 1.247 0 0 1-.744 1.688A52.872 52.872 0 0 0 26.19 39.926 52.164 52.164 0 0 0 16.85 69.62a52.08 52.08 0 0 0 9.275 29.794 52.364 52.364 0 0 0 24.598 19.361Z",
      fill: "url(#unique-ergo-4-light_svg__b)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M69.644 76.877a7.312 7.312 0 0 0 7.315-7.309 7.312 7.312 0 0 0-7.315-7.31 7.312 7.312 0 0 0-7.315 7.31 7.312 7.312 0 0 0 7.315 7.31Z",
      fill: "#121212"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M68.32 69.62a1.333 1.333 0 0 1 1.319-1.3 1.285 1.285 0 0 1 1.267 1.3v80.079a1.284 1.284 0 0 1-1.25 1.3 1.335 1.335 0 0 1-1.318-1.3l-.017-80.08Z",
      fill: "url(#unique-ergo-4-light_svg__c)"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("defs", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "unique-ergo-4-light_svg__b",
        x1: 46.8,
        y1: 31.639,
        x2: 69.55,
        y2: 131.962,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 0.51,
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#fff",
          stopOpacity: 0
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "unique-ergo-4-light_svg__c",
        x1: 62.85,
        y1: 142.204,
        x2: 62.007,
        y2: 72.994,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#fff",
          stopOpacity: 0
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 0.681,
          stopColor: "#121212"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#121212"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("radialGradient", {
        id: "unique-ergo-4-light_svg__a",
        cx: 0,
        cy: 0,
        r: 1,
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "matrix(0 43.9948 -44.0349 0 69.565 69.555)",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 0.443,
          stopColor: "#FF5E18"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 0.964,
          stopColor: "#FF5E18",
          stopOpacity: 0
        })]
      })]
    })]
  }));
};

/* harmony default export */ var UniqueErgo4Light = (SvgUniqueErgo4Light);
;// CONCATENATED MODULE: ./components/icons/WalletMinotaur.js


function WalletMinotaur_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function WalletMinotaur_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? WalletMinotaur_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : WalletMinotaur_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgWalletMinotaur = function SvgWalletMinotaur(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", WalletMinotaur_objectSpread(WalletMinotaur_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1337pt",
    height: "1337pt",
    viewBox: "0 0 1337 1337"
  }, props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      stroke: "#ff4221",
      strokeWidth: 8,
      d: "m12 280 178.333 140h187c170 0 170 0 263.334 140L660 589l-85 127.5L470.667 560h-187c-85 0-85 0-178.334-140L12 280zM1325 280l-178.333 140h-187c-170 0-170 0-263.334 140L583.5 729.25l85 127.5L866.333 560h187c85 0 85 0 178.334-140L1325 280z"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      stroke: "#ff4221",
      strokeWidth: 8,
      d: "M295 577h170l280 420H575L435 787c-10-15-25-75-10-90-50 0-50 0-130-120zM1042 577H872L677 869.5 762 997l140-210c10-15 25-75 10-90 50 0 50 0 130-120z"
    })]
  }));
};

/* harmony default export */ var WalletMinotaur = (SvgWalletMinotaur);
;// CONCATENATED MODULE: ./components/icons/WalletNautilus.js


function WalletNautilus_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function WalletNautilus_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? WalletNautilus_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : WalletNautilus_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgWalletNautilus = function SvgWalletNautilus(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", WalletNautilus_objectSpread(WalletNautilus_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    style: {
      enableBackground: 'new 0 0 1417.3 1417.3'
    },
    xmlSpace: "preserve",
    id: "wallet-nautilus_svg__svg230",
    viewBox: "414.37 258.52 575.6 575.6"
  }, props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("defs", {
      id: "wallet-nautilus_svg__defs234",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "wallet-nautilus_svg__SVGID_1_",
        gradientUnits: "userSpaceOnUse",
        x1: 221.06,
        y1: 1266.04,
        x2: 316.775,
        y2: 1266.04,
        gradientTransform: "rotate(179.899 496.251 848.76) scale(1.09098)",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 0,
          style: {
            stopColor: '#ffeabd'
          },
          id: "wallet-nautilus_svg__stop91"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          style: {
            stopColor: '#ffc027'
          },
          id: "wallet-nautilus_svg__stop93"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        y2: 500.892,
        x2: 772.494,
        y1: 500.892,
        x1: 629.244,
        gradientUnits: "userSpaceOnUse",
        id: "wallet-nautilus_svg__SVGID_00000085238500194547172150000002663939323965651385_",
        gradientTransform: "matrix(1.09098 0 0 1.09098 -66.042 -60.229)",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          id: "wallet-nautilus_svg__stop200",
          style: {
            stopColor: '#ffeabd'
          },
          offset: 0
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          id: "wallet-nautilus_svg__stop202",
          style: {
            stopColor: '#ffc027'
          },
          offset: 1
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("style", {
      type: "text/css",
      id: "style2",
      children: '.wallet-nautilus_svg__st0,.wallet-nautilus_svg__st2{fill:#ffae00}.wallet-nautilus_svg__st2,.wallet-nautilus_svg__st3{stroke:#000;strokeWidth:3;strokeLinecap:round;strokeLinejoin:round;strokeMiterlimit:10}.wallet-nautilus_svg__st4{fill:#ffeabd}'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      id: "wallet-nautilus_svg__g39",
      transform: "translate(.767 -1.182)",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        className: "wallet-nautilus_svg__st0",
        d: "M701.4 835.3c-76.9 0-149.2-29.9-203.5-84.3-54.4-54.4-84.3-126.7-84.3-203.5s29.9-149.2 84.3-203.5c54.4-54.4 126.7-84.3 203.5-84.3s149.2 29.9 203.5 84.3c54.4 54.4 84.3 126.7 84.3 203.5S959.3 696.7 904.9 751c-54.4 54.3-126.7 84.3-203.5 84.3zm0-560.4c-72.8 0-141.2 28.3-192.7 79.8s-79.8 119.9-79.8 192.7c0 72.8 28.3 141.2 79.8 192.7s119.9 79.8 192.7 79.8c72.8 0 141.2-28.3 192.7-79.8s79.8-119.9 79.8-192.7c0-72.8-28.4-141.2-79.9-192.7-51.4-51.5-119.9-79.8-192.6-79.8z",
        id: "wallet-nautilus_svg__path37",
        style: {
          fill: '#ffae00'
        }
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      id: "wallet-nautilus_svg__g1539",
      transform: "translate(13.422 8.323) scale(.98509)",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
        transform: "matrix(1.09098 0 0 1.09098 -66.042 -60.229)",
        id: "wallet-nautilus_svg__g47",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          id: "wallet-nautilus_svg__path43",
          d: "M701.4 788.8c-60.1 0-106.9-34.7-129.4-55.3-31.5-28.9-53.5-65-53.5-87.8 0-13 7.4-18.5 24.8-18.5 13.1 0 30.9 3.1 51.5 6.8 29.8 5.2 66.9 11.8 106.7 11.8s76.9-6.5 106.7-11.8c20.6-3.6 38.4-6.8 51.5-6.8 17.4 0 24.8 5.5 24.8 18.5 0 22.8-22 58.9-53.5 87.8-22.7 20.7-69.5 55.3-129.6 55.3z"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          id: "wallet-nautilus_svg__path45",
          d: "M859.6 628.9c8.2 0 13.9 1.2 17.6 3.8 3.7 2.6 5.5 6.7 5.5 13 0 18.3-16.6 53.2-53 86.6-22.3 20.5-68.7 54.9-128.3 54.9-59.6 0-106-34.4-128.3-54.9-36.4-33.4-53-68.3-53-86.6 0-6.3 1.7-10.4 5.5-13 3.7-2.6 9.4-3.8 17.6-3.8 12.9 0 30.7 3.1 51.2 6.7 29.9 5.3 67.1 11.8 107 11.8 39.9 0 77.1-6.5 107-11.8 20.5-3.6 38.2-6.7 51.2-6.7m0-3.3c-32.3 0-91.1 18.5-158.2 18.5s-125.9-18.5-158.2-18.5c-16.8 0-26.4 5-26.4 20.2 0 44.4 82.7 144.8 184.6 144.8 101.9 0 184.6-100.5 184.6-144.9 0-15.1-9.7-20.1-26.4-20.1z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        style: {
          fill: '#ffae00',
          strokeWidth: 1.09097826
        },
        id: "wallet-nautilus_svg__path53",
        d: "M857.798 623.924c0 38.184-71.023 124.48-158.737 124.48-87.715 0-158.629-86.405-158.629-124.48s71.023-1.419 158.738-1.419 158.628-36.766 158.628 1.419z",
        className: "wallet-nautilus_svg__st0"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
        transform: "matrix(1.09098 0 0 1.09098 -66.042 -60.229)",
        id: "wallet-nautilus_svg__g57",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          style: {
            fill: '#fff'
          },
          id: "wallet-nautilus_svg__path55",
          d: "M701.4 747.6c-68.2 0-122.2-52.9-141.8-88.5-1.7-3.1-.6-7.1 2.5-8.8 3.1-1.7 7.1-.6 8.8 2.5 10.9 19.8 29.3 39.6 50.5 54.5 17.7 12.4 46 27.3 79.9 27.3 3.6 0 6.5 2.9 6.5 6.5s-2.9 6.5-6.4 6.5z"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
        transform: "matrix(1.09098 0 0 1.09098 -66.042 -60.229)",
        id: "wallet-nautilus_svg__g63",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          id: "wallet-nautilus_svg__path59",
          d: "M701.4 663.2c-30.1 0-50.8-1.7-67.1-5.4-18.6-4.3-32-11.4-42.2-22.3-20.5-22.1-28.9-61.3-28.9-135.1 0-78.5 62-142.4 138.2-142.4 76.2 0 138.2 63.9 138.2 142.4 0 73.8-8.4 113-28.9 135.1-21.4 23.1-57.7 27.7-109.3 27.7z"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          id: "wallet-nautilus_svg__path61",
          d: "M701.4 359.5c36.5 0 70.8 14.6 96.6 41.2 25.8 26.6 40.1 62 40.1 99.6 0 73.4-8.2 112.3-28.5 134.1-9.9 10.7-23.1 17.7-41.4 21.9-16.2 3.7-36.8 5.4-66.8 5.4s-50.6-1.7-66.8-5.4c-18.3-4.2-31.5-11.2-41.4-21.9-20.2-21.8-28.5-60.7-28.5-134.1 0-37.6 14.2-73 40.1-99.6 25.7-26.5 60.1-41.2 96.6-41.2m0-3c-77.2 0-139.7 64.4-139.7 143.9 0 143.9 31.5 164.3 139.7 164.3 108.2 0 139.7-20.4 139.7-164.3 0-79.5-62.6-143.9-139.7-143.9z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("ellipse", {
        style: {
          fill: '#ffae00',
          stroke: '#000',
          strokeWidth: 3.27293491,
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: 10
        },
        id: "wallet-nautilus_svg__ellipse65",
        ry: 156.992,
        rx: 152.41,
        cy: 485.697,
        cx: 699.17,
        className: "wallet-nautilus_svg__st2"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        style: {
          stroke: '#000',
          strokeWidth: 3.27293491,
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: 10
        },
        id: "wallet-nautilus_svg__path77",
        d: "M606.873 360.67c6.982-5.127 19.856-10.145 38.839-.108l-15.492-14.729z",
        className: "wallet-nautilus_svg__st3"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        style: {
          stroke: '#000',
          strokeWidth: 3.27293491,
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: 10
        },
        id: "wallet-nautilus_svg__path79",
        d: "M791.14 360.67c-6.983-5.127-20.184-10.036-39.167.11l14.838-14.947z",
        className: "wallet-nautilus_svg__st3"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        style: {
          fill: '#ffae00',
          stroke: '#000',
          strokeWidth: 3.27293491,
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: 10
        },
        id: "wallet-nautilus_svg__path81",
        d: "M772.374 323.905c0-17.892-32.838-32.293-73.313-32.293-40.476 0-73.314 14.51-73.314 32.293v14.51c0 17.892 32.838 32.293 73.314 32.293 40.475 0 73.313-14.51 73.313-32.293v-14.51z",
        className: "wallet-nautilus_svg__st2"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
        transform: "matrix(1.09098 0 0 1.09098 -66.042 -60.229)",
        id: "wallet-nautilus_svg__g85",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          style: {
            fill: '#ffeabd'
          },
          id: "wallet-nautilus_svg__path83",
          d: "M607.5 643.5c-5.8 0-10.4-4.7-10.4-10.4s4.7-10.4 10.4-10.4 10.4 4.7 10.4 10.4-4.7 10.4-10.4 10.4zm0-15.9c-3 0-5.4 2.4-5.4 5.4 0 3 2.4 5.4 5.4 5.4 3 0 5.4-2.4 5.4-5.4 0-3-2.4-5.4-5.4-5.4z",
          className: "wallet-nautilus_svg__st4"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
        transform: "matrix(1.09098 0 0 1.09098 -66.042 -60.229)",
        id: "wallet-nautilus_svg__g89",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          style: {
            fill: '#ffeabd'
          },
          id: "wallet-nautilus_svg__path87",
          d: "M794.7 645.3c-5.8 0-10.4-4.7-10.4-10.4s4.7-10.4 10.4-10.4 10.4 4.7 10.4 10.4-4.6 10.4-10.4 10.4zm0-15.9c-3 0-5.4 2.4-5.4 5.4 0 3 2.4 5.4 5.4 5.4 3 0 5.4-2.4 5.4-5.4 0-3-2.4-5.4-5.4-5.4z",
          className: "wallet-nautilus_svg__st4"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("ellipse", {
        style: {
          fill: 'url(#wallet-nautilus_svg__SVGID_1_)',
          stroke: '#000',
          strokeWidth: 3.27293491,
          strokeMiterlimit: 10
        },
        id: "wallet-nautilus_svg__ellipse96",
        ry: 23.02,
        rx: 52.258,
        cy: 316.268,
        cx: 699.17
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
        transform: "matrix(1.09098 0 0 1.09098 -66.042 -60.229)",
        id: "wallet-nautilus_svg__g100",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          id: "wallet-nautilus_svg__path98",
          d: "M701.4 367.9c-36.2 0-64.5-10-64.5-22.8s28.3-22.8 64.5-22.8 64.5 10 64.5 22.8-28.4 22.8-64.5 22.8zm0-42.2c-36.5 0-61 10-61 19.4 0 9.4 24.5 19.4 61 19.4s61-10 61-19.4c0-9.4-24.5-19.4-61-19.4z"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
        transform: "matrix(1.09098 0 0 1.09098 -66.042 -60.229)",
        id: "wallet-nautilus_svg__g104",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          id: "wallet-nautilus_svg__path102",
          d: "M744.6 355c-28.2-9.6-60.5-9.6-86.5 0l-1-2.8c26.6-9.9 59.7-9.9 88.5 0z"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
        transform: "matrix(1.09098 0 0 1.09098 -66.042 -60.229)",
        id: "wallet-nautilus_svg__g108",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          id: "wallet-nautilus_svg__path106",
          d: "M745.9 339.3c-28.1-9.6-63-9.6-89 0l-1-2.8c26.5-9.8 62.3-9.8 91 0z"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
        transform: "matrix(1.09098 0 0 1.09098 -66.042 -60.229)",
        id: "wallet-nautilus_svg__g118",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("g", {
          id: "wallet-nautilus_svg__g112",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
            id: "wallet-nautilus_svg__path110",
            d: "M682.8 366c-4.7-12.6-4.7-28.8 0-42.4l2.8 1c-4.4 13-4.4 28.5 0 40.4z"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
          id: "wallet-nautilus_svg__g116",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
            id: "wallet-nautilus_svg__path114",
            d: "m719.9 365.9-2.8-1c4.4-13 4.4-28.5 0-40.4l2.8-1c4.6 12.6 4.6 28.8 0 42.4z"
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        style: {
          stroke: '#000',
          strokeWidth: 3.27293491,
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: 10
        },
        id: "wallet-nautilus_svg__path120",
        d: "M587.563 378.78c.327-.545-21.82 33.167-21.82 33.167l19.638 19.528c-.11 0-14.62-25.092 2.182-52.694z",
        className: "wallet-nautilus_svg__st3"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        style: {
          stroke: '#000',
          strokeWidth: 3.27293491,
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: 10
        },
        id: "wallet-nautilus_svg__path122",
        d: "M810.34 378.78c-.327-.545 21.82 33.167 21.82 33.167l-19.638 19.528c.11 0 14.62-25.092-2.181-52.694z",
        className: "wallet-nautilus_svg__st3"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        style: {
          stroke: '#000',
          strokeWidth: 3.27293491,
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: 10
        },
        id: "wallet-nautilus_svg__path124",
        d: "M574.471 552.574c-6.219 7.527-11.455 20.51-6.982 27.929l-11.783-18.11s-.218-16.474.546-16.474c.763 0 18.219 6.655 18.219 6.655z",
        className: "wallet-nautilus_svg__st3"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        style: {
          stroke: '#000',
          strokeWidth: 3.27293491,
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: 10
        },
        id: "wallet-nautilus_svg__path126",
        d: "M824.087 553.883c6.218 7.528 11.128 19.092 6.655 26.62l11.782-18.11s.219-16.474-.545-16.474-17.892 7.964-17.892 7.964z",
        className: "wallet-nautilus_svg__st3"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
        transform: "matrix(1.09098 0 0 1.09098 -66.042 -60.229)",
        id: "wallet-nautilus_svg__g159",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          style: {
            fill: '#ffae00',
            stroke: '#000',
            strokeWidth: 3,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeMiterlimit: 10
          },
          id: "wallet-nautilus_svg__path128",
          d: "M570.6 432.4c-16.4 0-29.6 30.1-29.6 67.2s13.3 67.2 29.6 67.2h6c16.4 0 29.6-30.1 29.6-67.2s-13.3-67.2-29.6-67.2h-6z",
          className: "wallet-nautilus_svg__st2"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
          gradientTransform: "rotate(90 -1315.372 2755.511)",
          y2: 879.72,
          x2: -3523.486,
          y1: 879.72,
          x1: -3619.201,
          gradientUnits: "userSpaceOnUse",
          id: "wallet-nautilus_svg__SVGID_00000176005321536671225770000008511700494046240935_",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
            id: "wallet-nautilus_svg__stop130",
            style: {
              stopColor: '#ffeabd'
            },
            offset: 0
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
            id: "wallet-nautilus_svg__stop132",
            style: {
              stopColor: '#ffc027'
            },
            offset: 1
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("ellipse", {
          id: "wallet-nautilus_svg__ellipse135",
          ry: 47.9,
          rx: 21.1,
          cy: 499.5,
          cx: 560.4,
          style: {
            fill: 'url(#wallet-nautilus_svg__SVGID_00000176005321536671225770000008511700494046240935_)',
            stroke: '#000',
            strokeWidth: 3,
            strokeMiterlimit: 10
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
          id: "wallet-nautilus_svg__g139",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
            id: "wallet-nautilus_svg__path137",
            d: "M564.8 567.2v-3.4c9.7 0 17.6-28.8 17.6-64.2 0-16.7-2.1-33.2-5.7-45.3-3.5-11.7-8.2-18.4-12.9-18.4v-3.4c6.5 0 12.1 7.2 16.2 20.8 3.8 12.5 5.9 28.9 5.9 46.3-.1 33.5-7.3 67.6-21.1 67.6z"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
          id: "wallet-nautilus_svg__g143",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
            id: "wallet-nautilus_svg__path141",
            d: "M567.5 543.8c-9.9-26.6-9.9-59.7 0-88.5l2.8 1c-9.6 28.2-9.6 60.5 0 86.5z"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
          id: "wallet-nautilus_svg__g147",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
            id: "wallet-nautilus_svg__path145",
            d: "M555.8 547.4c-10.5-28.3-10.5-65 0-95.6l2.8 1c-10.3 30-10.3 65.9 0 93.6z"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
          id: "wallet-nautilus_svg__g157",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("g", {
            id: "wallet-nautilus_svg__g151",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
              id: "wallet-nautilus_svg__path149",
              d: "M560.9 521.6c-7 0-14.2-1.2-21-3.5l1-2.8c13 4.4 27.3 4.4 39.3 0l1 2.8c-6.3 2.3-13.2 3.5-20.3 3.5z"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
            id: "wallet-nautilus_svg__g155",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
              id: "wallet-nautilus_svg__path153",
              d: "M580.2 483.8c-13-4.4-27.3-4.4-39.3 0l-1-2.8c12.6-4.7 27.7-4.7 41.3 0z"
            })
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
        transform: "matrix(1.09098 0 0 1.09098 -66.042 -60.229)",
        id: "wallet-nautilus_svg__g192",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          style: {
            fill: '#ffae00',
            stroke: '#000',
            strokeWidth: 3,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeMiterlimit: 10
          },
          id: "wallet-nautilus_svg__path161",
          d: "M831.7 432.4c16.4 0 29.6 30.1 29.6 67.2s-13.3 67.2-29.6 67.2h-6c-16.4 0-29.6-30.1-29.6-67.2s13.3-67.2 29.6-67.2h6z",
          className: "wallet-nautilus_svg__st2"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
          gradientTransform: "matrix(0 1 1 0 4141.96 4070.883)",
          y2: -3300.154,
          x2: -3523.486,
          y1: -3300.154,
          x1: -3619.201,
          gradientUnits: "userSpaceOnUse",
          id: "wallet-nautilus_svg__SVGID_00000121272453921459185760000015437207460504906381_",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
            id: "wallet-nautilus_svg__stop163",
            style: {
              stopColor: '#ffeabd'
            },
            offset: 0
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
            id: "wallet-nautilus_svg__stop165",
            style: {
              stopColor: '#ffc027'
            },
            offset: 1
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("ellipse", {
          id: "wallet-nautilus_svg__ellipse168",
          ry: 47.9,
          rx: 21.1,
          cy: 499.5,
          cx: 841.8,
          style: {
            fill: 'url(#wallet-nautilus_svg__SVGID_00000121272453921459185760000015437207460504906381_)',
            stroke: '#000',
            strokeWidth: 3,
            strokeMiterlimit: 10
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
          id: "wallet-nautilus_svg__g172",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
            id: "wallet-nautilus_svg__path170",
            d: "M841.8 564.4c-12.8 0-22.8-28.5-22.8-64.9 0-36.4 10-64.9 22.8-64.9v3.4c-9.4 0-19.4 24.7-19.4 61.4s10 61.4 19.4 61.4z"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
          id: "wallet-nautilus_svg__g176",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
            id: "wallet-nautilus_svg__path174",
            d: "m834.7 543.8-2.8-1c9.6-26 9.6-58.3 0-86.5l2.8-1c9.9 28.8 9.9 61.9 0 88.5z"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
          id: "wallet-nautilus_svg__g180",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
            id: "wallet-nautilus_svg__path178",
            d: "m846.4 547.4-2.8-1c10.3-27.7 10.3-63.6 0-93.6l2.8-1c10.5 30.6 10.5 67.3 0 95.6z"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
          id: "wallet-nautilus_svg__g190",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("g", {
            id: "wallet-nautilus_svg__g184",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
              id: "wallet-nautilus_svg__path182",
              d: "M841.3 521.6c-7.1 0-14-1.2-20.3-3.5l1-2.8c12 4.4 26.3 4.4 39.3 0l1 2.8c-6.8 2.3-14 3.5-21 3.5z"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
            id: "wallet-nautilus_svg__g188",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
              id: "wallet-nautilus_svg__path186",
              d: "m822 483.8-1-2.8c13.7-4.7 28.7-4.7 41.3 0l-1 2.8c-12-4.4-26.3-4.4-39.3 0z"
            })
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        style: {
          stroke: '#000',
          strokeWidth: 3.27293491,
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: 10
        },
        id: "wallet-nautilus_svg__path194",
        d: "M646.366 301.43c3.71-1.09 6.11 1.746 5.564 4.364 7.2-7.418 18.874-10.146 18.874-10.146z",
        className: "wallet-nautilus_svg__st3"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        style: {
          stroke: '#000',
          strokeWidth: 3.27293491,
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: 10
        },
        id: "wallet-nautilus_svg__path196",
        d: "M751.973 301.43c-3.71-1.09-6.982 2.4-5.127 5.455-8.183-6.327-17.456-11.237-17.456-11.237z",
        className: "wallet-nautilus_svg__st3"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
        cx: 698.624,
        cy: 486.242,
        r: 91.969,
        id: "wallet-nautilus_svg__circle198",
        style: {
          stroke: '#000',
          strokeWidth: 8.22194004,
          strokeMiterlimit: 10
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
        style: {
          fill: 'url(#wallet-nautilus_svg__SVGID_00000085238500194547172150000002663939323965651385_)',
          stroke: '#000',
          strokeWidth: 3.27293491,
          strokeMiterlimit: 10
        },
        cx: 698.624,
        cy: 486.242,
        r: 78.114,
        id: "wallet-nautilus_svg__circle205"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
        transform: "matrix(1.09098 0 0 1.09098 -66.042 -60.229)",
        id: "wallet-nautilus_svg__g223",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("g", {
          id: "wallet-nautilus_svg__g217",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
            d: "M726.9 565.6c-5 0-10-1.9-13.8-5.7l-71.2-71.2c-7.6-7.6-7.6-20 0-27.7l19.1-19.1c7.6-7.6 20-7.6 27.7 0l71.2 71.2c7.6 7.6 7.6 20 0 27.7l-19.1 19.1c-3.8 3.8-8.8 5.7-13.9 5.7zm-52.1-123.1c-3.6 0-6.9 1.4-9.4 3.9l-19.1 19.1c-2.5 2.5-3.9 5.8-3.9 9.4 0 3.6 1.4 6.9 3.9 9.4l71.2 71.2c5.2 5.2 13.6 5.2 18.8 0l19.1-19.1c5.2-5.2 5.2-13.6 0-18.8l-71.2-71.2c-2.5-2.6-5.8-3.9-9.4-3.9z",
            id: "wallet-nautilus_svg__path215"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
          id: "wallet-nautilus_svg__g221",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
            d: "M674.8 565.6c-5 0-10-1.9-13.8-5.7l-19.1-19.1c-7.6-7.6-7.6-20 0-27.7l71.2-71.2c7.6-7.6 20-7.6 27.7 0l19.1 19.1c7.6 7.6 7.6 20 0 27.7l-71.2 71.2c-3.9 3.8-8.9 5.7-13.9 5.7zm-9.4-10.2c2.5 2.5 5.8 3.9 9.4 3.9 3.6 0 6.9-1.4 9.4-3.9l71.2-71.2c5.2-5.2 5.2-13.6 0-18.8l-19.1-19.1c-5.2-5.2-13.6-5.2-18.8 0l-71.2 71.2c-5.2 5.2-5.2 13.6 0 18.8z",
            id: "wallet-nautilus_svg__path219"
          })
        })]
      })]
    })]
  }));
};

/* harmony default export */ var WalletNautilus = (SvgWalletNautilus);
;// CONCATENATED MODULE: ./components/icons/WalletSafew.js


function WalletSafew_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function WalletSafew_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? WalletSafew_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : WalletSafew_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgWalletSafew = function SvgWalletSafew(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", WalletSafew_objectSpread(WalletSafew_objectSpread({
    x: 0,
    y: 0,
    xmlSpace: "preserve",
    id: "wallet-safew_svg__svg8",
    width: 28,
    height: 28,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      id: "wallet-safew_svg__g6",
      transform: "matrix(.02857 0 0 .03265 -.286 -2.325)",
      style: {
        fill: '#333'
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M928.3 500V380.4c0-68.2-55.1-124.1-123-125.3v-60.6c0-67.8-56.4-123.3-125.4-123.3H135.4C66.4 71.2 10 126.6 10 194.4v609c0 68.9 56.4 125.4 125.4 125.4H803c68.9 0 125.4-56.4 125.4-125.4V683.5c34-.5 61.7-28.5 61.7-62.7v-58.3c-.1-34-27.8-62-61.8-62.5zm-1 120.8-.1.1H746.1l-.1-.1v-58l.1-.1h181.1l.1.1zM90.8 152.1c12-11.8 27.8-18.2 44.6-18.2h544.4c16.8 0 32.7 6.5 44.6 18.2 11.7 11.5 18.1 26.5 18.1 42.4V255H135.4c-16.8 0-32.7-6.5-44.6-18.2-11.7-11.5-18.1-26.5-18.1-42.4 0-15.8 6.4-30.9 18.1-42.3zm756.4 695.6c-11.9 11.9-27.6 18.5-44.2 18.5H135.4c-16.6 0-32.3-6.6-44.2-18.5-11.9-11.9-18.5-27.6-18.5-44.2V301.1c18.5 10.6 39.9 16.6 62.7 16.6H803c16.6 0 32.3 6.6 44.2 18.5 11.9 11.9 18.5 27.6 18.5 44.2V500H746c-34.5 0-62.7 28.2-62.7 62.7V621c0 34.5 28.2 62.7 62.7 62.7h119.7v119.9c-.1 16.5-6.6 32.2-18.5 44.1z",
        id: "wallet-safew_svg__path4",
        style: {
          fill: '#333'
        }
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("style", {
      type: "text/css",
      id: "style829",
      children: '.wallet-safew_svg__st0{fillRule:evenodd;clipRule:evenodd}'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      id: "wallet-safew_svg__main",
      transform: "matrix(.27836 0 0 .27863 2.326 8.915)",
      style: {
        fill: '#333'
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
        id: "wallet-safew_svg__Group-16",
        transform: "translate(-70 -35)",
        style: {
          fill: '#333'
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
          transform: "translate(70 34)",
          id: "wallet-safew_svg__g838",
          style: {
            fill: '#333'
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
            id: "wallet-safew_svg__Group-15",
            transform: "translate(0 .83)",
            style: {
              fill: '#333'
            },
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
              id: "wallet-safew_svg__Fill-9",
              className: "wallet-safew_svg__st0",
              d: "m11.2 47.8 18.3 7.4 18.2-7.8L55 29.1l-7.8-18.2-18.3-7.3-18.2 7.8-7.3 18.3Zm18.3 10.8c-.2 0-.4 0-.6-.1L9.3 50.6c-.4-.2-.7-.5-.9-.9L.1 30.3c-.2-.4-.2-.8 0-1.3L8 9.5c.2-.4.5-.7.9-.9L28.3.3c.4-.2.8-.2 1.3 0l19.6 7.9c.3.1.6.4.8.8l8.3 19.4c.2.4.2.8 0 1.3l-7.9 19.6c-.2.4-.5.7-.9.9l-19.4 8.3c-.1.1-.4.1-.6.1z",
              style: {
                fill: '#333'
              }
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
              id: "wallet-safew_svg__Fill-10",
              className: "wallet-safew_svg__st0",
              style: {
                fill: '#333'
              },
              d: "M28.3 29.1 20.5 21v-3.7H38V21H25.8l7.6 8.1-7.8 8.6H38v3.8H20.5v-3.8z"
            })]
          })
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      style: {
        fill: '#faa',
        strokeWidth: 0.0343388
      },
      d: "M3.172 25.878c-.452-.126-.898-.517-1.124-.985-.264-.551-.245.148-.245-9.08 0-4.545.011-8.259.025-8.252.015.006.123.062.24.123.253.132.492.223.8.307.209.056.819.061 10.18.078l9.958.018.196.08c.43.173.798.535 1.013.996.208.446.216.544.216 2.79v2.024h-1.767c-1.157 0-1.83.013-1.948.038-.707.147-1.314.813-1.453 1.593-.069.387-.069 2.394 0 2.781.139.78.746 1.446 1.453 1.594.119.025.791.038 1.948.038h1.767v2.023c0 2.297-.006 2.367-.243 2.848-.193.39-.498.7-.871.884l-.273.134-9.857.006c-7.896.004-9.888-.003-10.015-.038zm10.23-1.844c1.504-.644 2.763-1.19 2.797-1.21a.507.507 0 0 0 .127-.142c.128-.21 2.276-5.598 2.278-5.718.003-.14-2.341-5.655-2.443-5.747-.083-.075-5.586-2.293-5.74-2.313-.1-.014-.57.176-2.901 1.173-1.94.83-2.81 1.218-2.873 1.283-.124.125-2.344 5.6-2.343 5.776.001.08.393 1.035 1.162 2.833.638 1.492 1.188 2.76 1.223 2.816a.537.537 0 0 0 .142.152c.044.027 1.315.548 2.826 1.158 1.91.77 2.787 1.11 2.879 1.11.098 0 .83-.299 2.866-1.17z",
      id: "wallet-safew_svg__path1212"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      style: {
        fill: '#faa',
        strokeWidth: 0.0343388
      },
      d: "M21.032 16.999v-.928h5.15v1.855h-5.15z",
      id: "wallet-safew_svg__path1251"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      style: {
        fill: '#faa',
        strokeWidth: 0.0343388
      },
      d: "M3.173 5.926c-.558-.154-1.083-.684-1.267-1.28-.342-1.107.313-2.328 1.366-2.548.246-.05 15.88-.054 16.15-.003.435.083.857.372 1.123.77.322.482.327.512.341 1.9l.012 1.21-8.784-.003c-6.971-.002-8.816-.012-8.94-.046Z",
      id: "wallet-safew_svg__path1290"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      style: {
        fill: '#fff',
        strokeWidth: 0.0344216
      },
      d: "M8.003 23.2c-1.39-.563-2.541-1.045-2.556-1.07-.015-.026-.505-1.158-1.09-2.516l-1.062-2.47 1.012-2.542 1.012-2.542 2.503-1.073c1.377-.59 2.535-1.072 2.573-1.07.038.002 1.191.455 2.563 1.007l2.495 1.004 1.081 2.524 1.082 2.524-1.012 2.539-1.012 2.54-2.512 1.078-2.53 1.085c-.01.004-1.156-.454-2.547-1.017zm4.922-3.303v-.55l-1.702-.01-1.7-.008.654-.723 1.066-1.178.411-.455-1.053-1.12-1.053-1.12h3.377V13.666H8.003v1.052l1.086 1.128 1.087 1.128-.24.265-1.085 1.195-.845.93-.002.541-.001.543H12.925z",
      id: "wallet-safew_svg__path1535"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      style: {
        fill: '#fff',
        strokeWidth: 0.0344216
      },
      d: "M8.003 23.201c-2.082-.842-2.537-1.038-2.571-1.105-.022-.045-.513-1.178-1.09-2.517l-1.049-2.436 1.013-2.542 1.013-2.543 2.503-1.072c1.377-.59 2.526-1.072 2.553-1.072.056 0 4.99 1.957 5.05 2.003.02.016.523 1.162 1.114 2.545l1.076 2.517-.69 1.731c-.381.952-.836 2.096-1.012 2.54l-.319.81-2.514 1.075-2.53 1.083c-.01.004-1.156-.453-2.547-1.017zm4.922-3.304v-.55l-1.703-.01-1.702-.008.437-.485 1.066-1.177.63-.692-1.045-1.112-1.045-1.113 1.681-.008 1.68-.01v-1.066H8.004v1.05l1.087 1.128 1.088 1.129-.224.248c-.122.137-.61.675-1.085 1.196l-.863.946-.002.542-.001.543H12.925z",
      id: "wallet-safew_svg__path1574"
    })]
  }));
};

/* harmony default export */ var WalletSafew = (SvgWalletSafew);
;// CONCATENATED MODULE: ./components/icons/WalletSatergo.js




var SvgWalletSatergo = function SvgWalletSatergo(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.4538 13.4748C11.9733 9.55021 16.0755 7.01647 21.5982 7.85294C22.7014 8.02001 23.7312 7.26112 23.8982 6.15799C24.0653 5.05485 23.3064 4.02516 22.2033 3.85799C14.4931 2.69031 8.82208 6.59395 5.66895 11.9169L2.81663 10.7429C1.78491 10.3183 0.604201 10.8104 0.179554 11.8421C-0.245092 12.8739 0.247029 14.0546 1.27885 14.4793L30.5461 26.5253C28.0266 30.4497 23.9244 32.9834 18.4017 32.1471C17.2985 31.98 16.2687 32.7388 16.1017 33.8419C15.9346 34.945 16.6935 35.9749 17.7966 36.1419C25.5068 37.3096 31.1778 33.406 34.3311 28.083L37.1833 29.257C38.215 29.6817 39.3957 29.1895 39.8204 28.1578C40.245 27.1261 39.7529 25.9454 38.7212 25.5207L9.4538 13.4748ZM28.843 9.11435C29.5428 9.11435 30.1102 8.54718 30.1102 7.84768C30.1102 7.14809 29.5428 6.58102 28.843 6.58102C28.1431 6.58102 27.5757 7.14809 27.5757 7.84768C27.5757 8.54718 28.1431 9.11435 28.843 9.11435ZM33.8475 11.6861C33.8475 12.3856 33.2802 12.9527 32.5804 12.9527C31.8805 12.9527 31.3131 12.3856 31.3131 11.6861C31.3131 10.9865 31.8805 10.4194 32.5804 10.4194C33.2802 10.4194 33.8475 10.9865 33.8475 11.6861ZM34.5546 17.6414C35.2545 17.6414 35.8218 17.0743 35.8218 16.3748C35.8218 15.6752 35.2545 15.1081 34.5546 15.1081C33.8547 15.1081 33.2873 15.6752 33.2873 16.3748C33.2873 17.0743 33.8547 17.6414 34.5546 17.6414Z",
      fill: "url(#paint0_linear_108_275)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("defs", {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "paint0_linear_108_275",
        x1: "13.0357",
        y1: "12.5065",
        x2: "31.4869",
        y2: "13.1607",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#7B7DFF"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: "1",
          stopColor: "#3F41F7"
        })]
      })
    })]
  });
};

/* harmony default export */ var WalletSatergo = (SvgWalletSatergo);
// EXTERNAL MODULE: ./components/icons/ErgoWiki.js
var ErgoWiki = __webpack_require__(4057);
;// CONCATENATED MODULE: ./components/icons/BlogFacebook.js


function BlogFacebook_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function BlogFacebook_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? BlogFacebook_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : BlogFacebook_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgBlogFacebook = function SvgBlogFacebook(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", BlogFacebook_objectSpread(BlogFacebook_objectSpread({
    width: 50,
    height: 51,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M26.863 37.31V26.382h3.687l.548-4.28h-4.235v-2.725c0-1.235.344-2.08 2.116-2.08h2.246V13.48a29.806 29.806 0 0 0-3.29-.169c-3.26 0-5.497 1.99-5.497 5.642v3.14h-3.663v4.28h3.671v10.938h4.417Z",
      fill: "#FF5E18"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
      x: 1,
      y: 1.311,
      width: 48,
      height: 48,
      rx: 24,
      stroke: "#FF5E18",
      strokeWidth: 2
    })]
  }));
};

/* harmony default export */ var BlogFacebook = (SvgBlogFacebook);
;// CONCATENATED MODULE: ./components/icons/BlogLink.js


function BlogLink_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function BlogLink_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? BlogLink_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : BlogLink_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgBlogLink = function SvgBlogLink(props) {
  return /*#__PURE__*/_jsxs("svg", BlogLink_objectSpread(BlogLink_objectSpread({
    width: 50,
    height: 51,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      d: "M27.058 23.253a5.823 5.823 0 0 0-8.234 0l-4.118 4.117a5.823 5.823 0 1 0 8.235 8.235L25 33.547",
      stroke: "#FF5E18",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M22.941 27.37a5.823 5.823 0 0 0 8.235 0l4.118-4.118a5.824 5.824 0 0 0-8.235-8.235L25 17.075",
      stroke: "#FF5E18",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("rect", {
      x: 1,
      y: 1.311,
      width: 48,
      height: 48,
      rx: 24,
      stroke: "#FF5E18",
      strokeWidth: 2
    })]
  }));
};

/* harmony default export */ var BlogLink = ((/* unused pure expression or super */ null && (SvgBlogLink)));
;// CONCATENATED MODULE: ./components/icons/BlogX.js


function BlogX_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function BlogX_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? BlogX_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : BlogX_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SvgBlogX = function SvgBlogX(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", BlogX_objectSpread(BlogX_objectSpread({
    width: 50,
    height: 51,
    viewBox: "0 0 300 300.251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M178.57 127.15 290.27 0h-26.46l-97.03 110.38L89.34 0H0l117.13 166.93L0 300.25h26.46l102.4-116.59 81.8 116.59h89.34M36.01 19.54H76.66l187.13 262.13h-40.66",
      fill: "#FF5E18"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
      x: 1,
      y: 1.311,
      width: 48,
      height: 48,
      rx: 24,
      stroke: "#FF5E18",
      strokeWidth: 2
    })]
  }));
};

/* harmony default export */ var BlogX = (SvgBlogX);
// EXTERNAL MODULE: ./components/icons/Coingecko.js
var Coingecko = __webpack_require__(3353);
;// CONCATENATED MODULE: ./components/icons/index.tsx






























































































/***/ }),

/***/ 9816:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ getIconComponentByName; }
/* harmony export */ });
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


/**
 * Icons Component map.
 *
 * @param {string} name Icon Name.
 * @returns {*}
 */


var getIconComponentByName = function getIconComponentByName(name, props) {
  var ComponentsMap = {
    CheckDark: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
      return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 346));
    }, {
      ssr: false,
      loadableGenerated: {
        webpack: function webpack() {
          return [/*require.resolve*/(346)];
        }
      }
    }),
    CheckDarkHighlited: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
      return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 6156));
    }, {
      ssr: false,
      loadableGenerated: {
        webpack: function webpack() {
          return [/*require.resolve*/(6156)];
        }
      }
    }),
    CheckGreen: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
      return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 4793));
    }, {
      ssr: false,
      loadableGenerated: {
        webpack: function webpack() {
          return [/*require.resolve*/(4793)];
        }
      }
    }),
    CheckOrange: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
      return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 6024));
    }, {
      ssr: false,
      loadableGenerated: {
        webpack: function webpack() {
          return [/*require.resolve*/(6024)];
        }
      }
    }),
    CheckOrangeHighlighted: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
      return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 8512));
    }, {
      ssr: false,
      loadableGenerated: {
        webpack: function webpack() {
          return [/*require.resolve*/(8512)];
        }
      }
    }),
    Discord: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
      return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 4985));
    }, {
      ssr: false,
      loadableGenerated: {
        webpack: function webpack() {
          return [/*require.resolve*/(4985)];
        }
      }
    }),
    Wiki: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
      return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 7404));
    }, {
      ssr: false,
      loadableGenerated: {
        webpack: function webpack() {
          return [/*require.resolve*/(7404)];
        }
      }
    }),
    ErgoNode: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
      return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 6017));
    }, {
      ssr: false,
      loadableGenerated: {
        webpack: function webpack() {
          return [/*require.resolve*/(6017)];
        }
      }
    }),
    Github: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
      return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 4193));
    }, {
      ssr: false,
      loadableGenerated: {
        webpack: function webpack() {
          return [/*require.resolve*/(4193)];
        }
      }
    }),
    Highlight: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
      return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 8029));
    }, {
      ssr: false,
      loadableGenerated: {
        webpack: function webpack() {
          return [/*require.resolve*/(8029)];
        }
      }
    }),
    Ledger: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
      return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 3265));
    }, {
      ssr: false,
      loadableGenerated: {
        webpack: function webpack() {
          return [/*require.resolve*/(3265)];
        }
      }
    }),
    Linkedin: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
      return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 1979));
    }, {
      ssr: false,
      loadableGenerated: {
        webpack: function webpack() {
          return [/*require.resolve*/(1979)];
        }
      }
    }),
    Logo: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
      return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 3715));
    }, {
      ssr: false,
      loadableGenerated: {
        webpack: function webpack() {
          return [/*require.resolve*/(3715)];
        }
      }
    }),
    LogoWhite: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
      return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 5204));
    }, {
      ssr: false,
      loadableGenerated: {
        webpack: function webpack() {
          return [/*require.resolve*/(5204)];
        }
      }
    }),
    LogoWithText: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
      return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 6586));
    }, {
      ssr: false,
      loadableGenerated: {
        webpack: function webpack() {
          return [/*require.resolve*/(6586)];
        }
      }
    }),
    MenuClose: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
      return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 7983));
    }, {
      ssr: false,
      loadableGenerated: {
        webpack: function webpack() {
          return [/*require.resolve*/(7983)];
        }
      }
    }),
    MenuOpen: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
      return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 5128));
    }, {
      ssr: false,
      loadableGenerated: {
        webpack: function webpack() {
          return [/*require.resolve*/(5128)];
        }
      }
    }),
    Power: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
      return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 4802));
    }, {
      ssr: false,
      loadableGenerated: {
        webpack: function webpack() {
          return [/*require.resolve*/(4802)];
        }
      }
    }),
    Reddit: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
      return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 3157));
    }, {
      ssr: false,
      loadableGenerated: {
        webpack: function webpack() {
          return [/*require.resolve*/(3157)];
        }
      }
    }),
    Sync: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
      return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 1745));
    }, {
      ssr: false,
      loadableGenerated: {
        webpack: function webpack() {
          return [/*require.resolve*/(1745)];
        }
      }
    }),
    Telegram: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
      return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 5866));
    }, {
      ssr: false,
      loadableGenerated: {
        webpack: function webpack() {
          return [/*require.resolve*/(5866)];
        }
      }
    }),
    ThemeDarkBig: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
      return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 8357));
    }, {
      ssr: false,
      loadableGenerated: {
        webpack: function webpack() {
          return [/*require.resolve*/(8357)];
        }
      }
    }),
    ThemeDarkSmall: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
      return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 5883));
    }, {
      ssr: false,
      loadableGenerated: {
        webpack: function webpack() {
          return [/*require.resolve*/(5883)];
        }
      }
    }),
    ThemeLightBig: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
      return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 478));
    }, {
      ssr: false,
      loadableGenerated: {
        webpack: function webpack() {
          return [/*require.resolve*/(478)];
        }
      }
    }),
    ThemeLightSmall: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
      return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 2650));
    }, {
      ssr: false,
      loadableGenerated: {
        webpack: function webpack() {
          return [/*require.resolve*/(2650)];
        }
      }
    }),
    Wechat: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
      return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 599));
    }, {
      ssr: false,
      loadableGenerated: {
        webpack: function webpack() {
          return [/*require.resolve*/(599)];
        }
      }
    }),
    X: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
      return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 8128));
    }, {
      ssr: false,
      loadableGenerated: {
        webpack: function webpack() {
          return [/*require.resolve*/(8128)];
        }
      }
    }),
    XHightlighted: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
      return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 3829));
    }, {
      ssr: false,
      loadableGenerated: {
        webpack: function webpack() {
          return [/*require.resolve*/(3829)];
        }
      }
    }),
    XWhite: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
      return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 8597));
    }, {
      ssr: false,
      loadableGenerated: {
        webpack: function webpack() {
          return [/*require.resolve*/(8597)];
        }
      }
    }),
    XWhiteHighlighted: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
      return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 7503));
    }, {
      ssr: false,
      loadableGenerated: {
        webpack: function webpack() {
          return [/*require.resolve*/(7503)];
        }
      }
    }),
    Youtube: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
      return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 6107));
    }, {
      ssr: false,
      loadableGenerated: {
        webpack: function webpack() {
          return [/*require.resolve*/(6107)];
        }
      }
    }),
    ArrowRightBlack: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
      return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 7390));
    }, {
      ssr: false,
      loadableGenerated: {
        webpack: function webpack() {
          return [/*require.resolve*/(7390)];
        }
      }
    }),
    ArrowRightOrange: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
      return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 1891));
    }, {
      ssr: false,
      loadableGenerated: {
        webpack: function webpack() {
          return [/*require.resolve*/(1891)];
        }
      }
    }),
    Sigmaverse: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
      return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 7567));
    }, {
      ssr: false,
      loadableGenerated: {
        webpack: function webpack() {
          return [/*require.resolve*/(7567)];
        }
      }
    }),
    Line: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
      return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 7810));
    }, {
      ssr: false,
      loadableGenerated: {
        webpack: function webpack() {
          return [/*require.resolve*/(7810)];
        }
      }
    }),
    LanguageSelector: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
      return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 5713));
    }, {
      ssr: false,
      loadableGenerated: {
        webpack: function webpack() {
          return [/*require.resolve*/(5713)];
        }
      }
    }),
    LanguageSelectorWhite: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
      return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 3928));
    }, {
      ssr: false,
      loadableGenerated: {
        webpack: function webpack() {
          return [/*require.resolve*/(3928)];
        }
      }
    }),
    Highlights1: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
      return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 2720));
    }, {
      ssr: false,
      loadableGenerated: {
        webpack: function webpack() {
          return [/*require.resolve*/(2720)];
        }
      }
    }),
    Highlights2: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
      return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 1104));
    }, {
      ssr: false,
      loadableGenerated: {
        webpack: function webpack() {
          return [/*require.resolve*/(1104)];
        }
      }
    }),
    Highlights3: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
      return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 4881));
    }, {
      ssr: false,
      loadableGenerated: {
        webpack: function webpack() {
          return [/*require.resolve*/(4881)];
        }
      }
    }),
    Highlights1big: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
      return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 1191));
    }, {
      ssr: false,
      loadableGenerated: {
        webpack: function webpack() {
          return [/*require.resolve*/(1191)];
        }
      }
    }),
    Highlights2big: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
      return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 7655));
    }, {
      ssr: false,
      loadableGenerated: {
        webpack: function webpack() {
          return [/*require.resolve*/(7655)];
        }
      }
    }),
    Highlights3big: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
      return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 8283));
    }, {
      ssr: false,
      loadableGenerated: {
        webpack: function webpack() {
          return [/*require.resolve*/(8283)];
        }
      }
    }),
    Sigmanauts: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
      return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 9738));
    }, {
      ssr: false,
      loadableGenerated: {
        webpack: function webpack() {
          return [/*require.resolve*/(9738)];
        }
      }
    }),
    UsingErgBuyIt: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
      return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 417));
    }, {
      ssr: false,
      loadableGenerated: {
        webpack: function webpack() {
          return [/*require.resolve*/(417)];
        }
      }
    }),
    UsingErgBuyItLight: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
      return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 9140));
    }, {
      ssr: false,
      loadableGenerated: {
        webpack: function webpack() {
          return [/*require.resolve*/(9140)];
        }
      }
    }),
    UsingErgMineIt: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
      return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 2236));
    }, {
      ssr: false,
      loadableGenerated: {
        webpack: function webpack() {
          return [/*require.resolve*/(2236)];
        }
      }
    }),
    UsingErgMineItLight: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
      return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 483));
    }, {
      ssr: false,
      loadableGenerated: {
        webpack: function webpack() {
          return [/*require.resolve*/(483)];
        }
      }
    }),
    UsingErgStoreIt: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
      return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 5985));
    }, {
      ssr: false,
      loadableGenerated: {
        webpack: function webpack() {
          return [/*require.resolve*/(5985)];
        }
      }
    }),
    UsingErgStoreItLight: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
      return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 358));
    }, {
      ssr: false,
      loadableGenerated: {
        webpack: function webpack() {
          return [/*require.resolve*/(358)];
        }
      }
    }),
    UsingErgUseIt: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
      return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 4167));
    }, {
      ssr: false,
      loadableGenerated: {
        webpack: function webpack() {
          return [/*require.resolve*/(4167)];
        }
      }
    }),
    UsingErgUseItLight: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
      return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 4824));
    }, {
      ssr: false,
      loadableGenerated: {
        webpack: function webpack() {
          return [/*require.resolve*/(4824)];
        }
      }
    }),
    RoadmapPlanned: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
      return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 3027));
    }, {
      ssr: false,
      loadableGenerated: {
        webpack: function webpack() {
          return [/*require.resolve*/(3027)];
        }
      }
    }),
    RoadmapInProgress: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
      return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 8657));
    }, {
      ssr: false,
      loadableGenerated: {
        webpack: function webpack() {
          return [/*require.resolve*/(8657)];
        }
      }
    }),
    RoadmapCompleted: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
      return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 6804));
    }, {
      ssr: false,
      loadableGenerated: {
        webpack: function webpack() {
          return [/*require.resolve*/(6804)];
        }
      }
    }),
    ErgoFoundationIcon: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
      return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 9082));
    }, {
      ssr: false,
      loadableGenerated: {
        webpack: function webpack() {
          return [/*require.resolve*/(9082)];
        }
      }
    }),
    ErgoFoundationIconLight: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
      return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 7623));
    }, {
      ssr: false,
      loadableGenerated: {
        webpack: function webpack() {
          return [/*require.resolve*/(7623)];
        }
      }
    }),
    Discourse: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
      return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 9199));
    }, {
      ssr: false,
      loadableGenerated: {
        webpack: function webpack() {
          return [/*require.resolve*/(9199)];
        }
      }
    }),
    UniqueErgo1: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
      return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 2838));
    }, {
      ssr: false,
      loadableGenerated: {
        webpack: function webpack() {
          return [/*require.resolve*/(2838)];
        }
      }
    }),
    UniqueErgo2: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
      return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 9510));
    }, {
      ssr: false,
      loadableGenerated: {
        webpack: function webpack() {
          return [/*require.resolve*/(9510)];
        }
      }
    }),
    UniqueErgo3: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
      return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 7548));
    }, {
      ssr: false,
      loadableGenerated: {
        webpack: function webpack() {
          return [/*require.resolve*/(7548)];
        }
      }
    }),
    UniqueErgo4: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
      return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 2435));
    }, {
      ssr: false,
      loadableGenerated: {
        webpack: function webpack() {
          return [/*require.resolve*/(2435)];
        }
      }
    }),
    ErgoWiki: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
      return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 4057));
    }, {
      ssr: false,
      loadableGenerated: {
        webpack: function webpack() {
          return [/*require.resolve*/(4057)];
        }
      }
    }),
    Coingecko: next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
      return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 3353));
    }, {
      ssr: false,
      loadableGenerated: {
        webpack: function webpack() {
          return [/*require.resolve*/(3353)];
        }
      }
    })
  };

  if (name in ComponentsMap) {
    var IconComponent = ComponentsMap[name];
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(IconComponent, _objectSpread({}, props));
  } else {
    return null;
  }
};

/***/ })

}]);